import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { createPortal } from "react-dom";
import { logger } from "../utils/logger";
import { sanitizeCurrencyInput } from "../lib/utils";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import {
  Plus, Minus, Check, Clock, ChefHat, Package, Truck, User, Phone, MapPin,
  ArrowLeft, X, RefreshCw, ToggleLeft, ToggleRight, Bike, ShoppingBag, ShoppingCart,
  Store, CreditCard, DollarSign, Banknote, Eye, FileText, MessageSquare,
  Home, Building, Smartphone, Layers,
  Navigation, Calendar, Hash, XCircle, AlertTriangle,
  Volume2, VolumeX, Undo2,   ChevronDown, ChevronRight, ChevronLeft, Edit, Trash2,
  Search, ImageOff, RotateCw, History, Printer, Camera, Loader2, UserPlus, Ticket, Percent, Wallet, Sparkles, Radar,
  Monitor, KeyRound , ClipboardList } from "lucide-react";
import { CaixaRegistradoraIcon, TotemIcon } from "@/components/icons/ModulosIcons";
// Ícone do WhatsApp customizado
const WhatsAppIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

// Logo Nucleo como ícone
const NucleoLogoIcon = ({ className }) => (
  <img src="/logo-nucleo.png" alt="Nucleo" className={className} style={{ objectFit: 'contain' }} />
);

// Logo iFood oficial — alinhada com Pedidos.js (mesma imagem em /public)
const IFoodIcon = ({ className }) => (
  <img src="/logo-ifood.png" alt="iFood" className={className} style={{ objectFit: 'contain' }} />
);

// Som de novo pedido: servido pelo backend
const NOTIFICATION_SOUND_URL = "/api/sounds/notificacao-pedido";
// Som de loop pra pedidos em aguardando_aceite quando auto-aceite OFF
const PENDING_ACCEPT_SOUND_URL = "/api/sounds/aguardando-aceite";
import RadarDetailsModal from "../components/RadarDetailsModal";
import { BotaoNovoPedido, CartoesPedidoCarregando, MetricaTempoColuna, ResumoDoDia, assinaturaEtapas, useResumoDoDia, useTemposEtapas } from "../features/delivery-painel";
import { AvisoDinheiroUP, useDinheiroUP } from "../features/up-dinheiro";
import { useFilaAtendimento } from "../features/fila-atendimento";
import { FormNovoEndereco } from "../features/novo-pedido-endereco";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { CancelReasonSelect, HandshakeBanner, IfoodDeliveryCodeDialog, useIfoodDisputes, DELIVERY_STAGE_LABELS, fetchOrderTracking } from "../features/ifood";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { ScrollArea } from "../components/ui/scroll-area";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../components/ui/dialog";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogCancel,
  AlertDialogAction,
} from "../components/ui/alert-dialog";
import {
  Sheet,
  SheetContent,
} from "../components/ui/sheet";
import { temPersonalizacao } from "../utils/cartGrouping";
import { linhasDaEtapa, sinalDaEtapa, valorDaEtapa } from "../utils/precoEtapas";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "../components/ui/dropdown-menu";
import ProductPopupCardapio from "../components/ProductPopupCardapio";
import SeloOfertaItem from "../features/ofertas-do-dia/admin/SeloOfertaItem";
import { AvisoOfertasCliente, useOfertasNoCarrinho } from "../features/ofertas-do-dia";
import { descontoExclusivo, precoCheioOuPago } from "../lib/descontoExclusivo";
import { usePizzaPopup } from "../components/pizza/usePizzaPopup";
import { pizzaMetaDoItem } from "../utils/pizzaNoPedido";
import { imprimirCupom } from "../utils/cupomDelivery";
import { imprimirCupomPreparo } from "../utils/cupomPreparo";
const API = '/api';
// Card cancelado pelo iFood ainda sem aceite some sozinho depois disto (regra do dono, 16/09).
const AUTO_HIDE_CANCELADO_MS = 8 * 60 * 1000;
// Radar de pedidos oculto a pedido do dono (22/09/2026) — volta quando a análise for retomada.
const RADAR_VISIVEL = false;

const getAuthHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("data:") || url.startsWith("http://") || url.startsWith("https://")) return url;
  return `/api${url.startsWith("/") ? url : "/" + url}`;
};

// Cache de produtos (invalidado quando slug do tenant muda para evitar cross-tenant leak)
import { getTenantSlug } from "../utils/tenantScope";
import { FechamentoPedidoDialog, fechamentoDoPedido } from "../features/mesas-fechamento";
import { useLeitorNovoPedido } from "../features/novo-pedido-leitor";
import { apagarPassagem, lerPassagem, temPassagem } from "../features/balcao-entrega";
import { ConfirmarDescarte, avisoDoCupom, descontoDoCupom, faltasDoEndereco, itensDoCupom, mensagemDoErro, montarRepeticao, novaChaveEnvio, trocoAbaixoDoTotal, useRevalidarCupom } from "../features/novo-pedido-regras";
import QuantidadePeso, { vendePorPeso } from "../features/totem/popup-produto/QuantidadePeso";
import { Tecla, useTeclasNovoPedido } from "../features/novo-pedido-teclado";
import { ANEL_FOCO, tecladoPopupProduto } from "../lib/tecladoPopupProduto";
import { casaPeloCodigo } from "../lib/codigoBarras";
import { completarUnidadeDoCadastro, contarItens, formatarQtd, medidaDoItem, qtdDoItem } from "../lib/unidadeVenda";
import { motivoValido } from "../utils/motivoCancelamento";
import { CarregandoGrade } from "../components/carregando";
let productsCache = null;
let categoriesCache = null;
let productsCacheTime = null;
let productsCacheLoading = false;
let productsCacheSlug = null; // slug do tenant que populou o cache
const CACHE_TTL = 60000; // 60 segundos

function _invalidateIfWrongTenant() {
  const slug = getTenantSlug();
  if (productsCacheSlug && productsCacheSlug !== slug) {
    productsCache = null;
    categoriesCache = null;
    productsCacheTime = null;
    productsCacheLoading = false;
  }
  productsCacheSlug = slug;
}

// Função para carregar produtos no cache (chamada uma vez)
const loadProductsCache = async () => {
  _invalidateIfWrongTenant();
  if (productsCacheLoading) {
    while (productsCacheLoading) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    return;
  }

  if (productsCache && productsCacheTime && (Date.now() - productsCacheTime) < CACHE_TTL) {
    return;
  }
  
  productsCacheLoading = true;
  try {
    // FASE 0 dos Turnos do Cardápio (v1.5.408): este cache alimenta o PDV
    // (Novo Pedido, edição e "repetir pedido" do painel) e NÃO pode passar pelo
    // recorte de turno — turno é regra de vitrine do cliente; o atendente
    // continua podendo vender tudo. Antes usava `/public/products`, que é o
    // endpoint do CARDÁPIO e será recortado por turno na Fase 2 — o PDV
    // perderia produtos em silêncio.
    // Trocado por `/products/for-sale?module=Delivery` (autenticado, semântica
    // de painel) + filtro de categorias ocultas no cliente. Esse filtro é o que
    // o endpoint público fazia por dentro (get_products_for_sale ignora
    // categoria com hidden=true) e `for-sale` não fazia — sem ele o PDV passaria
    // a exibir produtos de categorias que o lojista escondeu. Verificado em
    // produção (UAI PIZZA): 49 do for-sale − 19 de categorias ocultas = 30,
    // exatamente o que o público devolvia. Desde 24/10/2026 o `for-sale` também
    // corta categoria escondida (vale para todo módulo); o filtro daqui fica
    // como segunda rede.
    const [productsRes, categoriesRes] = await Promise.all([
      axios.get(`${API}/products/for-sale?module=Delivery`, getAuthHeader()),
      axios.get(`${API}/categories`, getAuthHeader())
    ]);

    const prods = Array.isArray(productsRes.data) ? productsRes.data : [];
    categoriesCache = Array.isArray(categoriesRes.data) ? categoriesRes.data : [];
    const catsOcultas = new Set(
      categoriesCache.filter(c => c && c.hidden).map(c => c.name)
    );
    const visiveis = prods.filter(p => !catsOcultas.has(p.category || ''));
    productsCache = {
      all: visiveis,
      forSale: visiveis.filter(p => !p.is_insumo && !p.hidden)
    };
    productsCacheTime = Date.now();
  } catch (error) {
    console.error("Erro ao carregar cache de produtos:", error);
    // Tentar com endpoint autenticado como fallback
    try {
      const [productsRes, categoriesRes] = await Promise.all([
        axios.get(`${API}/products`, getAuthHeader()),
        axios.get(`${API}/categories`, getAuthHeader())
      ]);
      const prods = Array.isArray(productsRes.data) ? productsRes.data : [];
      productsCache = {
        all: prods,
        forSale: prods.filter(p => !p.is_insumo && !p.hidden)
      };
      categoriesCache = Array.isArray(categoriesRes.data) ? categoriesRes.data : [];
      productsCacheTime = Date.now();
    } catch (fallbackError) {
      console.error("Erro no fallback:", fallbackError);
    }
  } finally {
    productsCacheLoading = false;
  }
};

// Função para obter produtos do cache (instantâneo se disponível, isolado por tenant)
const getProductsFromCache = () => {
  _invalidateIfWrongTenant();
  if (productsCache && productsCacheTime && (Date.now() - productsCacheTime) < CACHE_TTL) {
    return {
      products: productsCache.forSale,
      allProducts: productsCache.all,
      categories: categoriesCache
    };
  }
  return null;
};

// Quilo/litro (30/09/2026): nas listas curtas de itens o peso aparece sempre
// (" · 1,250 kg"); por unidade, só quando passa de 1 (" x2"), como antes.
function qtdResumida(item, produtos) {
  const q = Number(item?.quantity || item?.quantidade || 1);
  const medida = medidaDoItem(item, produtos);
  if (medida) return ` · ${formatarQtd(q, medida)}`;
  return q > 1 ? ` x${formatarQtd(q, null)}` : "";
}

// Status dos pedidos com cores e etapas
const statusConfig = {
  aguardando_aceite: { label: "Aguardando Aceite", color: "bg-orange-500", step: 1 },
  producao: { label: "Em Produção", color: "bg-yellow-500", step: 2 },
  pronto: { label: "Pronto", color: "bg-green-500", step: 3 },
  // na_bag foi descontinuado — mantido apenas pra renderizar pedidos antigos/legados
  na_bag: { label: "Na Bag", color: "bg-blue-500", step: 4 },
  em_rota: { label: "Em Rota", color: "bg-purple-500", step: 5 },
  concluido: { label: "Concluído", color: "bg-emerald-600", step: 6 },
  cancelado: { label: "Cancelado", color: "bg-red-500", step: 0 },
};

/**
 * Indica se o pedido deve aparecer na aba Delivery (Cardápio, Delivery, retirada, entrega).
 * Inclui: modulo Delivery/Cardapio/CardapioPublico (case-insensitive), tipo_entrega delivery/pickup,
 * ou fallback: tem endereço ou valor_entrega > 0 e não é de mesa.
 */
function isPedidoParaDelivery(p) {
  const mod = (p.modulo || '').trim().toLowerCase();
  const t = (p.tipo_entrega || '').toLowerCase().trim();
  // Excluir explicitamente pedidos de Mesa
  if (mod === 'mesas' || t === 'mesa') return false;
  const hasMod = mod === 'delivery' || mod === 'cardapio' || mod === 'cardapiopublico' || mod === 'ifood';
  const hasTipo = t === 'delivery' || t === 'pickup';
  const looksLikeDelivery = !p.mesa_id && (!!p.endereco_rua || (Number(p.valor_entrega) || 0) > 0);
  return hasMod || hasTipo || looksLikeDelivery;
}

/**
 * Busca das colunas (v1.5.463): casa contra TUDO que o card mostra — código,
 * cliente, telefone, endereço (rua/nº/bairro/complemento) — e ignora acento:
 * "jose" acha "José", "goncalo" acha "Gonçalo".
 *
 * Multi-termo é E, não OU: "maria centro" só devolve pedidos que tenham os dois.
 * Termo com dígito é comparado só pelos dígitos, então "34999" acha o telefone
 * independente de máscara, e "(34)9" também funciona.
 */
const _semAcento = (t) => String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
function pedidoCasaBusca(p, busca) {
  const termos = _semAcento(busca).trim().split(/\s+/).filter(Boolean);
  if (!termos.length) return true;
  const alvo = _semAcento([
    p.codigo, p.cliente_nome, p.cliente_telefone,
    p.endereco_rua, p.endereco_numero, p.endereco_bairro, p.endereco_complemento,
  ].filter(Boolean).join(' '));
  const alvoDigitos = String(p.cliente_telefone || '').replace(/\D/g, '');
  return termos.every((t) => {
    if (alvo.includes(t)) return true;
    const dig = t.replace(/\D/g, '');
    return dig.length >= 2 && alvoDigitos.includes(dig);
  });
}

/**
 * Formata número de telefone para máscara (XX)X.XXXX-XXXX
 */
function formatPhoneNumber(phone) {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  // Formato: (XX)X.XXXX-XXXX (11 dígitos) ou (XX)XXXX-XXXX (10 dígitos)
  if (digits.length === 11) {
    return `(${digits.slice(0,2)})${digits[2]}.${digits.slice(3,7)}-${digits.slice(7)}`;
  } else if (digits.length === 10) {
    return `(${digits.slice(0,2)})${digits.slice(2,6)}-${digits.slice(6)}`;
  }
  return phone; // Retorna original se formato diferente
}

/**
 * Retorna ícone e cor baseado no módulo de origem do pedido
 */
function getModuloIcon(modulo) {
  const mod = (modulo || '').toLowerCase().trim();
  switch(mod) {
    case 'delivery':
      return { Icon: User, label: 'Lançado pelo atendente', color: 'text-blue-500' };
    case 'cardapio':
    case 'cardapiopublico':
      return { Icon: NucleoLogoIcon, label: 'Cardápio Digital', color: '' };
    case 'whatsapp':
      return { Icon: WhatsAppIcon, label: 'WhatsApp', color: 'text-green-500' };
    case 'balcao':
      return { Icon: CaixaRegistradoraIcon, label: 'Balcão', color: 'text-orange-500' };
    case 'comandas':
      return { Icon: ClipboardList, label: 'Comanda', color: 'text-amber-500' };
    case 'totem':
      return { Icon: TotemIcon, label: 'Totem', color: 'text-violet-500' };
    case 'ifood':
      return { Icon: IFoodIcon, label: 'iFood', color: 'text-red-500' };
    default:
      return null;
  }
}

/**
 * Ícone da origem antes do número do pedido (pedido do dono, 22/09/2026):
 * iFood = logo do iFood, Cardápio = logo do Núcleo, lançado na tela = atendente.
 * `grande` é o tamanho do cabeçalho do detalhe.
 */
// Mapa literal: o JIT do Tailwind não gera classe montada por replace().
const FUNDO_ICONE_ORIGEM = {
  'text-blue-500': 'bg-blue-500/15',
  'text-green-500': 'bg-green-500/15',
  'text-orange-500': 'bg-orange-500/15',
  'text-violet-500': 'bg-violet-500/15',
};

function IconeOrigemPedido({ modulo, campanha = null, grande = false }) {
  const lado = grande ? 'h-8' : 'h-5';
  // Pedido que veio de anúncio pago da Meta (Instagram/Facebook): a logo da
  // Meta entra no lugar da logo do Núcleo — pedido do dono (04/10/2026), para
  // a operação enxergar na hora que a campanha trouxe aquele pedido.
  if (campanha?.canal === 'meta') {
    const titulo = `Veio de anúncio da Meta: ${campanha.nome || 'campanha'}${campanha.ad_id ? ` · anúncio ${campanha.ad_id}` : ''}`;
    return (
      <span title={titulo} className="shrink-0 inline-flex" data-e2e="selo-meta">
        <img src="/logo-meta.svg" alt="Meta" className={`${lado} ${grande ? 'w-8' : 'w-5'}`} style={{ objectFit: 'contain' }} />
      </span>
    );
  }
  const origem = getModuloIcon(modulo);
  if (!origem) return null;
  const { Icon, label, color } = origem;
  if (Icon === IFoodIcon || Icon === NucleoLogoIcon) {
    return <span title={label} className="shrink-0 inline-flex"><Icon className={`${lado} ${Icon === IFoodIcon ? 'w-auto' : grande ? 'w-8' : 'w-5'}`} /></span>;
  }
  // Ícone de traço ganha um fundo redondo para ter o mesmo peso visual das logos.
  return (
    <span title={label} className={`shrink-0 inline-flex items-center justify-center rounded-full ${lado} ${grande ? 'w-8' : 'w-5'} ${color} ${FUNDO_ICONE_ORIGEM[color] || 'bg-muted'}`}>
      <Icon className={grande ? 'w-5 h-5' : 'w-3.5 h-3.5'} strokeWidth={2.5} />
    </span>
  );
}

// Base do code de forma de pagamento — remove o sufixo de tenant dos codes
// do cardápio ("cartao_<uuid>" → "cartao"). Fora dos componentes para o
// Delivery e o CardapioPopup (Novo Pedido) usarem a mesma regra (achado 269).
const _formaBase = (code) => String(code || "")
  .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, "")
  .toLowerCase();

export default function Delivery() {
  const navigate = useNavigate();
  const [pedidos, setPedidos] = useState([]);
  const [allProductsWithInsumos, setAllProductsWithInsumos] = useState([]);
  const [entregadores, setEntregadores] = useState([]);
  const [radar, setRadar] = useState(null); // { hour, expected, real, percent, weekday_label }
  const [radarModalOpen, setRadarModalOpen] = useState(false);

  // Popup de "Pedido alterado pelo cliente" — abre auto quando polling detecta
  // pedido novo com has_modification && !modification_seen. Lojista só "vê" e fecha
  // (a mudança já foi aplicada no banco e cupom reimpresso no caixa).
  const [modPopupPedido, setModPopupPedido] = useState(null);
  const modDismissedIdsRef = useRef(new Set());

  // Radar: esperado x real para a hora atual (média mesmo weekday+hora dos últimos 5 weeks)
  useEffect(() => {
    let mounted = true;
    if (!RADAR_VISIVEL) return undefined;
    const fetchRadar = async () => {
      try {
        const res = await axios.get(`${API}/delivery/radar`, getAuthHeader());
        if (mounted && res.data) setRadar(res.data);
      } catch (_) {}
    };
    fetchRadar();
    const t = setInterval(fetchRadar, 60000);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  // Carrega lista completa de produtos (incluindo insumos/adicionais com fotos) uma vez
  useEffect(() => {
    axios.get(`${API}/products`, getAuthHeader())
      .then(r => { if (Array.isArray(r.data)) setAllProductsWithInsumos(r.data); })
      .catch(() => {});
  }, []);

  const [loading, setLoading] = useState(true);
  // Tempos das colunas e resumo do dia se releem quando um pedido muda de etapa
  // (aqui ou em outra tela), sem esperar o relógio. null = lista não carregou.
  const assinaturaDoDia = useMemo(() => (loading ? null : assinaturaEtapas(pedidos)), [loading, pedidos]);
  const temposEtapas = useTemposEtapas(assinaturaDoDia);
  const dailyStats = useResumoDoDia(assinaturaDoDia);
  const [autoAccept, setAutoAccept] = useState(false);
  const autoAcceptProcessing = useRef(false);
  
  // Referência para rastrear pedidos anteriores (para detectar novos)
  const previousPedidosRef = useRef([]);
  const audioRef = useRef(null);
  // Loop de "aguardando aceite" — toca enquanto houver pedido nesse status e
  // auto-aceite estiver OFF. Mesmo padrao do alert do ChatBot (5s entre cada
  // reproducao). Para automaticamente quando o ultimo pedido sai do status ou
  // quando o auto-aceite eh ligado.
  const pendingAcceptAudioRef = useRef(null);
  const pendingAcceptIntervalRef = useRef(null);

  // Rastrear status anteriores para animação de transição entre colunas
  const prevStatusMapRef = useRef({}); // { pedidoId: status }
  const [transitionedIds, setTransitionedIds] = useState(new Set());
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [filterProducao, setFilterProducao] = useState('');
  const [filterPronto, setFilterPronto] = useState('');
  // Coluna CANCELADOS (v1.5.462): faixa estreita ao lado de PRONTO; expande no clique
  const [canceladosAberto, setCanceladosAberto] = useState(false);
  const canceladosRef = useRef(null);
  // Clique em QUALQUER lugar fora da coluna recolhe (v1.5.464, pedido do dono).
  // `pointerdown` em vez de `click`: fecha antes do clique agir, e o clique
  // original segue valendo no que foi clicado — sem backdrop que engole o toque.
  useEffect(() => {
    if (!canceladosAberto) return undefined;
    const fechar = (e) => {
      if (canceladosRef.current && !canceladosRef.current.contains(e.target)) {
        setCanceladosAberto(false);
      }
    };
    document.addEventListener('pointerdown', fechar);
    return () => document.removeEventListener('pointerdown', fechar);
  }, [canceladosAberto]);
  const [printMenuPedidoId, setPrintMenuPedidoId] = useState(null);
  // Posição do botão que abriu o menu de impressão. O menu é renderizado em
  // PORTAL (document.body): dentro do card ele era recortado pela coluna
  // (overflow-hidden/auto) e coberto pelos cards vizinhos — z-index não escapa
  // de ancestral com overflow. Portal + posição fixa resolve nos dois eixos.
  const [printMenuAnchor, setPrintMenuAnchor] = useState(null);
  
  // State UP Entrega
  const [entregaAiConfig, setEntregaAiConfig] = useState(null);
  const [entregaAiBalance, setEntregaAiBalance] = useState(null);
  const [entregaAiOrdersStatus, setEntregaAiOrdersStatus] = useState({});

  // Clientes aguardando atendimento humano (WhatsApp). A lista mora no sino do
  // cabeçalho; aqui só o total, para o som em loop.
  const { quantidade: waitingQueueCount } = useFilaAtendimento();
  const clienteEsperandoIntervalRef = useRef(null);
  
  // Pré-carregar produtos no cache quando a página monta
  useEffect(() => {
    loadProductsCache();
  }, []);

  // Carregar config e saldo do UP Entrega
  useEffect(() => {
    const fetchEntregaAi = async () => {
      try {
        const configRes = await axios.get(`${API}/entregaai/config`, getAuthHeader());
        setEntregaAiConfig(configRes.data);
        if (configRes.data.enabled) {
          try {
            const balanceRes = await axios.get(`${API}/entregaai/wallet/balance`, getAuthHeader());
            const data = balanceRes.data?.data || balanceRes.data;
            setEntregaAiBalance(data?.balance ?? data?.amount ?? null);
          } catch (e) {
            // Saldo não disponível
          }
        }
      } catch (e) {
        // Integração não configurada
      }
    };
    fetchEntregaAi();
    const interval = setInterval(fetchEntregaAi, 60000);
    return () => clearInterval(interval);
  }, []);

  // Polling status UP Entrega para pedidos prontos
  useEffect(() => {
    if (!entregaAiConfig?.enabled) return;
    const fetchOrdersStatus = async () => {
      const prontoIds = pedidos.filter(p => p.status === 'pronto' && p.tipo_entrega !== 'pickup').map(p => p.id);
      if (prontoIds.length === 0) { setEntregaAiOrdersStatus({}); return; }
      try {
        const res = await axios.get(`${API}/entregaai/orders-status?pedido_ids=${prontoIds.join(',')}`, getAuthHeader());
        setEntregaAiOrdersStatus(res.data || {});
      } catch (e) {}
    };
    fetchOrdersStatus();
    // Polling de 15s (era 5s) — UP API tem latencia variavel e cada tick dispara
    // N HTTP calls. 15s ainda e responsivo pra detectar mudancas de status do
    // entregador, sem saturar UP API + backend.
    const interval = setInterval(fetchOrdersStatus, 15000);
    return () => clearInterval(interval);
  }, [entregaAiConfig?.enabled, pedidos]);

  // Pedido em dinheiro entregue pela UP: o entregador espera a loja confirmar o recebimento.
  const dinheiroUP = useDinheiroUP({ ativo: !!entregaAiConfig?.enabled, pedidos });

  // Loop do som "cliente esperando": toca a cada 10s enquanto houver fila, som ativo e não silenciado; para quando fila=0, som desativado ou "Silenciar alerta"
  useEffect(() => {
    const play = () => {
      try {
        const a = new Audio("/api/sounds/cliente-esperando");
        a.volume = 0.8;
        a.play().catch(() => {});
      } catch (e) { /* ignora */ }
    };

    if (waitingQueueCount > 0 && soundEnabled) {
      if (!clienteEsperandoIntervalRef.current) {
        play();
        clienteEsperandoIntervalRef.current = setInterval(play, 10000);
      }
    } else {
      if (clienteEsperandoIntervalRef.current) {
        clearInterval(clienteEsperandoIntervalRef.current);
        clienteEsperandoIntervalRef.current = null;
      }
    }
    
    return () => {
      if (clienteEsperandoIntervalRef.current) {
        clearInterval(clienteEsperandoIntervalRef.current);
        clienteEsperandoIntervalRef.current = null;
      }
    };
  }, [waitingQueueCount, soundEnabled]);
  
  // Sistema de heartbeat para rastrear abas ADMIN ativas
  const [adminSessionId, setAdminSessionId] = useState(null);
  const heartbeatIntervalRef = useRef(null);
  // CORREÇÃO: Usar ref para garantir que sessionId está sempre disponível no handleBeforeUnload
  const sessionIdRef = useRef(null);
  
  // Gerar session_id único para esta aba
  useEffect(() => {
    const sessionId = `admin_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    setAdminSessionId(sessionId);
    sessionIdRef.current = sessionId; // Armazenar no ref para acesso no handleBeforeUnload
    
    // Enviar heartbeat inicial
    const sendHeartbeat = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          await axios.post('/api/admin/heartbeat', {}, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'X-Session-ID': sessionId
            }
          });
        }
      } catch (error) {
        logger.debug('Erro ao enviar heartbeat:', error);
      }
    };
    
    sendHeartbeat();
    
    // Enviar heartbeat a cada 15 segundos
    heartbeatIntervalRef.current = setInterval(sendHeartbeat, 15000);
    
    // Remover sessão quando a aba for fechada
    // CORREÇÃO: Não bloquear navegação se falhar
    const handleBeforeUnload = async () => {
      try {
        const token = localStorage.getItem('token');
        // CORREÇÃO: Usar ref para garantir valor atualizado
        const currentSessionId = sessionIdRef.current;
        if (token && currentSessionId) {
          // Enviar session_id no body JSON (padrão REST)
          const response = await fetch('/api/admin/leave', {
            method: 'POST',
            headers: { 
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ session_id: currentSessionId }),
            keepalive: true // Garantir que a requisição seja enviada mesmo ao fechar
          });
          
          // CRÍTICO: Não fazer nada se falhar - apenas logar
          if (!response.ok) {
            console.warn('⚠️ Erro ao registrar saída (ignorado):', response.status);
          }
        }
      } catch (error) {
        // CRÍTICO: Ignorar erros completamente - NÃO interferir na navegação
        console.warn('⚠️ Erro ao registrar saída (ignorado):', error);
      }
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      if (heartbeatIntervalRef.current) {
        clearInterval(heartbeatIntervalRef.current);
      }
      // REMOVIDO: Não chamar handleBeforeUnload no cleanup
      // Isso estava causando requisições desnecessárias ao navegar
      // O beforeunload já é tratado pelo listener do window
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
  
  // Inicializar áudio de notificação
  useEffect(() => {
    const audio = new Audio(NOTIFICATION_SOUND_URL);
    audioRef.current = audio;
    audioRef.current.volume = 1.0; // Volume 100%

    // Carregar preferência de som do localStorage
    const savedSoundPref = localStorage.getItem('delivery_sound_enabled');
    if (savedSoundPref !== null) {
      setSoundEnabled(savedSoundPref === 'true');
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  // Função para tocar som de notificação (áudio normal 100%)
  const playNotificationSound = useCallback(() => {
    console.log("[DELIVERY] playNotificationSound chamado, soundEnabled:", soundEnabled);
    if (!soundEnabled) {
      console.log("[DELIVERY] Som desabilitado, não tocando");
      return;
    }

    try {
      if (audioRef.current) {
        console.log("[DELIVERY] Tocando som de notificação...");
        audioRef.current.volume = 1.0; // Volume 100%
        audioRef.current.currentTime = 0;
        audioRef.current.play()
          .then(() => console.log("[DELIVERY] Som tocou com sucesso!"))
          .catch(err => {
            console.error("[DELIVERY] Erro ao tocar som:", err);
          });
      } else {
        console.log("[DELIVERY] audioRef.current é null!");
      }
    } catch (err) {
      console.error("[DELIVERY] Erro ao tocar som:", err);
    }
  }, [soundEnabled]);

  // Som de CANCELAMENTO (regra do dono, 16/09/2026): pedido já aceito, pronto
  // ou em rota cancelado pelo iFood precisa alertar de forma diferente do
  // "pedido novo" — alguém pode estar preparando ou entregando algo que não
  // vai sair. Gerado no navegador (Web Audio): três tons descendentes, 2x.
  const playCancelSound = useCallback(() => {
    if (!soundEnabled) return;
    try {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      const ctx = new Ctx();
      [880, 660, 440, 880, 660, 440].forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = "square";
        osc.frequency.value = freq;
        const t0 = ctx.currentTime + i * 0.22 + (i >= 3 ? 0.25 : 0);
        gain.gain.setValueAtTime(0.0001, t0);
        gain.gain.exponentialRampToValueAtTime(0.5, t0 + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.2);
        osc.connect(gain).connect(ctx.destination);
        osc.start(t0);
        osc.stop(t0 + 0.21);
      });
      setTimeout(() => { try { ctx.close(); } catch {} }, 2500);
    } catch (err) {
      console.error("[DELIVERY] Erro ao tocar som de cancelamento:", err);
    }
  }, [soundEnabled]);

  // Para o loop de "aguardando aceite" (idempotente)
  const stopPendingAcceptLoop = useCallback(() => {
    if (pendingAcceptAudioRef.current) {
      try { pendingAcceptAudioRef.current.pause(); } catch {}
      pendingAcceptAudioRef.current = null;
    }
    if (pendingAcceptIntervalRef.current) {
      clearInterval(pendingAcceptIntervalRef.current);
      pendingAcceptIntervalRef.current = null;
    }
  }, []);

  // Inicia (se ainda nao ativo) o loop de "aguardando aceite"
  const startPendingAcceptLoop = useCallback(() => {
    if (pendingAcceptIntervalRef.current) return; // ja rodando
    const playOnce = () => {
      try {
        const a = new Audio(PENDING_ACCEPT_SOUND_URL);
        a.volume = 1.0;
        pendingAcceptAudioRef.current = a;
        a.onended = () => { pendingAcceptAudioRef.current = null; };
        a.play().catch(() => { pendingAcceptAudioRef.current = null; });
      } catch {
        pendingAcceptAudioRef.current = null;
      }
    };
    playOnce();
    // 5s entre cada reproducao (consistente com loop do ChatBot)
    pendingAcceptIntervalRef.current = setInterval(() => {
      if (!pendingAcceptAudioRef.current) playOnce();
    }, 5000);
  }, []);

  // Toggle som de notificação
  const toggleSound = () => {
    const newValue = !soundEnabled;
    setSoundEnabled(newValue);
    localStorage.setItem('delivery_sound_enabled', String(newValue));
    
    if (newValue) {
      // Tocar um som de teste na primeira vez que ativa (requer interação do usuário para destravar áudio no navegador)
      setTimeout(() => {
        if (audioRef.current) {
          audioRef.current.currentTime = 0;
          audioRef.current.play().catch(() => {});
        }
      }, 100);
    }
    
    toast.success(newValue ? "Som de notificação ativado" : "Som de notificação desativado");
  };
  
  // Modal de criar entregador
  const [criarEntregadorModalOpen, setCriarEntregadorModalOpen] = useState(false);
  const [novoEntregadorNome, setNovoEntregadorNome] = useState("");
  const [novoEntregadorTelefone, setNovoEntregadorTelefone] = useState("");
  const [novoEntregadorFoto, setNovoEntregadorFoto] = useState(null);
  const [novoEntregadorFotoPreview, setNovoEntregadorFotoPreview] = useState(null);
  const [uploadingFoto, setUploadingFoto] = useState(false);

  // Mobile tabs
  const [mobileTab, setMobileTab] = useState("producao"); // "aceite" | "producao" | "pronto"

  // Seleção múltipla na coluna PRONTO
  const [entregadorProntoSelecionado, setEntregadorProntoSelecionado] = useState("");
  const [pedidosSelecionados, setPedidosSelecionados] = useState([]);

  // Modal "escolher entregador" ao avançar pedido delivery pronto -> em_rota
  const [atribuirEntregadorModal, setAtribuirEntregadorModal] = useState({ open: false, pedido: null, entregadorId: "" });

  // Modal de pagamento para retirada
  const [pagamentoModalOpen, setPagamentoModalOpen] = useState(false);
  const [pedidoParaPagamento, setPedidoParaPagamento] = useState(null);
  const [paymentMethodsDelivery, setPaymentMethodsDelivery] = useState([]);
  // Retirada a receber: popup do Fechar mesa (features/mesas-fechamento)
  const [pedidoFechamento, setPedidoFechamento] = useState(null);
  const [fechamentoAberto, setFechamentoAberto] = useState(false);

  // Modal de detalhes do pedido
  const [detalhesModalOpen, setDetalhesModalOpen] = useState(false);
  const [pedidoDetalhes, setPedidoDetalhes] = useState(null);
  const [nowTick, setNowTick] = useState(Date.now());

  // Live timer tick every second when modal is open
  useEffect(() => {
    if (!detalhesModalOpen) return;
    const iv = setInterval(() => setNowTick(Date.now()), 1000);
    return () => clearInterval(iv);
  }, [detalhesModalOpen]);

  // Modal de cancelamento
  const [cancelarModalOpen, setCancelarModalOpen] = useState(false);
  const [pedidoParaCancelar, setPedidoParaCancelar] = useState(null);
  const [motivoCancelamento, setMotivoCancelamento] = useState("");
  // Pedido iFood: motivo escolhido da lista do iFood (obrigatório na homologação)
  const [ifoodCancelReason, setIfoodCancelReason] = useState(null);
  // Negociações abertas do iFood (cliente pediu cancelamento/reembolso/tempo) — painel no topo
  const ifoodDisputes = useIfoodDisputes({ onNew: playNotificationSound });

  // Modal de saldo insuficiente UP Entrega
  const [saldoInsuficienteModal, setSaldoInsuficienteModal] = useState({
    open: false,
    currentBalance: null,
    deliveryPrice: null,
    missingAmount: null,
  });

  // Modal de edição de pedido (CardapioPopup)
  const [editarPedidoModalOpen, setEditarPedidoModalOpen] = useState(false);
  const [pedidoEditando, setPedidoEditando] = useState(null);
  // Balcão de mercearia → "Entrega": chega aqui com o carrinho do Balcão e já
  // abre o Novo Pedido com ele (features/balcao-entrega, 29/09/2026).
  useEffect(() => {
    if (temPassagem()) { setPedidoEditando(null); setEditarPedidoModalOpen(true); }
  }, []);

  // Tela Novo Pedido Delivery (igual Mesas/Cardápio: combos, etapas, categorias, fotos; nome do cliente em destaque)
  const [deliveryVendasOpen, setDeliveryVendasOpen] = useState(false);
  const [deliveryVendasLoading, setDeliveryVendasLoading] = useState(false);
  const [dvProducts, setDvProducts] = useState([]);
  const [dvAllProducts, setDvAllProducts] = useState([]);
  const [dvCategories, setDvCategories] = useState([]);
  const [dvSelectedCategory, setDvSelectedCategory] = useState("all");
  const [dvCart, setDvCart] = useState([]);
  const [dvClienteNome, setDvClienteNome] = useState("");
  const [dvClienteTelefone, setDvClienteTelefone] = useState("");
  const [dvTipoEntrega, setDvTipoEntrega] = useState("delivery");
  const [dvEndereco, setDvEndereco] = useState({ rua: "", numero: "", bairro: "", complemento: "" });
  const [dvBairros, setDvBairros] = useState([]);
  const [dvTaxaEntrega, setDvTaxaEntrega] = useState(0);
  const [dvEntregaPopupOpen, setDvEntregaPopupOpen] = useState(false);
  const [dvSelectedProduct, setDvSelectedProduct] = useState(null);
  const [dvProductPopupOpen, setDvProductPopupOpen] = useState(false);
  const [dvActivePromotions, setDvActivePromotions] = useState([]);
  const [dvProductSearchTerm, setDvProductSearchTerm] = useState("");
  const [dvShowMobileCart, setDvShowMobileCart] = useState(false);
  const [dvClientes, setDvClientes] = useState([]);
  const [dvSelectedClienteId, setDvSelectedClienteId] = useState(null);
  // Campanha Inteligente: ofertas do cliente escolhido aplicadas nas linhas do carrinho.
  const dvOfertasCliente = useOfertasNoCarrinho({ clienteId: dvSelectedClienteId, modulo: "Delivery", cart: dvCart, setCart: setDvCart });
  // Promoção exclusiva de tipos de cliente (27/10/2026): escolhido (ou tirado) o
  // cliente, as promoções voltam com as do tipo dele (ou sem as exclusivas)
  const dvPromosDoCliente = useRef(false);
  useEffect(() => {
    if (!dvPromosDoCliente.current) { dvPromosDoCliente.current = true; return; }
    const doCliente = dvSelectedClienteId ? `&cliente_id=${encodeURIComponent(dvSelectedClienteId)}` : "";
    axios.get(`${API}/promotions/active?module=Delivery${doCliente}`)
      .then((r) => { if (Array.isArray(r.data)) setDvActivePromotions(r.data); }).catch(() => {});
  }, [dvSelectedClienteId]);
  const [dvShowClienteDropdown, setDvShowClienteDropdown] = useState(false);
  const [dvPaymentMethods, setDvPaymentMethods] = useState([]);
  const [dvPaymentDialogOpen, setDvPaymentDialogOpen] = useState(false);
  const [dvFormaPagamento, setDvFormaPagamento] = useState("");
  const [dvShowChangeDialog, setDvShowChangeDialog] = useState(false);
  const [dvNeedsChange, setDvNeedsChange] = useState(null);
  const [dvChangeAmount, setDvChangeAmount] = useState("");
  const [dvJaPago, setDvJaPago] = useState(false);
  const [dvClienteHistorico, setDvClienteHistorico] = useState([]);
  const [dvClienteHistoricoLoading, setDvClienteHistoricoLoading] = useState(false);
  const [dvEnderecosCliente, setDvEnderecosCliente] = useState([]);
  const [dvEnderecosLoading, setDvEnderecosLoading] = useState(false);
  const [dvEnderecoSelecionadoId, setDvEnderecoSelecionadoId] = useState(null);
  const [dvShowNewAddressForm, setDvShowNewAddressForm] = useState(false);
  const [dvNewAddress, setDvNewAddress] = useState({ label: "Casa", endereco: "", numero: "", complemento: "", bairro: "", cep: "" });
  const [dvSavingAddress, setDvSavingAddress] = useState(false);
  const [dvShowCadastrarCliente, setDvShowCadastrarCliente] = useState(false);
  const [dvShowCadastrarForm, setDvShowCadastrarForm] = useState(false);
  const [dvNovoClienteNome, setDvNovoClienteNome] = useState("");
  const [dvNovoClienteTelefone, setDvNovoClienteTelefone] = useState("");
  const [dvNovoClienteCpf, setDvNovoClienteCpf] = useState("");
  const [dvNovoClienteNascimento, setDvNovoClienteNascimento] = useState("");
  const [dvObservacao, setDvObservacao] = useState("");
  const [dvCadastrandoCliente, setDvCadastrandoCliente] = useState(false);
  const [dvSubmitting, setDvSubmitting] = useState(false);
  const [isDark, setIsDark] = useState(() => typeof localStorage !== "undefined" && localStorage.getItem("darkMode") === "true");

  useEffect(() => {
    const onTheme = () => setIsDark(document.documentElement.classList.contains("dark"));
    window.addEventListener("themeChange", onTheme);
    return () => window.removeEventListener("themeChange", onTheme);
  }, []);

  // Carregar formas de pagamento do módulo Delivery
  useEffect(() => {
    axios.get(`${API}/payment-methods/module/delivery`, getAuthHeader())
      .then(res => {
        const pms = Array.isArray(res.data) ? res.data : [];
        const iconMap = { dinheiro: Banknote, pix: Banknote, pix_online: Banknote, cartao_online: CreditCard, credito: CreditCard, debito: CreditCard, cartao: CreditCard, cartao_credito: CreditCard, cartao_debito: CreditCard };
        const colorMap = { dinheiro: "bg-green-500", pix: "bg-teal-500", pix_online: "bg-teal-500", cartao_online: "bg-blue-500", credito: "bg-blue-500", debito: "bg-purple-500", cartao: "bg-blue-500" };
        setPaymentMethodsDelivery(pms.map(pm => ({
          id: pm.code || pm.id,
          code: pm.code,
          label: pm.name || pm.code,
          icon: iconMap[(pm.code || "").toLowerCase()] || CreditCard,
          color: colorMap[(pm.code || "").toLowerCase()] || "bg-gray-500"
        })));
      })
      .catch(() => {
        setPaymentMethodsDelivery([
          { id: "dinheiro", code: "dinheiro", label: "Dinheiro", icon: Banknote, color: "bg-green-500" },
          { id: "pix", code: "pix", label: "PIX", icon: Banknote, color: "bg-teal-500" },
          { id: "credito", code: "credito", label: "Crédito", icon: CreditCard, color: "bg-blue-500" },
          { id: "debito", code: "debito", label: "Débito", icon: CreditCard, color: "bg-purple-500" },
        ]);
      });
  }, []);

  // Carregar dados ao abrir tela Novo Pedido Delivery
  useEffect(() => {
    if (!deliveryVendasOpen) return;
    setDeliveryVendasLoading(true);
    setDvCart([]);
    setDvClienteNome("");
    setDvClienteTelefone("");
    setDvSelectedClienteId(null);
    setDvTipoEntrega("delivery");
    setDvEndereco({ rua: "", numero: "", bairro: "", complemento: "" });
    setDvTaxaEntrega(0);
    setDvEntregaPopupOpen(false);
    setDvSelectedCategory("all");
    setDvProductSearchTerm("");
    setDvFormaPagamento("");
    setDvShowChangeDialog(false);
    setDvNeedsChange(null);
    setDvChangeAmount("");
    setDvJaPago(false);
    setDvClienteHistorico([]);
    setDvClienteHistoricoLoading(false);
    setDvEnderecosCliente([]);
    setDvEnderecosLoading(false);
    setDvEnderecoSelecionadoId(null);
    setDvShowNewAddressForm(false);
    setDvNewAddress({ label: "Casa", endereco: "", numero: "", complemento: "", bairro: "", cep: "" });
    setDvShowCadastrarCliente(false);
    setDvShowCadastrarForm(false);
    setDvNovoClienteNome("");
    setDvNovoClienteTelefone("");
    setDvObservacao("");
    Promise.all([
      axios.get(`${API}/products/for-sale?module=Delivery`, getAuthHeader()),
      axios.get(`${API}/categories`, getAuthHeader()),
      axios.get(`${API}/products`, getAuthHeader()),
      axios.get(`${API}/bairros`, getAuthHeader()),
      axios.get(`${API}/clientes`, getAuthHeader()),
      axios.get(`${API}/payment-methods/module/delivery`, getAuthHeader()).catch(() => ({ data: [] })),
      axios.get(`${API}/promotions/active?module=Delivery`).catch(() => ({ data: [] })),
    ]).then(([pRes, cRes, aRes, bRes, clRes, pmRes, promoRes]) => {
      setDvProducts(Array.isArray(pRes?.data) ? pRes.data : []);
      setDvCategories(Array.isArray(cRes?.data) ? cRes.data : []);
      setDvAllProducts(Array.isArray(aRes?.data) ? aRes.data : []);
      setDvBairros(Array.isArray(bRes?.data) ? bRes.data : []);
      setDvClientes(Array.isArray(clRes?.data) ? clRes.data : []);
      setDvActivePromotions(Array.isArray(promoRes?.data) ? promoRes.data : []);
      const pms = Array.isArray(pmRes?.data) ? pmRes.data : [];
      const iconMap = { dinheiro: Banknote, pix: Banknote, pix_online: Banknote, cartao_online: CreditCard, credito: CreditCard, debito: CreditCard, cartao: CreditCard };
      const colorMap = { dinheiro: "bg-green-500", pix: "bg-teal-500", pix_online: "bg-teal-500", cartao_online: "bg-blue-500", credito: "bg-blue-500", debito: "bg-purple-500", cartao: "bg-blue-500" };
      setDvPaymentMethods(pms.map((pm) => ({ id: pm.code || pm.id, code: pm.code, label: pm.name || pm.code, icon: iconMap[(pm.code || "").toLowerCase()] || CreditCard, color: colorMap[(pm.code || "").toLowerCase()] || "bg-gray-500" })));
    }).catch(() => toast.error("Erro ao carregar dados")).finally(() => setDeliveryVendasLoading(false));
  }, [deliveryVendasOpen]);

  // Carregar dados
  const fetchData = useCallback(async () => {
    try {
      const [pedidosRes, entregadoresRes, settingsRes] = await Promise.all([
        axios.get(`${API}/pedidos?for_screen=delivery`, getAuthHeader()),
        axios.get(`${API}/entregadores`, getAuthHeader()),
        axios.get(`${API}/settings`, getAuthHeader())
      ]);
      
      const novosPedidos = pedidosRes.data;

      // Verificar configuração de auto-aceite
      // Som de notificação SÓ pra pedido entrando em PRODUÇÃO (regra de
      // 21/07/2026): chegada em aguardando_aceite NÃO toca mais a notificação
      // — o loop de aguardando_aceite.mp3 (a cada 5s) é o único som até o
      // aceite. A notificação fica pra: pedido novo já em produção (auto-aceite
      // ON) e aceite manual (idsAceitosManual abaixo).
      const statusParaSom = 'producao';

      // Verificar se há novos pedidos no status relevante
      const pedidosStatusAtuais = novosPedidos.filter(p => p.status === statusParaSom);
      const pedidosStatusAnteriores = previousPedidosRef.current.filter(p => p.status === statusParaSom);

      // Encontrar IDs de pedidos novos que não existiam antes nesse status
      const idsAnteriores = new Set(pedidosStatusAnteriores.map(p => p.id));
      const novosPedidosParaSom = pedidosStatusAtuais.filter(p => !idsAnteriores.has(p.id));

      // Aceite manual: pedido que estava em "aguardando_aceite" agora em "producao".
      // Auto-aceite ja faz o pedido nascer em "producao" (nao passa por aguardando),
      // entao essa transicao so acontece em aceite manual — toca som de novo pedido.
      const previousById = new Map(previousPedidosRef.current.map(pp => [pp.id, pp]));
      const idsAceitosManual = novosPedidos.filter(p => {
        const prev = previousById.get(p.id);
        return p.status === 'producao' && prev && prev.status === 'aguardando_aceite';
      }).map(p => p.id);

      // Se houver novos pedidos OU pedidos aceitos manualmente: tocar o som (se aba ADMIN ativa)
      const tocarSom = (novosPedidosParaSom.length > 0 || idsAceitosManual.length > 0)
        && previousPedidosRef.current.length > 0;
      if (tocarSom) {
        try {
          const token = localStorage.getItem('token');
          if (token) {
            const activeCheck = await axios.get('/api/admin/active-sessions', {
              headers: { 'Authorization': `Bearer ${token}` }
            });
            if (activeCheck.data.has_active_sessions) {
              playNotificationSound();
              if (novosPedidosParaSom.length > 0) {
                logger.debug(`🔔 Novo(s) pedido(s) em ${statusParaSom}: ${novosPedidosParaSom.map(p => p.codigo).join(', ')}`);
              }
              if (idsAceitosManual.length > 0) {
                logger.debug(`🔔 Pedido(s) aceito(s) manualmente: ${idsAceitosManual.join(', ')}`);
              }
            } else {
              logger.debug(`🔇 Som suprimido — nenhuma aba ADMIN ativa`);
            }
          }
        } catch (error) {
          playNotificationSound();
        }
      }

      // Cancelamento externo (iFood) de pedido que JÁ estava aceito, pronto ou em
      // rota: som próprio. Cancelado ainda "aguardando aceite" não toca — só
      // ganha o carimbo, que some sozinho em 8 min.
      if (previousPedidosRef.current.length > 0) {
        const prevStatus = new Map(previousPedidosRef.current.map(pp => [pp.id, pp.status]));
        const canceladosGraves = novosPedidos.filter(p =>
          p.status === 'cancelado'
          && !p.cancel_acknowledged_at
          && (p.modulo || '').toLowerCase() === 'ifood'
          && prevStatus.get(p.id) !== 'cancelado'
          && (p.ts_producao || p.ts_pronto || p.ts_em_rota)
        );
        if (canceladosGraves.length > 0) {
          playCancelSound();
          logger.debug(`🔴 Cancelado(s) pelo iFood após o aceite: ${canceladosGraves.map(p => p.codigo).join(', ')}`);
        }
      }

      // Impressão automática: para novos pedidos EM PRODUÇÃO — nunca em
      // aguardando_aceite (regra de 21/07/2026, regra do dono: cupom só sai depois do
      // aceite; a transição de status no backend imprime no aceite manual).
      // NOTA: Pedidos PIX Online NÃO devem ser impressos até serem pagos
      const statusParaImprimir = 'producao';
      const pedidosParaImprimirAtuais = novosPedidos.filter(p => p.status === statusParaImprimir);
      const pedidosParaImprimirAnteriores = previousPedidosRef.current.filter(p => p.status === statusParaImprimir);
      const idsAnterioresImprimir = new Set(pedidosParaImprimirAnteriores.map(p => p.id));
      const novosPedidosParaImprimir = pedidosParaImprimirAtuais.filter(p => !idsAnterioresImprimir.has(p.id));

      if (novosPedidosParaImprimir.length > 0 && previousPedidosRef.current.length > 0) {
        // Impressão automática: Cupom de Entrega + Cupom de Preparo para cada novo pedido
        // EXCETO: Pedidos com pagamento online que ainda não foram pagos (payment_status != 'paid')
        // Módulos onde o BACKEND já cuida da impressão — frontend NÃO imprime para evitar duplicação.
        // 'delivery' continua aqui: o backend NAO imprime (frontend_modules em
        // create_hooks.py) e o guard print_status abaixo evita duplicar quando o
        // pedido ja foi impresso via handleCreatePedido ou handleAceitar.
        // 'mesaqr': a rodada do Mesa QR é impressa pelo servidor (só o preparo) —
        // sem isto, vista antes do print_status, saía aqui com cupom de caixa.
        // 'mesas', 'balcao', 'totem' (dono, 26/09/2026): a PRÓPRIA tela imprime —
        // Mesas o preparo no ENVIAR e o fechamento ao fechar; Balcão/Totem o cupom e
        // o preparo na venda (PIX online: o servidor, no pagamento). Com o Delivery
        // aberto no caixa, o pedido visto "em produção" saía de novo aqui com cupom
        // completo + preparo (Point: 9 mesas num dia; Balcão #99731 saiu 3 vezes).
        const SKIP_PRINT_MODULES = ['cardapio', 'cardapiopublico', 'whatsapp', 'chatbot', 'ifood', 'mesaqr', 'mesas', 'balcao', 'balcão', 'totem'];

        for (const p of novosPedidosParaImprimir) {
          // Skip: módulos impressos pelo backend (evitar duplicação)
          const modulo = (p.modulo || '').toLowerCase();
          if (SKIP_PRINT_MODULES.includes(modulo) || (p.tipo_entrega || '').toLowerCase() === 'mesa') {
            logger.debug(`Pedido ${p.codigo || p.id} módulo ${p.modulo} — impressão já tratada pelo backend, skipping`);
            continue;
          }

          // Skip: pedido ja tem cupom impresso (via handleCreatePedido, handleAceitar,
          // ou tentativa anterior deste mesmo loop) — evita duplicacao.
          if (p.print_status === 'success' || p.print_status === 'pending') {
            logger.debug(`Pedido ${p.codigo || p.id} print_status=${p.print_status} — ja impresso, skipping`);
            continue;
          }

          // Verificar se é pagamento online aguardando pagamento - NÃO imprimir
          const isOnlinePending = (p.forma_pagamento === 'pix_online' || p.forma_pagamento === 'cartao_online') && p.payment_status !== 'paid';
          if (isOnlinePending) {
            logger.debug(`Pedido ${p.codigo || p.id} é pagamento online aguardando - não imprimir ainda`);
            continue; // Pular impressão para pagamento online pendente
          }

          (async () => {
            try {
              const [r1, r2] = await Promise.all([imprimirCupom(p, { automatico: true }), imprimirCupomPreparo(p)]);
              const printSuccess = r1?.success && r2?.success;
              const printStatus = printSuccess ? 'success' : 'failed';
              await axios.patch(`${API}/pedidos/${p.id}/print-status`, { print_status: printStatus }, getAuthHeader()).catch(() => {});
              if (!printSuccess) {
                toast.error('Falha ao imprimir pedido #' + (p.codigo || p.id) + ' - verifique a impressora!');
              }
            } catch (e) {
              logger.debug('Erro ao imprimir automaticamente:', e);
              toast.error('Erro ao imprimir pedido ' + (p.codigo || p.id) + ': ' + (e?.message || ''));
              await axios.patch(`${API}/pedidos/${p.id}/print-status`, { print_status: 'failed' }, getAuthHeader()).catch(() => {});
            }
          })();
        }
      }

      // Notificação de pedidos com pagamento online confirmado (impressão pelo backend PIX Monitor)
      const pedidosOnlinePagos = novosPedidos.filter(p => {
        if ((p.forma_pagamento !== 'pix_online' && p.forma_pagamento !== 'cartao_online') || p.payment_status !== 'paid') return false;
        const anterior = previousPedidosRef.current.find(ant => ant.id === p.id);
        return anterior && anterior.payment_status === 'pending';
      });
      for (const p of pedidosOnlinePagos) {
        const tipoLabel = p.forma_pagamento === 'cartao_online' ? 'Cartão' : 'PIX';
        toast.success(`Pedido #${p.codigo || p.id} - ${tipoLabel} confirmado!`);
      }

      // Atualizar referência de pedidos anteriores
      previousPedidosRef.current = novosPedidos;

      // Detectar mudanças de status para animação de transição entre colunas
      const changedIds = new Set();
      novosPedidos.forEach(p => {
        const prevStatus = prevStatusMapRef.current[p.id];
        if (prevStatus !== undefined && prevStatus !== p.status) {
          changedIds.add(p.id);
        }
      });

      // Atualizar mapa de status anteriores
      const newStatusMap = {};
      novosPedidos.forEach(p => {
        newStatusMap[p.id] = p.status;
      });
      prevStatusMapRef.current = newStatusMap;

      // Se houver transições, atualizar estado e limpar após animação
      if (changedIds.size > 0) {
        setTransitionedIds(changedIds);
        setTimeout(() => setTransitionedIds(new Set()), 500);
      }

      setPedidos(novosPedidos);
      setEntregadores(entregadoresRes.data);
      // delivery_auto_accept vem como string "true"/"false" do /api/settings; converter para boolean
      setAutoAccept(settingsRes.data.delivery_auto_accept === "true" || settingsRes.data.delivery_auto_accept === true);
      
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
    } finally {
      setLoading(false);
    }
  }, [playNotificationSound, playCancelSound]);

  useEffect(() => {
    fetchData();
    
    // Auto-refresh a cada 5 segundos para atualização mais rápida dos cards
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, [fetchData]);

  // Processar aceite automático
  useEffect(() => {
    if (autoAccept && !autoAcceptProcessing.current) {
      const pedidosAguardando = pedidos.filter(p =>
        p.status === 'aguardando_aceite' && isPedidoParaDelivery(p)
      );
      
      if (pedidosAguardando.length > 0) {
        autoAcceptProcessing.current = true;
        
        Promise.all(
          pedidosAguardando.map(pedido =>
            axios.patch(`${API}/pedidos/${pedido.id}/status?status=producao`, {}, getAuthHeader())
          )
        ).then(() => {
          fetchData();
        }).catch(error => {
          console.error("Erro no aceite automático:", error);
        }).finally(() => {
          autoAcceptProcessing.current = false;
        });
      }
    }
  }, [pedidos, autoAccept, fetchData]);

  // Loop sonoro de "aguardando aceite": ativo quando ha pedido nesse status
  // E auto-aceite OFF E som ligado. Para automaticamente quando alguma condicao
  // deixa de ser verdadeira (todos pedidos aceitos/cancelados, toggle ligado, etc).
  // OBS: sem cleanup que para no unmount do efeito — startPendingAcceptLoop eh
  // idempotente, e o stop ocorre no else. Cleanup no unmount real do componente
  // fica no useEffect separado abaixo.
  useEffect(() => {
    const hasPending = pedidos.some(p =>
      p.status === 'aguardando_aceite' && isPedidoParaDelivery(p)
    );
    // Pedidos AGENDADOS também precisam de aprovação manual do lojista —
    // mesmo som pra sinalizar "chegou algo que precisa da sua atenção".
    // Independe do auto-aceite (agendado é sempre manual, por definição).
    const hasScheduled = pedidos.some(p =>
      p.status === 'agendado' && isPedidoParaDelivery(p)
    );
    const shouldLoop = ((hasPending && !autoAccept) || hasScheduled) && soundEnabled;
    if (shouldLoop) {
      startPendingAcceptLoop();
    } else {
      stopPendingAcceptLoop();
    }
  }, [pedidos, autoAccept, soundEnabled, startPendingAcceptLoop, stopPendingAcceptLoop]);

  // Para o loop quando o componente eh desmontado (sair da pagina, logout, etc)
  useEffect(() => {
    return () => stopPendingAcceptLoop();
  }, [stopPendingAcceptLoop]);

  // Toggle aceite automático
  // Marcar modificação como vista (dismiss badge "ALTERADO")
  const handleMarkModificationSeen = async (pedido) => {
    try {
      await axios.patch(`${API}/pedidos/${pedido.id}/modification-seen`, {}, getAuthHeader());
      toast.success(`Alteração do pedido #${pedido.codigo} marcada como vista`);
      fetchData();
    } catch (err) {
      toast.error("Erro ao marcar modificação como vista");
    }
  };

  // Hook: detecta pedido com modificação não-vista e abre o popup automaticamente.
  // Polling normal (10s) atualiza `pedidos` — sempre que a lista renovar, vê se
  // tem alguém com has_modification && !modification_seen que ainda não foi
  // mostrado nesta sessão (cache local em modDismissedIdsRef pra não reabrir
  // popup do mesmo pedido sem o lojista ter feito nada).
  useEffect(() => {
    if (modPopupPedido) return; // já tem popup aberto, espera fechar
    if (!Array.isArray(pedidos) || pedidos.length === 0) return;
    const pendente = pedidos.find(
      (p) =>
        p?.has_modification &&
        !p?.modification_seen &&
        p?.last_modification &&
        !modDismissedIdsRef.current.has(`${p.id}_${p.last_modification.created_at}`)
    );
    if (pendente) {
      setModPopupPedido(pendente);
    }
  }, [pedidos, modPopupPedido]);

  // Fechar popup: marca como visto no backend + cache local (evita reabrir)
  // e dispara fetchData pra atualizar o badge ALTERADO no card.
  const closeModPopup = async () => {
    const pedido = modPopupPedido;
    setModPopupPedido(null);
    if (pedido?.id && pedido?.last_modification?.created_at) {
      modDismissedIdsRef.current.add(`${pedido.id}_${pedido.last_modification.created_at}`);
    }
    if (pedido?.id) {
      try {
        await axios.patch(`${API}/pedidos/${pedido.id}/modification-seen`, {}, getAuthHeader());
        fetchData();
      } catch (err) {
        // não-bloqueante: popup já fechou, badge volta no próximo polling se patch falhar
      }
    }
  };

  const handleToggleAutoAccept = async () => {
    try {
      const newValue = !autoAccept;
      await axios.put(`${API}/system/settings`, {
        delivery_auto_accept: newValue
      }, getAuthHeader());
      setAutoAccept(newValue);
      toast.success(newValue ? "Aceite automático ativado" : "Aceite automático desativado");
    } catch (error) {
      console.error("Erro:", error);
      toast.error("Erro ao alterar configuração");
    }
  };

  // Modal de "Pedidos Agendados" — lista pedidos com status='agendado' pra
  // o lojista aprovar 1 a 1. Aprovar chama POST /pedidos/{id}/aprovar-agendado
  // → backend transiciona 'agendado' → 'producao', dispara impressão.
  const [showAgendadosModal, setShowAgendadosModal] = useState(false);
  const [aprovandoAgendadoId, setAprovandoAgendadoId] = useState(null);
  // v1.5.362+ MVP Agendamentos: recusa + decisão de cancelamento
  const [rejeitandoAgendadoId, setRejeitandoAgendadoId] = useState(null);
  const [decidindoCancelId, setDecidindoCancelId] = useState(null);
  // { pedidoId, mode: 'recusar' | 'negar_cancel', title, placeholder }
  const [motivoDialog, setMotivoDialog] = useState(null);
  const [motivoText, setMotivoText] = useState('');

  const handleAprovarAgendado = async (pedidoId, e) => {
    if (e) e.stopPropagation();
    if (!pedidoId) return;
    setAprovandoAgendadoId(pedidoId);
    try {
      await axios.post(
        `${API}/pedidos/${pedidoId}/aprovar-agendado`,
        {},
        getAuthHeader(),
      );
      toast.success("Pedido agendado aprovado — foi pra Produção!");
      fetchData();
    } catch (error) {
      const detail = error?.response?.data?.detail || "Erro ao aprovar pedido agendado";
      toast.error(detail);
    } finally {
      setAprovandoAgendadoId(null);
    }
  };

  // Abre dialog pra digitar motivo. `mode` decide qual endpoint chamar no confirm.
  const openMotivoDialog = (pedidoId, mode) => {
    const dialogs = {
      recusar: { title: 'Recusar pedido agendado', placeholder: 'Ex.: horário indisponível pra esse dia (opcional)' },
      negar_cancel: { title: 'Negar pedido de cancelamento', placeholder: 'Ex.: pedido já preparado (opcional)' },
    };
    setMotivoText('');
    setMotivoDialog({ pedidoId, mode, ...dialogs[mode] });
  };

  const confirmMotivoDialog = async () => {
    if (!motivoDialog) return;
    const { pedidoId, mode } = motivoDialog;
    const motivo = (motivoText || '').trim();
    setMotivoDialog(null);
    if (mode === 'recusar') {
      setRejeitandoAgendadoId(pedidoId);
      try {
        await axios.post(`${API}/pedidos/${pedidoId}/recusar-agendado`, { motivo }, getAuthHeader());
        toast.success("Pedido agendado recusado — cliente foi avisado por WhatsApp.");
        fetchData();
      } catch (error) {
        toast.error(error?.response?.data?.detail || "Erro ao recusar pedido agendado");
      } finally {
        setRejeitandoAgendadoId(null);
      }
    } else if (mode === 'negar_cancel') {
      setDecidindoCancelId(pedidoId);
      try {
        await axios.post(`${API}/pedidos/${pedidoId}/decidir-cancelamento`, { aceitar: false, motivo }, getAuthHeader());
        toast.success("Cancelamento negado — cliente foi avisado por WhatsApp. Pedido segue no fluxo.");
        fetchData();
      } catch (error) {
        toast.error(error?.response?.data?.detail || "Erro ao negar cancelamento");
      } finally {
        setDecidindoCancelId(null);
      }
    }
  };

  const handleAceitarCancelamento = async (pedidoId) => {
    if (!pedidoId) return;
    setDecidindoCancelId(pedidoId);
    try {
      await axios.post(`${API}/pedidos/${pedidoId}/decidir-cancelamento`, { aceitar: true }, getAuthHeader());
      toast.success("Cancelamento aprovado — cliente foi avisado por WhatsApp.");
      fetchData();
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Erro ao aceitar cancelamento");
    } finally {
      setDecidindoCancelId(null);
    }
  };

  // Formata scheduled_at ("2026-07-05T19:00:00") como janela +30min
  // ("Hoje · 20:00–20:30"), consistente com admin Pedidos/Meus Pedidos/cardápio.
  const fmtScheduledAt = (iso) => {
    if (!iso) return "";
    try {
      const [d, hm] = String(iso).split("T");
      const [y, mo, da] = d.split("-").map((n) => parseInt(n, 10));
      const [hh, mm] = (hm || "00:00").split(":");
      const dt = new Date(y, mo - 1, da);
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const diff = Math.round((dt - today) / (1000 * 60 * 60 * 24));
      let dayLbl;
      if (diff === 0) dayLbl = "Hoje";
      else if (diff === 1) dayLbl = "Amanhã";
      else {
        const wd = dt.toLocaleDateString("pt-BR", { weekday: "short" }).replace(/\.$/, "");
        dayLbl = `${wd.charAt(0).toUpperCase() + wd.slice(1)} ${da}`;
      }
      const startMin = parseInt(hh, 10) * 60 + parseInt(mm, 10);
      const endMin = startMin + 30;
      const eh = String(Math.floor(endMin / 60) % 24).padStart(2, "0");
      const em = String(endMin % 60).padStart(2, "0");
      return `${dayLbl} · ${hh}:${mm}–${eh}:${em}`;
    } catch { return iso; }
  };

  // "Hoje às 11:59" — quando o cliente FEZ o pedido (modal de agendados, v1.5.377)
  const fmtCriadoEm = (iso) => {
    if (!iso) return "";
    try {
      const [d, hm] = String(iso).split("T");
      const [y, mo, da] = d.split("-").map((n) => parseInt(n, 10));
      const dt = new Date(y, mo - 1, da);
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const diff = Math.round((dt - today) / (1000 * 60 * 60 * 24));
      const dayLbl = diff === 0 ? "Hoje" : diff === -1 ? "Ontem"
        : dt.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
      return `${dayLbl} às ${(hm || "").slice(0, 5)}`;
    } catch { return iso; }
  };

  // Label amigável ("cartao_<uuid>" → "Cartão") — usado no card E no modal.
  const fmtFormaPagamentoLabel = (code) => {
    if (!code) return "Não definida";
    const base = _formaBase(code);
    const map = {
      dinheiro: "Dinheiro", pix: "PIX", pix_online: "PIX Online",
      cartao_online: "Cartão Online", cartao: "Cartão", credito: "Crédito",
      debito: "Débito", cartao_credito: "Crédito", cartao_debito: "Débito",
      vale_alimentacao: "Vale Alimentação", vale_refeicao: "Vale Refeição",
      multiplo: "Múltiplo",
    };
    return map[base] || base.charAt(0).toUpperCase() + base.slice(1).replace(/_/g, " ");
  };

  // "De/Para" da alteração feita pelo cliente: forma de pagamento sai pelo nome,
  // nunca pelo código "dinheiro_<loja>" (pedido do dono, 30/09/2026).
  const valorDaAlteracao = (mod, lado) => {
    const v = mod?.[lado];
    if (!v) return "—";
    const campo = String(mod?.field || mod?.field_changed || mod?.type || "").toLowerCase();
    return campo.includes("pagamento") || /_[0-9a-f]{8}-[0-9a-f]{4}-/i.test(String(v)) ? fmtFormaPagamentoLabel(v) : v;
  };

  // Versão com extras (troco/pago) pro modal de agendados.
  const fmtPagamentoAgendado = (pedido) => {
    const code = pedido?.forma_pagamento;
    if (!code) return "Não definida";
    const base = _formaBase(code);
    let label = fmtFormaPagamentoLabel(code);
    if (base === "dinheiro" && Number(pedido.troco_valor) > 0) {
      label += ` · troco pra R$ ${Number(pedido.troco_valor).toFixed(2).replace(".", ",")}`;
    }
    if ((base === "pix_online" || base === "cartao_online") && pedido.payment_status === "paid") {
      label += " · PAGO ✓";
    }
    return label;
  };

  // Aceitar pedido
  const handleAceitar = async (pedidoId, e) => {
    if (e) e.stopPropagation();
    try {
      await axios.patch(`${API}/pedidos/${pedidoId}/status?status=producao`, {}, getAuthHeader());
      toast.success("Pedido aceito!");
      // Impressão AO ACEITAR agora é 100% do BACKEND (regra de 21/07/2026): o PATCH acima
      // dispara _handle_print_on_producao na transição aguardando_aceite →
      // producao, pra qualquer módulo, com idempotência via print_status.
      // Imprimir aqui de novo causava cupom duplicado (caso UAI PIZZA).
      fetchData();
    } catch (error) {
      toast.error("Erro ao aceitar pedido");
    }
  };

  // Marcar como pronto
  // Marcar como pronto SEM chamar UP Entrega (pedido vai pra coluna Pronto)
  const handleMarcarPronto = async (pedidoId, e) => {
    if (e) e.stopPropagation();
    try {
      await axios.patch(`${API}/pedidos/${pedidoId}/status?status=pronto`, {}, getAuthHeader());
      toast.success("Pedido marcado como pronto!");
      fetchData();
    } catch (error) {
      toast.error("Erro ao marcar pedido como pronto");
    }
  };

  // Chamar entregador direto da Producao: marca pronto + chama UP Entrega
  const handleChamarEntregadorFromProducao = async (pedidoId, e) => {
    if (e) e.stopPropagation();
    try {
      await axios.patch(`${API}/pedidos/${pedidoId}/status?status=pronto`, {}, getAuthHeader());
      await handleChamarEntregador(pedidoId);
    } catch (error) {
      toast.error("Erro ao marcar pedido como pronto");
    }
  };

  // Chamar entregador UP Entrega (chamado da coluna Pronto)
  const handleChamarEntregador = async (pedidoId, e) => {
    if (e) e.stopPropagation();
    const pedido = pedidos.find(p => p.id === pedidoId);
    if (!pedido) return;
    try {
      // Mandamos apenas forma_pagamento (code) e payment_status — o backend
      // resolve o payment_method e return_to_establishment a partir da config
      // de FINANCEIRO → FORMA DE PAGAMENTO.
      const orderData = {
        external_id: String(pedido.id),
        client: { name: pedido.cliente_nome || 'Cliente', phone: pedido.cliente_telefone || '' },
        address: {
          street: pedido.endereco_rua || '', number: pedido.endereco_numero || '',
          complement: pedido.endereco_complemento || '', neighborhood: pedido.endereco_bairro || '',
          city: pedido.endereco_cidade || '', state: pedido.endereco_estado || '',
          reference: pedido.endereco_referencia || '',
        },
        order: { code: pedido.codigo || String(pedido.id).slice(0, 8), value: pedido.total || 0 },
        forma_pagamento: pedido.forma_pagamento || '',
        payment_status: pedido.payment_status || '',
      };
      await axios.post(`${API}/entregaai/orders`, orderData, getAuthHeader());
      toast.success("Entregador solicitado via UP Entrega!");
      try {
        const balanceRes = await axios.get(`${API}/entregaai/wallet/balance`, getAuthHeader());
        const data = balanceRes.data?.data || balanceRes.data;
        setEntregaAiBalance(data?.balance ?? data?.amount ?? null);
      } catch (_) {}
      fetchData();
    } catch (entregaError) {
      const detail = entregaError.response?.data?.detail;
      const code = typeof detail === 'object' ? detail?.code : null;
      const msg = typeof detail === 'object' ? detail?.message : (detail || "Erro ao solicitar entregador");
      if (code === 'insufficient_balance') {
        const cur = typeof detail === 'object' ? detail?.current_balance : null;
        const need = typeof detail === 'object' ? detail?.delivery_price : null;
        const miss = typeof detail === 'object' ? detail?.missing_amount : null;
        if (cur != null) setEntregaAiBalance(cur);
        setSaldoInsuficienteModal({
          open: true,
          currentBalance: cur,
          deliveryPrice: need,
          missingAmount: miss,
        });
      } else if (code === 'invalid_address') {
        toast.error("Endereço rejeitado pela UP Entrega", {
          description: msg,
          duration: 8000,
        });
      } else if (code === 'unauthorized') {
        toast.error("Credenciais da UP Entrega inválidas", {
          description: "Verifique a API Key nas configurações da integração.",
          duration: 8000,
        });
      } else {
        toast.error(`Falha no UP Entrega: ${msg}`);
      }
      // Atualiza polling para o badge de erro aparecer no card
      try {
        const prontoIds = pedidos.filter(p => p.status === 'pronto' && p.tipo_entrega !== 'pickup').map(p => p.id);
        if (prontoIds.length > 0) {
          const res = await axios.get(`${API}/entregaai/orders-status?pedido_ids=${prontoIds.join(',')}`, getAuthHeader());
          setEntregaAiOrdersStatus(res.data || {});
        }
      } catch (_) {}
    }
  };

  // Voltar etapa do pedido
  const handleVoltarEtapa = async (pedido, e) => {
    if (e) e.stopPropagation();
    
    // Definir mapeamento de etapa anterior
    // (etapa na_bag foi descontinuada — em_rota volta direto pra pronto)
    const etapaAnterior = {
      // aguardando_aceite: não pode voltar (não mostrar botão)
      // producao: não pode voltar (não mostrar botão)
      'pronto': 'producao',
      'na_bag': 'pronto', // compat com pedidos legados que ainda estejam em na_bag
      'em_rota': 'pronto',
      'concluido': 'em_rota'
    };
    
    const novaEtapa = etapaAnterior[pedido.status];
    if (!novaEtapa) {
      toast.error("Não é possível voltar desta etapa");
      return;
    }
    
    // ATUALIZAÇÃO OTIMISTA: UI muda imediatamente; rollback se der erro.
    const statusAnterior = pedido.status;
    setPedidos(prev => prev.map(p => p.id === pedido.id ? { ...p, status: novaEtapa } : p));
    if (pedidoDetalhes && pedidoDetalhes.id === pedido.id) {
      setPedidoDetalhes({ ...pedidoDetalhes, status: novaEtapa });
    }
    toast.success(`Pedido voltou para: ${statusConfig[novaEtapa]?.label}`);

    // O aviso "Correção, voltamos para a etapa" sai pelo servidor na troca de
    // status (texto editável em ChatBot → Configurações, com as travas de
    // envio). Antes era montado aqui e mandado por /whatsapp/send, fora das
    // travas (achado 366).

    try {
      await axios.patch(`${API}/pedidos/${pedido.id}/status?status=${novaEtapa}`, {}, getAuthHeader());
    } catch (error) {
      // Rollback da atualização otimista
      setPedidos(prev => prev.map(p => p.id === pedido.id ? { ...p, status: statusAnterior } : p));
      if (pedidoDetalhes && pedidoDetalhes.id === pedido.id) {
        setPedidoDetalhes({ ...pedidoDetalhes, status: statusAnterior });
      }
      toast.error("Erro ao voltar etapa do pedido");
      console.error(error);
    }
  };
  
  // Verificar se pedido pode voltar etapa.
  // Aceita string (status apenas — comportamento legado) ou objeto { status, entregaAiStatus, entregador_id }
  // Quando o pedido está em 'em_rota' E tem entregador real atribuído E a Entrega-AI
  // não está em estado 'failed', NÃO permite voltar — a corrida já saiu, voltar agora
  // bagunça (motorista a caminho não vai cancelar magicamente).
  const podeVoltarEtapa = (statusOrPedido, entregaAiStatusObj) => {
    const status = typeof statusOrPedido === 'string' ? statusOrPedido : statusOrPedido?.status;
    if (['aguardando_aceite', 'producao', 'cancelado'].includes(status)) return false;

    // Pedido em rota: só permite voltar se houve falha no UP OU se não tem entregador
    if (status === 'em_rota') {
      const ped = typeof statusOrPedido === 'object' ? statusOrPedido : null;
      const aiStatus = entregaAiStatusObj || ped?.entregaAiStatus || {};
      const aiFailed = (aiStatus.entregaai_status || '').toLowerCase() === 'failed';
      const semEntregador = !ped?.entregador_id;
      return aiFailed || semEntregador;
    }
    return true;
  };

  // Mudar status do pedido para qualquer status válido
  const handleMudarStatus = async (pedido, novoStatus) => {
    if (!pedido || !novoStatus || pedido.status === novoStatus) return;

    // iFood com código de entrega: pede o código do cliente antes de concluir.
    if (novoStatus === 'concluido' && !pedido._codigoEntregaOk && precisaCodigoEntregaIfood(pedido)) {
      setIfoodCodeDialog({ pedido, proceed: () => handleMudarStatus({ ...pedido, _codigoEntregaOk: true }, 'concluido') });
      return;
    }

    // Pedido de delivery indo pra em_rota/na_bag sem entregador: abrir modal de atribuição
    // em vez de chamar o endpoint direto. O backend bloqueia essa transição sem entregador.
    const precisaEntregador = (novoStatus === 'em_rota' || novoStatus === 'na_bag')
      && pedido.tipo_entrega === 'delivery'
      && !pedido.entregador_id;
    if (precisaEntregador) {
      setAtribuirEntregadorModal({ open: true, pedido, entregadorId: "" });
      return;
    }

    // ATUALIZAÇÃO OTIMISTA: UI muda imediatamente; rollback se der erro.
    // Toast de sucesso só vai DEPOIS do ack do backend — caso contrário um
    // toast verde "piscaria" antes do erro vermelho (ex: 409 sem caixa aberto),
    // confundindo o usuário sobre o que realmente aconteceu.
    const statusAnterior = pedido.status;
    setPedidos(prev => prev.map(p => p.id === pedido.id ? { ...p, status: novoStatus } : p));
    if (pedidoDetalhes && pedidoDetalhes.id === pedido.id) {
      setPedidoDetalhes({ ...pedidoDetalhes, status: novoStatus });
    }

    try {
      await axios.patch(`${API}/pedidos/${pedido.id}/status?status=${novoStatus}`, {}, getAuthHeader());
      toast.success(`Status alterado para: ${statusConfig[novoStatus]?.label || novoStatus}`);
    } catch (error) {
      // Rollback da atualização otimista
      setPedidos(prev => prev.map(p => p.id === pedido.id ? { ...p, status: statusAnterior } : p));
      if (pedidoDetalhes && pedidoDetalhes.id === pedido.id) {
        setPedidoDetalhes({ ...pedidoDetalhes, status: statusAnterior });
      }
      // Duração maior pro usuário ter tempo de ler mensagens explicativas
      // (ex: "abra o caixa primeiro", "atribua um entregador") sem o toast
      // sumir antes de ler.
      toast.error(
        error?.response?.data?.detail || "Erro ao alterar status do pedido",
        { duration: 6000 },
      );
      console.error(error);
    }
  };

  // Confirmar atribuição de entregador do modal (usado no fluxo pronto -> em_rota)
  const handleConfirmarAtribuirEntregador = async () => {
    const { pedido, entregadorId } = atribuirEntregadorModal;
    if (!pedido || !entregadorId) {
      toast.error("Selecione um entregador");
      return;
    }

    // ATUALIZAÇÃO OTIMISTA: fecha o modal, move pedido pra em_rota e notifica imediatamente.
    const statusAnterior = pedido.status;
    const entregadorInfo = entregadores.find(e => e.id === entregadorId);
    const entregadorNome = entregadorInfo?.nome || '';

    setAtribuirEntregadorModal({ open: false, pedido: null, entregadorId: "" });
    setPedidos(prev => prev.map(p =>
      p.id === pedido.id
        ? { ...p, status: 'em_rota', entregador_id: entregadorId, entregador_nome: entregadorNome }
        : p
    ));
    if (pedidoDetalhes && pedidoDetalhes.id === pedido.id) {
      setPedidoDetalhes({ ...pedidoDetalhes, status: 'em_rota', entregador_id: entregadorId, entregador_nome: entregadorNome });
    }
    toast.success("Pedido enviado pra entrega!");

    try {
      await axios.patch(
        `${API}/pedidos/${pedido.id}/entregador?entregador_id=${entregadorId}`,
        {},
        getAuthHeader()
      );
    } catch (error) {
      // Rollback
      setPedidos(prev => prev.map(p =>
        p.id === pedido.id
          ? { ...p, status: statusAnterior, entregador_id: pedido.entregador_id, entregador_nome: pedido.entregador_nome }
          : p
      ));
      if (pedidoDetalhes && pedidoDetalhes.id === pedido.id) {
        setPedidoDetalhes({ ...pedidoDetalhes, status: statusAnterior, entregador_id: pedido.entregador_id, entregador_nome: pedido.entregador_nome });
      }
      toast.error(error?.response?.data?.detail || "Erro ao atribuir entregador");
      console.error(error);
    }
  };

  // Obter próximo status válido
  const getProximoStatus = (status, isRetirada) => {
    if (isRetirada) {
      const fluxoRetirada = {
        'aguardando_aceite': 'producao',
        'producao': 'pronto',
        'pronto': 'concluido'
      };
      return fluxoRetirada[status];
    } else {
      // Fluxo simplificado: na_bag foi descontinuado, vai de pronto direto pra em_rota.
      // 'na_bag': 'em_rota' mantido só pra permitir avançar pedidos legados presos nesse status.
      const fluxoDelivery = {
        'aguardando_aceite': 'producao',
        'producao': 'pronto',
        'pronto': 'em_rota',
        'na_bag': 'em_rota',
        'em_rota': 'concluido'
      };
      return fluxoDelivery[status];
    }
  };

  // Obter status anterior válido
  // (etapa na_bag foi descontinuada — em_rota volta direto pra pronto)
  const getStatusAnterior = (status) => {
    const etapaAnterior = {
      'pronto': 'producao',
      'na_bag': 'pronto', // compat com pedidos legados em na_bag
      'em_rota': 'pronto',
      'concluido': 'em_rota'
    };
    return etapaAnterior[status];
  };

  // Abrir página do entregador
  const handleAbrirEntregador = (entregador) => {
    // Navegar para página de detalhes do entregador usando slug (URL amigável)
    // IMPORTANTE: Sempre usar slug se disponível, nunca ID UUID
    if (entregador.slug) {
      logger.debug("Navegando para entregador usando slug:", entregador.slug, "Nome:", entregador.nome);
      navigate(`/admin/entregador/${entregador.slug}`);
    } else {
      // Se não tem slug, tentar gerar um temporário ou usar ID como último recurso
      console.warn("Entregador sem slug, usando ID:", entregador.id, "Nome:", entregador.nome);
      navigate(`/admin/entregador/${entregador.id}`);
    }
  };

  // Criar novo entregador
  const handleCriarEntregador = async () => {
    if (!novoEntregadorNome.trim()) {
      toast.error("Digite o nome do entregador");
      return;
    }

    try {
      let foto_url = null;

      // Upload da foto se selecionada
      if (novoEntregadorFoto) {
        setUploadingFoto(true);
        const formData = new FormData();
        formData.append("file", novoEntregadorFoto);
        const uploadRes = await axios.post(`${API}/upload/entregador-photo`, formData, {
          ...getAuthHeader(),
          headers: { ...getAuthHeader().headers, "Content-Type": "multipart/form-data" }
        });
        foto_url = uploadRes.data.photo_url;
        setUploadingFoto(false);
      }

      await axios.post(`${API}/entregadores`, {
        nome: novoEntregadorNome,
        telefone: novoEntregadorTelefone,
        foto_url
      }, getAuthHeader());

      toast.success("Entregador cadastrado!");
      setCriarEntregadorModalOpen(false);
      setNovoEntregadorNome("");
      setNovoEntregadorTelefone("");
      setNovoEntregadorFoto(null);
      setNovoEntregadorFotoPreview(null);
      fetchData();
    } catch (error) {
      setUploadingFoto(false);
      toast.error("Erro ao cadastrar entregador");
    }
  };

  // Toggle seleção de pedido na coluna PRONTO (apenas delivery)
  const togglePedidoSelecionado = (pedidoId, e) => {
    if (e) e.stopPropagation();
    setPedidosSelecionados(prev => {
      if (prev.includes(pedidoId)) {
        return prev.filter(id => id !== pedidoId);
      } else {
        return [...prev, pedidoId];
      }
    });
  };

  // Selecionar/deselecionar todos os pedidos prontos (apenas delivery, não retirada)
  const toggleSelecionarTodos = () => {
    // Sem pedidos com UP Entrega em andamento (nao pode co-atribuir)
    const pedidosProntosDelivery = pedidosPronto.filter(p => {
      if (isRetirada(p)) return false;
      const s = entregaAiOrdersStatus[p.id];
      const hasAi = s && s.entregaai_status && s.entregaai_status !== 'none' && s.entregaai_status !== 'error';
      return !hasAi;
    });
    if (pedidosSelecionados.length === pedidosProntosDelivery.length) {
      setPedidosSelecionados([]);
    } else {
      setPedidosSelecionados(pedidosProntosDelivery.map(p => p.id));
    }
  };

  // Enviar pedidos selecionados para o entregador
  const handleEnviarPedidosEmLote = async () => {
    if (!entregadorProntoSelecionado) {
      toast.error("Selecione um entregador");
      return;
    }
    if (pedidosSelecionados.length === 0) {
      toast.error("Selecione pelo menos um pedido");
      return;
    }

    try {
      await Promise.all(pedidosSelecionados.map(pedidoId =>
        axios.patch(
          `${API}/pedidos/${pedidoId}/entregador?entregador_id=${entregadorProntoSelecionado}`,
          {},
          getAuthHeader()
        )
      ));
      
      toast.success(`${pedidosSelecionados.length} pedido(s) enviado(s) para a BAG!`);
      setPedidosSelecionados([]);
      fetchData();
    } catch (error) {
      toast.error("Erro ao enviar pedidos");
    }
  };

  // Verificar se é pedido de retirada
  const isRetirada = (pedido) => pedido.tipo_entrega === 'pickup';

  // iFood (Etapa 4): `ifood_meta` vem como objeto no PedidoResponse. "Código de
  // entrega" = o cliente recebeu um código no app do iFood e o entregador precisa
  // digitá-lo antes de marcar entregue (evento DELIVERY_DROP_CODE_REQUESTED).
  const ifoodMeta = (p) => (p && p.ifood_meta && typeof p.ifood_meta === 'object') ? p.ifood_meta : {};
  const isIfoodPedido = (p) => (p?.modulo || '').toLowerCase() === 'ifood';
  const precisaCodigoEntregaIfood = (p) => isIfoodPedido(p) && !!ifoodMeta(p).delivery_code_required && !ifoodMeta(p).delivery_code_verified_at;
  const [ifoodCodeDialog, setIfoodCodeDialog] = useState(null); // { pedido, proceed }
  const [ifoodPickupDialog, setIfoodPickupDialog] = useState(null); // pedido (entrega iFood com código de coleta)

  // Retirada: pedido já pago só confirma a entrega (popup simples); o resto
  // abre o fechamento das Mesas (dividir, várias formas, desconto). "Já pago"
  // de qualquer forma conta, não só o online (achado 344, 27/10/2026): antes o
  // delivery marcado "Já pago" e trocado para retirada pedia o total de novo.
  const pedidoJaPago = (p) => p?.payment_status === 'paid';
  const handleAbrirPagamento = (pedido, e) => {
    if (e) e.stopPropagation();
    if (pedidoJaPago(pedido)) {
      setPedidoParaPagamento(pedido);
      setPagamentoModalOpen(true);
      return;
    }
    setPedidoFechamento(pedido);
    setFechamentoAberto(true);
  };

  const pgTotal = pedidoParaPagamento?.total || 0;

  // Pedido já pago: só conclui (a venda entra no caixa na conclusão)
  const handleFinalizarRetirada = async () => {
    if (!pedidoParaPagamento) return;
    try {
      await axios.patch(`${API}/pedidos/${pedidoParaPagamento.id}/status?status=concluido`, {}, getAuthHeader());
      toast.success("Pedido finalizado com sucesso!");
      setPagamentoModalOpen(false);
      setPedidoParaPagamento(null);
      fetchData();
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Erro ao finalizar pedido");
    }
  };

  // Última parte paga no fechamento: grava forma(s)/desconto e conclui — o
  // servidor lança no caixa uma venda por forma. Erro sobe pro popup, que
  // mantém o pagamento guardado para tentar de novo.
  const concluirRetirada = async (conta) => {
    const pedido = pedidoFechamento;
    await axios.put(`${API}/pedidos/${pedido.id}`, fechamentoDoPedido(conta, pedido), getAuthHeader());
    await axios.patch(`${API}/pedidos/${pedido.id}/status?status=concluido`, {}, getAuthHeader());
    toast.success(`Pedido ${pedido.codigo || ""} finalizado!`);
    fetchData();
  };

  // Abrir modal de cancelamento
  const handleAbrirCancelar = (pedido, e) => {
    if (e) e.stopPropagation();
    setPedidoParaCancelar(pedido);
    setMotivoCancelamento("");
    setCancelarModalOpen(true);
  };

  // Estado p/ modal de confirmação de "ciente do cancelamento iFood".
  // Usar AlertDialog do projeto (Radix) em vez de window.confirm — popup
  // nativo do navegador é feio e quebra contexto visual da SaaS.
  const [ackCancelPedido, setAckCancelPedido] = useState(null);

  // Abre o modal de confirmação
  const handleAcknowledgeCancellation = (pedido) => {
    if (!pedido?.id) return;
    setAckCancelPedido(pedido);
  };

  // Confirma o ack (chamado pelo botão dentro do AlertDialog)
  const confirmAcknowledgeCancellation = async (pedidoDireto) => {
    // Com pedido no argumento = "Dispensar" do card ainda não aceito (sem popup);
    // sem argumento = botão do AlertDialog (recebe o evento de clique).
    const pedido = pedidoDireto?.id ? pedidoDireto : ackCancelPedido;
    if (!pedido?.id) return;
    setAckCancelPedido(null);
    // Atualização otimista — some do bloco já. Rollback se der erro.
    setPedidos(prev => prev.map(p =>
      p.id === pedido.id ? { ...p, cancel_acknowledged_at: new Date().toISOString() } : p
    ));
    try {
      await axios.patch(
        `${API}/pedidos/${pedido.id}/acknowledge-cancel`,
        {},
        getAuthHeader(),
      );
      toast.success("Cancelamento confirmado");
    } catch (error) {
      // rollback
      setPedidos(prev => prev.map(p =>
        p.id === pedido.id ? { ...p, cancel_acknowledged_at: null } : p
      ));
      toast.error(
        error?.response?.data?.detail || "Erro ao confirmar cancelamento",
        { duration: 6000 },
      );
      console.error(error);
    }
  };

  // Cancelar pedido com motivo
  const handleCancelarPedido = async () => {
    if (!pedidoParaCancelar) return;
    
    const isIfood = (pedidoParaCancelar.modulo || "").toLowerCase() === "ifood";
    if (isIfood && !ifoodCancelReason?.code) {
      toast.error("Escolha o motivo do cancelamento na lista do iFood");
      return;
    }
    if (!isIfood && !motivoValido(motivoCancelamento)) {
      toast.error("Informe o motivo do cancelamento");
      return;
    }
    
    try {
      // iFood: o texto livre é opcional — sem ele, vai a descrição oficial do motivo.
      const motivoFinal = (motivoCancelamento || "").trim() || ifoodCancelReason?.description || "";
      await axios.patch(`${API}/pedidos/${pedidoParaCancelar.id}/cancelar`, {
        motivo: motivoFinal,
        ...(isIfood ? { ifood_cancel_code: ifoodCancelReason.code } : {}),
      }, getAuthHeader());
      
      toast.success(isIfood ? "Cancelamento enviado ao iFood" : "Pedido cancelado!");
      // Atualização otimista: remover pedido da lista imediatamente
      setPedidos(prev => prev.filter(p => p.id !== pedidoParaCancelar.id));
      setCancelarModalOpen(false);
      setPedidoParaCancelar(null);
      setMotivoCancelamento("");
      setIfoodCancelReason(null);
      setDetalhesModalOpen(false);
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(detail || "Erro ao cancelar pedido");
    }
  };

  // Abrir detalhes do pedido
  const handleAbrirDetalhes = (pedido) => {
    setPedidoDetalhes(pedido);
    setDetalhesModalOpen(true);
  };

  // Abrir modal de edição de pedido (redireciona para CardapioPopup)
  const handleAbrirEditarPedido = async (pedido, e) => {
    if (e) e.stopPropagation();
    setPedidoEditando(pedido);
    setEditarPedidoModalOpen(true);
    setDetalhesModalOpen(false); // Fechar modal de detalhes
  };

  // Ir para cardápio para novo pedido

  // Filtrar pedidos por status (otimizado com useMemo)
  const getPedidosByStatus = useCallback((status) => {
    const filtered = pedidos.filter(p =>
      p.status === status && isPedidoParaDelivery(p)
    );

    // Ordenar por tempo: mais antigo primeiro (maior tempo de produção = mais em cima)
    return filtered.sort((a, b) => {
      const dateA = new Date(a.created_at || 0);
      const dateB = new Date(b.created_at || 0);
      return dateA - dateB; // Mais antigo (menor data) = primeiro = em cima
    });
  }, [pedidos]);
  
  // Cancelamentos externos (vindos do iFood ou parceiros) ainda não vistos
  // pelo lojista — bloco com prioridade visual máxima no topo da tela.
  // Filtro: status=cancelado, vindo de módulo externo, sem cancel_acknowledged_at.
  const pedidosCanceladosExternos = useMemo(() => {
    return pedidos.filter(p => {
      if (p.status !== 'cancelado') return false;
      if (p.cancel_acknowledged_at) return false;  // já visto
      const modulo = (p.modulo || '').toLowerCase();
      // Por ora só iFood — futuramente expansível pra Grandchef/AnotaAi/etc.
      return modulo === 'ifood';
    }).sort((a, b) => new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at));
  }, [pedidos]);

  // Regra do dono (16/09/2026) para cancelamento vindo do iFood: o pedido fica
  // na coluna em que ESTAVA, com carimbo CANCELADO vermelho por cima do card.
  //  - ainda aguardando aceite: sem confirmação, some sozinho 8 min depois;
  //  - já aceito / pronto / em rota: topo da coluna (em rota volta pra PRONTO)
  //    até o funcionário confirmar que viu (popup).
  // A coluna é inferida pelos carimbos de tempo, porque o status já é 'cancelado'.
  const colunaDoCancelado = (p) => (p.ts_em_rota || p.ts_pronto) ? 'pronto' : (p.ts_producao ? 'producao' : 'aguardando');
  const [agoraTick, setAgoraTick] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setAgoraTick(Date.now()), 30000);
    return () => clearInterval(id);
  }, []);
  const canceladosPorColuna = useMemo(() => {
    const out = { aguardando: [], producao: [], pronto: [], expirados: [] };
    for (const p of pedidosCanceladosExternos) {
      const col = colunaDoCancelado(p);
      if (col === 'aguardando') {
        const t = new Date(p.ts_cancelado || p.updated_at || p.created_at).getTime();
        if (agoraTick - t > AUTO_HIDE_CANCELADO_MS) { out.expirados.push(p); continue; }
      }
      out[col].push(p);
    }
    return out;
  }, [pedidosCanceladosExternos, agoraTick]);
  // Os que sumiram sozinhos são marcados como vistos no servidor — senão o
  // for_screen devolve o pedido em todo poll, para sempre.
  const autoAckedRef = useRef(new Set());
  useEffect(() => {
    canceladosPorColuna.expirados.forEach((p) => {
      if (autoAckedRef.current.has(p.id)) return;
      autoAckedRef.current.add(p.id);
      axios.patch(`${API}/pedidos/${p.id}/acknowledge-cancel`, {}, getAuthHeader()).catch(() => {});
    });
  }, [canceladosPorColuna]);

  // Cache de pedidos por status usando useMemo (evita recalcular a cada render)
  const pedidosAguardando = useMemo(() => getPedidosByStatus('aguardando_aceite'), [getPedidosByStatus]);
  const pedidosProducao = useMemo(() => getPedidosByStatus('producao'), [getPedidosByStatus]);
  // Pedidos AGENDADOS (feature v1.5.262+ — atualmente travada por kill-switch).
  // Aparecem numa "gaveta" no topo da coluna Em Produção pra aprovação manual.
  // Ao aprovar (POST /aprovar-agendado), vão direto pra 'producao' e imprimem.
  const pedidosAgendados = useMemo(() => getPedidosByStatus('agendado'), [getPedidosByStatus]);
  const pedidosPronto = useMemo(() => getPedidosByStatus('pronto'), [getPedidosByStatus]);
  const pedidosNaBag = useMemo(() => getPedidosByStatus('na_bag'), [getPedidosByStatus]);
  // Cancelados de HOJE apenas. O for_screen devolve os de hoje E os não
  // reconhecidos de datas antigas (pro alerta de cancelamento externo) — a
  // coluna filtra pela data local: created_at é ISO com offset -03:00, então os
  // 10 primeiros caracteres JÁ são o dia local. Mais recente primeiro.
  const pedidosCancelados = useMemo(() => {
    const d = new Date();
    const hoje = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    return getPedidosByStatus('cancelado')
      .filter((p) => (p.created_at || '').slice(0, 10) === hoje)
      .slice().reverse();
  }, [getPedidosByStatus]);
  const pedidosEmRota = useMemo(() => getPedidosByStatus('em_rota'), [getPedidosByStatus]);
  const pedidosConcluido = useMemo(() => getPedidosByStatus('concluido'), [getPedidosByStatus]);

  // Entregadores com pedidos na BAG (otimizado com useMemo)
  const entregadoresComPedidos = useMemo(() => {
    return entregadores.filter(e => {
      const count = pedidos.filter(p => 
        p.entregador_id === e.id && 
        (p.status === 'na_bag' || p.status === 'em_rota')
      ).length;
      return count > 0;
    });
  }, [entregadores, pedidos]);

  // Calcular pedidos na bag por entregador (otimizado com useCallback)
  const getEntregadorBagCount = useCallback((entregadorId) => {
    return pedidos.filter(p => 
      p.entregador_id === entregadorId && 
      (p.status === 'na_bag' || p.status === 'em_rota')
    ).length;
  }, [pedidos]);

  // --- Novo Pedido Delivery: useMemos e handlers (tela tipo Mesas/Cardápio) ---
  const dvProductsByCategory = useMemo(() => {
    const m = {};
    (dvProducts || []).forEach((p) => {
      const cat = p.category || "Outros";
      if (!m[cat]) m[cat] = [];
      m[cat].push(p);
    });
    return m;
  }, [dvProducts]);

  const dvCategoriesWithProducts = useMemo(() => {
    const categorySet = new Set((dvProducts || []).map((p) => p.category).filter(Boolean));
    return (dvCategories || []).filter((cat) => categorySet.has(cat.name));
  }, [dvCategories, dvProducts]);

  const dvSectionsToShow = useMemo(() => {
    if (dvSelectedCategory === "all" || !dvSelectedCategory) {
      const ordered = dvCategoriesWithProducts
        .filter((cat) => dvProductsByCategory[cat.name]?.length)
        .map((cat) => [cat.name, dvProductsByCategory[cat.name]]);
      const others = Object.entries(dvProductsByCategory).filter(
        ([n]) => !dvCategoriesWithProducts.some((c) => c.name === n)
      );
      return [...ordered, ...others];
    }
    return [[dvSelectedCategory, dvProductsByCategory[dvSelectedCategory] || []]];
  }, [dvSelectedCategory, dvProductsByCategory, dvCategoriesWithProducts]);

  const dvSectionsToShowFiltered = useMemo(() => {
    if (!dvProductSearchTerm?.trim()) return dvSectionsToShow;
    const q = dvProductSearchTerm.toLowerCase().trim();
    return dvSectionsToShow
      .map(([cat, prods]) => [cat, (prods || []).filter((p) =>
        (p.name || "").toLowerCase().includes(q) || (p.description || "").toLowerCase().includes(q)
      )])
      .filter(([, prods]) => (prods || []).length > 0);
  }, [dvSectionsToShow, dvProductSearchTerm]);

  const dvFilteredClientes = useMemo(() => {
    if (!dvClienteNome || dvClienteNome.trim().length < 2) return [];
    const q = dvClienteNome.toLowerCase().trim();
    const dig = (dvClienteNome || "").replace(/\D/g, "");
    return (dvClientes || []).filter((c) => {
      const matchNome = (c.nome || "").toLowerCase().includes(q);
      const matchTel = dig.length >= 4 && (() => {
        const ct = (c.telefone || "").replace(/\D/g, "");
        return ct.includes(dig) || (ct.length >= 8 && dig.length >= 8 && ct.slice(-8) === dig.slice(-8));
      })();
      return matchNome || matchTel;
    }).slice(0, 8);
  }, [dvClientes, dvClienteNome]);

  const dvClienteIdResolved = useMemo(() => {
    if (dvSelectedClienteId) return dvSelectedClienteId;
    if (dvFilteredClientes.length === 1 && (dvClienteNome || "").trim().length >= 2) return dvFilteredClientes[0]?.id || null;
    const tel = (dvClienteTelefone || "").replace(/\D/g, "");
    if (tel.length < 8) return null;
    const c = (dvClientes || []).find((x) => ((x.telefone || "").replace(/\D/g, "") || "").slice(-8) === tel.slice(-8) || ((x.telefone || "").replace(/\D/g, "") || "") === tel);
    return c ? c.id : null;
  }, [dvSelectedClienteId, dvClienteTelefone, dvClientes, dvFilteredClientes, dvClienteNome]);

  // Últimos 10 pedidos: somente do cliente selecionado (escolhido no dropdown), não por inferência de nome/telefone
  useEffect(() => {
    if (!deliveryVendasOpen || !dvSelectedClienteId) {
      setDvClienteHistorico([]);
      setDvClienteHistoricoLoading(false);
      return;
    }
    setDvClienteHistorico([]);
    setDvClienteHistoricoLoading(true);
    axios.get(`${API}/pedidos/cliente/${dvSelectedClienteId}`, getAuthHeader())
      .then((res) => {
        const list = Array.isArray(res?.data) ? res.data : [];
        const naoCancelados = list.filter((p) => (p.status || "").toLowerCase() !== "cancelado");
        setDvClienteHistorico(naoCancelados.slice(0, 10));
      })
      .catch(() => setDvClienteHistorico([]))
      .finally(() => setDvClienteHistoricoLoading(false));
  }, [deliveryVendasOpen, dvSelectedClienteId]);

  // Handler: Enter no campo cliente — se não encontrou, abre modal cadastro
  const formatPhone = (raw) => {
    const n = raw.replace(/\D/g, "");
    if (n.length <= 2) return `(${n}`;
    if (n.length <= 3) return `(${n.slice(0,2)}) ${n.slice(2)}`;
    if (n.length <= 7) return `(${n.slice(0,2)}) ${n.slice(2,3)}.${n.slice(3)}`;
    return `(${n.slice(0,2)}) ${n.slice(2,3)}.${n.slice(3,7)}-${n.slice(7,11)}`;
  };

  const dvOpenNovoClienteModal = () => {
    const text = (dvClienteNome || "").trim();
    const isPhone = /^\d{7,}$/.test(text.replace(/\D/g, ""));
    setDvNovoClienteTelefone(isPhone ? formatPhone(text) : "");
    setDvNovoClienteNome(isPhone ? "" : text);
    setDvNovoClienteCpf("");
    setDvNovoClienteNascimento("");
    setDvShowCadastrarCliente(true);
    setDvShowCadastrarForm(true);
  };

  const dvCloseNovoClienteModal = () => {
    setDvShowCadastrarCliente(false);
    setDvShowCadastrarForm(false);
    setDvNovoClienteNome("");
    setDvNovoClienteTelefone("");
    setDvNovoClienteCpf("");
    setDvNovoClienteNascimento("");
  };

  // Endereços cadastrados do cliente (igual Cardápio) — ao abrir entrega e selecionar delivery
  useEffect(() => {
    if (!dvEntregaPopupOpen || dvTipoEntrega !== "delivery" || !dvClienteIdResolved) {
      setDvEnderecosCliente([]);
      setDvEnderecosLoading(false);
      return;
    }
    setDvEnderecosLoading(true);
    setDvEnderecosCliente([]);
    axios
      .get(`${API}/client-addresses/${dvClienteIdResolved}`, getAuthHeader())
      .then((res) => {
        const list = Array.isArray(res?.data) ? res.data : [];
        setDvEnderecosCliente(list);
        const padrao = list.find((a) => a.is_default);
        const addr = padrao || list[0];
        if (addr) {
          setDvEndereco((o) => ({
            ...o,
            rua: addr.endereco || "",
            numero: addr.numero || "",
            bairro: addr.bairro || "",
            complemento: addr.complemento || "",
          }));
          setDvEnderecoSelecionadoId(addr.id);
          const b = (dvBairros || []).find((x) => String(x.name || x.nome || "").trim().toLowerCase() === String(addr.bairro || "").trim().toLowerCase());
          setDvTaxaEntrega(b ? (b.valor_entrega ?? b.taxa_entrega ?? b.taxa ?? b.valor ?? 0) : 0);
        } else {
          setDvEnderecoSelecionadoId(null);
        }
      })
      .catch(() => setDvEnderecosCliente([]))
      .finally(() => setDvEnderecosLoading(false));
  }, [dvEntregaPopupOpen, dvTipoEntrega, dvClienteIdResolved, dvBairros]);

  const getDvPromoForProduct = (productId, comboType) => {
    for (const promo of dvActivePromotions) {
      const pp = (promo.products || []).find(p => p.product_id === productId);
      if (pp) {
        if (comboType === 'combo' && pp.discount_value_combo) return { promo, value: pp.discount_value_combo, type: promo.discount_type };
        // Pizza por tamanho (`pp.sizes`): não tem valor único pra exibir aqui;
        // o popup do pizza mostra o preço já com desconto por tamanho.
        if (pp.sizes && typeof pp.sizes === 'object' && pp.discount_value == null) return null;
        return { promo, value: pp.discount_value, type: promo.discount_type };
      }
    }
    return null;
  };
  const calcDvPromoPrice = (originalPrice, promoInfo) => {
    if (!promoInfo) return null;
    if (promoInfo.type === 'percentage') return originalPrice * (1 - promoInfo.value / 100);
    if (promoInfo.type === 'fixed_price') return promoInfo.value;
    return null;
  };

  const dvCartTotal = (dvCart || []).reduce((t, i) => t + (i.final_price ?? i.sale_price ?? 0) * (i.quantity || 1), 0);
  const dvCartItemsCount = (dvCart || []).reduce((c, i) => c + (i.quantity || 1), 0);

  const getDvStepsSummary = (item) => {
    if (item.etapas && item.etapas.length > 0) return item.etapas.map((e) => ({ stepName: e.stepName || e.name || "", items: e.items || [] }));
    if (!item.step_selections || !item.order_steps) return [];
    const steps = (item.order_steps || []).filter((s) => (item.combo_type === "simples" ? !s.combo_only : true));
    const out = [];
    steps.forEach((step, idx) => {
      const ids = item.step_selections?.[idx] || [];
      const names = ids.map((id) => step.items?.find((x) => x.product_id === id)?.product_name || "").filter(Boolean);
      if (names.length) out.push({ stepName: step.name || "", items: names });
    });
    return out;
  };

  // Pizza tem fluxo dedicado (tamanho → sabores → borda → adicionais → finalizar)
  const dvPizza = usePizzaPopup({
    clienteId: dvOfertasCliente.estado === "ativo" ? dvSelectedClienteId : null,
    moduloOferta: "Delivery",
    onAddToCart: (item) => handleDvAddToCartFromPopup({
      ...item,
      final_price: item.preco || item.sale_price || 0,
      sale_price: item.preco || item.sale_price || 0,
      quantity: item.quantity || 1,
    }),
    allProducts: dvAllProducts.length ? dvAllProducts : (typeof dvProducts !== "undefined" ? dvProducts : []),
    darkMode: isDark,
  });

  const openDvProductPopup = (product) => {
    if (dvPizza.tryOpenPizza(product)) return;
    setDvSelectedProduct(product);
    setDvProductPopupOpen(true);
  };
  const closeDvProductPopup = () => { setDvProductPopupOpen(false); setDvSelectedProduct(null); };

  const handleDvAddToCartFromPopup = (data) => {
    // Segundo caminho de carrinho do Delivery (popup do Novo Pedido) — recebe
    // pizza via dvPizza/usePizzaPopup e usava a condição SEM `subitems`, então
    // estava afetado pelo mesmo bug dos outros canais.
    const hasCustom = temPersonalizacao(data);
    const unitPrice = data.final_price ?? data.sale_price ?? 0;
    const toAdd = { ...data, sale_price: unitPrice, cartItemId: Date.now() };
    if (hasCustom) setDvCart([...dvCart, toAdd]);
    else {
      const ex = dvCart.find((i) => i.id === data.id && !temPersonalizacao(i));
      if (ex) setDvCart(dvCart.map((i) => (i.cartItemId === ex.cartItemId ? { ...i, quantity: (i.quantity || 1) + (data.quantity || 1) } : i)));
      else setDvCart([...dvCart, toAdd]);
    }
    toast.success(`${data.name} adicionado!`);
    setDvShowMobileCart(true);
    closeDvProductPopup();
  };

  const dvUpdateQuantity = (cartItemId, delta) => {
    setDvCart(dvCart.map((item) => {
      if ((item.cartItemId || item.id) === cartItemId) {
        const stepDelta = item.is_divisible
          ? (item.sale_unit === "kg" || item.sale_unit === "L" ? 0.1 : 0.5)
          : 1;
        const adjustedDelta = delta > 0 ? stepDelta : -stepDelta;
        const newQuantity = parseFloat(((item.quantity || 1) + adjustedDelta).toFixed(3));
        return newQuantity > 0 ? { ...item, quantity: newQuantity } : item;
      }
      return item;
    }).filter((item) => (item.quantity || 1) > 0));
  };

  const dvRemoveFromCart = (cartItemId) => setDvCart(dvCart.filter((item) => (item.cartItemId || item.id) !== cartItemId));

  const handleDvRepetirPedido = (pedido) => {
    const items = pedido?.items || [];
    if (items.length === 0) { toast.error("Pedido sem itens."); return; }
    const allProds = (dvAllProducts && dvAllProducts.length ? dvAllProducts : dvProducts) || [];
    const now = Date.now();
    const cartItems = items.map((it, idx) => {
      const id = it.product_id || it.id;
      const name = it.nome || it.name || it.product_name || "";
      const qty = it.quantidade || it.quantity || 1;
      const price = it.preco ?? it.price ?? it.final_price ?? 0;
      const obs = it.observacao || it.observation || null;
      const subitems = Array.isArray(it.subitems) ? [...it.subitems] : [];
      const etapas = Array.isArray(it.etapas) ? [...it.etapas] : [];
      const stepSelections = it.step_selections && typeof it.step_selections === "object" ? { ...it.step_selections } : null;
      let orderSteps = null;
      if (stepSelections && Object.keys(stepSelections).length > 0 && etapas.length === 0) {
        const prod = allProds.find((p) => String(p.id || "") === String(id || ""));
        if (prod && Array.isArray(prod.order_steps) && prod.order_steps.length) orderSteps = prod.order_steps;
      }
      return {
        id,
        name,
        quantity: qty,
        sale_price: price,
        final_price: price,
        observation: obs,
        combo_type: it.combo_type || null,
        subitems,
        etapas,
        step_selections: stepSelections,
        order_steps: orderSteps,
        photo_url: it.photo_url || null,
        cartItemId: now + idx,
      };
    });
    setDvCart(cartItems);
    setDvObservacao((pedido.observacao || "").trim() || "");
    toast.success("Pedido adicionado ao carrinho. Observações e etapas incluídas.");
  };

  const handleDvCadastrarNovoCliente = async () => {
    const nome = dvNovoClienteNome?.trim();
    if (!nome) { toast.error("Informe o nome do cliente."); return; }
    setDvCadastrandoCliente(true);
    try {
      const body = {
        nome,
        telefone: (dvNovoClienteTelefone || "").trim() || null,
        cpf: (dvNovoClienteCpf || "").trim() || null,
        data_nascimento: (dvNovoClienteNascimento || "").trim() || null,
      };
      const { data: created } = await axios.post(`${API}/clientes`, body, getAuthHeader());
      setDvClientes((prev) => [...(prev || []), created]);
      setDvClienteNome(created.nome || "");
      setDvClienteTelefone(created.telefone || "");
      setDvSelectedClienteId(created.id);
      dvCloseNovoClienteModal();
      toast.success("Cliente cadastrado!");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao cadastrar cliente.");
    } finally {
      setDvCadastrandoCliente(false);
    }
  };

  const handleDvEnviarPedido = () => {
    if (!dvClienteNome || !dvClienteNome.trim()) { toast.error("Informe o nome do cliente."); return; }
    if (dvCart.length === 0) { toast.error("Adicione itens ao pedido."); return; }
    setDvEntregaPopupOpen(true);
  };

  const handleDvSaveNewAddress = async () => {
    if (!dvNewAddress.endereco?.trim() || !dvNewAddress.bairro?.trim()) {
      toast.error("Preencha o endereço e bairro");
      return;
    }
    if (!dvClienteIdResolved) {
      toast.error("Cliente não identificado");
      return;
    }
    setDvSavingAddress(true);
    try {
      const res = await axios.post(
        `${API}/client-addresses`,
        {
          client_id: dvClienteIdResolved,
          label: dvNewAddress.label,
          endereco: dvNewAddress.endereco.trim(),
          numero: dvNewAddress.numero?.trim() || null,
          complemento: dvNewAddress.complemento?.trim() || null,
          bairro: dvNewAddress.bairro?.trim() || null,
          cep: dvNewAddress.cep?.trim() || null,
          is_default: dvEnderecosCliente.length === 0,
        },
        getAuthHeader()
      );
      const addr = res.data;
      setDvEnderecosCliente((prev) => [addr, ...prev]);
      setDvEnderecoSelecionadoId(addr.id);
      setDvEndereco({
        rua: addr.endereco || "",
        numero: addr.numero || "",
        bairro: addr.bairro || "",
        complemento: addr.complemento || "",
      });
      const b = (dvBairros || []).find((x) => String(x.name || x.nome || "").toLowerCase() === String(addr.bairro || "").toLowerCase());
      setDvTaxaEntrega(b ? (b.valor_entrega ?? b.taxa_entrega ?? b.taxa ?? b.valor ?? 0) : 0);
      setDvShowNewAddressForm(false);
      setDvNewAddress({ label: "Casa", endereco: "", numero: "", complemento: "", bairro: "", cep: "" });
      toast.success("Endereço salvo no perfil do cliente!");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao salvar endereço");
    } finally {
      setDvSavingAddress(false);
    }
  };

  const handleDvContinuarEntrega = () => {
    if (dvTipoEntrega === "delivery") {
      if (!dvEndereco.rua?.trim() || !dvEndereco.numero?.trim() || !dvEndereco.bairro?.trim()) {
        toast.error("Preencha rua, número e bairro para entrega.");
        return;
      }
      // Bloqueia criar entrega se o bairro nao bate com nenhum bairro cadastrado
      // (caso contrario a taxa de entrega ficaria zerada).
      const _bairroDigitado = String(dvEndereco.bairro || "").trim().toLowerCase();
      const _bairroCadastrado = (dvBairros || []).find(
        (x) => String(x.name || x.nome || "").trim().toLowerCase() === _bairroDigitado
      );
      if (!_bairroCadastrado) {
        toast.error("Bairro '" + dvEndereco.bairro + "' não está cadastrado. Selecione um bairro do cadastro pra ter a taxa de entrega correta.", { duration: 6000 });
        return;
      }
    }
    setDvEntregaPopupOpen(false);
    setDvPaymentDialogOpen(true);
  };

  const handleDvDoSubmit = async () => {
    // O code real é "dinheiro_<uuid>": comparar só a base (achado 269)
    const isDinheiro = _formaBase(dvFormaPagamento) === "dinheiro";
    const totalPedido = dvCartTotal + (dvTipoEntrega === "delivery" ? (dvTaxaEntrega || 0) : 0);
    setDvSubmitting(true);
    try {
      const items = dvCart.map((i) => {
        let etapas = i.etapas && i.etapas.length ? i.etapas : [];
        if (etapas.length === 0 && i.step_selections && i.order_steps) {
          const steps = (i.order_steps || []).filter((s) => (i.combo_type === "simples" ? !s.combo_only : true));
          etapas = steps.map((step, idx) => {
            const ids = i.step_selections?.[idx] || [];
            const names = ids.map((id) => step.items?.find((x) => x.product_id === id)?.product_name || "").filter(Boolean);
            return names.length ? { stepName: step.name || "", items: names } : null;
          }).filter(Boolean);
        }
        return {
          id: i.id || null,
          product_id: i.id || null,
          nome: i.name || i.nome,
          quantidade: i.quantity || 1,
          preco: i.final_price ?? i.sale_price ?? 0,
          observacao: i.observation || i.observacao || null,
          combo_type: i.combo_type || null,
          photo_url: i.photo_url || null,
          subitems: i.subitems || [],
          etapas,
          ...(i.pesado_balanca ? { pesado_balanca: true } : {}),
          // Pizza: tamanho/sabores/borda para o backend conferir o preço (igual ao cardápio)
          pizza_meta: pizzaMetaDoItem(i),
        };
      });
      const payload = {
        cliente_id: dvSelectedClienteId || null,
        cliente_nome: dvClienteNome.trim(),
        cliente_telefone: dvClienteTelefone?.trim() || null,
        items,
        total: totalPedido,
        status: "producao",
        tipo_entrega: dvTipoEntrega,
        modulo: "Delivery",
        valor_entrega: dvTipoEntrega === "delivery" ? (dvTaxaEntrega || 0) : 0,
        forma_pagamento: dvFormaPagamento,
        troco_precisa: isDinheiro && !!dvNeedsChange,
        troco_valor: isDinheiro && dvNeedsChange ? parseFloat(dvChangeAmount) : null,
        observacao: dvObservacao?.trim() || null,
        payment_status: dvJaPago ? "paid" : "pending",
      };
      if (dvTipoEntrega === "delivery") {
        payload.endereco_rua = dvEndereco.rua?.trim();
        payload.endereco_numero = dvEndereco.numero?.trim();
        payload.endereco_bairro = dvEndereco.bairro?.trim();
        payload.endereco_complemento = dvEndereco.complemento?.trim() || null;
      }
      const createRes = await axios.post(`${API}/pedidos`, payload, getAuthHeader());
      const pedidoCriado = createRes.data;
      window.dispatchEvent(new CustomEvent("pedidosUpdated"));
      fetchData();
      setDeliveryVendasOpen(false);
      setDvPaymentDialogOpen(false);
      toast.success("Pedido criado com sucesso!");

      // Som de notificação + impressão imediata
      if (pedidoCriado) {
        try { playNotificationSound(); } catch (_) {}
        // Impressão imediata (modulo Delivery = frontend cuida)
        (async () => {
          try {
            const [r1, r2] = await Promise.all([imprimirCupom(pedidoCriado, { automatico: true }), imprimirCupomPreparo(pedidoCriado)]);
            const printSuccess = r1?.success && r2?.success;
            await axios.patch(`${API}/pedidos/${pedidoCriado.id}/print-status`, { print_status: printSuccess ? 'success' : 'failed' }, getAuthHeader()).catch(() => {});
            if (!printSuccess) {
              toast.error('Falha ao imprimir pedido #' + (pedidoCriado.codigo || pedidoCriado.id) + ' - verifique a impressora!');
            }
          } catch (e) {
            console.error('Erro ao imprimir:', e);
            await axios.patch(`${API}/pedidos/${pedidoCriado.id}/print-status`, { print_status: 'failed' }, getAuthHeader()).catch(() => {});
          }
        })();
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao criar pedido.");
    } finally {
      setDvSubmitting(false);
    }
  };

  const handleDvConfirmChange = () => {
    const total = dvCartTotal + (dvTipoEntrega === "delivery" ? (dvTaxaEntrega || 0) : 0);
    if (dvNeedsChange && (!dvChangeAmount || parseFloat(dvChangeAmount) <= total)) {
      toast.error("Informe um valor maior que o total do pedido");
      return;
    }
    setDvShowChangeDialog(false);
    handleDvDoSubmit();
  };

  const handleDvConfirmPayment = () => {
    if (!dvFormaPagamento && dvTipoEntrega !== "pickup") { toast.error("Selecione a forma de pagamento."); return; }
    const isDinheiro = _formaBase(dvFormaPagamento) === "dinheiro";
    if (isDinheiro && dvNeedsChange === null) {
      setDvShowChangeDialog(true);
      return;
    }
    handleDvDoSubmit();
  };

  // Formatação de data
  const formatTime = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
  };

  // Renderizar etapas do pedido (corrigido e simétrico)
  const renderEtapas = (pedido) => {
    const isPickup = isRetirada(pedido);
    const status = pedido.status;
    
    // Timeline simplificada: sem etapa 'Bag' (descontinuada).
    // Pedidos legados em status 'na_bag' são exibidos na etapa 'Rota' (mesma coluna em_rota).
    const etapasDelivery = [
      { key: 'aguardando_aceite', label: 'Aceite' },
      { key: 'producao', label: 'Produção' },
      { key: 'pronto', label: 'Pronto' },
      { key: 'em_rota', label: 'Rota' },
      { key: 'concluido', label: 'Entregue' },
    ];
    
    const etapasRetirada = [
      { key: 'aguardando_aceite', label: 'Aceite' },
      { key: 'producao', label: 'Produção' },
      { key: 'pronto', label: 'Pronto' },
      { key: 'concluido', label: 'Retirado' },
    ];
    
    const etapas = isPickup ? etapasRetirada : etapasDelivery;
    // Pedidos legados em 'na_bag' são tratados como 'em_rota' no timeline
    const statusForTimeline = status === 'na_bag' ? 'em_rota' : status;
    const currentIndex = etapas.findIndex(e => e.key === statusForTimeline);
    
    if (status === 'cancelado') {
      return (
        <div className="flex items-center justify-center gap-2 text-red-600 bg-red-50 dark:bg-red-950/20 p-3 rounded-lg">
          <XCircle className="w-5 h-5" />
          <span className="font-semibold">Pedido Cancelado</span>
        </div>
      );
    }
    
    return (
      <div className="flex items-center justify-between w-full">
        {etapas.map((etapa, index) => (
          <div key={etapa.key} className="flex items-center flex-1">
            <div className="flex flex-col items-center flex-1">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 ${
                index <= currentIndex 
                  ? 'bg-primary text-primary-foreground border-primary' 
                  : 'bg-muted text-muted-foreground border-muted'
              }`}>
                {index <= currentIndex ? <Check className="w-4 h-4" /> : index + 1}
              </div>
              <span className={`text-[10px] mt-1 text-center ${
                index <= currentIndex ? 'text-primary font-medium' : 'text-muted-foreground'
              }`}>
                {etapa.label}
              </span>
            </div>
            {index < etapas.length - 1 && (
              <div className={`h-0.5 flex-1 -mt-4 ${
                index < currentIndex ? 'bg-primary' : 'bg-muted'
              }`} />
            )}
          </div>
        ))}
      </div>
    );
  };

  // Tela Novo Pedido Delivery (igual Mesas/Cardápio: combos, etapas, fotos, categorias; nome do cliente em destaque)
  if (deliveryVendasOpen) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col bg-background overflow-hidden">
        {/* Header compacto */}
        <header className="shrink-0 px-3 sm:px-4 py-2.5 pt-[max(0.5rem,env(safe-area-inset-top,0px))] bg-card border-b shadow-sm">
          <div className="flex items-center gap-3">
            <Button variant="ghost" size="icon" className="h-10 w-10 rounded-full shrink-0 hover:bg-orange-500/10" onClick={() => setDeliveryVendasOpen(false)}>
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <div className="flex-1 min-w-0">
              <h1 className="text-base sm:text-lg font-bold truncate">Novo Pedido</h1>
              <p className="text-xs text-muted-foreground">Delivery • Cliente e itens</p>
            </div>
            {/* Cliente selecionado — inline no header */}
            {dvSelectedClienteId && (
              <div className="flex items-center gap-2 bg-orange-500/15 border border-orange-500/30 rounded-lg px-3 py-1.5 shrink-0">
                <User className="w-3.5 h-3.5 text-orange-500 shrink-0" />
                <span className="text-sm font-semibold truncate max-w-[150px]">{dvClienteNome}</span>
                {dvClienteTelefone && (
                  <span className="text-xs text-muted-foreground shrink-0 flex items-center gap-0.5">
                    <Phone className="w-3 h-3" />
                    {dvClienteTelefone}
                  </span>
                )}
                <button
                  type="button"
                  onClick={() => { setDvSelectedClienteId(null); setDvClienteNome(""); setDvClienteTelefone(""); }}
                  className="text-xs text-orange-500 hover:text-orange-600 font-medium ml-1"
                >
                  Trocar
                </button>
              </div>
            )}
          </div>
        </header>

        {/* Card Cliente — só mostra busca quando não tem cliente selecionado */}
        {!dvSelectedClienteId && (
        <div className="shrink-0 px-3 sm:px-4 py-2">
            <Card className="bg-orange-500 shadow-md">
              <CardHeader className="p-4 pb-2">
                <CardTitle className="flex items-center gap-2 text-sm font-semibold text-white">
                  <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center"><User className="w-4 h-4 text-white" /></div>
                  Nome ou telefone do cliente
                </CardTitle>
              </CardHeader>
              <CardContent className="p-4 pt-0">
                <div className="relative flex-1 min-w-0">
                  <Input
                    placeholder="Digite o nome ou telefone para buscar"
                    value={dvClienteNome}
                    onChange={(e) => { const v = e.target.value; const digits = v.replace(/\D/g, ""); const isPhone = digits.length > 0 && digits.length === v.replace(/[\s().\-]/g, "").length; setDvClienteNome(isPhone ? formatPhone(v) : v); setDvSelectedClienteId(null); setDvClienteTelefone(""); setDvShowCadastrarCliente(false); setDvShowCadastrarForm(false); setDvNovoClienteNome(""); setDvNovoClienteTelefone(""); }}
                    onKeyDown={(e) => { if (e.key === "Enter" && dvClienteNome.trim() && !dvSelectedClienteId && dvFilteredClientes.length === 0) { e.preventDefault(); dvOpenNovoClienteModal(); } }}
                    onFocus={() => setDvShowClienteDropdown(true)}
                    onBlur={() => setTimeout(() => setDvShowClienteDropdown(false), 150)}
                    className="h-11 text-base font-medium bg-background/80 pr-10"
                  />
                  <button type="button" onClick={dvOpenNovoClienteModal} className="absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-orange-500 hover:bg-orange-600 flex items-center justify-center transition-colors" title="Cadastrar novo cliente">
                    <UserPlus className="w-3.5 h-3.5 text-white" />
                  </button>
                  {dvShowClienteDropdown && dvClienteNome.trim().length >= 2 && (
                    <div className="absolute top-full left-0 right-0 mt-1.5 z-50 bg-popover border rounded-lg shadow-xl max-h-52 overflow-y-auto">
                      {dvFilteredClientes.map((c) => (
                        <button key={c.id} type="button" onMouseDown={() => { setDvClienteNome(c.nome || ""); setDvSelectedClienteId(c.id); setDvClienteTelefone(c.telefone || ""); setDvShowClienteDropdown(false); setDvShowCadastrarCliente(false); setDvShowCadastrarForm(false); }} className="w-full text-left px-4 py-3 hover:bg-orange-500/10 flex items-center gap-2 border-b border-border/50 last:border-0">
                          <User className="w-4 h-4 text-muted-foreground shrink-0" />
                          <span className="font-medium">{c.nome}</span>
                          {c.telefone && <span className="text-muted-foreground text-xs ml-1">{c.telefone}</span>}
                        </button>
                      ))}
                      {dvFilteredClientes.length === 0 && (
                        <button type="button" onMouseDown={() => { setDvShowClienteDropdown(false); dvOpenNovoClienteModal(); }} className="w-full text-left px-4 py-3 hover:bg-orange-500/10 flex items-center gap-2 text-orange-600 dark:text-orange-400 font-medium">
                          <UserPlus className="w-4 h-4 shrink-0" />
                          Cadastrar novo cliente
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          {/* Dialog Cadastrar Novo Cliente */}
          <Dialog open={dvShowCadastrarForm} onOpenChange={(open) => { if (!open) dvCloseNovoClienteModal(); }}>
            <DialogContent className="sm:max-w-md max-h-[90dvh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle className="flex items-center gap-2">
                  <UserPlus className="w-5 h-5 text-orange-500" />
                  Cadastrar Novo Cliente
                </DialogTitle>
              </DialogHeader>
              <div className="space-y-4 mt-2">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <Label className="text-xs font-semibold">Nome <span className="text-red-500">*</span></Label>
                    <Input placeholder="Nome completo" value={dvNovoClienteNome} onChange={(e) => setDvNovoClienteNome(e.target.value)} className="h-10 mt-1" autoFocus />
                  </div>
                  <div>
                    <Label className="text-xs font-semibold">Telefone</Label>
                    <Input placeholder="(00) 0.0000-0000" value={dvNovoClienteTelefone} onChange={(e) => setDvNovoClienteTelefone(formatPhone(e.target.value))} className="h-10 mt-1" inputMode="tel" />
                  </div>
                </div>
                <div className="border-t pt-3">
                  <p className="text-xs font-semibold text-muted-foreground mb-2">Informações extras (opcional)</p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                      <Label className="text-xs">CPF</Label>
                      <Input placeholder="000.000.000-00" value={dvNovoClienteCpf} onChange={(e) => { const n = e.target.value.replace(/\D/g, ""); let f = n; if (n.length <= 3) f = n; else if (n.length <= 6) f = `${n.slice(0,3)}.${n.slice(3)}`; else if (n.length <= 9) f = `${n.slice(0,3)}.${n.slice(3,6)}.${n.slice(6)}`; else f = `${n.slice(0,3)}.${n.slice(3,6)}.${n.slice(6,9)}-${n.slice(9,11)}`; setDvNovoClienteCpf(f); }} className="h-9 mt-1" inputMode="numeric" />
                    </div>
                    <div>
                      <Label className="text-xs">Data de Nascimento</Label>
                      <Input type="date" value={dvNovoClienteNascimento} onChange={(e) => setDvNovoClienteNascimento(e.target.value)} className="h-9 mt-1" />
                    </div>
                  </div>
                </div>
                <div className="flex gap-2 pt-2">
                  <Button onClick={handleDvCadastrarNovoCliente} disabled={!dvNovoClienteNome?.trim() || dvCadastrandoCliente} className="flex-1 bg-orange-500 hover:bg-orange-600 text-white">
                    {dvCadastrandoCliente ? "Cadastrando..." : "Cadastrar Cliente"}
                  </Button>
                  <Button variant="outline" onClick={dvCloseNovoClienteModal}>Cancelar</Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </div>
        )}

        <div className="flex-1 flex overflow-hidden min-h-0">
          {/* Lateral: últimos 10 pedidos — Card + ScrollArea */}
          {dvSelectedClienteId && (
            <aside className="w-64 shrink-0 border-r bg-card/50 flex flex-col overflow-hidden">
              <div className="p-2 border-b shrink-0 flex items-center gap-1.5">
                <History className="w-3.5 h-3.5 text-orange-600 dark:text-orange-400" />
                <span className="font-semibold text-xs">Últimos pedidos</span>
              </div>
              <ScrollArea className="flex-1">
                <div className="p-2 space-y-1.5 min-h-0">
                {dvClienteHistoricoLoading && dvClienteHistorico.length === 0 ? (
                  <p className="text-[10px] text-muted-foreground">Carregando...</p>
                ) : (
                  dvClienteHistorico.map((p) => {
                    const items = p.items || [];
                    const isDelivery = (p.tipo_entrega || "").toLowerCase() === "delivery";
                    const parts = [p.endereco_rua, p.endereco_numero].filter(Boolean);
                    const enderecoStr = isDelivery
                      ? (parts.length ? parts.join(", ") + (p.endereco_bairro ? ` - ${p.endereco_bairro}` : "") : "") || (p.endereco_label || "")
                      : "";
                    const enderecoDisplay = isDelivery ? (enderecoStr.trim() || "Sem endereço") : "Retirada";
                    return (
                      <Card key={p.id} className="p-2 space-y-1 text-[10px] overflow-hidden">
                        <div className="flex items-center justify-between gap-1">
                          <Badge variant="secondary" className="font-mono text-[9px] px-1 py-0">{p.codigo || "—"}</Badge>
                          <span className="text-muted-foreground text-[9px]">{formatDate(p.created_at)}</span>
                          <span className="text-orange-600 dark:text-orange-400 font-bold text-[11px]">R$ {(p.total || 0).toFixed(2).replace(".", ",")}</span>
                        </div>
                        <p className="text-muted-foreground text-[9px] truncate">{enderecoDisplay} {p.forma_pagamento ? `· ${fmtFormaPagamentoLabel(p.forma_pagamento)}` : ''}</p>
                        <div className="flex gap-1 flex-wrap">
                          {items.slice(0, 4).map((it, i) => (
                            <div key={i} className="w-8 h-8 rounded overflow-hidden bg-muted flex-shrink-0">
                              {it.photo_url ? <img src={getImageUrl(it.photo_url)} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-[10px]">🍽</div>}
                            </div>
                          ))}
                          {items.length > 4 && <div className="w-8 h-8 rounded bg-muted flex items-center justify-center text-[9px] text-muted-foreground">+{items.length - 4}</div>}
                        </div>
                        <div className="space-y-0.5">
                          {items.slice(0, 3).map((it, i) => (
                            <p key={i} className="text-[9px] truncate">
                              <span className="font-medium">{it.nome || it.name || "Item"}</span>
                              <span className="text-muted-foreground">{qtdResumida(it, allProductsWithInsumos)}</span>
                            </p>
                          ))}
                          {items.length > 3 && <p className="text-[9px] text-muted-foreground">+{items.length - 3} mais</p>}
                        </div>
                        <button onClick={() => handleDvRepetirPedido(p)} className="w-full py-1 px-2 text-[10px] font-medium border rounded hover:bg-muted transition-colors flex items-center justify-center gap-1">
                          <RotateCw className="w-2.5 h-2.5" /> Refazer
                        </button>
                      </Card>
                    );
                  })
                )}
              </div>
              </ScrollArea>
            </aside>
          )}
          {/* Área Produtos — toolbar + grid */}
          <section className="flex-1 flex flex-col min-w-0 overflow-hidden min-h-0 bg-background">
            <div className="shrink-0 p-3 border-b bg-card/50 space-y-3">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <Input placeholder="Buscar produto..." value={dvProductSearchTerm} onChange={(e) => setDvProductSearchTerm(e.target.value)} className="pl-10 h-10 rounded-xl border-2 focus:border-orange-500/50 bg-background" />
              </div>
              <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
                <button onClick={() => setDvSelectedCategory("all")} className={`flex-shrink-0 px-4 py-2 rounded-xl text-xs font-semibold transition-all ${dvSelectedCategory === "all" ? "bg-orange-500 text-white shadow-md" : "bg-muted hover:bg-muted/80"}`}>Todos</button>
                {dvCategoriesWithProducts.map((cat) => (
                  <button key={cat.id} onClick={() => setDvSelectedCategory(cat.name)} className={`flex-shrink-0 px-4 py-2 rounded-xl text-xs font-semibold transition-all ${dvSelectedCategory === cat.name ? "bg-orange-500 text-white shadow-md" : "bg-muted hover:bg-muted/80"}`}>{cat.name}</button>
                ))}
              </div>
            </div>
            <div className="flex-1 overflow-auto min-h-0">
              <div className="p-3 sm:p-4 pb-6">
                {deliveryVendasLoading ? (
                  <div className="flex flex-col items-center justify-center h-48 gap-2"><div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" /><p className="text-sm text-muted-foreground">Carregando...</p></div>
                ) : (
                  <div className="space-y-6">
                    {/* Promoções Ativas no Topo */}
                    {dvActivePromotions.length > 0 && dvActivePromotions.map(promo => {
                      const promoProds = (promo.products || [])
                        .map(pp => (dvAllProducts.length ? dvAllProducts : dvProducts).find(p => p.id === pp.product_id))
                        .filter(Boolean);
                      if (promoProds.length === 0) return null;
                      return (
                        <div key={promo.id}>
                          <h2 className="text-sm font-bold text-green-500 uppercase tracking-wide mb-1 flex items-center gap-2">
                            <span>🔥</span> {promo.name}
                          </h2>
                          {promo.description && <p className="text-xs text-muted-foreground mb-2">{promo.description}</p>}
                          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-2 sm:gap-3">
                            {promoProds.map(p => (
                              <button key={p.id} onClick={() => p.available !== false && openDvProductPopup(p)} className={`group bg-card rounded-xl border-2 border-green-500/40 text-left overflow-hidden transition-all shadow-sm ${p.available === false ? "opacity-60 cursor-not-allowed" : "hover:border-green-500/60 hover:shadow-md active:scale-[0.98]"}`}>
                                <div className="aspect-[3/4] bg-muted relative overflow-hidden">
                                  {p.photo_url ? <img src={getImageUrl(p.photo_url)} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200" /> : <div className="w-full h-full flex items-center justify-center"><ImageOff className="w-6 h-6 text-muted-foreground" /></div>}
                                </div>
                                <div className="p-2">
                                  <p className="font-semibold text-[10px] sm:text-xs line-clamp-1">{p.name}</p>
                                  {(() => {
                                    const promoInfo = getDvPromoForProduct(p.id, 'simples');
                                    const origPrice = p.sale_price || 0;
                                    const finalPrice = calcDvPromoPrice(origPrice, promoInfo);
                                    return finalPrice != null && finalPrice !== origPrice ? (
                                      <div className="flex items-center gap-1">
                                        <span className="text-[9px] line-through text-muted-foreground">R$ {origPrice.toFixed(2).replace(".", ",")}</span>
                                        <span className="font-bold text-[10px] sm:text-xs text-green-500">R$ {finalPrice.toFixed(2).replace(".", ",")}</span>
                                      </div>
                                    ) : (
                                      <span className="font-bold text-[10px] sm:text-xs text-orange-500">R$ {origPrice.toFixed(2).replace(".", ",")}</span>
                                    );
                                  })()}
                                </div>
                              </button>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                    {dvSectionsToShowFiltered.map(([cat, prods]) => (
                      <div key={cat}>
                        <h2 className="text-sm font-bold text-orange-600 dark:text-orange-400 uppercase tracking-wide mb-2 flex items-center gap-2">
                          <div className="w-1 h-4 rounded-full bg-orange-500" />
                          {cat}
                        </h2>
                        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-2 sm:gap-3">
                          {(prods || []).map((p) => (
                            <button key={p.id} onClick={() => p.available !== false && openDvProductPopup(p)} className={`group bg-card rounded-xl border-2 text-left overflow-hidden transition-all shadow-sm ${p.available === false ? "opacity-60 cursor-not-allowed" : "hover:border-orange-500/60 hover:shadow-md active:scale-[0.98]"}`}>
                              <div className="aspect-[3/4] bg-muted relative overflow-hidden">
                                {p.photo_url ? <img src={getImageUrl(p.photo_url)} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200" /> : <div className="w-full h-full flex items-center justify-center"><ImageOff className="w-6 h-6 text-muted-foreground" /></div>}
                              </div>
                              <div className="p-2">
                                <p className="font-semibold text-[10px] sm:text-xs line-clamp-1">{p.name}</p>
                                {(() => {
                                  const promoInfo = getDvPromoForProduct(p.id, 'simples');
                                  const origPrice = p.sale_price || 0;
                                  const finalPrice = calcDvPromoPrice(origPrice, promoInfo);
                                  return finalPrice != null && finalPrice !== origPrice ? (
                                    <div className="flex items-center gap-1">
                                      <span className="text-[9px] line-through text-muted-foreground">R$ {origPrice.toFixed(2).replace(".", ",")}</span>
                                      <span className="font-bold text-[10px] sm:text-xs text-green-500">R$ {finalPrice.toFixed(2).replace(".", ",")}</span>
                                    </div>
                                  ) : (
                                    <span className="font-bold text-[10px] sm:text-xs text-orange-500">R$ {origPrice.toFixed(2).replace(".", ",")}</span>
                                  );
                                })()}
                              </div>
                            </button>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </section>

          {/* Carrinho lateral fixo — estilo Mesas */}
          <div className="hidden lg:flex w-72 flex-col border-l bg-muted/20 shrink-0">
            <div className="p-4 border-b">
              <div className="flex items-center gap-2">
                <ShoppingCart className="w-5 h-5 text-primary" />
                <h3 className="font-bold">Pedido</h3>
                {dvCart.length > 0 && <span className="text-sm text-muted-foreground">({dvCartItemsCount} itens)</span>}
              </div>
            </div>

            <div className="flex-1 overflow-auto p-3 space-y-4">
              <div>
                <p className="text-xs font-semibold text-muted-foreground uppercase mb-2">Itens (a enviar)</p>
                <AvisoOfertasCliente ofertasDia={dvOfertasCliente} cart={dvCart} className="mb-2" />
                {dvCart.length === 0 ? (
                  <p className="text-sm text-muted-foreground">Nenhum item</p>
                ) : (
                  <div className="space-y-2">
                    {dvCart.map((item) => {
                      const stepsSummary = getDvStepsSummary(item);
                      return (
                        <div key={item.cartItemId || item.id} className="flex items-center gap-2 p-2 bg-background rounded-lg">
                          <div className="w-10 h-10 bg-muted rounded-lg flex-shrink-0 overflow-hidden">
                            {item.photo_url ? (
                              <img src={getImageUrl(item.photo_url)} alt="" className="w-full h-full object-cover" />
                            ) : (
                              <div className="w-full h-full flex items-center justify-center text-base">🍽️</div>
                            )}
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-1 flex-wrap">
                              <p className="font-medium text-sm truncate">{item.name}</p>
                              {item.combo_type && (
                                <span className={`text-[9px] px-1 py-0.5 rounded ${item.combo_type === 'combo' ? 'bg-green-500/20 text-green-700 dark:text-green-400' : 'bg-blue-500/20 text-blue-600 dark:text-blue-400'}`}>
                                  {item.combo_type === 'combo' ? 'COMBO' : 'SIMPLES'}
                                </span>
                              )}
                            </div>
                            {(item.observation || item.observacao) && (
                              <p className="text-xs text-orange-500 truncate">📝 {item.observation || item.observacao}</p>
                            )}
                            {stepsSummary.length > 0 && (
                              <p className="text-[10px] text-muted-foreground mt-0.5 line-clamp-2">
                                {stepsSummary.map((s) => s.items.join(', ')).join(' • ')}
                              </p>
                            )}
                            <p className="text-xs text-primary font-bold">
                              R$ {((item.final_price ?? item.sale_price ?? 0) * (item.quantity || 1)).toFixed(2).replace(".", ",")}
                            </p>
                          </div>
                          <div className="flex items-center gap-1">
                            <Button variant="outline" size="icon" className="h-7 w-7" onClick={() => dvUpdateQuantity(item.cartItemId || item.id, -1)}>
                              <Minus className="w-3 h-3" />
                            </Button>
                            <span className="min-w-[1.5rem] text-center text-sm">
                              {item.is_divisible ? Number(item.quantity).toFixed(3).replace('.', ',') : item.quantity}
                              {item.sale_unit && item.sale_unit !== "un" && <span className="text-[10px] text-muted-foreground ml-0.5">{item.sale_unit}</span>}
                            </span>
                            <Button variant="outline" size="icon" className="h-7 w-7" onClick={() => dvUpdateQuantity(item.cartItemId || item.id, 1)}>
                              <Plus className="w-3 h-3" />
                            </Button>
                          </div>
                          <Button variant="ghost" size="icon" className="h-7 w-7 text-destructive" onClick={() => dvRemoveFromCart(item.cartItemId || item.id)}>
                            <X className="w-3 h-3" />
                          </Button>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            {/* Footer: Total + AVANÇAR */}
            <div className="p-4 border-t bg-background">
              <div className="flex justify-between items-center mb-2">
                <span className="font-medium">Total</span>
                <span className="text-xl font-bold text-primary">R$ {(dvCartTotal + (dvTipoEntrega === "delivery" ? dvTaxaEntrega : 0)).toFixed(2).replace(".", ",")}</span>
              </div>
              <Button
                onClick={handleDvEnviarPedido}
                className="w-full h-12 font-semibold bg-orange-500 hover:bg-orange-600"
                disabled={dvCart.length === 0 || !dvSelectedClienteId}
              >
                {!dvSelectedClienteId ? "Selecione um cliente" : dvCart.length === 0 ? "Adicione itens" : "AVANÇAR"}
              </Button>
            </div>
          </div>
        </div>

        {/* Mobile: barra fixa no rodapé com resumo do carrinho */}
        <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-card border-t shadow-lg px-4 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0 flex-1">
            <ShoppingCart className="w-5 h-5 text-primary shrink-0" />
            <span className="text-sm font-medium truncate">{dvCartItemsCount} itens</span>
            <span className="text-sm font-bold text-primary">R$ {(dvCartTotal + (dvTipoEntrega === "delivery" ? dvTaxaEntrega : 0)).toFixed(2).replace(".", ",")}</span>
          </div>
          <Button
            onClick={handleDvEnviarPedido}
            className="h-11 px-4 font-semibold bg-orange-500 hover:bg-orange-600 shrink-0"
            disabled={dvCart.length === 0 || !dvSelectedClienteId}
          >
            AVANÇAR
          </Button>
        </div>

        <ProductPopupCardapio product={dvSelectedProduct} open={dvProductPopupOpen} onClose={closeDvProductPopup} onAddToCart={handleDvAddToCartFromPopup} darkMode={isDark} allProducts={dvAllProducts.length ? dvAllProducts : dvProducts} activePromotions={dvActivePromotions} />
        {/* Popup dedicado de Pizza */}
        {dvPizza.popup}

        {/* Dialog Entrega/Retirada — igual ao Cardápio */}
        <Dialog
          open={dvEntregaPopupOpen}
          onOpenChange={(open) => {
            setDvEntregaPopupOpen(open);
            if (!open) {
              setDvShowNewAddressForm(false);
              setDvNewAddress({ label: "Casa", endereco: "", numero: "", complemento: "", bairro: "", cep: "" });
            }
          }}
        >
          <DialogContent className="sm:max-w-lg max-h-[90dvh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <Truck className="w-5 h-5" /> Tipo de Entrega
              </DialogTitle>
            </DialogHeader>
            <div className="space-y-4 mt-2">
              {/* Tipo: Entrega ou Retirada */}
              <div className="grid grid-cols-2 gap-3">
                <button
                  type="button"
                  className={`p-4 border-2 rounded-xl flex flex-col items-center gap-2 transition-all ${
                    dvTipoEntrega === "delivery" ? "border-orange-500 bg-orange-500/10" : "border-border hover:border-orange-300"
                  }`}
                  onClick={() => setDvTipoEntrega("delivery")}
                >
                  <Bike className="w-8 h-8 text-orange-500" />
                  <span className="font-medium">Delivery</span>
                  <span className="text-xs text-muted-foreground text-center">Entrega no endereço</span>
                </button>
                <button
                  type="button"
                  className={`p-4 border-2 rounded-xl flex flex-col items-center gap-2 transition-all ${
                    dvTipoEntrega === "pickup" ? "border-orange-500 bg-orange-500/10" : "border-border hover:border-orange-300"
                  }`}
                  onClick={() => setDvTipoEntrega("pickup")}
                >
                  <Store className="w-8 h-8 text-orange-500" />
                  <span className="font-medium">Retirada</span>
                  <span className="text-xs text-muted-foreground text-center">Cliente retira no local</span>
                </button>
              </div>

              {/* Endereço (se delivery) — igual Cardápio: lista + botão "Cadastrar novo endereço"; dados só ao clicar */}
              {dvTipoEntrega === "delivery" && (
                <div className="space-y-3 border-t pt-4">
                  <h4 className="font-medium flex items-center gap-2">
                    <MapPin className="w-4 h-4" /> Endereço de Entrega
                  </h4>
                  {dvClienteIdResolved && (
                    <>
                      {dvEnderecosLoading ? (
                        <div className="flex justify-center py-6">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500" />
                        </div>
                      ) : !dvShowNewAddressForm ? (
                        <>
                          {dvEnderecosCliente.length > 0 && (
                            <div className="space-y-3">
                              <p className="text-sm text-muted-foreground">Selecione um endereço:</p>
                              {dvEnderecosCliente.map((addr) => (
                                <div
                                  key={addr.id}
                                  className={`relative w-full p-4 rounded-xl border-2 transition-all text-left cursor-pointer ${
                                    dvEnderecoSelecionadoId === addr.id ? "border-orange-500 bg-orange-500/10" : "border-border hover:border-orange-300"
                                  }`}
                                  onClick={() => {
                                    setDvEndereco({ rua: addr.endereco || "", numero: addr.numero || "", bairro: addr.bairro || "", complemento: addr.complemento || "" });
                                    setDvEnderecoSelecionadoId(addr.id);
                                    const b = (dvBairros || []).find((x) => String(x.name || x.nome || "").trim().toLowerCase() === String(addr.bairro || "").trim().toLowerCase());
                                    setDvTaxaEntrega(b ? (b.valor_entrega ?? b.taxa_entrega ?? b.taxa ?? b.valor ?? 0) : 0);
                                  }}
                                >
                                  <div className="flex items-start gap-3">
                                    <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${dvEnderecoSelecionadoId === addr.id ? "bg-orange-500" : "bg-muted"}`}>
                                      {(addr.label || "").toLowerCase() === "casa" ? (
                                        <Home className={`w-5 h-5 ${dvEnderecoSelecionadoId === addr.id ? "text-white" : "text-muted-foreground"}`} />
                                      ) : (
                                        <Building className={`w-5 h-5 ${dvEnderecoSelecionadoId === addr.id ? "text-white" : "text-muted-foreground"}`} />
                                      )}
                                    </div>
                                    <div className="flex-1 min-w-0">
                                      <div className="flex items-center gap-2">
                                        <span className="font-semibold">{addr.label || "Endereço"}</span>
                                        {addr.is_default && <span className="text-xs bg-orange-500 text-white px-2 py-0.5 rounded-full">Padrão</span>}
                                      </div>
                                      <p className="text-sm text-muted-foreground mt-1">
                                        {addr.endereco}, {addr.numero || "S/N"} {addr.complemento ? `- ${addr.complemento}` : ""}
                                      </p>
                                      <p className="text-sm text-muted-foreground">{addr.bairro}{addr.cep ? ` - ${addr.cep}` : ""}</p>
                                    </div>
                                    {dvEnderecoSelecionadoId === addr.id && <Check className="w-6 h-6 text-orange-500 shrink-0" />}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                          <button
                            type="button"
                            onClick={() => setDvShowNewAddressForm(true)}
                            className="w-full p-4 rounded-xl border-2 border-dashed border-border hover:border-orange-500 transition-all flex items-center justify-center gap-2 text-muted-foreground"
                          >
                            <Plus className="w-5 h-5" />
                            Cadastrar novo endereço de entrega
                          </button>
                        </>
                      ) : (
                        <div className="p-4 rounded-xl bg-card space-y-4">
                          <div className="flex items-center justify-between">
                            <h3 className="font-semibold">Novo Endereço</h3>
                            <button
                              type="button"
                              onClick={() => { setDvShowNewAddressForm(false); setDvNewAddress({ label: "Casa", endereco: "", numero: "", complemento: "", bairro: "", cep: "" }); }}
                              className="text-muted-foreground hover:text-foreground"
                            >
                              <X className="w-5 h-5" />
                            </button>
                          </div>
                          <div className="grid grid-cols-2 gap-3">
                            <button
                              type="button"
                              onClick={() => setDvNewAddress((p) => ({ ...p, label: "Casa" }))}
                              className={`p-2 rounded-lg border text-sm font-medium transition-all ${dvNewAddress.label === "Casa" ? "border-orange-500 bg-orange-500/10 text-orange-500" : "border-border"}`}
                            >
                              🏠 Casa
                            </button>
                            <button
                              type="button"
                              onClick={() => setDvNewAddress((p) => ({ ...p, label: "Trabalho" }))}
                              className={`p-2 rounded-lg border text-sm font-medium transition-all ${dvNewAddress.label === "Trabalho" ? "border-orange-500 bg-orange-500/10 text-orange-500" : "border-border"}`}
                            >
                              🏢 Trabalho
                            </button>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                            <div className="sm:col-span-2">
                              <Label>Rua *</Label>
                              <Input
                                placeholder="Nome da rua"
                                value={dvNewAddress.endereco}
                                onChange={(e) => setDvNewAddress((p) => ({ ...p, endereco: e.target.value }))}
                                className="h-10 mt-1"
                              />
                            </div>
                            <div>
                              <Label>Número *</Label>
                              <Input
                                placeholder="Nº"
                                value={dvNewAddress.numero}
                                onChange={(e) => setDvNewAddress((p) => ({ ...p, numero: e.target.value }))}
                                className="h-10 mt-1"
                              />
                            </div>
                          </div>
                          <div>
                            <Label>Bairro *</Label>
                            <Select
                              value={dvNewAddress.bairro || ""}
                              onValueChange={(v) => {
                                const b = (dvBairros || []).find((x) => (x.name || x.nome) === v);
                                setDvNewAddress((p) => ({ ...p, bairro: v, cep: b?.cep || p.cep }));
                              }}
                            >
                              <SelectTrigger className="h-10 mt-1">
                                <SelectValue placeholder="Selecione o bairro" />
                              </SelectTrigger>
                              <SelectContent>
                                {(dvBairros || []).map((b) => (
                                  <SelectItem key={b.id || b.name || b.nome} value={b.name || b.nome}>
                                    {(b.name || b.nome) || "—"} — R$ {((b.valor_entrega ?? b.taxa_entrega ?? b.taxa ?? b.valor) || 0).toFixed(2).replace(".", ",")}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </div>
                          <div>
                            <Label>Complemento</Label>
                            <Input
                              placeholder="Apto, bloco..."
                              value={dvNewAddress.complemento}
                              onChange={(e) => setDvNewAddress((p) => ({ ...p, complemento: e.target.value }))}
                              className="h-10 mt-1"
                            />
                          </div>
                          <div>
                            <Label>CEP</Label>
                            <Input
                              placeholder="CEP"
                              value={dvNewAddress.cep}
                              onChange={(e) => setDvNewAddress((p) => ({ ...p, cep: e.target.value }))}
                              className="h-10 mt-1"
                            />
                          </div>
                          {(() => {
                            const b = (dvBairros || []).find((x) => (x.name || x.nome) === dvNewAddress.bairro);
                            const v = b ? (b.valor_entrega ?? b.taxa_entrega ?? b.taxa ?? b.valor ?? 0) : 0;
                            return v > 0 ? <p className="text-sm text-green-600 dark:text-green-400">Taxa de entrega: R$ {v.toFixed(2).replace(".", ",")}</p> : null;
                          })()}
                          <Button onClick={handleDvSaveNewAddress} disabled={dvSavingAddress} className="w-full bg-orange-500 hover:bg-orange-600 text-white">
                            {dvSavingAddress ? "Salvando..." : "Salvar Endereço"}
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                  {!dvShowNewAddressForm && dvTaxaEntrega > 0 && (
                    <p className="text-sm text-muted-foreground">Taxa de entrega: <strong className="text-foreground">R$ {dvTaxaEntrega.toFixed(2).replace(".", ",")}</strong></p>
                  )}
                </div>
              )}

              {!(dvTipoEntrega === "delivery" && dvShowNewAddressForm) && (
                <Button onClick={handleDvContinuarEntrega} className="w-full h-12 bg-orange-500 hover:bg-orange-600 font-semibold">
                  Avançar
                </Button>
              )}
            </div>
          </DialogContent>
        </Dialog>

        {/* Dialog Pagamento */}
        <Dialog
          open={dvPaymentDialogOpen}
          onOpenChange={(open) => {
            setDvPaymentDialogOpen(open);
            if (!open) {
              setDvShowChangeDialog(false);
              setDvNeedsChange(null);
              setDvChangeAmount("");
            }
          }}
        >
          <DialogContent className="sm:max-w-md">
            <DialogHeader><DialogTitle>Forma de pagamento {dvTipoEntrega === "pickup" && <span className="text-sm font-normal text-muted-foreground ml-1">(opcional)</span>}</DialogTitle></DialogHeader>
            <div className="space-y-4 mt-4">
              <p className="text-center text-2xl font-bold text-primary">R$ {(dvCartTotal + (dvTipoEntrega === "delivery" ? dvTaxaEntrega : 0)).toFixed(2).replace(".", ",")}</p>
              {dvTipoEntrega === "pickup" && (
                <p className="text-sm text-center text-muted-foreground">Cliente pode pagar ao retirar. Selecione apenas se for pagamento online.</p>
              )}
              <div className="grid grid-cols-2 gap-3">
                {(dvPaymentMethods.length ? dvPaymentMethods : [{ id: "dinheiro", code: "dinheiro", label: "Dinheiro", icon: Banknote, color: "bg-green-500" }, { id: "pix", code: "pix", label: "PIX", icon: Banknote, color: "bg-teal-500" }, { id: "cartao", code: "cartao", label: "Cartão", icon: CreditCard, color: "bg-blue-500" }]).filter((m) => {
                  if (dvTipoEntrega === "pickup") {
                    const code = m.code || m.id;
                    return code === 'pix_online' || code === 'cartao_online';
                  }
                  return true;
                }).map((m) => {
                  const Icon = m.icon || Banknote;
                  return (
                    <button key={m.id} type="button" onClick={() => setDvFormaPagamento(m.code)} className={`p-4 rounded-lg border-2 flex flex-col items-center gap-2 ${dvFormaPagamento === m.code ? "border-primary bg-primary/10" : "border-transparent bg-muted"}`}>
                      <div className={`p-2 rounded-lg ${m.color} text-white`}><Icon className="w-5 h-5" /></div>
                      <span className="font-medium">{m.label}</span>
                    </button>
                  );
                })}
              </div>
              {/* Já pago — só para delivery */}
              {dvTipoEntrega !== "pickup" && (
                <button
                  onClick={() => setDvJaPago(!dvJaPago)}
                  className={`w-full flex items-center gap-2 p-2 rounded-lg border-2 transition-all text-xs mb-2 ${
                    dvJaPago ? 'border-green-500 bg-green-500/10 text-green-700 dark:text-green-400' : 'border-border text-muted-foreground hover:border-green-300'
                  }`}
                >
                  {dvJaPago ? <ToggleRight className="w-4 h-4 text-green-500" /> : <ToggleLeft className="w-4 h-4" />}
                  <span className="font-medium">{dvJaPago ? 'Já pago' : 'Marcar como já pago'}</span>
                  {dvJaPago && <Check className="w-3.5 h-3.5 ml-auto text-green-500" />}
                </button>
              )}
              {_formaBase(dvFormaPagamento) === "dinheiro" && dvNeedsChange !== null && (
                <div className="p-3 rounded-lg bg-muted/50 border border-border">
                  <p className="text-sm text-muted-foreground">
                    💵 {dvNeedsChange
                      ? `Troco para R$ ${parseFloat(dvChangeAmount || 0).toFixed(2).replace(".", ",")}`
                      : "Não precisa de troco"}
                  </p>
                </div>
              )}
              <div className="flex gap-2">
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => { setDvPaymentDialogOpen(false); setDvEntregaPopupOpen(true); }}
                  className="flex-1"
                >
                  <ArrowLeft className="w-4 h-4 mr-1" />
                  Voltar
                </Button>
                <Button onClick={handleDvConfirmPayment} disabled={dvSubmitting || (!dvFormaPagamento && dvTipoEntrega !== "pickup")} className="flex-1">
                  {dvTipoEntrega === "pickup" && !dvFormaPagamento ? "Enviar sem pagamento" : "Confirmar e enviar pedido"}
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>

        {/* Dialog de Troco (igual ao Cardápio) */}
        <Dialog
          open={dvShowChangeDialog}
          onOpenChange={(open) => {
            if (!open) {
              setDvShowChangeDialog(false);
              setDvNeedsChange(null);
              setDvChangeAmount("");
            }
          }}
        >
          <DialogContent className="sm:max-w-sm">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <Banknote className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-xl font-bold">Vai precisar de troco?</h3>
              <p className="text-muted-foreground text-sm mt-2">
                Total do pedido: <span className="font-bold text-orange-500">R$ {(dvCartTotal + (dvTipoEntrega === "delivery" ? dvTaxaEntrega : 0)).toFixed(2).replace(".", ",")}</span>
              </p>
            </div>

            {dvNeedsChange === null ? (
              <div className="grid grid-cols-2 gap-3">
                <Button
                  type="button"
                  onClick={() => setDvNeedsChange(false)}
                  variant="outline"
                  className="h-12 border-border"
                >
                  Não preciso
                </Button>
                <Button
                  type="button"
                  onClick={() => setDvNeedsChange(true)}
                  className="h-12 bg-orange-500 hover:bg-orange-600 text-white"
                >
                  Sim, preciso
                </Button>
              </div>
            ) : dvNeedsChange ? (
              <div className="space-y-4">
                <div>
                  <Label className="text-sm text-muted-foreground">Troco para quanto?</Label>
                  <div className="relative mt-1">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-lg font-bold text-green-600">R$</span>
                    <Input
                      type="text"
                      inputMode="decimal"
                      value={dvChangeAmount}
                      onChange={(e) => setDvChangeAmount(sanitizeCurrencyInput(e.target.value))}
                      placeholder="0.00"
                      className="pl-12 h-14 text-xl font-bold mt-1"
                      autoFocus
                    />
                  </div>
                  {dvChangeAmount && parseFloat(dvChangeAmount) > (dvCartTotal + (dvTipoEntrega === "delivery" ? dvTaxaEntrega : 0)) && (
                    <p className="text-sm text-green-600 dark:text-green-400 mt-2">
                      Troco: R$ {(parseFloat(dvChangeAmount) - (dvCartTotal + (dvTipoEntrega === "delivery" ? dvTaxaEntrega : 0))).toFixed(2).replace(".", ",")}
                    </p>
                  )}
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <Button
                    type="button"
                    onClick={() => { setDvNeedsChange(null); setDvChangeAmount(""); }}
                    variant="outline"
                    className="border-border"
                  >
                    Voltar
                  </Button>
                  <Button
                    type="button"
                    onClick={handleDvConfirmChange}
                    disabled={!dvChangeAmount || parseFloat(dvChangeAmount) <= (dvCartTotal + (dvTipoEntrega === "delivery" ? dvTaxaEntrega : 0))}
                    className="bg-orange-500 hover:bg-orange-600 text-white"
                  >
                    Confirmar
                  </Button>
                </div>
              </div>
            ) : (
              <Button
                type="button"
                onClick={handleDvConfirmChange}
                className="w-full h-12 bg-orange-500 hover:bg-orange-600 text-white"
              >
                Continuar
              </Button>
            )}
          </DialogContent>
        </Dialog>
      </div>
    );
  }


  // 1ª leitura dos pedidos (dono, 25/10/2026): a tela abre com cabeçalhos,
  // busca e botões na hora e as colunas mostram cartões em cinza
  // (CartoesPedidoCarregando) — antes era um círculo girando na tela toda. O
  // contador das colunas fica cinza em vez de "0". A releitura de 5 s não volta.
  const contagem = (n) => (loading ? <span className="inline-block w-3 h-2.5 rounded-sm bg-current opacity-25 animate-pulse align-middle" /> : n);

  // Calcular tempo decorrido desde a criação do pedido
  // `fimEm` = instante em que o pedido terminou (cancelamento): o relógio para ali.
  const calcularTempoDecorrido = (createdAt, fimEm = null) => {
    if (!createdAt) return "";
    const agora = fimEm ? new Date(fimEm) : new Date();
    const criacao = new Date(createdAt);
    const diffMs = agora - criacao;
    const diffMin = Math.floor(diffMs / 60000);
    const horas = Math.floor(diffMin / 60);
    const minutos = diffMin % 60;
    if (horas > 0) {
      return `${horas}h${minutos.toString().padStart(2, '0')}min`;
    }
    return `${minutos}min`;
  };

  // Cancelamento externo do iFood (regra de 16/09): o PRÓPRIO card, vermelho,
  // com faixa "Cancelado pelo iFood" e o botão de confirmar na base. Olhinho e
  // clique no corpo continuam abrindo os detalhes. `autoHide` = ainda não tinha
  // sido aceito: sem popup, some sozinho em 8 min ou no "Dispensar".
  const CanceladoCard = ({ pedido, autoHide }) => {
    const bruto = pedido.motivo_cancelamento ? String(pedido.motivo_cancelamento).replace(/\s*\([A-Z_]+\)\s*(\[\d+\])?$/, '') : '';
    const inicio = new Date(pedido.ts_cancelado || pedido.updated_at || pedido.created_at).getTime();
    return (
      <PedidoCard
        pedido={pedido}
        showButton={false}
        cancelado={{
          autoHide,
          minutesLeft: Math.max(1, Math.ceil((AUTO_HIDE_CANCELADO_MS - (agoraTick - inicio)) / 60000)),
          motivo: bruto === 'Cancelado pelo iFood' ? '' : bruto,
          onConfirm: () => (autoHide ? confirmAcknowledgeCancellation(pedido) : handleAcknowledgeCancellation(pedido)),
        }}
      />
    );
  };

  // Card de Pedido reutilizável
  const PedidoCard = ({ pedido, showButton, buttonType, onButtonClick, selectable, selected, onSelect, justTransitioned, onViewDetails, entregaAiActive, entregaAiStatus, cancelado }) => {
    const retirada = isRetirada(pedido);
    // Pedido cancelado: o relógio congela no cancelamento (ts_cancelado; updated_at nos antigos).
    const fimEm = pedido.status === 'cancelado' ? (pedido.ts_cancelado || pedido.updated_at || null) : null;
    const [tempoDecorrido, setTempoDecorrido] = useState(calcularTempoDecorrido(pedido.created_at, fimEm));

    // Verificar se é pagamento online (PIX ou Cartão) e status do pagamento
    const isPixOnline = pedido.forma_pagamento === 'pix_online';
    const isCartaoOnline = pedido.forma_pagamento === 'cartao_online';
    const isOnlinePayment = isPixOnline || isCartaoOnline;
    const onlinePaymentStatus = pedido.payment_status;
    const isOnlinePending = isOnlinePayment && onlinePaymentStatus !== 'paid';
    const isOnlinePaid = isOnlinePayment && onlinePaymentStatus === 'paid';
    const isOnlineCancelled = isOnlinePayment && (onlinePaymentStatus === 'expired' || onlinePaymentStatus === 'cancelled' || onlinePaymentStatus === 'refunded' || onlinePaymentStatus === 'rejected');
    const isManualPaid = !isOnlinePayment && pedido.payment_status === 'paid';

    // Tempo decorrido com cor dinâmica
    useEffect(() => {
      const interval = setInterval(() => {
        setTempoDecorrido(calcularTempoDecorrido(pedido.created_at, fimEm));
      }, 60000);
      return () => clearInterval(interval);
    }, [pedido.created_at, fimEm]);

    // Urgência por ETAPA, não por idade absoluta: 30min é aceitável pra um
    // pedido em produção e um desastre pra um aguardando aceite. Limiar único
    // deixava a coluna de produção sempre vermelha e dessensibilizava o alerta.
    const LIMIARES = { aguardando_aceite: [5, 10], producao: [20, 40], pronto: [10, 20] };
    const getTempoTom = () => {
      if (!pedido.created_at) return 'muted';
      const mins = (Date.now() - new Date(pedido.created_at).getTime()) / 60000;
      const [ok, alerta] = LIMIARES[pedido.status] || [20, 40];
      if (mins < ok) return 'ok';
      if (mins < alerta) return 'alerta';
      return 'critico';
    };
    const TEMPO_PILL = {
      muted:   'bg-muted text-muted-foreground',
      ok:      'bg-green-500/15 text-green-600 dark:text-green-400',
      alerta:  'bg-amber-500/15 text-amber-600 dark:text-amber-400',
      critico: 'bg-red-500/15 text-red-600 dark:text-red-400 font-bold animate-pulse',
    };

    // Montar endereço completo
    const enderecoCompleto = retirada ? null : [
      pedido.endereco_rua,
      pedido.endereco_numero ? `nº ${pedido.endereco_numero}` : null,
      pedido.endereco_bairro,
      pedido.endereco_complemento
    ].filter(Boolean).join(', ') || "Sem endereço";

    const handlePrint = async (type) => {
      setPrintMenuPedidoId(null);
      try {
        let results = [];
        if (type === 'ambos') { results = await Promise.all([imprimirCupom(pedido), imprimirCupomPreparo(pedido)]); }
        else if (type === 'entrega') { results = [await imprimirCupom(pedido)]; }
        else { results = [await imprimirCupomPreparo(pedido)]; }
        const printSuccess = results.every(r => r?.success);
        const printStatus = printSuccess ? 'success' : 'failed';
        await axios.patch(`${API}/pedidos/${pedido.id}/print-status`, { print_status: printStatus }, getAuthHeader()).catch(() => {});
        if (printSuccess) {
          toast.success('Cupom enviado!');
          fetchData();
        } else {
          toast.error('Falha ao enviar cupom - verifique a impressora!');
        }
      } catch (err) {
        toast.error(err?.message || 'Erro ao imprimir');
        await axios.patch(`${API}/pedidos/${pedido.id}/print-status`, { print_status: 'failed' }, getAuthHeader()).catch(() => {});
      }
    };

    // Primeiro pedido do cliente: pedidos_count incrementa na criação, então count===1 = é o primeiro
    const isFirstOrder = (pedido.cliente_pedidos_count || 0) === 1;
    const isIfood = (pedido.modulo || '').toLowerCase() === 'ifood';
    return (
      <div
        onClick={() => selectable && !retirada ? (onSelect && onSelect(pedido.id)) : handleAbrirDetalhes(pedido)}
        className={`rounded-xl border-l-4 border shadow-sm cursor-pointer relative overflow-hidden
          transition-all duration-200 ease-out hover:shadow-md
          ${justTransitioned ? 'animate-in fade-in slide-in-from-left-3 duration-300' : ''}
          ${isFirstOrder && !selected && !cancelado ? 'ring-2 ring-amber-400/40 shadow-amber-500/10' : ''}
          ${
          cancelado
            ? 'bg-red-50 dark:bg-red-950/40 border-l-red-600 border-red-500/60 ring-2 ring-red-500/50 shadow-md shadow-red-900/20'
            : retirada
            ? 'bg-amber-50 dark:bg-amber-950/20 border-l-amber-500 border-amber-400/50'
            : selected
              ? 'bg-primary/10 border-l-primary border-primary border-2 ring-2 ring-primary/30 shadow-md'
              : isIfood
                ? 'bg-card border-l-red-500 border-red-200 dark:border-red-800/50 hover:border-red-400'
                : 'bg-card border-l-orange-500 border-border/50 hover:border-primary/30'
        }`}
      >
        {/* Faixa de CANCELADO PELO IFOOD (16/09): cancelamento externo — o card fica
            vermelho na coluna em que estava até o funcionário confirmar (ou, se ainda
            não tinha sido aceito, até sumir sozinho em 8 min). */}
        {cancelado && (
          <div className="px-3 py-1.5 bg-red-600 text-white flex items-center justify-between gap-x-3 gap-y-0.5 flex-wrap">
            <span className="inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wide">
              <XCircle className="w-3.5 h-3.5" /> Cancelado pelo iFood
            </span>
            {cancelado.motivo && <span className="text-[11px] font-medium truncate max-w-full">{cancelado.motivo}</span>}
            {cancelado.autoHide && <span className="text-[10px] font-semibold opacity-90">some sozinho em {cancelado.minutesLeft} min</span>}
          </div>
        )}
        {/* Faixa de AGENDADO (v1.5.378): pedido aprovado que veio de agendamento
            mostra quando foi FEITO e pra quando está PREVISTA a entrega/retirada —
            o tempo decorrido padrão não representa urgência nesses pedidos. */}
        {pedido.scheduled_at && (
          <div className="px-3 py-1.5 bg-indigo-500/15 border-b border-indigo-500/30 flex items-center gap-x-3 gap-y-0.5 flex-wrap">
            <span className="inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-wide text-indigo-500">
              <Calendar className="w-3 h-3" />
              {pedido.tipo_entrega === 'pickup' ? 'Retirada' : 'Entrega'} {fmtScheduledAt(pedido.scheduled_at)}
            </span>
            <span className="inline-flex items-center gap-1 text-[10px] text-muted-foreground font-semibold">
              <Clock className="w-3 h-3" />
              pedido feito {fmtCriadoEm(pedido.created_at)}
            </span>
          </div>
        )}
        <div className="p-2.5 sm:p-3">
        {/* ESQUELETO FIXO (v1.5.461): todo card tem as mesmas 4 linhas + botão,
            na mesma ordem — código/tempo, cliente/impressora, local, valor/meta.
            Blocos contextuais (agendado, UP, entregador) entram entre o local e
            o rodapé só quando existem. O que saiu daqui não sumiu: mora nos
            detalhes (clique no card). */}

        {/* L1: seleção + código + identidade + TEMPO (pílula, canto fixo) */}
        <div className="flex items-center gap-1.5 mb-1">
          {selectable && !retirada && (
            <input
              type="checkbox"
              checked={selected}
              onChange={(e) => { e.stopPropagation(); onSelect && onSelect(pedido.id, e); }}
              onClick={(e) => e.stopPropagation()}
              className="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer shrink-0"
            />
          )}
          {/* Ícone da origem ANTES do código (iFood 16/09; Cardápio e atendente
              22/09). No iFood o código dele vem depois do nosso —
              "#76277 - #7904", igual ao cupom de preparo. */}
          <IconeOrigemPedido modulo={pedido.modulo} campanha={pedido.origem_campanha} />
          <span className={`font-mono text-base sm:text-lg font-black tracking-tight ${isIfood ? 'text-red-500' : 'text-orange-500'}`}>
            {pedido.codigo}
            {isIfood && (pedido.ifood_display_id || ifoodMeta(pedido).display_id) && (
              <span> - #{pedido.ifood_display_id || ifoodMeta(pedido).display_id}</span>
            )}
          </span>
          {retirada && (
            <span className="bg-amber-500 text-white text-[9px] px-1.5 py-0.5 rounded font-bold flex items-center gap-0.5 shrink-0">
              <Store className="w-3 h-3" /> RETIRADA
            </span>
          )}
          {pedido.print_status === 'failed' && (
            <span className="inline-flex items-center gap-0.5 text-[9px] px-1.5 py-0.5 rounded font-bold shrink-0 bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400 animate-pulse" title="Falha na impressão">
              <Printer className="w-3 h-3" /><AlertTriangle className="w-2.5 h-2.5" />
            </span>
          )}
          {pedido.has_modification && !pedido.modification_seen && (
            <button
              onClick={(e) => { e.stopPropagation(); handleMarkModificationSeen(pedido); }}
              className="inline-flex items-center gap-0.5 text-[9px] px-1.5 py-0.5 rounded font-bold shrink-0 bg-amber-500 text-white animate-pulse cursor-pointer hover:bg-amber-600"
              title="Pedido alterado pelo WhatsApp — clique para marcar como visto"
            >
              <AlertTriangle className="w-3 h-3" /> ALTERADO
            </button>
          )}
          <span className={`ml-auto shrink-0 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold tabular-nums ${TEMPO_PILL[getTempoTom()]}`}>
            <Clock className="w-3 h-3" /> {tempoDecorrido}
          </span>
        </div>

        {/* L2: cliente + selo de recorrência + fone | impressora */}
        <div className="flex items-center gap-1.5 mb-1 min-w-0">
          <span className="font-semibold text-sm sm:text-base truncate">{pedido.cliente_nome || "Cliente"}</span>
          {isFirstOrder ? (
            <span
              className="inline-flex items-center gap-0.5 text-[9px] font-black uppercase tracking-wider px-1.5 py-0.5 rounded-full shrink-0 bg-gradient-to-r from-amber-400 to-yellow-500 text-amber-950 shadow-sm"
              title="Primeiro pedido deste cliente — boas-vindas!"
            >
              <Sparkles className="w-3 h-3" strokeWidth={2.5} /> 1º
            </span>
          ) : pedido.cliente_pedidos_count > 1 ? (
            <span className="inline-flex items-center gap-0.5 text-[9px] font-bold px-1.5 py-0.5 rounded-full shrink-0 bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400" title={`${pedido.cliente_pedidos_count} pedido(s) no total`}>
              <Package className="w-3 h-3" /> {pedido.cliente_pedidos_count}
            </span>
          ) : null}
          {/* Cliente do iFood não tem telefone próprio: é sempre o 0800 700 3020 e
              o atendente digita o código (localizador) do pedido para ser conectado.
              Por isso sem link de WhatsApp — só 0800 + código, quando houver. */}
          {isIfood ? (() => {
            const c = ifoodMeta(pedido).customer || {};
            if (!c.localizer) return null;
            const fone = String(c.phone_number || pedido.cliente_telefone || '0800 700 3020');
            // tel: com vírgula = pausa e discagem do código (DTMF) — o telefone liga
            // no 0800 do iFood e digita o localizador do pedido sozinho.
            return (
              <a
                href={`tel:${fone.replace(/\D/g, '')},${c.localizer}`}
                onClick={(e) => e.stopPropagation()}
                className="inline-flex items-center gap-0.5 text-[11px] text-green-500 hover:text-green-400 hover:underline shrink-0"
                title="Liga no 0800 do iFood e digita o código do pedido para conectar com o cliente"
              >
                <Phone className="w-3 h-3" /> {fone} · cód. {c.localizer}
              </a>
            );
          })() : pedido.cliente_telefone && (
            <a
              href={`https://wa.me/55${pedido.cliente_telefone.replace(/\D/g, '')}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              className="inline-flex items-center gap-0.5 text-[11px] text-green-500 hover:text-green-400 hover:underline shrink-0"
            >
              <Phone className="w-3 h-3" />
              <span className="hidden sm:inline">{formatPhoneNumber(pedido.cliente_telefone)}</span>
            </a>
          )}
          <div className="flex items-center gap-1 ml-auto shrink-0" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={(e) => {
                  e.stopPropagation();
                  if (printMenuPedidoId === pedido.id) { setPrintMenuPedidoId(null); return; }
                  setPrintMenuAnchor(e.currentTarget.getBoundingClientRect());
                  setPrintMenuPedidoId(pedido.id);
                }}
              className="p-1 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
              title="Imprimir 2ª via"
            >
              <Printer className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Menu de impressão — em PORTAL. Dentro do card era recortado pela
            coluna (overflow) e coberto pelos vizinhos; no body, sempre por cima.
            Alinhado à direita do botão, com clamp pra não sair da viewport. */}
        {printMenuPedidoId === pedido.id && printMenuAnchor && createPortal(
          <>
            <div className="fixed inset-0 z-[90]" onClick={(e) => { e.stopPropagation(); setPrintMenuPedidoId(null); }} />
            <div
              className="fixed z-[91] bg-popover border rounded-lg shadow-lg p-1 min-w-[160px]"
              style={{
                top: Math.min(printMenuAnchor.bottom + 4, window.innerHeight - 210),
                left: Math.max(8, Math.min(printMenuAnchor.right - 160, window.innerWidth - 168)),
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button onClick={() => handlePrint('ambos')} className="w-full text-left px-3 py-2 rounded-md text-xs font-medium hover:bg-muted transition-colors flex items-center gap-2">
                <Printer className="w-3.5 h-3.5" /> Ambos
              </button>
              <button onClick={() => handlePrint('entrega')} className="w-full text-left px-3 py-2 rounded-md text-xs font-medium hover:bg-muted transition-colors flex items-center gap-2">
                <FileText className="w-3.5 h-3.5" /> Entrega
              </button>
              <button onClick={() => handlePrint('preparo')} className="w-full text-left px-3 py-2 rounded-md text-xs font-medium hover:bg-muted transition-colors flex items-center gap-2">
                <ChefHat className="w-3.5 h-3.5" /> Preparo
              </button>
              {pedido.status === 'producao' && entregaAiActive && !retirada && (
                <>
                  <div className="border-t my-1" />
                  <button onClick={() => { setPrintMenuPedidoId(null); handleMarcarPronto(pedido.id); }} className="w-full text-left px-3 py-2 rounded-md text-xs font-medium hover:bg-muted transition-colors flex items-center gap-2 text-muted-foreground">
                    <Package className="w-3.5 h-3.5" /> Apenas marcar pronto
                  </button>
                </>
              )}
            </div>
          </>,
          document.body
        )}

        {/* L3: local — SEMPRE 1 linha (padroniza a altura; o endereço completo
            está nos detalhes, um clique de distância) */}
        <div className="text-[11px] sm:text-xs text-muted-foreground mb-1.5 flex items-center gap-1 min-w-0">
          {retirada ? (
            <><Store className="w-3 h-3 shrink-0" /> <span>Retirada no local</span></>
          ) : (
            <><MapPin className="w-3 h-3 shrink-0" /> <span className="truncate">{enderecoCompleto}</span></>
          )}
        </div>

        {/* Status UP Entrega */}
        {entregaAiStatus && pedido.status === 'pronto' && (() => {
          const aiStatus = entregaAiStatus.entregaai_status || '';
          const isCancelled = aiStatus === 'cancelled';
          const isError = aiStatus === 'error';
          if (isError) {
            const errMsg = entregaAiStatus.entregaai_error || entregaAiStatus.entregaai_status_label || 'Falha ao solicitar entregador';
            const errCode = entregaAiStatus.entregaai_error_code || '';
            return (
              <div className="flex items-center gap-2 mb-1.5 px-2 py-1.5 rounded-md bg-red-500/10 border border-red-500/30">
                <div className="w-7 h-7 rounded-full bg-red-500/20 flex items-center justify-center shrink-0">
                  <XCircle className="w-4 h-4 text-red-500" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-[10px] sm:text-xs font-semibold text-red-600 truncate">{errMsg}</p>
                  {errCode && errCode !== 'generic' && (
                    <p className="text-[9px] sm:text-[10px] text-red-500/80">UP Entrega: {errCode.replace('_', ' ')}</p>
                  )}
                </div>
              </div>
            );
          }
          // Calcular tempo desde que o pedido ficou pronto
          const tsPronto = pedido.ts_pronto || pedido.updated_at;
          const tempoStatus = tsPronto ? (() => {
            const diff = Math.floor((Date.now() - new Date(tsPronto).getTime()) / 1000);
            const mins = Math.floor(diff / 60);
            const secs = diff % 60;
            return mins > 0 ? `${mins}m${String(secs).padStart(2, '0')}s` : `${secs}s`;
          })() : null;

          if (isCancelled) {
            return (
              <div className="flex items-center gap-2 mb-1.5 px-2 py-1.5 rounded-md bg-red-500/10 border border-red-500/20">
                <div className="w-7 h-7 rounded-full bg-red-500/20 flex items-center justify-center shrink-0">
                  <XCircle className="w-4 h-4 text-red-500" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-[10px] sm:text-xs font-semibold text-red-600">Cancelado pelo UP Entrega</p>
                </div>
                <button
                  onClick={(e) => { e.stopPropagation(); handleAbrirCancelar(pedido, e); }}
                  className="shrink-0 px-2.5 py-1 rounded-md bg-red-500 hover:bg-red-600 text-white text-[10px] sm:text-xs font-semibold transition-colors"
                >
                  Cancelar
                </button>
              </div>
            );
          }
          return (
            <div className="flex items-center gap-2 mb-1.5 px-2 py-1.5 rounded-md bg-[#0ea5e9]/10 border border-[#0ea5e9]/20">
              {entregaAiStatus.entregaai_driver_name ? (
                <>
                  {entregaAiStatus.entregaai_driver_photo ? (
                    <img src={entregaAiStatus.entregaai_driver_photo} alt="" className="w-8 h-8 rounded-full border-2 border-[#0ea5e9] object-cover shrink-0" />
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-[#0ea5e9] flex items-center justify-center shrink-0">
                      <Bike className="w-4 h-4 text-white" />
                    </div>
                  )}
                  <div className="min-w-0 flex-1">
                    <p className="text-[10px] sm:text-xs font-semibold text-[#0ea5e9] truncate">{entregaAiStatus.entregaai_driver_name}</p>
                    <p className="text-[9px] sm:text-[10px] text-muted-foreground">{entregaAiStatus.entregaai_status_label || 'Motorista encontrado'}</p>
                  </div>
                  {tempoStatus && (
                    <span className="text-[10px] font-mono font-bold text-[#0ea5e9] shrink-0">{tempoStatus}</span>
                  )}
                  {entregaAiStatus.entregaai_driver_phone && (
                    <a href={`tel:${entregaAiStatus.entregaai_driver_phone}`} onClick={(e) => e.stopPropagation()} className="p-1 rounded-md hover:bg-muted" title={entregaAiStatus.entregaai_driver_phone}>
                      <Phone className="w-3.5 h-3.5 text-[#0ea5e9]" />
                    </a>
                  )}
                </>
              ) : (
                <>
                  <div className="w-8 h-8 rounded-full bg-[#0ea5e9]/20 flex items-center justify-center shrink-0 animate-pulse">
                    <Bike className="w-4 h-4 text-[#0ea5e9]" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-[10px] sm:text-xs font-semibold text-[#0ea5e9]">{entregaAiStatus.entregaai_status_label || 'Buscando entregador...'}</p>
                    <p className="text-[9px] sm:text-[10px] text-muted-foreground animate-pulse">Aguardando motorista aceitar</p>
                  </div>
                  {tempoStatus && (
                    <span className="text-[10px] font-mono font-bold text-[#0ea5e9] animate-pulse shrink-0">{tempoStatus}</span>
                  )}
                </>
              )}
            </div>
          );
        })()}

        {/* Entregador atribuído (manual) — mostra foto + nome quando o pedido está em rota/bag.
            Só renderiza pra entregadores manuais; UP Entrega usa o bloco entregaAiStatus acima. */}
        {/* Bloco iFood (Etapa 4): quem entrega, etapa do entregador do iFood, código
            de coleta e aviso de código de entrega. Só aparece quando há algo a dizer. */}
        {isIfood && (() => {
          const m = ifoodMeta(pedido);
          const ifoodEntrega = m.delivered_by === 'IFOOD';
          const etapa = ifoodEntrega && m.delivery_stage ? DELIVERY_STAGE_LABELS[m.delivery_stage] : null;
          const motoboy = pedido.ifood_driver_name || (String(pedido.entregador_nome || '').startsWith('iFood · ') ? pedido.entregador_nome.slice(8) : '');
          // Código de coleta mora no rodapé do card (junto do pagamento); o aviso de
          // código de entrega saiu — o sistema pede o código na hora de marcar entregue.
          if (!ifoodEntrega) return null;
          return (
            <div className="flex flex-wrap items-center gap-1.5 mb-1.5 text-[11px]">
              {ifoodEntrega && (
                <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300 font-semibold" title="O entregador é do iFood — não precisa chamar entregador nem marcar em rota">
                  <Bike className="w-3 h-3" /> Entrega iFood{motoboy ? ` · ${motoboy}` : ''}
                </span>
              )}
              {etapa && <span className="text-muted-foreground">{etapa}</span>}
              {m.delivery_stage && m.delivery_stage !== 'DRIVER_DEALLOCATED' && !['concluido', 'cancelado', 'entregue'].includes(pedido.status) && (
                <button
                  type="button"
                  onClick={async (e) => {
                    e.stopPropagation();
                    try {
                      const t = await fetchOrderTracking(pedido.id);
                      window.open(t.maps_url, '_blank', 'noopener');
                    } catch (err) {
                      toast.error(err?.response?.data?.detail || 'O iFood ainda não tem a posição do entregador');
                    }
                  }}
                  className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md border text-purple-700 dark:text-purple-300 hover:bg-purple-50 dark:hover:bg-purple-900/30"
                  title="Abre a posição atual do entregador do iFood no mapa"
                >
                  <MapPin className="w-3 h-3" /> Ver no mapa
                </button>
              )}
            </div>
          );
        })()}
        {(pedido.status === 'em_rota' || pedido.status === 'na_bag') && pedido.entregador_id && !entregaAiStatus && (() => {
          const entregador = (entregadores || []).find(e => e.id === pedido.entregador_id);
          if (!entregador && !pedido.entregador_nome) return null;
          const nome = entregador?.nome || pedido.entregador_nome || '';
          const foto = entregador?.foto_url ? getImageUrl(entregador.foto_url) : null;
          const iniciais = (nome || '?').substring(0, 2).toUpperCase();
          // Tempo desde que o pedido foi pra rota
          const tsRota = pedido.ts_em_rota || pedido.ts_na_bag || pedido.updated_at;
          const tempoRota = tsRota ? (() => {
            const diff = Math.floor((Date.now() - new Date(tsRota).getTime()) / 1000);
            const mins = Math.floor(diff / 60);
            return mins > 0 ? `${mins}min` : `${diff}s`;
          })() : null;
          const isOnRoute = pedido.status === 'em_rota';
          const accent = isOnRoute ? 'purple' : 'blue';
          const accentClasses = isOnRoute
            ? 'bg-purple-500/10 border-purple-500/20'
            : 'bg-blue-500/10 border-blue-500/20';
          const textClasses = isOnRoute ? 'text-purple-600 dark:text-purple-400' : 'text-blue-600 dark:text-blue-400';
          const ringClasses = isOnRoute ? 'ring-purple-500/40' : 'ring-blue-500/40';
          const phoneTel = entregador?.telefone || pedido.entregador_telefone;
          return (
            <div className={`flex items-center gap-2 mb-1.5 px-2 py-1.5 rounded-md border ${accentClasses}`}>
              {foto ? (
                <img src={foto} alt={nome} className={`w-8 h-8 rounded-full ring-2 ${ringClasses} object-cover shrink-0`} onError={(e) => { e.target.style.display = 'none'; }} />
              ) : (
                <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 text-[10px] font-bold ${isOnRoute ? 'bg-purple-500/20 text-purple-700 dark:text-purple-300' : 'bg-blue-500/20 text-blue-700 dark:text-blue-300'}`}>
                  {iniciais}
                </div>
              )}
              <div className="min-w-0 flex-1">
                <p className={`text-[10px] sm:text-xs font-semibold truncate flex items-center gap-1 ${textClasses}`}>
                  <Bike className="w-3 h-3 shrink-0" />
                  {nome}
                </p>
                <p className="text-[9px] sm:text-[10px] text-muted-foreground">
                  {isOnRoute ? 'Em rota com o cliente' : 'Saiu para entrega'}
                </p>
              </div>
              {tempoRota && (
                <span className={`text-[10px] font-mono font-bold shrink-0 ${textClasses}`}>{tempoRota}</span>
              )}
              {phoneTel && (
                <a
                  href={`tel:${phoneTel}`}
                  onClick={(e) => e.stopPropagation()}
                  className="p-1 rounded-md hover:bg-muted shrink-0"
                  title={phoneTel}
                >
                  <Phone className={`w-3.5 h-3.5 ${textClasses}`} />
                </a>
              )}
            </div>
          );
        })()}

        {/* L4: valor + pagamento | hora · itens */}
        <div className="flex items-center gap-1.5 flex-wrap min-w-0">
          <span className="font-black text-orange-500 text-base sm:text-lg tabular-nums">R$ {(pedido.total || 0).toFixed(2).replace('.', ',')}</span>
          {pedido.forma_pagamento && (
            <span className="flex items-center gap-1 text-[10px] sm:text-[11px] text-muted-foreground bg-muted/50 px-1.5 py-0.5 rounded">
              <CreditCard className="w-3 h-3" />
              {isIfood
                ? (Number(ifoodMeta(pedido).payments_pending || 0) > 0
                    ? `iFood · cobrar R$ ${Number(ifoodMeta(pedido).payments_pending).toFixed(2).replace('.', ',')} na entrega`
                    : 'iFood · pago no app')
                : fmtFormaPagamentoLabel(pedido.forma_pagamento)}
              {_formaBase(pedido.forma_pagamento) === 'dinheiro' && pedido.troco_valor && (
                <span className="text-amber-600 dark:text-amber-400 font-medium">(troco R$ {Math.max(0, Number(pedido.troco_valor) - Number(pedido.total || 0)).toFixed(2).replace('.', ',')})</span>
              )}
            </span>
          )}
          {isIfood && ifoodMeta(pedido).pickup_code && (
            <span className="flex items-center gap-1 text-[10px] sm:text-[11px] font-mono font-bold bg-slate-800 text-white dark:bg-slate-200 dark:text-slate-900 px-1.5 py-0.5 rounded" title="Código de coleta: quem retira o pedido na loja informa este código">
              <Hash className="w-3 h-3" /> coleta {ifoodMeta(pedido).pickup_code}
            </span>
          )}
          {isManualPaid && (
            <span className="flex items-center gap-0.5 text-[10px] px-1.5 py-0.5 rounded-full font-semibold bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400">
              <Check className="w-3 h-3" /> Pago
            </span>
          )}
          {isOnlinePayment && (
            <span className={`flex items-center gap-0.5 text-[10px] px-1.5 py-0.5 rounded-full font-semibold ${
              isOnlinePaid
                ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                : isOnlineCancelled
                  ? 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
                  : 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 animate-pulse'
            }`}>
              {isOnlinePaid ? (
                <><Check className="w-3 h-3" /> Pago</>
              ) : isOnlineCancelled ? (
                <><X className="w-3 h-3" /> {onlinePaymentStatus === 'rejected' ? 'Recusado' : 'Cancelado'}</>
              ) : (
                <><Clock className="w-3 h-3" /> Aguardando</>
              )}
            </span>
          )}
          <span className="ml-auto shrink-0 text-[10px] sm:text-[11px] text-muted-foreground tabular-nums">
            {formatTime(pedido.created_at)} · {pedido.items?.length || 0} {(pedido.items?.length || 0) === 1 ? 'item' : 'itens'}
          </span>
        </div>

        {/* AÇÃO: botão inteiro na base — alvo grande, mesmo lugar em todo card */}
        {(cancelado || showButton || (pedido.status === 'pronto' && onViewDetails) || podeVoltarEtapa(pedido, entregaAiStatus)) && (
          <div className="flex items-center gap-1.5 mt-2" onClick={(e) => e.stopPropagation()}>
            {!cancelado && podeVoltarEtapa(pedido, entregaAiStatus) && (
              <button onClick={(e) => handleVoltarEtapa(pedido, e)} className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-colors shrink-0" title="Voltar etapa">
                <Undo2 className="w-4 h-4" />
              </button>
            )}
            {((pedido.status === 'pronto' && onViewDetails) || cancelado) && (
              <button
                onClick={(e) => { e.stopPropagation(); (onViewDetails || handleAbrirDetalhes)(pedido); }}
                className="p-2 rounded-lg bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 hover:bg-blue-200 dark:hover:bg-blue-800/40 transition-colors shrink-0"
                title="Ver detalhes do pedido"
              >
                <Eye className="w-4 h-4" />
              </button>
            )}
            {cancelado && (
              <Button
                size="sm"
                onClick={(e) => { e.stopPropagation(); cancelado.onConfirm(); }}
                className={`flex-1 h-9 font-bold ${cancelado.autoHide
                  ? 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 hover:bg-red-200 dark:hover:bg-red-900/60'
                  : 'bg-red-600 hover:bg-red-700 text-white animate-pulse shadow-md shadow-red-600/40'}`}
                title={cancelado.autoHide ? 'Tirar da coluna agora (some sozinho em 8 min)' : 'Confirmar que a equipe viu o cancelamento'}
              >
                <XCircle className="w-4 h-4 mr-1" /> {cancelado.autoHide ? 'Dispensar' : 'Confirmar cancelamento'}
              </Button>
            )}
            {showButton && (
              <Button
                size="sm"
                onClick={(e) => onButtonClick && onButtonClick(e)}
                disabled={buttonType === 'aceitar' && isOnlinePending}
                className={`flex-1 h-9 font-semibold ${buttonType === 'aceitar' && isOnlinePending ? 'opacity-50 cursor-not-allowed' : ''} ${buttonType === 'chamar_entregador' ? 'bg-[#0ea5e9] hover:bg-[#0284c7] text-white' : ''} ${buttonType === 'validar_coleta' ? 'bg-red-600 hover:bg-red-700 text-white' : ''}`}
                title={buttonType === 'aceitar' && isOnlinePending ? `Aguardando pagamento ${isCartaoOnline ? 'Cartão' : 'PIX'}` : buttonType === 'chamar_entregador' ? 'Solicitar entregador via UP Entrega' : buttonType === 'validar_coleta' ? 'O entregador do iFood informa um código na coleta — digite para liberar o pedido' : undefined}
              >
                {buttonType === 'aceitar' && <><Check className="w-4 h-4 mr-1" /> Aceitar</>}
                {buttonType === 'pronto' && <><Package className="w-4 h-4 mr-1" /> Pronto</>}
                {buttonType === 'chamar_entregador' && <><img src="/logo-upentrega-v3.png" alt="UP" className="w-5 h-5 mr-1 object-contain" /> Chamar Entregador</>}
                {buttonType === 'finalizar' && <><DollarSign className="w-4 h-4 mr-1" /> Finalizar</>}
                {buttonType === 'validar_coleta' && <><KeyRound className="w-4 h-4 mr-1" /> Validar coleta</>}
              </Button>
            )}
          </div>
        )}
        </div>
      </div>
    );
  };

  return (
    <div className="relative h-full flex flex-col overflow-hidden bg-background">
      {/* Tabs mobile */}
      <div className="flex xl:hidden border-b bg-muted/30 shrink-0">
        {!autoAccept && (
          <button
            onClick={() => setMobileTab("aceite")}
            className={`flex-1 py-2 text-xs font-semibold text-center transition-colors relative ${
              mobileTab === "aceite" ? 'text-orange-600 dark:text-orange-400' : 'text-muted-foreground'
            }`}
          >
            <div className="flex items-center justify-center gap-1">
              <Clock className="w-3.5 h-3.5" />
              <span>Aceite</span>
              <span className={`px-1 py-0.5 rounded-full text-[9px] font-bold ${
                mobileTab === "aceite" ? 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400' : 'bg-muted text-muted-foreground'
              }`}>{contagem(pedidosAguardando.length)}</span>
            </div>
            {mobileTab === "aceite" && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-orange-500" />}
          </button>
        )}
        <button
          onClick={() => setMobileTab("producao")}
          className={`flex-1 py-2 text-xs font-semibold text-center transition-colors relative ${
            mobileTab === "producao" ? 'text-yellow-600 dark:text-yellow-400' : 'text-muted-foreground'
          }`}
        >
          <div className="flex items-center justify-center gap-1">
            <ChefHat className="w-3.5 h-3.5" />
            <span>Produção</span>
            <span className={`px-1 py-0.5 rounded-full text-[9px] font-bold ${
              mobileTab === "producao" ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400' : 'bg-muted text-muted-foreground'
            }`}>{contagem(pedidosProducao.length)}</span>
          </div>
          {mobileTab === "producao" && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-yellow-500" />}
        </button>
        <button
          onClick={() => setMobileTab("pronto")}
          className={`flex-1 py-2 text-xs font-semibold text-center transition-colors relative ${
            mobileTab === "pronto"
              ? entregaAiConfig?.enabled ? 'text-[#0ea5e9]' : 'text-green-600 dark:text-green-400'
              : 'text-muted-foreground'
          }`}
        >
          <div className="flex items-center justify-center gap-1">
            {entregaAiConfig?.enabled ? <img src="/logo-upentrega-v3.png" alt="UP" className="w-5 h-5 object-contain" /> : <Package className="w-3.5 h-3.5" />}
            <span>{entregaAiConfig?.enabled ? 'UP Entrega' : 'Pronto'}</span>
            <span className={`px-1 py-0.5 rounded-full text-[9px] font-bold ${
              mobileTab === "pronto"
                ? entregaAiConfig?.enabled ? 'bg-[#0ea5e9]/20 text-[#0ea5e9]' : 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                : 'bg-muted text-muted-foreground'
            }`}>{contagem(pedidosPronto.length)}</span>
          </div>
          {mobileTab === "pronto" && <div className={`absolute bottom-0 left-0 right-0 h-0.5 ${entregaAiConfig?.enabled ? 'bg-[#0ea5e9]' : 'bg-green-500'}`} />}
        </button>
      </div>

      {/* Negociações abertas do iFood (cliente pediu cancelamento etc.) — prazo curto, alta prioridade */}
      <HandshakeBanner
        disputes={ifoodDisputes.disputes}
        rejectReasons={ifoodDisputes.rejectReasons}
        onRespond={ifoodDisputes.respond}
      />

      <AvisoDinheiroUP itens={dinheiroUP.aguardando} confirmando={dinheiroUP.confirmando} onConfirmar={dinheiroUP.confirmar} />

      {/* Código de entrega do iFood — abre ao marcar entregue um pedido que exige código */}
      <IfoodDeliveryCodeDialog
        pedido={ifoodCodeDialog?.pedido}
        open={!!ifoodCodeDialog}
        onClose={() => setIfoodCodeDialog(null)}
        onVerified={() => { const d = ifoodCodeDialog; setIfoodCodeDialog(null); d?.proceed?.(); }}
        onSkip={() => { const d = ifoodCodeDialog; setIfoodCodeDialog(null); d?.proceed?.(); }}
      />

      {/* Código de coleta (entrega iFood): o entregador informa, a loja valida e libera */}
      <IfoodDeliveryCodeDialog
        mode="pickup"
        pedido={ifoodPickupDialog}
        open={!!ifoodPickupDialog}
        onClose={() => setIfoodPickupDialog(null)}
        onVerified={() => { setIfoodPickupDialog(null); fetchData(); }}
      />

      {/* Área principal com colunas - responsivo */}
      <div className="relative flex-1 flex flex-col xl:flex-row gap-2 sm:gap-3 p-1 sm:p-2 md:p-3 lg:p-4 overflow-hidden">

        {/* Coluna 1: AGUARDANDO ACEITE — oculta quando auto-aceite ativo */}
        {!autoAccept && (
        <div className={`flex-1 xl:flex-1 flex flex-col rounded-lg sm:rounded-xl border border-t-[3px] border-t-orange-500 bg-card overflow-hidden min-w-0 min-h-[200px] sm:min-h-[300px] ${mobileTab !== "aceite" ? "hidden xl:flex" : ""}`}>
          <div className="px-1.5 sm:px-2 md:px-3 bg-muted/50 border-b h-[52px] sm:h-[60px] flex items-center">
            <div className="flex items-center justify-between w-full">
              <h3 className="font-bold text-[10px] sm:text-xs md:text-sm flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse" />
                AGUARDANDO ACEITE
              </h3>
              <span className="bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400 px-2 py-0.5 rounded-full text-xs font-bold tabular-nums">
                {contagem(pedidosAguardando.length)}
              </span>
            </div>
          </div>
          <MetricaTempoColuna rotulo="Tempo médio de aceite" etapa={temposEtapas.aceite} />

          <div className="flex-1 overflow-auto p-2 space-y-2">
            {canceladosPorColuna.aguardando.map(pedido => (
              <CanceladoCard key={`canc-${pedido.id}`} pedido={pedido} autoHide />
            ))}
            {loading ? <CartoesPedidoCarregando /> : pedidosAguardando.length === 0 && canceladosPorColuna.aguardando.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-full text-sm rounded-xl border-2 border-dashed border-border/60 text-muted-foreground/60">
                <Clock className="w-8 h-8 mb-2 opacity-40" />
                <p>Nenhum pedido aguardando</p>
              </div>
            ) : (
              pedidosAguardando.map(pedido => (
                <PedidoCard
                  key={pedido.id}
                  pedido={pedido}
                  showButton={true}
                  buttonType="aceitar"
                  onButtonClick={(e) => handleAceitar(pedido.id, e)}
                  justTransitioned={transitionedIds.has(pedido.id)}
                />
              ))
            )}
            {pedidosAguardando.length > 0 && <div aria-hidden className="h-12 shrink-0" />}
          </div>
        </div>
        )}

        {/* Coluna 2: EM PRODUÇÃO */}
        <div className={`flex-1 xl:flex-1 flex flex-col rounded-lg sm:rounded-xl border border-t-[3px] border-t-amber-500 bg-card overflow-hidden min-w-0 min-h-[200px] sm:min-h-[300px] ${mobileTab !== "producao" ? "hidden xl:flex" : ""}`}>
          <div className="p-1.5 sm:p-2 md:p-3 bg-muted/50 border-b h-[52px] sm:h-[60px] flex items-center">
            <div className="flex items-center gap-1.5 w-full">
              <h3 className="font-bold text-[10px] sm:text-xs md:text-sm shrink-0 flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-amber-500" />
                EM PRODUÇÃO
              </h3>
              {/* Auto-aceite inline */}
              <button
                onClick={handleToggleAutoAccept}
                className={`flex items-center gap-1 px-1.5 py-0.5 rounded-md text-[10px] sm:text-xs font-medium transition-all shrink-0 ${
                  autoAccept
                    ? 'bg-green-500 text-white'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                }`}
              >
                <span>{autoAccept ? 'Auto-aceite' : 'Auto-aceite'}</span>
                {autoAccept ? (
                  <ToggleRight className="w-4 h-4" />
                ) : (
                  <ToggleLeft className="w-4 h-4" />
                )}
              </button>
              {/* Busca inline */}
              <div className="relative flex-1 min-w-0">
                <Search className="absolute left-2 top-1/2 -translate-y-1/2 w-3 h-3 text-muted-foreground" />
                <input
                  type="text"
                  value={filterProducao}
                  onChange={e => setFilterProducao(e.target.value)}
                  placeholder="Buscar..."
                  className="w-full pl-7 pr-2 py-1 text-xs rounded-md border bg-background focus:outline-none focus:ring-1 focus:ring-primary"
                />
              </div>
              {/* Botão de som */}
              <button
                onClick={toggleSound}
                className={`p-1 rounded-lg transition-all shrink-0 ${
                  soundEnabled
                    ? 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400'
                    : 'bg-gray-100 text-gray-400 dark:bg-gray-800 dark:text-gray-500'
                }`}
                title={soundEnabled ? "Som ativado" : "Som desativado"}
              >
                {soundEnabled ? <Volume2 className="w-3.5 h-3.5" /> : <VolumeX className="w-3.5 h-3.5" />}
              </button>
              <span className="bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400 px-1.5 py-0.5 rounded-full text-[10px] font-bold shrink-0">
                {contagem(pedidosProducao.length)}
              </span>
            </div>
          </div>
          <MetricaTempoColuna rotulo="Tempo médio de produção" etapa={temposEtapas.producao} />

          <div className="flex-1 overflow-auto p-1 sm:p-2 space-y-1.5 sm:space-y-2">
            {/* Gaveta AGENDADOS — fica sempre no topo da coluna quando houver.
                Clique abre modal com lista pra aprovar 1 a 1. Animação pulse
                pra chamar atenção (mesmo som toca via startPendingAcceptLoop). */}
            {pedidosAgendados.length > 0 && (() => {
              const cancelCount = pedidosAgendados.filter(p => !!p.cancel_requested_at).length;
              const hasCancel = cancelCount > 0;
              return (
              <button
                type="button"
                onClick={() => setShowAgendadosModal(true)}
                className={`w-full rounded-lg p-2.5 text-white shadow-md hover:shadow-lg transition-all flex items-center gap-2.5 group ${hasCancel ? 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700' : 'bg-gradient-to-r from-indigo-500 to-indigo-600 hover:from-indigo-600 hover:to-indigo-700'}`}
              >
                <div className="relative flex-shrink-0">
                  <div className="w-9 h-9 rounded-lg bg-white/20 backdrop-blur flex items-center justify-center">
                    <Calendar className="w-5 h-5" />
                  </div>
                  <span className={`absolute -top-1 -right-1 w-4 h-4 text-[10px] font-black rounded-full flex items-center justify-center ring-2 animate-pulse tabular-nums ${hasCancel ? 'bg-yellow-400 text-red-900 ring-red-500' : 'bg-yellow-400 text-indigo-900 ring-indigo-500'}`}>
                    {pedidosAgendados.length}
                  </span>
                </div>
                <div className="flex-1 min-w-0 text-left">
                  <p className="text-[10px] uppercase tracking-wider opacity-90 font-bold leading-tight">
                    {hasCancel ? `${cancelCount} pediu(m) cancelamento` : 'Aguardando aprovação'}
                  </p>
                  <p className="text-sm font-bold leading-tight truncate">
                    {pedidosAgendados.length} pedido{pedidosAgendados.length === 1 ? "" : "s"} agendado{pedidosAgendados.length === 1 ? "" : "s"}
                  </p>
                </div>
                <ChevronRight className="w-4 h-4 opacity-80 group-hover:translate-x-0.5 transition-transform" />
              </button>
              );
            })()}
            {(() => {
              const q = filterProducao.toLowerCase().trim();
              const filtered = q ? pedidosProducao.filter(p => pedidoCasaBusca(p, q)) : pedidosProducao;
              const canceladosAqui = q ? [] : canceladosPorColuna.producao;
              return loading ? <CartoesPedidoCarregando /> : filtered.length === 0 && pedidosAgendados.length === 0 && canceladosAqui.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-20 lg:h-full text-xs sm:text-sm rounded-xl border-2 border-dashed border-border/60 text-muted-foreground/60">
                  <ChefHat className="w-6 h-6 sm:w-8 sm:h-8 mb-2 opacity-40" />
                  <p>{q ? 'Nenhum resultado' : 'Nenhum pedido em produção'}</p>
                </div>
              ) : (<>
                {canceladosAqui.map(pedido => <CanceladoCard key={`canc-${pedido.id}`} pedido={pedido} />)}
                {filtered.map(pedido => (
                  <PedidoCard
                    key={pedido.id}
                    pedido={pedido}
                    showButton={true}
                    buttonType="pronto"
                    onButtonClick={(e) => handleMarcarPronto(pedido.id, e)}
                    justTransitioned={transitionedIds.has(pedido.id)}
                    entregaAiActive={entregaAiConfig?.enabled}
                  />
                ))}
                <div aria-hidden className="h-12 shrink-0" />
              </>);
            })()}
          </div>
        </div>

        {/* Coluna 3: PRONTO */}
        <div className={`flex-1 xl:flex-1 flex flex-col rounded-lg sm:rounded-xl border border-t-[3px] border-t-green-500 overflow-hidden min-w-0 min-h-[200px] sm:min-h-[300px] ${mobileTab !== "pronto" ? "hidden xl:flex" : ""} ${entregaAiConfig?.enabled ? 'bg-[#0ea5e9]/[0.03] border-[#0ea5e9]/30' : 'bg-card'}`}>
          {(() => {
            const selectableCount = pedidosPronto.filter(p => {
              if (isRetirada(p)) return false;
              const s = entregaAiOrdersStatus[p.id];
              const hasAi = s && s.entregaai_status && s.entregaai_status !== 'none' && s.entregaai_status !== 'error';
              return !hasAi;
            }).length;
            const allSelected = pedidosSelecionados.length > 0 && pedidosSelecionados.length === selectableCount;
            return (
              <>
                {/* Header linha 1: Logo/titulo + busca + saldo */}
                <div className={`px-2 sm:px-3 border-b h-[52px] sm:h-[60px] flex items-center gap-2 ${entregaAiConfig?.enabled ? 'bg-[#0ea5e9]/10' : 'bg-muted/50'}`}>
                  {entregaAiConfig?.enabled ? (
                    <img src="/logo-upentrega-v3.png" alt="UP Entrega" className="w-9 h-9 sm:w-11 sm:h-11 rounded object-contain shrink-0" />
                  ) : (
                    <h3 className="font-bold text-xs sm:text-sm shrink-0 flex items-center gap-1.5">
                      <span className="w-2 h-2 rounded-full bg-green-500" />
                      PRONTO
                    </h3>
                  )}
                  <div className="relative flex-1 min-w-0">
                    <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-muted-foreground" />
                    <input
                      type="text"
                      value={filterPronto}
                      onChange={e => setFilterPronto(e.target.value)}
                      placeholder="Buscar..."
                      className={`w-full pl-8 pr-2 py-1.5 text-xs rounded-md border bg-background focus:outline-none focus:ring-1 ${entregaAiConfig?.enabled ? 'focus:ring-[#0ea5e9]' : 'focus:ring-primary'}`}
                    />
                  </div>
                  {entregaAiConfig?.enabled ? (
                    <div className="flex items-center gap-1.5 shrink-0">
                      <span className="text-xs sm:text-sm font-bold text-sky-700 dark:text-sky-300 tabular-nums">
                        {entregaAiBalance !== null ? `R$ ${Number(entregaAiBalance).toFixed(2).replace(".", ",")}` : '—'}
                      </span>
                      <button
                        onClick={() => window.open('https://entregaai.usenucleo.com.br/wallet', '_blank')}
                        className="flex items-center gap-1 px-2 h-7 rounded-md bg-[#0ea5e9] hover:bg-[#0284c7] text-white text-[11px] font-semibold transition-colors"
                        title="Adicionar saldo"
                      >
                        <Plus className="w-3 h-3" />
                        Saldo
                      </button>
                    </div>
                  ) : (
                    <span className="px-2 py-0.5 rounded-full text-[11px] font-bold shrink-0 bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400">
                      {contagem(pedidosPronto.length)}
                    </span>
                  )}
                </div>

                {/* Header linha 2: envio em lote — so aparece quando usuario
                    selecionou pelo menos 1 pedido. So entregadores PROPRIOS da
                    loja entram na lista (UP Entrega / Entrega Ai sao filtrados). */}
                {pedidosSelecionados.length > 0 && (() => {
                  const entregadoresProprios = entregadores.filter(e =>
                    !e.nome?.startsWith('[UP Entrega]') && !e.nome?.startsWith('[Entrega Aí]')
                  );
                  return (
                    <div className={`px-2 sm:px-3 py-2 border-b flex items-center gap-2 ${entregaAiConfig?.enabled ? 'bg-[#0ea5e9]/[0.04]' : 'bg-muted/30'}`}>
                      <Select value={entregadorProntoSelecionado} onValueChange={setEntregadorProntoSelecionado}>
                        <SelectTrigger className="h-8 text-xs flex-1 min-w-0">
                          <SelectValue placeholder={entregadoresProprios.length === 0 ? 'Nenhum entregador cadastrado' : 'Selecionar entregador...'} />
                        </SelectTrigger>
                        <SelectContent>
                          {entregadoresProprios.map(e => (
                            <SelectItem key={e.id} value={e.id}>
                              {e.nome}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                      <Button
                        size="sm"
                        variant="outline"
                        className="h-8 text-xs whitespace-nowrap shrink-0"
                        onClick={toggleSelecionarTodos}
                        title={allSelected ? 'Desmarcar todos' : 'Marcar todos'}
                      >
                        {allSelected ? 'Desmarcar' : `Marcar ${selectableCount}`}
                      </Button>
                      <Button
                        size="sm"
                        className="h-8 text-xs whitespace-nowrap shrink-0"
                        onClick={handleEnviarPedidosEmLote}
                        disabled={!entregadorProntoSelecionado || pedidosSelecionados.length === 0}
                      >
                        <ShoppingBag className="w-3.5 h-3.5 mr-1" />
                        Enviar ({pedidosSelecionados.length})
                      </Button>
                    </div>
                  );
                })()}
              </>
            );
          })()}

          <MetricaTempoColuna rotulo="Tempo médio aguardando retirada/entregador" etapa={temposEtapas.espera_saida} />

          <div className="flex-1 overflow-auto p-1 sm:p-2 space-y-1.5 sm:space-y-2">
            {(() => {
              const q = filterPronto.toLowerCase().trim();
              const filtered = q ? pedidosPronto.filter(p => pedidoCasaBusca(p, q)) : pedidosPronto;
              const canceladosAqui = q ? [] : canceladosPorColuna.pronto;
              return loading ? <CartoesPedidoCarregando /> : filtered.length === 0 && canceladosAqui.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-full text-muted-foreground text-sm relative overflow-hidden rounded-xl border-2 border-dashed border-border/60">
                  {entregaAiConfig?.enabled ? (
                    <>
                      <img src="/logo-upentrega-v3.png" alt="UP Entrega" className="w-96 h-96 sm:w-[480px] sm:h-[480px] object-contain opacity-10 absolute" />
                      <p className="z-10 text-muted-foreground/60 text-sm font-medium">{q ? 'Nenhum resultado' : 'Nenhum pedido pronto'}</p>
                    </>
                  ) : (
                    <>
                      <Package className="w-8 h-8 mb-2 opacity-30" />
                      <p>{q ? 'Nenhum resultado' : 'Nenhum pedido pronto'}</p>
                    </>
                  )}
                </div>
              ) : (<>
                {canceladosAqui.map(pedido => <CanceladoCard key={`canc-${pedido.id}`} pedido={pedido} />)}
                {filtered.map(pedido => {
                  const aiStatus = entregaAiOrdersStatus[pedido.id];
                  const hasAiOrder = aiStatus && aiStatus.entregaai_status && aiStatus.entregaai_status !== 'none' && aiStatus.entregaai_status !== 'error';
                  if (isRetirada(pedido)) {
                    // iFood: já pago no app — "Finalizar" conclui direto, sem tela de pagamento.
                    return (
                      <PedidoCard
                        key={pedido.id}
                        pedido={pedido}
                        showButton={true}
                        buttonType="finalizar"
                        onButtonClick={(e) => isIfoodPedido(pedido) ? (e.stopPropagation(), handleMudarStatus(pedido, 'concluido')) : handleAbrirPagamento(pedido, e)}
                        justTransitioned={transitionedIds.has(pedido.id)}
                        onViewDetails={handleAbrirDetalhes}
                      />
                    );
                  }
                  if (ifoodMeta(pedido).delivered_by === 'IFOOD') {
                    // Entrega do iFood: o entregador é deles. Nada a fazer aqui —
                    // o card vai para EM ROTA quando o iFood mandar DISPATCHED.
                    // Exceção: pedido com "código de coleta" (DELIVERY_PICKUP_CODE_REQUESTED):
                    // o entregador informa o código e a loja valida no iFood para liberar.
                    const m = ifoodMeta(pedido);
                    const pedeColeta = !!m.pickup_code_required && !m.pickup_code_validated_at;
                    return (
                      <PedidoCard
                        key={pedido.id}
                        pedido={pedido}
                        showButton={pedeColeta}
                        buttonType={pedeColeta ? 'validar_coleta' : undefined}
                        onButtonClick={(e) => { e.stopPropagation(); setIfoodPickupDialog(pedido); }}
                        selectable={false}
                        justTransitioned={transitionedIds.has(pedido.id)}
                        onViewDetails={handleAbrirDetalhes}
                      />
                    );
                  }
                  if (entregaAiConfig?.enabled && !hasAiOrder) {
                    // UP Entrega ativo mas ainda nao chamou entregador —
                    // permite tanto "Chamar Entregador" (UP) quanto envio em lote
                    // para entregador proprio (via checkbox + seletor no topo).
                    return (
                      <PedidoCard
                        key={pedido.id}
                        pedido={pedido}
                        showButton={true}
                        buttonType="chamar_entregador"
                        onButtonClick={(e) => handleChamarEntregador(pedido.id, e)}
                        selectable={true}
                        selected={pedidosSelecionados.includes(pedido.id)}
                        onSelect={togglePedidoSelecionado}
                        justTransitioned={transitionedIds.has(pedido.id)}
                        onViewDetails={handleAbrirDetalhes}
                        entregaAiActive={true}
                        entregaAiStatus={aiStatus}
                      />
                    );
                  }
                  if (entregaAiConfig?.enabled && hasAiOrder) {
                    // UP Entrega com pedido ativo - sem checkbox, sem selectable
                    return (
                      <PedidoCard
                        key={pedido.id}
                        pedido={pedido}
                        showButton={false}
                        selectable={false}
                        justTransitioned={transitionedIds.has(pedido.id)}
                        onViewDetails={handleAbrirDetalhes}
                        entregaAiActive={true}
                        entregaAiStatus={aiStatus}
                      />
                    );
                  }
                  // Sem UP Entrega - comportamento padrão com checkbox
                  return (
                    <PedidoCard
                      key={pedido.id}
                      pedido={pedido}
                      showButton={false}
                      selectable={true}
                      selected={pedidosSelecionados.includes(pedido.id)}
                      onSelect={togglePedidoSelecionado}
                      justTransitioned={transitionedIds.has(pedido.id)}
                      onViewDetails={handleAbrirDetalhes}
                      entregaAiActive={false}
                      entregaAiStatus={aiStatus}
                    />
                  );
                })}
                <div aria-hidden className="h-12 shrink-0" />
              </>);
            })()}
          </div>

          {/* Entregadores no rodapé */}
          {entregadoresComPedidos.length > 0 && (
            <div className="border-t bg-muted/30 p-2 sm:p-3">
              <div className="flex items-center gap-1 mb-1.5">
                <Bike className="w-3.5 h-3.5 text-muted-foreground" />
                <span className="text-[10px] font-semibold text-muted-foreground uppercase tracking-wide">Entregadores</span>
              </div>
              <div className="flex items-center gap-3 overflow-x-auto scrollbar-hide">
                {entregadoresComPedidos.map(entregador => {
                  const bagCount = getEntregadorBagCount(entregador.id);
                  const isEntregaAi = entregador.nome?.startsWith('[UP Entrega]') || entregador.nome?.startsWith('[Entrega Aí]');
                  const displayName = isEntregaAi ? entregador.nome.replace('[UP Entrega] ', '').replace('[Entrega Aí] ', '').split(' ')[0] : (entregador.nome?.split(' ')[0] || '');
                  return (
                    <button
                      key={entregador.id}
                      onClick={() => handleAbrirEntregador(entregador)}
                      className="relative shrink-0 flex flex-col items-center gap-0.5 hover:scale-105 transition-transform"
                      title={`${entregador.nome} — ${bagCount} pedido(s) na BAG`}
                    >
                      <div className="relative">
                        {entregador.foto_url ? (
                          <img src={getImageUrl(entregador.foto_url)} alt={entregador.nome} className={`w-10 h-10 rounded-full border-2 object-cover ${isEntregaAi ? 'border-[#0ea5e9]' : 'border-primary/30'}`} />
                        ) : (
                          <div className={`w-10 h-10 rounded-full flex items-center justify-center text-xs font-bold uppercase ${isEntregaAi ? 'bg-[#0ea5e9]/10 border-2 border-[#0ea5e9] text-[#0ea5e9]' : 'bg-primary/10 border-2 border-primary/30 text-primary'}`}>
                            {isEntregaAi ? <img src="/logo-upentrega-v3.png" alt="UP" className="w-7 h-7 object-contain" /> : entregador.nome?.substring(0, 2)}
                          </div>
                        )}
                        <span className={`absolute -top-1 -right-1 text-white text-[9px] font-bold w-5 h-5 rounded-full flex items-center justify-center ${isEntregaAi ? 'bg-[#0ea5e9]' : 'bg-primary'}`}>
                          {bagCount}
                        </span>
                      </div>
                      <span className={`text-[10px] font-medium truncate max-w-[60px] ${isEntregaAi ? 'text-[#0ea5e9]' : 'text-foreground'}`}>{displayName}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          )}
          {/* Com o aceite automático sobram 2 colunas e o botão NOVO PEDIDO cai no vão
              entre elas, por cima do começo desta faixa: o rótulo recua. */}
          <MetricaTempoColuna rotulo="Tempo médio em trânsito" etapa={temposEtapas.transito} rodape className={autoAccept ? 'xl:pl-24' : ''} />
        </div>

        {/* Coluna 4: CANCELADOS — faixa estreita ao lado de PRONTO (pedido do
            dono, 26/08). Fechada é só o rótulo na VERTICAL + contador; o clique
            abre uma coluna normal com os cancelamentos de HOJE (o for_screen já
            devolve esses pedidos — nenhuma chamada extra). Desktop apenas: no
            mobile as abas Aceite/Produção/Pronto seguem como estão. */}
        <div ref={canceladosRef} className={`hidden xl:flex ${canceladosAberto ? 'xl:w-80' : 'xl:w-10'} shrink-0 flex-col rounded-lg sm:rounded-xl border border-t-[3px] border-t-red-500 bg-card overflow-hidden transition-all duration-200`}>
          {canceladosAberto ? (
            <>
              <div className="px-2 sm:px-3 bg-muted/50 border-b h-[52px] sm:h-[60px] flex items-center justify-between shrink-0">
                <h3 className="font-bold text-xs sm:text-sm flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full bg-red-500" />
                  CANCELADOS
                </h3>
                <div className="flex items-center gap-1.5">
                  <span className="bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 px-2 py-0.5 rounded-full text-xs font-bold tabular-nums">
                    {pedidosCancelados.length}
                  </span>
                  <button onClick={() => setCanceladosAberto(false)} className="p-1 rounded-md hover:bg-muted text-muted-foreground" title="Recolher">
                    <ChevronRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
              <div className="flex-1 overflow-auto p-2 space-y-2">
                {pedidosCancelados.length === 0 ? (
                  <div className="flex flex-col items-center justify-center h-full text-sm rounded-xl border-2 border-dashed border-border/60 text-muted-foreground/60">
                    <XCircle className="w-8 h-8 mb-2 opacity-40" />
                    <p>Nenhum cancelamento hoje</p>
                  </div>
                ) : (
                  pedidosCancelados.map((p) => (
                    <div
                      key={p.id}
                      onClick={() => handleAbrirDetalhes(p)}
                      className="rounded-xl border border-l-4 border-l-red-500 bg-card p-2.5 cursor-pointer opacity-75 hover:opacity-100 hover:shadow-md transition-all"
                    >
                      <div className="flex items-center gap-1.5 mb-0.5">
                        <span className="font-mono text-sm font-bold text-red-500 line-through decoration-red-500/60">{p.codigo}</span>
                        <span className="ml-auto text-[10px] text-muted-foreground tabular-nums">{formatTime(p.created_at)}</span>
                      </div>
                      <p className="text-sm font-medium truncate">{p.cliente_nome || 'Cliente'}</p>
                      <p className="text-[11px] text-muted-foreground tabular-nums">R$ {(p.total || 0).toFixed(2).replace('.', ',')} · {p.items?.length || 0} {(p.items?.length || 0) === 1 ? 'item' : 'itens'}</p>
                    </div>
                  ))
                )}
              </div>
            </>
          ) : (
            <button
              onClick={() => setCanceladosAberto(true)}
              className="flex-1 flex flex-col items-center gap-2 py-3 hover:bg-muted/50 transition-colors"
              title="Ver pedidos cancelados de hoje"
            >
              <span className={`text-[11px] font-bold px-1.5 py-0.5 rounded-full tabular-nums ${pedidosCancelados.length ? 'bg-red-500 text-white' : 'bg-muted text-muted-foreground'}`}>
                {contagem(pedidosCancelados.length)}
              </span>
              <span className="[writing-mode:vertical-rl] text-[11px] font-bold tracking-[0.2em] text-muted-foreground uppercase">
                Cancelados
              </span>
            </button>
          )}
        </div>

        {/* Novo pedido flutua no centro das colunas, por cima delas. No desktop
            o centro desconta a faixa de Cancelados (40px fechada, 320px aberta)
            mais o espaço de 12px entre ela e a coluna Pronto. */}
        <BotaoNovoPedido
          className={`absolute bottom-4 z-30 -translate-x-1/2 left-1/2 ${canceladosAberto ? 'xl:left-[calc(50%-166px)]' : 'xl:left-[calc(50%-26px)]'}`}
          onClick={() => { setPedidoEditando(null); setEditarPedidoModalOpen(true); }}
        />
      </div>

      {/* Resumo do dia no rodapé do canto direito, por cima da faixa de tempo em
          trânsito. Em tela onde a coluna Pronto é estreita demais para caber
          rótulo + resumo lado a lado, ele sobe para logo acima da faixa. No
          mobile só aparece na aba Pronto e fica acima do botão de novo pedido. */}
      <div className={`fixed right-3 z-30 pointer-events-none ${mobileTab === 'pronto' ? '' : 'max-xl:hidden'} ${entregadoresComPedidos.length > 0 ? 'bottom-44' : 'bottom-20'} ${autoAccept ? 'xl:bottom-[52px] min-[1440px]:bottom-3' : 'xl:bottom-[52px] min-[1830px]:bottom-3'}`}>
        <div className="pointer-events-auto">
          <ResumoDoDia
            pedidos={dailyStats.pedidosHoje}
            faturamento={dailyStats.faturamentoHoje}
            tempoMedio={dailyStats.tempoMedioHoje}
            carregando={!dailyStats.carregado}
          />
        </div>
      </div>

      {/* Modal de Detalhes do Pedido */}
      <Dialog open={detalhesModalOpen} onOpenChange={setDetalhesModalOpen}>
        <DialogContent aria-describedby={undefined} className="max-w-[100vw] sm:max-w-[95vw] md:max-w-4xl w-full h-[100dvh] sm:h-auto sm:max-h-[90vh] flex flex-col m-0 sm:m-4 rounded-none sm:rounded-xl p-0">
          {/* Título só para leitor de tela: sem ele o Radix soltava erro no console a cada abertura (25/10/2026) */}
          <DialogTitle className="sr-only">Detalhes do pedido{pedidoDetalhes?.codigo ? ` ${pedidoDetalhes.codigo}` : ""}</DialogTitle>
          {pedidoDetalhes && (() => {
            const isPickup = isRetirada(pedidoDetalhes);
            const p = pedidoDetalhes;
            const stColor = statusConfig[p.status]?.color || 'bg-gray-500';
            const stLabel = statusConfig[p.status]?.label || p.status;
            // Chip de status SUAVE (v1.5.464): o header tinha banho de cor do
            // status com opacity — no dark virava um mostarda pesado (print do
            // dono). Mapa LITERAL porque o JIT do Tailwind não gera classe
            // construída por replace().
            const ST_CHIP = {
              aguardando_aceite: 'bg-orange-500/15 text-orange-600 dark:text-orange-400',
              agendado: 'bg-indigo-500/15 text-indigo-600 dark:text-indigo-400',
              producao: 'bg-yellow-500/15 text-yellow-600 dark:text-yellow-400',
              pronto: 'bg-green-500/15 text-green-600 dark:text-green-400',
              na_bag: 'bg-blue-500/15 text-blue-600 dark:text-blue-400',
              em_rota: 'bg-purple-500/15 text-purple-600 dark:text-purple-400',
              retirado: 'bg-blue-500/15 text-blue-600 dark:text-blue-400',
              concluido: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400',
              cancelado: 'bg-red-500/15 text-red-600 dark:text-red-400',
            };
            const stChip = ST_CHIP[p.status] || 'bg-muted text-muted-foreground';

            // Delegado pro helper compartilhado (v1.5.378) — trata codes do
            // cardápio com sufixo de tenant ("cartao_<uuid>" → "Cartão").
            const fmtPagamento = (code) => fmtFormaPagamentoLabel(code);

            // Pedido agendado: 1º passo vira "Agendado" — o intervalo até
            // Produção é a espera de aprovação do lojista (por design), não
            // lentidão de aceite (v1.5.379).
            const firstStepLabel = p.scheduled_at ? 'Agendado' : 'Aceite';
            const steps = isPickup
              ? [
                  { label: firstStepLabel, ts: p.created_at },
                  { label: 'Produção', ts: p.ts_producao },
                  { label: 'Pronto', ts: p.ts_pronto },
                  { label: 'Retirado', ts: p.ts_concluido },
                ]
              : [
                  { label: firstStepLabel, ts: p.created_at },
                  { label: 'Produção', ts: p.ts_producao },
                  { label: 'Pronto', ts: p.ts_pronto },
                  // 'Na Bag' descontinuado — só exibido para pedidos legados que gravaram ts_na_bag
                  ...(p.ts_na_bag ? [{ label: 'Na Bag', ts: p.ts_na_bag }] : []),
                  { label: 'Em Rota', ts: p.ts_em_rota },
                  { label: 'Entregue', ts: p.ts_concluido },
                ];
            const fmtElapsed = (ms) => {
              if (!ms || ms < 0) return '';
              const totalSec = Math.floor(ms / 1000);
              if (totalSec < 60) return `${totalSec}s`;
              const min = Math.floor(totalSec / 60);
              const sec = totalSec % 60;
              if (min < 60) return sec > 0 ? `${min}min ${sec}s` : `${min}min`;
              const h = Math.floor(min / 60);
              const m = min % 60;
              return m > 0 ? `${h}h ${m}min` : `${h}h`;
            };
            // Cancelado: a régua congela no instante do cancelamento (ts_cancelado; updated_at
            // nos pedidos antigos). O contador ao vivo só faz sentido em pedido aberto.
            const fimTs = p.status === 'cancelado' ? new Date(p.ts_cancelado || p.updated_at).getTime() : null;
            let totalMs = 0;
            const stepsWithElapsed = steps.map((s, i) => {
              let diffMs = 0;
              let isLive = false;
              if (s.ts) {
                const nextTs = (i < steps.length - 1 && steps[i + 1]?.ts) ? new Date(steps[i + 1].ts).getTime() : null;
                if (nextTs) { diffMs = nextTs - new Date(s.ts).getTime(); }
                else if (i < steps.length - 1) { diffMs = (fimTs ?? nowTick) - new Date(s.ts).getTime(); isLive = !fimTs; }
                if (diffMs > 0) totalMs += diffMs;
              }
              return { ...s, diffMs, isLive };
            });
            let lastCompletedIdx = -1;
            stepsWithElapsed.forEach((s, i) => { if (s.ts) lastCompletedIdx = i; });
            const progressPct = steps.length > 1 ? Math.min(100, (lastCompletedIdx / (steps.length - 1)) * 100) : 0;

            // Render item (reusável)
            // Lookup de fotos por nome do subitem (cobre adicionais salvos sem photo_url)
            const photoByName = {};
            const _allProds = allProductsWithInsumos.length > 0 ? allProductsWithInsumos : ((productsCache && productsCache.all) || []);
            (_allProds || []).forEach(pp => {
              const ph = pp?.photo_url || pp?.foto_url;
              if (ph && pp?.name) photoByName[String(pp.name).toLowerCase().trim()] = ph;
            });
            const lookupPhoto = (name) => {
              if (!name) return null;
              const k = String(name).toLowerCase().trim();
              if (photoByName[k]) return photoByName[k];
              // partial match
              for (const key in photoByName) {
                if (key.includes(k) || k.includes(key)) return photoByName[key];
              }
              return null;
            };

            const renderItem = (item, index) => {
              const photoUrl = item.photo_url || item.foto_url || lookupPhoto(item.nome || item.name);
              const photoSrc = photoUrl ? getImageUrl(photoUrl) : null;
              const unitPrice = item.preco_unitario || item.preco || item.price || 0;
              const qty = item.quantidade || item.qty || item.quantity || 1;
              // Quilo/litro (30/09/2026): "1,250 kg × R$ 59,90/kg" em vez de "1.25x R$ 59,90".
              const medida = medidaDoItem(item, _allProds);
              // Preco base do produto (sem adicionais). unitPrice ja inclui os extras dos subitems,
              // entao subtraimos pra exibir o preco do produto cru — os adicionais aparecem listados embaixo.
              // `sub.preco` JÁ é o total da linha (unitário x quantidade) — multiplicar
              // pela quantidade de novo dobrava o valor e derrubava o preço-base exibido.
              const subsExtras = (item.subitems || []).reduce((s, sub) => s + Number(sub.preco || 0), 0);
              const basePrice = Math.max(0, unitPrice - subsExtras);
              return (
                <div key={index} className="px-4 py-3">
                  <div className="flex gap-3 items-start">
                    <div className="w-14 h-14 rounded-xl bg-muted flex-shrink-0 overflow-hidden flex items-center justify-center">
                      {photoSrc ? (
                        <img src={photoSrc} alt="" className="w-full h-full object-cover" onError={(e) => { e.target.style.display = "none"; }} />
                      ) : (
                        <ShoppingBag className="w-5 h-5 text-muted-foreground/50" />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex justify-between items-start gap-2">
                        <div className="min-w-0">
                          <p className="text-sm font-bold leading-tight">{item.nome || item.name}</p>
                          <div className="flex items-center gap-1.5 mt-0.5">
                            <span className="text-xs text-muted-foreground">{qtdDoItem(qty, medida)}{medida ? " ×" : ""} R$ {basePrice.toFixed(2).replace('.', ',')}{medida ? `/${medida}` : ""}</span>
                            {item.combo_type && (
                              <span className={`text-[9px] px-1.5 py-0.5 rounded-full font-bold ${item.combo_type === 'combo' ? 'bg-green-500/15 text-green-600 dark:text-green-400' : 'bg-blue-500/15 text-blue-600 dark:text-blue-400'}`}>
                                {item.combo_type === 'combo' ? 'COMBO' : 'SIMPLES'}
                              </span>
                            )}
                            <SeloOfertaItem item={item} />
                          </div>
                        </div>
                        <div className="shrink-0 text-right">
                          {item.oferta_preco_cheio && (
                            <span className="block text-[11px] text-muted-foreground line-through leading-none">R$ {(Number(item.oferta_preco_cheio) * qty).toFixed(2).replace('.', ',')}</span>
                          )}
                          <span className="font-bold text-sm text-primary">R$ {(unitPrice * qty).toFixed(2).replace('.', ',')}</span>
                        </div>
                      </div>
                      {item.subitems && item.subitems.length > 0 && (() => {
                        // Agrupa subitems iguais (mesmo step_name + nome + preço) em uma só linha com quantidade
                        const grouped = [];
                        const indexMap = new Map();
                        for (const sub of item.subitems) {
                          const subName = sub.nome || sub.name || '';
                          const stepName = sub.step_name || sub.stepName || '';
                          const preco = Number(sub.preco || 0);
                          const explicitQty = Number(sub.quantidade || sub.qty || 0);
                          const key = `${stepName}||${subName}||${preco}`;
                          if (indexMap.has(key)) {
                            grouped[indexMap.get(key)].qty += explicitQty > 0 ? explicitQty : 1;
                          } else {
                            indexMap.set(key, grouped.length);
                            grouped.push({ ...sub, _name: subName, _stepName: stepName, _preco: preco, qty: explicitQty > 0 ? explicitQty : 1 });
                          }
                        }
                        return (
                          <div className="mt-2 space-y-1 pl-1 border-l-2 border-orange-400/30 ml-0.5">
                            {grouped.map((sub, subIdx) => {
                              const subPhotoUrl = sub.photo_url || sub.foto_url || lookupPhoto(sub._name);
                              const subPhotoSrc = subPhotoUrl ? getImageUrl(subPhotoUrl) : null;
                              return (
                                <div key={subIdx} className="flex items-center gap-1.5 pl-2">
                                  <div className="w-5 h-5 rounded bg-muted flex-shrink-0 overflow-hidden relative flex items-center justify-center">
                                    <Package className="w-2.5 h-2.5 text-muted-foreground" />
                                    {subPhotoSrc && <img src={subPhotoSrc} alt="" className="w-full h-full object-cover absolute inset-0" onError={(e) => { e.target.style.display = "none"; }} />}
                                  </div>
                                  <p className="text-[11px] text-muted-foreground">
                                    {sub._stepName && <span className="opacity-70">{sub._stepName}: </span>}
                                    {sub.qty > 1 && <span className="font-bold text-foreground mr-0.5">{sub.qty}×</span>}
                                    <span className="font-medium text-foreground/80">{sub._name}</span>
                                    {sub._preco > 0 && (
                                      <span className="text-orange-500 font-medium">
                                        {' '}+R$ {(sub._preco * sub.qty).toFixed(2).replace('.', ',')}
                                        {sub.qty > 1 && <span className="text-muted-foreground/70 font-normal"> ({sub.qty}× R$ {sub._preco.toFixed(2).replace('.', ',')})</span>}
                                      </span>
                                    )}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })()}
                      {(!item.subitems || item.subitems.length === 0) && item.etapas && item.etapas.length > 0 && (() => {
                        // Agrupa items dentro de cada etapa por nome
                        const flatGrouped = [];
                        const indexMap = new Map();
                        item.etapas.forEach((etapa, etapaIdx) => {
                          const etapaItems = etapa.items || etapa.itens || [];
                          const stepName = etapa.name || etapa.nome || '';
                          etapaItems.forEach((etapaItem) => {
                            const itemNome = typeof etapaItem === 'string' ? etapaItem : (etapaItem.nome || etapaItem.name || '');
                            const explicitQty = typeof etapaItem !== 'string' ? Number(etapaItem.quantidade || etapaItem.qty || 0) : 0;
                            const photoSource = typeof etapaItem !== 'string' ? etapaItem : null;
                            const key = `${etapaIdx}||${itemNome}`;
                            if (indexMap.has(key)) {
                              flatGrouped[indexMap.get(key)].qty += explicitQty > 0 ? explicitQty : 1;
                            } else {
                              indexMap.set(key, flatGrouped.length);
                              flatGrouped.push({
                                etapaIdx,
                                stepName,
                                nome: itemNome,
                                qty: explicitQty > 0 ? explicitQty : 1,
                                photoSource,
                              });
                            }
                          });
                        });
                        return (
                          <div className="mt-2 space-y-1 pl-1 border-l-2 border-orange-400/30 ml-0.5">
                            {flatGrouped.map((g, idx) => {
                              const etPhotoUrl = g.photoSource ? (g.photoSource.photo_url || g.photoSource.foto_url || lookupPhoto(g.nome)) : lookupPhoto(g.nome);
                              const etPhotoSrc = etPhotoUrl ? getImageUrl(etPhotoUrl) : null;
                              return (
                                <div key={idx} className="flex items-center gap-1.5 pl-2">
                                  <div className="w-5 h-5 rounded bg-muted flex-shrink-0 overflow-hidden relative flex items-center justify-center">
                                    <Package className="w-2.5 h-2.5 text-muted-foreground" />
                                    {etPhotoSrc && <img src={etPhotoSrc} alt="" className="w-full h-full object-cover absolute inset-0" onError={(e) => { e.target.style.display = "none"; }} />}
                                  </div>
                                  <p className="text-[11px] text-muted-foreground">
                                    {g.stepName && <span className="opacity-70">{g.stepName}: </span>}
                                    {g.qty > 1 && <span className="font-bold text-foreground mr-0.5">{g.qty}×</span>}
                                    <span className="font-medium text-foreground/80">{g.nome}</span>
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })()}
                      {item.observacao && (
                        <p className="text-[11px] text-yellow-600 dark:text-yellow-400 mt-1.5 flex items-center gap-1">
                          <MessageSquare className="w-3 h-3 shrink-0" /> {item.observacao}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              );
            };

            return (
              <>
                {/* ===== HEADER (full width) ===== */}
                <div className="px-5 pt-5 pb-4 shrink-0 bg-card border-b">
                  <div className="flex items-start justify-between gap-3">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2.5 flex-wrap">
                        <IconeOrigemPedido modulo={p.modulo} campanha={p.origem_campanha} grande />
                        <span className="font-mono text-xl font-black tracking-tight">
                          {String(p.codigo || '').startsWith('#') ? p.codigo : `#${p.codigo}`}
                          {isIfoodPedido(p) && (p.ifood_display_id || ifoodMeta(p).display_id) && (
                            <span> - #{p.ifood_display_id || ifoodMeta(p).display_id}</span>
                          )}
                        </span>
                        <span className={`px-2.5 py-1 rounded-full text-[11px] font-bold inline-flex items-center gap-1.5 ${stChip}`}>
                          <span className={`w-1.5 h-1.5 rounded-full ${stColor}`} />
                          {stLabel}
                        </span>
                        {isPickup && (
                          <span className="bg-amber-500/15 text-amber-600 dark:text-amber-400 text-[11px] px-2.5 py-1 rounded-full font-bold flex items-center gap-1">
                            <Store className="w-3 h-3" /> RETIRADA
                          </span>
                        )}
                        {isIfoodPedido(p) && ifoodMeta(p).pickup_code && (
                          <span className="bg-slate-800 text-white dark:bg-slate-200 dark:text-slate-900 text-[11px] px-2.5 py-1 rounded-full font-bold font-mono flex items-center gap-1" title="Código de coleta — quem retira o pedido informa este código">
                            <Hash className="w-3 h-3" /> coleta {ifoodMeta(p).pickup_code}
                          </span>
                        )}
                        {isIfoodPedido(p) && ifoodMeta(p).delivered_by === 'IFOOD' && (
                          <span className="bg-purple-500/15 text-purple-600 dark:text-purple-300 text-[11px] px-2.5 py-1 rounded-full font-bold flex items-center gap-1" title="O entregador é do iFood">
                            <Bike className="w-3 h-3" /> Entrega iFood{p.ifood_driver_name ? ` · ${p.ifood_driver_name}` : ''}
                          </span>
                        )}
                      </div>
                      <p className="text-xs text-muted-foreground mt-1.5 flex items-center gap-1.5">
                        <Calendar className="w-3.5 h-3.5" />
                        {formatDate(p.created_at)} às {formatTime(p.created_at)}
                      </p>
                    </div>
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <button className="p-2.5 rounded-lg hover:bg-muted/80 bg-muted/40 transition-colors mr-5" title="Imprimir">
                          <Printer className="w-4.5 h-4.5 text-muted-foreground" />
                        </button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end" className="w-48">
                        <DropdownMenuItem onClick={async () => { try { await Promise.all([imprimirCupom(p), imprimirCupomPreparo(p)]); toast.success('Cupom enviado!'); } catch (err) { toast.error(err?.message || 'Erro ao imprimir'); } }}>
                          <Printer className="w-4 h-4 mr-2" /> Ambos
                        </DropdownMenuItem>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem onClick={async () => { try { await imprimirCupom(p); toast.success('Cupom enviado!'); } catch (err) { toast.error(err?.message || 'Erro ao imprimir'); } }}>
                          <FileText className="w-4 h-4 mr-2" /> Entrega
                        </DropdownMenuItem>
                        <DropdownMenuItem onClick={async () => { try { await imprimirCupomPreparo(p); toast.success('Cupom enviado!'); } catch (err) { toast.error(err?.message || 'Erro ao imprimir'); } }}>
                          <ChefHat className="w-4 h-4 mr-2" /> Preparo
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </div>
                </div>

                {/* ===== CORPO: Layout livro (esquerda info + direita itens) ===== */}
                <div className="flex-1 flex flex-col md:flex-row overflow-hidden min-h-0">

                  {/* === PÁGINA ESQUERDA: Info do pedido === */}
                  <div className="flex-1 md:w-1/2 overflow-y-auto px-5 py-4 space-y-4 md:border-r">

                    {/* Cancelamento */}
                    {p.status === 'cancelado' && p.motivo_cancelamento && (
                      <div className="bg-red-50 dark:bg-red-950/30 rounded-xl p-3.5 border border-red-200 dark:border-red-800">
                        <p className="text-xs font-bold text-red-700 dark:text-red-400 flex items-center gap-1.5 mb-1">
                          <AlertTriangle className="w-4 h-4" /> Motivo do Cancelamento
                        </p>
                        <p className="text-sm text-red-600 dark:text-red-300">{p.motivo_cancelamento}</p>
                      </div>
                    )}

                    {/* Cliente + endereço (v1.5.465): sem caixa dentro de caixa —
                        nome grande, telefone clicável e endereço em linhas curtas.
                        A moldura saiu; quem separa as seções agora é o respiro. */}
                    <div className={`rounded-xl p-4 space-y-3 ${(p.cliente_pedidos_count || 0) === 1 ? 'bg-amber-500/[0.06] ring-1 ring-amber-400/30' : 'bg-muted/30'}`}>
                      <div className="flex items-start gap-3">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <p className="font-black text-lg leading-tight truncate">{p.cliente_nome || "Não informado"}</p>
                            {(p.cliente_pedidos_count || 0) === 1 && (
                              <span className="inline-flex items-center gap-0.5 text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded-full shrink-0 bg-gradient-to-r from-amber-400 to-yellow-500 text-amber-950 shadow-sm">
                                <Sparkles className="w-3 h-3" strokeWidth={2.5} /> 1º PEDIDO
                              </span>
                            )}
                          </div>
                          {isIfoodPedido(p) ? (() => {
                            // Cliente do iFood: telefone é o 0800 + código do pedido (liga e digita);
                            // CPF vem do app quando o cliente pediu na nota.
                            const c = ifoodMeta(p).customer || {};
                            const fone = String(c.phone_number || p.cliente_telefone || '0800 700 3020');
                            return (
                              <div className="mt-0.5 space-y-0.5">
                                {c.localizer && (
                                  <a href={`tel:${fone.replace(/\D/g, '')},${c.localizer}`} className="inline-flex items-center gap-1 text-sm text-green-500 hover:text-green-400 hover:underline" title="Liga no 0800 do iFood e digita o código do pedido">
                                    <Phone className="w-3.5 h-3.5" /> {fone} · cód. {c.localizer}
                                  </a>
                                )}
                                {c.document_number && (
                                  <p className="text-xs text-muted-foreground">CPF na nota: <span className="font-medium text-foreground">{c.document_number}</span></p>
                                )}
                              </div>
                            );
                          })() : p.cliente_telefone && (
                            <a href={`https://wa.me/55${p.cliente_telefone.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-sm text-green-500 hover:text-green-400 hover:underline mt-0.5">
                              <Phone className="w-3.5 h-3.5" /> {formatPhoneNumber(p.cliente_telefone)}
                            </a>
                          )}
                        </div>
                        {p.entregador_nome && (() => {
                          const entregadorObj = (entregadores || []).find(e => e.id === p.entregador_id);
                          const foto = entregadorObj?.foto_url ? getImageUrl(entregadorObj.foto_url) : null;
                          const iniciais = (p.entregador_nome || '?').substring(0, 2).toUpperCase();
                          return (
                            <div className="shrink-0 flex items-center gap-2 bg-purple-500/10 rounded-lg px-2.5 py-1.5 border border-purple-500/20">
                              {foto ? (
                                <img src={foto} alt={p.entregador_nome} className="w-9 h-9 rounded-full ring-2 ring-purple-500/40 object-cover" onError={(e) => { e.target.style.display = 'none'; }} />
                              ) : (
                                <div className="w-9 h-9 rounded-full bg-purple-500/20 flex items-center justify-center text-[10px] font-bold text-purple-700 dark:text-purple-300">
                                  {iniciais}
                                </div>
                              )}
                              <div className="text-right">
                                <p className="text-[10px] text-purple-400 font-medium">Entregador</p>
                                <p className="text-xs font-bold text-purple-600 dark:text-purple-400 flex items-center gap-1 justify-end">
                                  <Bike className="w-3 h-3" /> {p.entregador_nome}
                                </p>
                              </div>
                            </div>
                          );
                        })()}
                      </div>
                      {isPickup ? (
                        <p className="text-sm text-muted-foreground flex items-center gap-1.5">
                          <Store className="w-4 h-4 shrink-0 text-amber-500" /> Retirada no local
                        </p>
                      ) : (p.endereco_rua || p.endereco_bairro) && (
                        <div className="flex items-start gap-1.5 text-sm">
                          <MapPin className="w-4 h-4 shrink-0 mt-0.5 text-primary" />
                          <div className="min-w-0">
                            <p className="font-semibold">
                              {p.endereco_rua}{p.endereco_numero && `, ${p.endereco_numero}`}
                              {p.endereco_bairro && <span className="font-normal text-muted-foreground"> · {p.endereco_bairro}</span>}
                            </p>
                            {(p.endereco_complemento || p.endereco_referencia) && (
                              <p className="text-xs text-muted-foreground">
                                {[p.endereco_complemento, p.endereco_referencia && `Ref: ${p.endereco_referencia}`].filter(Boolean).join(' · ')}
                              </p>
                            )}
                            {isIfoodPedido(p) && ifoodMeta(p).delivery_observations && (
                              <p className="text-xs text-yellow-600 dark:text-yellow-400 flex items-start gap-1 mt-0.5">
                                <MessageSquare className="w-3 h-3 shrink-0 mt-0.5" /> {ifoodMeta(p).delivery_observations}
                              </p>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Senha do Balcão */}
                    {(p.modulo === 'Balcao' || p.modulo === 'Totem') && p.senha_balcao && (
                      <div className="bg-orange-50 dark:bg-orange-950/30 border border-orange-200 dark:border-orange-800 rounded-xl p-4 text-center">
                        <p className="text-xs text-muted-foreground mb-1">Senha do Balcão</p>
                        <p className="text-4xl font-black text-orange-500">{p.senha_balcao}</p>
                      </div>
                    )}

                    {/* Timeline de Status */}
                    <div className="rounded-xl bg-muted/30 p-4">
                      {/* Info de agendamento (v1.5.379): quando o pedido foi FEITO
                          e pra quando a entrega/retirada está PREVISTA — os tempos
                          da régua abaixo são etapas operacionais, não atraso. */}
                      {p.scheduled_at && (
                        <div className="mb-4 rounded-lg bg-indigo-500/10 border border-indigo-500/30 px-3 py-2.5">
                          <p className="text-[10px] uppercase font-black tracking-wide text-indigo-500 flex items-center gap-1 mb-1">
                            <Calendar className="w-3 h-3" /> Pedido agendado
                          </p>
                          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs">
                            <span className="text-muted-foreground">
                              Feito: <strong className="text-foreground">{fmtCriadoEm(p.created_at)}</strong>
                            </span>
                            <span className="text-muted-foreground">
                              {isPickup ? 'Retirada prevista' : 'Entrega prevista'}:{' '}
                              <strong className="text-indigo-500 dark:text-indigo-400">{fmtScheduledAt(p.scheduled_at)}</strong>
                            </span>
                          </div>
                        </div>
                      )}
                      <div className="relative">
                        <div className="absolute top-[11px] left-0 right-0 h-1 bg-muted rounded-full" />
                        <div className={`absolute top-[11px] left-0 h-1 rounded-full transition-all duration-500 ${p.status === 'cancelado' ? 'bg-red-500' : 'bg-primary'}`} style={{ width: `${progressPct}%` }} />
                        <div className="relative flex justify-between">
                          {stepsWithElapsed.map((s, i) => {
                            const isDone = !!s.ts;
                            const isActive = isDone && i === lastCompletedIdx && i < steps.length - 1;
                            const isFinal = isDone && i === steps.length - 1;
                            return (
                              <div key={i} className="flex flex-col items-center" style={{ width: `${100 / steps.length}%` }}>
                                <div className={`w-6 h-6 rounded-full flex items-center justify-center z-10 transition-all ${
                                  isFinal ? 'bg-green-500 ring-2 ring-green-500/30' :
                                  isActive ? `${stColor} ring-2 ring-primary/30 ${p.status === 'cancelado' ? '' : 'animate-pulse'}` :
                                  isDone ? 'bg-primary' :
                                  'bg-muted border-2 border-muted-foreground/20'
                                }`}>
                                  {isDone ? <Check className="w-3 h-3 text-white" /> : <span className="w-2 h-2 rounded-full bg-muted-foreground/20" />}
                                </div>
                                <p className={`text-[10px] mt-1.5 text-center leading-tight font-medium ${isDone ? 'text-foreground' : 'text-muted-foreground/60'}`}>{s.label}</p>
                                {s.diffMs > 0 && (
                                  <span className={`text-[9px] font-mono mt-0.5 ${s.isLive ? 'text-green-500' : 'text-orange-500'}`}>{fmtElapsed(s.diffMs)}</span>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      {totalMs > 0 && (
                        <div className="flex items-center justify-center gap-1.5 mt-4 pt-3 border-t text-xs text-muted-foreground">
                          <Clock className="w-3.5 h-3.5" />
                          <span>Tempo total: <span className="font-bold text-foreground">{fmtElapsed(totalMs)}</span></span>
                        </div>
                      )}
                      {p.status === 'cancelado' && (
                        <div className="flex items-center justify-center gap-1.5 mt-3 text-red-500 text-xs font-bold">
                          <XCircle className="w-4 h-4" /> Pedido Cancelado
                        </div>
                      )}
                    </div>

                    {/* Pagamento (v1.5.465): uma linha operacional — forma, troco,
                        status e o VALOR A COBRAR. Antes era um bloco com "TOTAL"
                        rotulado gigante, duplicando o rótulo do fecho da conta à
                        direita; agora a direita explica a conta (subtotal + taxa −
                        descontos) e esta linha responde o que o atendente precisa
                        na hora: "PIX · R$ 12,00". */}
                    {isIfoodPedido(p) && Array.isArray(p.pagamentos) && p.pagamentos.length > 0 ? (
                      <div className="rounded-xl bg-muted/30 px-4 py-3 space-y-1.5">
                        {p.pagamentos.map((pg, i) => {
                          const pago = /pago pelo ifood/i.test(pg.label || '');
                          const nome = String(pg.label || pg.method || '').replace(/\s*—.*$/, '');
                          return (
                            <div key={i} className="flex items-center gap-2 flex-wrap">
                              <CreditCard className="w-4 h-4 text-primary shrink-0" />
                              <span className="text-sm font-bold">{nome}</span>
                              <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${pago ? 'text-green-600 dark:text-green-400 bg-green-500/10' : 'text-amber-600 dark:text-amber-400 bg-amber-500/10'}`}>
                                {pago ? 'online · pago' : 'cobrar na entrega'}
                              </span>
                              {pg.troco_precisa && pg.troco_valor && (
                                <span className="text-xs font-semibold text-amber-600 dark:text-amber-400">troco p/ R$ {Number(pg.troco_valor).toFixed(2).replace('.', ',')}</span>
                              )}
                              <span className="ml-auto text-sm font-black tabular-nums">R$ {Number(pg.amount || 0).toFixed(2).replace('.', ',')}</span>
                            </div>
                          );
                        })}
                        <div className="flex items-center justify-between pt-1.5 border-t">
                          <span className="text-xs text-muted-foreground">
                            {Number(ifoodMeta(p).payments_pending || 0) > 0 ? 'A cobrar na entrega' : 'Tudo pago no app do iFood'}
                          </span>
                          <span className="text-lg font-black text-primary tabular-nums">
                            R$ {Number(Number(ifoodMeta(p).payments_pending || 0) > 0 ? ifoodMeta(p).payments_pending : (p.total || 0)).toFixed(2).replace('.', ',')}
                          </span>
                        </div>
                      </div>
                    ) : (
                    <div className="rounded-xl bg-muted/30 px-4 py-3 flex items-center gap-2.5 flex-wrap">
                      <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                        <CreditCard className="w-4 h-4 text-primary" />
                      </div>
                      <span className="text-sm font-bold">{fmtPagamento(p.forma_pagamento)}</span>
                      {_formaBase(p.forma_pagamento) === 'dinheiro' && p.troco_valor && (
                        <span className="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-500/10 px-2 py-0.5 rounded-full">
                          troco R$ {Math.max(0, Number(p.troco_valor) - Number(p.total || 0)).toFixed(2).replace('.', ',')}
                        </span>
                      )}
                      {p.payment_status === 'paid' && (
                        <span className="inline-flex items-center gap-0.5 text-xs font-semibold text-green-600 dark:text-green-400 bg-green-500/10 px-2 py-0.5 rounded-full">
                          <Check className="w-3 h-3" /> Pago
                        </span>
                      )}
                      <span className="ml-auto text-lg font-black text-primary tabular-nums">
                        R$ {(p.total || 0).toFixed(2).replace('.', ',')}
                      </span>
                    </div>
                    )}

                    {/* Observação geral */}
                    {p.observacao && (
                      <div className="bg-yellow-50 dark:bg-yellow-950/20 rounded-xl p-3.5 border border-yellow-200 dark:border-yellow-800">
                        <p className="text-xs font-bold text-yellow-700 dark:text-yellow-400 flex items-center gap-1.5 mb-1">
                          <MessageSquare className="w-4 h-4" /> Observação
                        </p>
                        <p className="text-sm">{p.observacao}</p>
                      </div>
                    )}
                  </div>

                  {/* === PÁGINA DIREITA: Itens do pedido === */}
                  <div className="md:w-1/2 flex flex-col overflow-hidden border-t md:border-t-0">
                    {/* Header dos itens */}
                    <div className="px-5 py-3 bg-muted/30 border-b flex items-center justify-between shrink-0">
                      <p className="text-sm font-bold flex items-center gap-2">
                        <ShoppingBag className="w-4 h-4 text-primary" /> Itens do Pedido
                      </p>
                      <span className="text-[11px] text-muted-foreground font-semibold bg-muted px-2.5 py-1 rounded-full">
                        {p.items?.length || 0} {(p.items?.length || 0) === 1 ? 'item' : 'itens'}
                      </span>
                    </div>
                    {/* Lista de itens scrollável */}
                    <div className="flex-1 overflow-y-auto divide-y">
                      {p.items && p.items.length > 0 ? (
                        p.items.map((item, index) => renderItem(item, index))
                      ) : (
                        <div className="flex flex-col items-center justify-center py-12 text-muted-foreground">
                          <ShoppingBag className="w-10 h-10 mb-2 opacity-30" />
                          <p className="text-sm">Nenhum item</p>
                        </div>
                      )}
                    </div>
                    {isIfoodPedido(p) && Array.isArray(ifoodMeta(p).items_unmapped) && ifoodMeta(p).items_unmapped.length > 0 && (
                      <p className="px-5 py-2 text-[11px] text-amber-700 dark:text-amber-400 bg-amber-500/10 border-t shrink-0">
                        {ifoodMeta(p).items_unmapped.length} item(ns) sem produto no Núcleo — vincule em Configurações → Integração → iFood → Cardápio.
                      </p>
                    )}
                    {/* Breakdown do pedido: subtotal produtos, frete, cupom, desconto manual e total */}
                    {p.items && p.items.length > 0 && (() => {
                      // Peso conta 1 item (30/09/2026): era "Subtotal (2.25 itens)".
                      const itemsCount = contarItens(p.items, _allProds);
                      // Campanha Inteligente: subtotal no preço cheio + linha de desconto exclusivo.
                      const itemsSubtotal = (p.items || []).reduce((s, i) => s + (i.oferta_preco_cheio ? precoCheioOuPago(i) : (i.preco_unitario || i.preco || i.price || 0)) * (i.quantidade || i.qty || 1), 0);
                      const descExclusivo = descontoExclusivo(p.items);
                      const cupomDesc = Number(p.cupom_desconto || 0);
                      const descManual = Number(p.desconto_manual || 0);
                      const cashbackUsado = Number(p.cashback_usado || 0);
                      const taxaEntrega = Number(p.valor_entrega || 0);
                      return (
                        <div className="px-5 py-3 border-t bg-muted/30 shrink-0 space-y-1">
                          <div className="flex items-center justify-between">
                            <span className="text-xs text-muted-foreground">Subtotal ({itemsCount} {itemsCount === 1 ? 'item' : 'itens'})</span>
                            <span className="text-xs font-medium">R$ {itemsSubtotal.toFixed(2).replace('.', ',')}</span>
                          </div>
                          {isIfoodPedido(p) && (
                            <div className="flex items-center justify-between">
                              <span className="text-xs text-muted-foreground">Taxa de serviço iFood</span>
                              <span className="text-xs font-medium">(+) R$ {Number((ifoodMeta(p).totals || {}).additional_fees || 0).toFixed(2).replace('.', ',')}</span>
                            </div>
                          )}
                          {taxaEntrega > 0 && (
                            <div className="flex items-center justify-between">
                              <span className="text-xs text-muted-foreground">Taxa de entrega</span>
                              <span className="text-xs font-medium">(+) R$ {taxaEntrega.toFixed(2).replace('.', ',')}</span>
                            </div>
                          )}
                          {descExclusivo > 0 && (
                            <div className="flex items-center justify-between text-primary" data-e2e="linha-desconto-exclusivo">
                              <span className="text-xs font-semibold">Desconto exclusivo (Campanha Inteligente)</span>
                              <span className="text-xs font-semibold">(−) R$ {descExclusivo.toFixed(2).replace('.', ',')}</span>
                            </div>
                          )}
                          {cupomDesc > 0 && (
                            <div className="flex items-center justify-between text-green-600 dark:text-green-400">
                              <span className="text-xs font-semibold">{isIfoodPedido(p) ? 'Cupom da loja (loja paga)' : `Cupom ${p.cupom_codigo || ''}`}</span>
                              <span className="text-xs font-semibold">(−) R$ {cupomDesc.toFixed(2).replace('.', ',')}</span>
                            </div>
                          )}
                          {isIfoodPedido(p) && Number(ifoodMeta(p).benefits_ifood || 0) > 0 && (
                            <div className="flex items-center justify-between text-green-600 dark:text-green-400">
                              <span className="text-xs font-semibold">Cupom iFood (iFood paga)</span>
                              <span className="text-xs font-semibold">(−) R$ {Number(ifoodMeta(p).benefits_ifood).toFixed(2).replace('.', ',')}</span>
                            </div>
                          )}
                          {descManual > 0 && (
                            <div className="flex items-center justify-between text-green-600 dark:text-green-400">
                              <span className="text-xs font-semibold">Desconto manual</span>
                              <span className="text-xs font-semibold">(−) R$ {descManual.toFixed(2).replace('.', ',')}</span>
                            </div>
                          )}
                          {cashbackUsado > 0 && (
                            <div className="flex items-center justify-between text-emerald-600 dark:text-emerald-400">
                              <span className="text-xs font-semibold">Cashback</span>
                              <span className="text-xs font-semibold">(−) R$ {cashbackUsado.toFixed(2).replace('.', ',')}</span>
                            </div>
                          )}
                          <div className="flex items-center justify-between pt-1 border-t">
                            <span className="text-xs font-bold">Total</span>
                            <span className="text-base font-black text-primary tabular-nums">R$ {Number(p.total ?? itemsSubtotal).toFixed(2).replace('.', ',')}</span>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </div>

                {/* ===== FOOTER (full width) ===== */}
                <div className="border-t px-5 py-3 shrink-0 flex flex-col sm:flex-row gap-2 items-stretch sm:items-center">
                  {/* Botão principal */}
                  {p.status !== 'cancelado' && p.status !== 'concluido' && (() => {
                    const proximoStatus = getProximoStatus(p.status, isPickup);
                    if (!proximoStatus) return null;
                    const isOnlinePending = (p.forma_pagamento === 'pix_online' || p.forma_pagamento === 'cartao_online') && p.payment_status !== 'paid';
                    const disabled = p.status === 'aguardando_aceite' && isOnlinePending;
                    const nextLabel = statusConfig[proximoStatus]?.label || proximoStatus;
                    const showChamarEntregador = !isPickup && entregaAiConfig?.enabled && (p.status === 'producao' || p.status === 'pronto') && !p.entrega_ai_order_id;
                    return (
                      <div className="flex gap-2 order-first sm:order-last sm:ml-auto">
                        <Button
                          className="h-11 px-6 text-sm font-bold bg-orange-500 hover:bg-orange-600 text-white rounded-xl shadow-lg shadow-orange-500/20"
                          disabled={disabled}
                          title={disabled ? 'Aguardando pagamento online' : undefined}
                          onClick={() => handleMudarStatus(p, proximoStatus)}
                        >
                          <ChevronRight className="w-4.5 h-4.5 mr-1.5" /> {nextLabel}
                        </Button>
                        {showChamarEntregador && (
                          <Button
                            className="h-11 px-6 text-sm font-bold bg-[#0ea5e9] hover:bg-[#0284c7] text-white rounded-xl shadow-lg shadow-[#0ea5e9]/20"
                            onClick={() => p.status === 'producao' ? handleChamarEntregadorFromProducao(p.id) : handleChamarEntregador(p.id)}
                          >
                            <img src="/logo-upentrega-v3.png" alt="UP" className="w-5 h-5 mr-1.5 object-contain" />
                            Chamar Entregador
                          </Button>
                        )}
                      </div>
                    );
                  })()}
                  {/* Botões secundários */}
                  {p.status !== 'cancelado' && p.status !== 'concluido' && (
                    <div className="flex gap-2">
                      {podeVoltarEtapa(p) && (
                        <Button variant="outline" size="sm" className="h-9 text-xs rounded-xl" onClick={() => { const sa = getStatusAnterior(p.status); if (sa) handleMudarStatus(p, sa); }}>
                          <Undo2 className="w-3.5 h-3.5 mr-1" /> Voltar
                        </Button>
                      )}
                      {!isIfoodPedido(p) && (
                        <Button variant="outline" size="sm" className="h-9 text-xs rounded-xl" onClick={(e) => handleAbrirEditarPedido(p, e)}>
                          <Edit className="w-3.5 h-3.5 mr-1" /> Editar
                        </Button>
                      )}
                      <Button variant="outline" size="sm" className="h-9 text-xs rounded-xl text-red-500 border-red-500/30 hover:bg-red-500/10 hover:text-red-600" onClick={(e) => handleAbrirCancelar(p, e)}>
                        <XCircle className="w-3.5 h-3.5 mr-1" /> Cancelar
                      </Button>
                    </div>
                  )}
                </div>
              </>
            );
          })()}
        </DialogContent>
      </Dialog>

      {/* Modal de Cancelamento */}
      {/* Popup: pedido alterado pelo cliente via WhatsApp (notificação) */}
      <Dialog open={!!modPopupPedido} onOpenChange={(open) => { if (!open) closeModPopup(); }}>
        <DialogContent className="max-w-[95vw] sm:max-w-md w-full m-2 sm:m-4">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-amber-600">
              <AlertTriangle className="w-5 h-5" />
              📢 PEDIDO #{modPopupPedido?.codigo} ALTERADO PELO CLIENTE
            </DialogTitle>
          </DialogHeader>
          {modPopupPedido && (
            <div className="space-y-3">
              <div className="p-3 bg-amber-50 dark:bg-amber-950/20 rounded-lg border border-amber-200 dark:border-amber-800">
                <p className="font-semibold text-sm text-zinc-700 dark:text-zinc-300">
                  {modPopupPedido.cliente_nome || "Cliente"}
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  Tipo: {(() => {
                    const t = modPopupPedido.last_modification?.type;
                    if (t === "payment") return "Forma de pagamento";
                    if (t === "troco") return "Troco";
                    if (t === "address") return "Endereço de entrega";
                    return t || "—";
                  })()}
                </p>
                <div className="mt-3 flex flex-col gap-1">
                  <div className="text-sm">
                    <span className="text-muted-foreground">De: </span>
                    <span className="font-medium line-through opacity-70">
                      {valorDaAlteracao(modPopupPedido.last_modification, "old_value")}
                    </span>
                  </div>
                  <div className="text-sm">
                    <span className="text-muted-foreground">Para: </span>
                    <span className="font-bold text-emerald-700 dark:text-emerald-400">
                      {valorDaAlteracao(modPopupPedido.last_modification, "new_value")}
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-xs text-muted-foreground flex items-center gap-1">
                <Printer className="w-3 h-3" /> Cupom completo reimpresso no caixa.
              </p>
            </div>
          )}
          <DialogFooter>
            <Button onClick={closeModPopup} className="w-full">
              OK, VISTO
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={cancelarModalOpen} onOpenChange={setCancelarModalOpen}>
        <DialogContent className="max-w-[95vw] sm:max-w-md w-full m-2 sm:m-4">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <XCircle className="w-5 h-5" />
              Cancelar Pedido
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            {pedidoParaCancelar && (
              <div className="p-3 bg-red-50 dark:bg-red-950/20 rounded-lg border border-red-200 dark:border-red-800">
                <p className="font-mono text-sm">{pedidoParaCancelar.codigo}</p>
                <p className="font-semibold">{pedidoParaCancelar.cliente_nome}</p>
                <p className="text-lg font-bold text-primary mt-1">
                  R$ {(pedidoParaCancelar.total || 0).toFixed(2).replace(".", ",")}
                </p>
              </div>
            )}
            
            {(pedidoParaCancelar?.modulo || "").toLowerCase() === "ifood" && (
              <CancelReasonSelect
                pedidoId={pedidoParaCancelar.id}
                value={ifoodCancelReason}
                onChange={setIfoodCancelReason}
              />
            )}

            <div>
              <Label className="text-sm font-semibold">
                {(pedidoParaCancelar?.modulo || "").toLowerCase() === "ifood" ? "Observação (opcional)" : <>Motivo do Cancelamento <span className="text-red-500">*</span></>}
              </Label>
              <Textarea
                value={motivoCancelamento}
                onChange={(e) => setMotivoCancelamento(e.target.value)}
                placeholder={(pedidoParaCancelar?.modulo || "").toLowerCase() === "ifood" ? "Detalhe para o cliente, se quiser..." : "Informe o motivo do cancelamento..."}
                className="mt-2 min-h-[80px]"
              />
              <p className="text-xs text-muted-foreground mt-1">
                {/* Achado 446: o WhatsApp leva um aviso padrão; o motivo fica no painel e no acompanhamento. */}
                Este motivo fica no painel e no acompanhamento do pedido. No WhatsApp o cliente recebe um aviso padrão de cancelamento.
              </p>
            </div>
            
            <div className="flex gap-2">
              <Button variant="outline" onClick={() => setCancelarModalOpen(false)} className="flex-1">
                Voltar
              </Button>
              <Button 
                variant="destructive"
                onClick={handleCancelarPedido} 
                disabled={
                  (pedidoParaCancelar?.modulo || "").toLowerCase() === "ifood"
                    ? !ifoodCancelReason?.code
                    : !motivoValido(motivoCancelamento)
                }
                className="flex-1"
              >
                <XCircle className="w-4 h-4 mr-1" />
                Confirmar Cancelamento
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal: Saldo insuficiente UP Entrega */}
      <Dialog
        open={saldoInsuficienteModal.open}
        onOpenChange={(open) => { if (!open) setSaldoInsuficienteModal((s) => ({ ...s, open: false })); }}
      >
        <DialogContent className="max-w-[95vw] sm:max-w-md w-full m-2 sm:m-4">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-orange-600">
              <Wallet className="w-5 h-5" />
              Saldo insuficiente na carteira UP Entrega
            </DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            <div className="p-4 bg-orange-50 dark:bg-orange-950/20 rounded-lg border border-orange-200 dark:border-orange-800">
              <p className="text-sm text-orange-900 dark:text-orange-200 mb-3">
                Você não tem saldo suficiente para solicitar este entregador. O pedido <strong>continua em "Pronto"</strong> e você pode chamar o entregador novamente assim que recarregar.
              </p>

              {(saldoInsuficienteModal.currentBalance != null && saldoInsuficienteModal.deliveryPrice != null && saldoInsuficienteModal.missingAmount != null) && (
                <div className="space-y-1.5 text-sm">
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Saldo atual:</span>
                    <span className="font-semibold">R$ {Number(saldoInsuficienteModal.currentBalance).toFixed(2).replace('.', ',')}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Valor da entrega:</span>
                    <span className="font-semibold">R$ {Number(saldoInsuficienteModal.deliveryPrice).toFixed(2).replace('.', ',')}</span>
                  </div>
                  <div className="flex justify-between border-t border-orange-200 dark:border-orange-800 pt-1.5 mt-1.5">
                    <span className="font-semibold text-orange-700 dark:text-orange-300">Faltam:</span>
                    <span className="font-bold text-orange-700 dark:text-orange-300">R$ {Number(saldoInsuficienteModal.missingAmount).toFixed(2).replace('.', ',')}</span>
                  </div>
                </div>
              )}
            </div>

            <div className="flex gap-2">
              <Button
                variant="outline"
                onClick={() => setSaldoInsuficienteModal((s) => ({ ...s, open: false }))}
                className="flex-1"
              >
                Fechar
              </Button>
              <Button
                onClick={() => {
                  window.open("https://entregaai.usenucleo.com.br/wallet", "_blank");
                  setSaldoInsuficienteModal((s) => ({ ...s, open: false }));
                }}
                className="flex-1 bg-green-600 hover:bg-green-700 text-white"
              >
                <Wallet className="w-4 h-4 mr-1" />
                Recarregar carteira
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal: Atribuir entregador ao avançar pedido pronto -> em_rota */}
      <Dialog
        open={atribuirEntregadorModal.open}
        onOpenChange={(open) => { if (!open) setAtribuirEntregadorModal({ open: false, pedido: null, entregadorId: "" }); }}
      >
        <DialogContent className="max-w-[95vw] sm:max-w-md w-full m-2 sm:m-4">
          <DialogHeader>
            <DialogTitle>Quem vai levar o pedido?</DialogTitle>
          </DialogHeader>
          <div className="space-y-3 py-2">
            <p className="text-sm text-muted-foreground">
              Pedido <strong>{atribuirEntregadorModal.pedido?.codigo}</strong> — selecione o entregador responsável.
            </p>
            <Select
              value={atribuirEntregadorModal.entregadorId}
              onValueChange={(v) => setAtribuirEntregadorModal((s) => ({ ...s, entregadorId: v }))}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder={
                  (entregadores || []).filter((e) => !String(e.nome || '').startsWith('[UP Entrega]') && !String(e.nome || '').startsWith('[Entrega Aí]')).length === 0
                    ? "Nenhum entregador próprio cadastrado"
                    : "Selecione um entregador"
                } />
              </SelectTrigger>
              <SelectContent>
                {(entregadores || [])
                  .filter((e) => !String(e.nome || '').startsWith('[UP Entrega]') && !String(e.nome || '').startsWith('[Entrega Aí]'))
                  .map((e) => (
                    <SelectItem key={e.id} value={e.id}>
                      {e.nome}{e.telefone ? ` — ${e.telefone}` : ''}
                    </SelectItem>
                  ))}
              </SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground">
              O entregador vai receber uma mensagem no WhatsApp com os dados da entrega.
            </p>
          </div>
          <DialogFooter className="gap-2">
            <Button
              variant="outline"
              onClick={() => setAtribuirEntregadorModal({ open: false, pedido: null, entregadorId: "" })}
              className="flex-1"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleConfirmarAtribuirEntregador}
              disabled={!atribuirEntregadorModal.entregadorId}
              className="flex-1 bg-orange-500 hover:bg-orange-600"
            >
              Enviar pra entrega
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal de Criar Entregador */}
      <Dialog open={criarEntregadorModalOpen} onOpenChange={setCriarEntregadorModalOpen}>
        <DialogContent className="max-w-[95vw] sm:max-w-md w-full m-2 sm:m-4">
          <DialogHeader>
            <DialogTitle>Novo Entregador</DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            {/* Foto */}
            <div className="flex justify-center">
              <label className="relative cursor-pointer group">
                <div className="w-20 h-20 rounded-full border-2 border-dashed border-muted-foreground/40 group-hover:border-primary flex items-center justify-center overflow-hidden bg-muted transition-colors">
                  {novoEntregadorFotoPreview ? (
                    <img src={novoEntregadorFotoPreview} alt="Preview" className="w-full h-full object-cover" />
                  ) : (
                    <Camera className="w-6 h-6 text-muted-foreground group-hover:text-primary" />
                  )}
                </div>
                <input type="file" accept="image/*" className="hidden" onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    setNovoEntregadorFoto(file);
                    setNovoEntregadorFotoPreview(URL.createObjectURL(file));
                  }
                }} />
                <span className="text-[10px] text-muted-foreground block text-center mt-1">Foto</span>
              </label>
            </div>

            <div>
              <Label>Nome *</Label>
              <Input
                value={novoEntregadorNome}
                onChange={(e) => setNovoEntregadorNome(e.target.value)}
                placeholder="Nome do entregador"
                className="mt-1"
              />
            </div>

            <div>
              <Label>Telefone</Label>
              <Input
                value={novoEntregadorTelefone}
                onChange={(e) => setNovoEntregadorTelefone(e.target.value)}
                placeholder="(00) 00000-0000"
                className="mt-1"
              />
            </div>

            <div className="flex gap-2">
              <Button variant="outline" onClick={() => { setCriarEntregadorModalOpen(false); setNovoEntregadorFoto(null); setNovoEntregadorFotoPreview(null); }} className="flex-1">
                Cancelar
              </Button>
              <Button onClick={handleCriarEntregador} disabled={uploadingFoto} className="flex-1">
                {uploadingFoto ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Plus className="w-4 h-4 mr-1" />}
                Cadastrar
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Retirada já paga online: só confirma a entrega */}
      <Dialog open={pagamentoModalOpen} onOpenChange={setPagamentoModalOpen}>
        <DialogContent className="max-w-[95vw] sm:max-w-md w-full m-2 sm:m-4 max-h-[90dvh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <DollarSign className="w-5 h-5" />
              Finalizar Pedido
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 mt-2">
            <div className="text-center p-4 bg-muted rounded-lg">
              <p className="text-sm text-muted-foreground">Total do pedido</p>
              <p className="text-3xl font-bold text-primary">R$ {pgTotal.toFixed(2).replace(".", ",")}</p>
            </div>
            <div className="p-4 bg-green-50 dark:bg-green-900/20 rounded-lg border-2 border-green-500 text-center">
              <Check className="w-10 h-10 text-green-600 mx-auto mb-2" />
              <p className="text-xl font-bold text-green-700 dark:text-green-400">PEDIDO PAGO</p>
              <p className="text-sm text-green-600 dark:text-green-500 mt-1">
                Pago via {fmtFormaPagamentoLabel(pedidoParaPagamento?.forma_pagamento)}
              </p>
            </div>
            <Button className="w-full h-12 text-lg bg-green-600 hover:bg-green-700" onClick={handleFinalizarRetirada}>
              <Check className="w-4 h-4 mr-1" />
              Confirmar Entrega
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Retirada a receber: mesmo popup do Fechar mesa */}
      <FechamentoPedidoDialog
        pedido={pedidoFechamento}
        formas={paymentMethodsDelivery}
        open={fechamentoAberto}
        onOpenChange={setFechamentoAberto}
        onConcluir={concluirRetirada}
      />

      {/* Modal de Novo Pedido - Cardápio Completo */}
      <CardapioPopup 
        open={editarPedidoModalOpen} 
        onClose={() => {
          setEditarPedidoModalOpen(false);
          setPedidoEditando(null);
        }}
        onPedidoCriado={(updatedPedido) => {
          setEditarPedidoModalOpen(false);
          setPedidoEditando(null);
          if (updatedPedido) {
            setPedidos(prev => prev.map(p => p.id === updatedPedido.id ? { ...p, ...updatedPedido } : p));
          }
          fetchData();
          toast.success(updatedPedido ? "Pedido atualizado com sucesso!" : "Pedido criado com sucesso!");
        }}
        pedidoParaEditar={pedidoEditando}
      />

      {/* Widget fixo inferior-esquerdo: RADAR — esperado x real para a hora atual */}
      {RADAR_VISIVEL && radar && (() => {
        const hh = String(radar.hour ?? 0).padStart(2, '0');
        const pct = Number(radar.percent || 0);
        const hasExpected = Number(radar.expected || 0) > 0;
        const pctColor = !hasExpected
          ? 'text-muted-foreground'
          : (pct < 50 ? 'text-red-500' : (pct < 90 ? 'text-amber-500' : 'text-emerald-500'));
        const dotColor = !hasExpected
          ? 'bg-muted-foreground'
          : (pct < 50 ? 'bg-red-500' : (pct < 90 ? 'bg-amber-500' : 'bg-emerald-500'));
        // Tooltip com breakdown das 8 amostras
        const tooltip = (() => {
          const lines = [
            `Radar ${radar.weekday_label} ${hh}:00`,
            `Hoje: dia ${radar.today_dom} (${radar.today_bucket_label})`,
            `Média ponderada das últimas ${radar.lookback_weeks} semanas:`,
            ``,
          ];
          (radar.samples || []).forEach(s => {
            const d = (s.date || '').split('-').slice(1).reverse().join('/'); // MM-DD → DD/MM
            lines.push(`  ${d} (${s.bucket}) → ${s.count} pedidos · peso ${s.weight}`);
          });
          lines.push('');
          lines.push('Pesos: bucket × recência');
          lines.push('Bucket: mesmo=1.0 · adjacente=0.4 · oposto=0.15');
          lines.push('Recência: semana 1=1.0 ↘ semana 8=0.65');
          return lines.join('\n');
        })();
        return (
          <div className={`fixed bottom-3 left-3 z-30 pointer-events-none ${mobileTab === 'producao' ? '' : 'max-xl:hidden'}`}>
            <button
              type="button"
              onClick={() => setRadarModalOpen(true)}
              className="pointer-events-auto bg-card/95 backdrop-blur-sm border border-border/60 rounded-xl shadow-lg px-3 py-2 flex items-center gap-3 text-xs cursor-pointer hover:border-orange-500/60 hover:shadow-orange-500/10 transition-colors"
              title={tooltip}
            >
              <span className={`w-1.5 h-1.5 rounded-full ${dotColor} animate-pulse`} />
              <div className="flex items-center gap-1">
                <Radar className="w-3.5 h-3.5 text-muted-foreground" strokeWidth={1.75} />
                <span className="font-semibold text-foreground tabular-nums">{hh}h</span>
                <span className="ml-1 px-1.5 py-0.5 rounded text-[8px] font-bold uppercase tracking-wider bg-violet-500/15 text-violet-500 border border-violet-500/30">
                  Beta
                </span>
              </div>
              <span className="w-px h-3 bg-border" />
              <div className="flex items-center gap-1">
                <span className="text-[10px] text-muted-foreground">esp.</span>
                <span className="font-bold text-foreground tabular-nums">{Math.round(Number(radar.expected || 0))}</span>
              </div>
              <span className="w-px h-3 bg-border" />
              <div className="flex items-center gap-1">
                <span className="text-[10px] text-muted-foreground">real</span>
                <span className="font-bold text-foreground tabular-nums">{radar.real ?? 0}</span>
              </div>
              <span className="w-px h-3 bg-border" />
              <span className={`font-bold tabular-nums ${pctColor}`}>
                {hasExpected ? `${pct.toFixed(0)}%` : '—'}
              </span>
            </button>
          </div>
        );
      })()}

      <RadarDetailsModal open={radarModalOpen} onClose={() => setRadarModalOpen(false)} />

      {/* Confirmação de ciente no cancelamento iFood — AlertDialog do projeto
          (Radix). Antes estava ao final do arquivo, mas o final é do
          CardapioPopup (componente separado) — gerou ReferenceError em runtime
          porque ackCancelPedido só existe no escopo do Delivery. */}
      <AlertDialog
        open={!!ackCancelPedido}
        onOpenChange={(open) => { if (!open) setAckCancelPedido(null); }}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmar cancelamento iFood?</AlertDialogTitle>
            <AlertDialogDescription>
              O pedido <strong>#{(ackCancelPedido?.codigo || '').toString().replace('#', '')}</strong>
              {ackCancelPedido?._ifood_display_id || ackCancelPedido?.ifood_display_id
                ? <> (iFood #{ackCancelPedido?._ifood_display_id || ackCancelPedido?.ifood_display_id})</>
                : null}
              {' '}foi cancelado pelo iFood
              {ackCancelPedido?.cliente_nome ? <> (cliente: {ackCancelPedido.cliente_nome})</> : null}.
              {ackCancelPedido?.motivo_cancelamento && (
                <span className="block mt-2 text-red-700 dark:text-red-400 text-sm">
                  Motivo: {ackCancelPedido.motivo_cancelamento}
                </span>
              )}
              <span className="block mt-3">
                Ao confirmar, o carimbo sai da coluna e o pedido fica só no histórico de cancelados do dia.
              </span>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Voltar</AlertDialogCancel>
            <AlertDialogAction
              onClick={confirmAcknowledgeCancellation}
              className="bg-red-600 hover:bg-red-700 text-white"
            >
              Confirmar que vi
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Modal de PEDIDOS AGENDADOS — abre pelo card no topo da coluna Em Produção.
          Precisa ficar DENTRO do componente Delivery pra acessar showAgendadosModal
          + pedidosAgendados + handleAprovarAgendado (regressão v1.5.278 corrigida em v1.5.279). */}
      <Dialog open={showAgendadosModal} onOpenChange={setShowAgendadosModal}>
        <DialogContent className="sm:max-w-2xl max-h-[90vh] p-0 overflow-hidden flex flex-col">
          <DialogHeader className="p-0 space-y-0">
            <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 text-white px-5 py-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-white/20 backdrop-blur flex items-center justify-center flex-shrink-0">
                  <Calendar className="w-5 h-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <DialogTitle asChild>
                    <h2 className="text-lg font-bold leading-tight">Pedidos Agendados</h2>
                  </DialogTitle>
                  <p className="text-xs opacity-90 mt-0.5">
                    Aprovar envia o pedido pra <strong>Produção</strong> e dispara a impressão do cupom.
                  </p>
                </div>
              </div>
            </div>
          </DialogHeader>

          <div className="flex-1 overflow-y-auto p-5 space-y-3 bg-muted/30">
            {pedidosAgendados.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-16 text-muted-foreground">
                <Calendar className="w-12 h-12 mb-3 opacity-40" />
                <p className="text-sm font-medium">Nenhum agendamento pendente.</p>
                <p className="text-xs mt-1 opacity-70">Quando um cliente agendar, aparece aqui.</p>
              </div>
            ) : (
              pedidosAgendados.map((pedido) => {
                const aprovando = aprovandoAgendadoId === pedido.id;
                const rejeitando = rejeitandoAgendadoId === pedido.id;
                const decidindoCancel = decidindoCancelId === pedido.id;
                const busy = aprovando || rejeitando || decidindoCancel;
                const tipoLabel = pedido.tipo_entrega === 'pickup' ? 'Retirada' : 'Entrega';
                const cancelSolicitado = !!pedido.cancel_requested_at;
                const cancelReason = (pedido.cancel_request_reason || '').trim();
                return (
                  <div
                    key={pedido.id}
                    className={`rounded-xl border-2 ${cancelSolicitado ? 'border-red-500/60 bg-red-50/40 dark:bg-red-950/20' : 'border-indigo-500/30 bg-card'} p-4 shadow-sm`}
                  >
                    <div className={`-mx-4 -mt-4 mb-3 px-4 py-1.5 text-white text-[10px] font-black uppercase tracking-wider flex items-center gap-1.5 rounded-t-lg ${cancelSolicitado ? 'bg-red-500' : 'bg-indigo-500'}`}>
                      {cancelSolicitado ? (
                        <>
                          <XCircle className="w-3 h-3" />
                          Cliente pediu cancelamento — {fmtScheduledAt(pedido.scheduled_at)}
                        </>
                      ) : (
                        <>
                          <Calendar className="w-3 h-3" />
                          Entrega prevista {fmtScheduledAt(pedido.scheduled_at)}
                        </>
                      )}
                    </div>
                    <div className="flex items-start justify-between gap-2 mb-3">
                      <div className="min-w-0">
                        <p className="font-mono font-bold text-sm">{pedido.codigo}</p>
                        <p className="text-sm font-semibold truncate">{pedido.cliente_nome || 'Cliente'}</p>
                        {pedido.cliente_telefone && (
                          <p className="text-xs text-muted-foreground">{formatPhoneNumber(pedido.cliente_telefone)}</p>
                        )}
                      </div>
                      <div className="text-right shrink-0">
                        <span className="text-primary font-bold text-sm whitespace-nowrap block">
                          R$ {(pedido.total || 0).toFixed(2).replace('.', ',')}
                        </span>
                        <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-bold mt-1 ${pedido.tipo_entrega === 'pickup' ? 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400' : 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400'}`}>
                          {pedido.tipo_entrega === 'pickup' ? <Store className="w-3 h-3" /> : <Truck className="w-3 h-3" />}
                          {tipoLabel}
                        </span>
                      </div>
                    </div>

                    {/* Grid: feito às / entrega às / pagamento / endereço (v1.5.377) */}
                    <div className="grid grid-cols-2 gap-1.5 mb-3 text-xs">
                      <div className="rounded-lg bg-muted/50 px-2.5 py-1.5">
                        <p className="text-[10px] uppercase font-bold text-muted-foreground flex items-center gap-1"><Clock className="w-3 h-3" /> Pedido feito</p>
                        <p className="font-semibold mt-0.5">{fmtCriadoEm(pedido.created_at)}</p>
                      </div>
                      <div className="rounded-lg bg-indigo-500/10 px-2.5 py-1.5">
                        <p className="text-[10px] uppercase font-bold text-indigo-500 flex items-center gap-1"><Calendar className="w-3 h-3" /> {pedido.tipo_entrega === 'pickup' ? 'Retirada' : 'Entrega'} agendada</p>
                        <p className="font-semibold mt-0.5">{fmtScheduledAt(pedido.scheduled_at)}</p>
                      </div>
                      <div className="rounded-lg bg-muted/50 px-2.5 py-1.5">
                        <p className="text-[10px] uppercase font-bold text-muted-foreground flex items-center gap-1"><CreditCard className="w-3 h-3" /> Pagamento</p>
                        <p className="font-semibold mt-0.5">{fmtPagamentoAgendado(pedido)}</p>
                      </div>
                      <div className="rounded-lg bg-muted/50 px-2.5 py-1.5">
                        <p className="text-[10px] uppercase font-bold text-muted-foreground flex items-center gap-1">
                          {pedido.tipo_entrega === 'pickup' ? <Store className="w-3 h-3" /> : <MapPin className="w-3 h-3" />} {pedido.tipo_entrega === 'pickup' ? 'Retirada' : 'Endereço'}
                        </p>
                        <p className="font-semibold mt-0.5 leading-snug">
                          {pedido.tipo_entrega === 'pickup'
                            ? 'Cliente retira no balcão'
                            : [
                                `${pedido.endereco_rua || ''}${pedido.endereco_numero ? `, ${pedido.endereco_numero}` : ''}`.trim(),
                                pedido.endereco_complemento,
                                pedido.endereco_bairro,
                              ].filter(Boolean).join(' · ') || '—'}
                        </p>
                        {pedido.tipo_entrega !== 'pickup' && pedido.endereco_referencia && (
                          <p className="text-[10px] text-muted-foreground mt-0.5">Ref.: {pedido.endereco_referencia}</p>
                        )}
                      </div>
                    </div>

                    {/* Itens com foto (v1.5.377) */}
                    {(pedido.items?.length || 0) > 0 && (
                      <div className="space-y-1.5 mb-3">
                        {pedido.items.map((it, i) => (
                          <div key={i} className="flex items-center gap-2.5 rounded-lg bg-muted/40 px-2 py-1.5">
                            <div className="w-10 h-10 rounded-md overflow-hidden bg-muted flex-shrink-0">
                              {it.photo_url
                                ? <img src={getImageUrl(it.photo_url)} alt="" className="w-full h-full object-cover" loading="lazy" />
                                : <div className="w-full h-full flex items-center justify-center"><ImageOff className="w-4 h-4 text-muted-foreground/60" /></div>}
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-xs font-semibold truncate">{qtdDoItem(Number(it.quantidade) || 1, medidaDoItem(it, allProductsWithInsumos))} {it.nome}</p>
                              {(it.subitems?.length || 0) > 0 && (
                                <p className="text-[10px] text-muted-foreground truncate">
                                  {it.subitems.map((s) => s.nome).join(', ')}
                                </p>
                              )}
                              {it.observacao && (
                                <p className="text-[10px] text-amber-600 dark:text-amber-400 truncate">Obs: {it.observacao}</p>
                              )}
                            </div>
                            <span className="text-[11px] font-bold text-muted-foreground whitespace-nowrap">
                              R$ {(((Number(it.preco) || 0) * (Number(it.quantidade) || 1))).toFixed(2).replace('.', ',')}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                    {/* v1.5.362+: se cliente pediu cancelamento, mostra motivo + 2 botões */}
                    {cancelSolicitado ? (
                      <>
                        {cancelReason && (
                          <div className="mb-3 rounded-lg bg-red-500/10 border border-red-500/30 px-3 py-2">
                            <p className="text-[11px] font-bold text-red-700 dark:text-red-300">Motivo do cliente</p>
                            <p className="text-xs text-red-800 dark:text-red-200 mt-0.5 leading-relaxed">{cancelReason}</p>
                          </div>
                        )}
                        <div className="grid grid-cols-2 gap-2">
                          <button
                            type="button"
                            onClick={() => handleAceitarCancelamento(pedido.id)}
                            disabled={busy}
                            className="h-10 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-bold gap-1.5 inline-flex items-center justify-center transition-colors disabled:opacity-60"
                          >
                            {decidindoCancel ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
                            Cancelar pedido
                          </button>
                          <button
                            type="button"
                            onClick={() => openMotivoDialog(pedido.id, 'negar_cancel')}
                            disabled={busy}
                            className="h-10 rounded-lg border-2 border-indigo-500 text-indigo-600 hover:bg-indigo-500/10 text-sm font-bold inline-flex items-center justify-center transition-colors disabled:opacity-60"
                          >
                            Manter pedido
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="grid grid-cols-2 gap-2">
                        <button
                          type="button"
                          onClick={(e) => handleAprovarAgendado(pedido.id, e)}
                          disabled={busy}
                          className="h-10 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-bold gap-1.5 inline-flex items-center justify-center transition-colors disabled:opacity-60"
                        >
                          {aprovando ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
                          Aprovar
                        </button>
                        <button
                          type="button"
                          onClick={() => openMotivoDialog(pedido.id, 'recusar')}
                          disabled={busy}
                          className="h-10 rounded-lg border-2 border-red-500 text-red-600 hover:bg-red-500/10 text-sm font-bold gap-1.5 inline-flex items-center justify-center transition-colors disabled:opacity-60"
                        >
                          {rejeitando ? <Loader2 className="w-4 h-4 animate-spin" /> : <XCircle className="w-4 h-4" />}
                          Recusar
                        </button>
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* v1.5.362+ Dialog de motivo pra Recusar agendamento OU Negar cancelamento */}
      <Dialog open={!!motivoDialog} onOpenChange={(o) => { if (!o) setMotivoDialog(null); }}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>{motivoDialog?.title || 'Motivo'}</DialogTitle>
          </DialogHeader>
          <div className="space-y-3">
            <p className="text-xs text-muted-foreground">
              O cliente vai receber esse motivo por WhatsApp. Pode deixar em branco se preferir não explicar.
            </p>
            <textarea
              value={motivoText}
              onChange={(e) => setMotivoText(e.target.value.slice(0, 500))}
              placeholder={motivoDialog?.placeholder || ''}
              className="w-full min-h-[80px] rounded-lg border p-2 text-sm resize-none bg-background"
              autoFocus
            />
            <div className="flex justify-end gap-2 pt-1">
              <button
                type="button"
                onClick={() => setMotivoDialog(null)}
                className="h-9 px-3 rounded-lg text-sm font-medium text-muted-foreground hover:bg-muted"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={confirmMotivoDialog}
                className={`h-9 px-4 rounded-lg text-sm font-bold text-white ${motivoDialog?.mode === 'recusar' ? 'bg-red-600 hover:bg-red-700' : 'bg-indigo-600 hover:bg-indigo-700'}`}
              >
                {motivoDialog?.mode === 'recusar' ? 'Recusar pedido' : 'Manter pedido'}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

// ==================== COMPONENTE CARDÁPIO POPUP ====================
// getImageUrl já definido no topo do arquivo

// Verifica se a imagem é PNG (para usar fundo transparente)
const isPngImage = (url) => {
  if (!url) return false;
  return url.toLowerCase().endsWith('.png');
};

// Cache em modulo — sobrevive entre aberturas do popup dentro da mesma SPA session.
// Invalida naturalmente ao refresh de pagina. Reduz drasticamente o tempo do
// "Novo Pedido" a partir da 2a abertura (clientes/bairros/promocoes/formas de
// pagamento ja disponiveis em ms).
const CARDAPIO_POPUP_CACHE = {
  clientes: null,
  bairros: null,
  paymentMethods: null,
  activePromotions: null,
};

function CardapioPopup({ open, onClose, onPedidoCriado, pedidoParaEditar = null }) {
  const [products, setProducts] = useState([]);
  const [allProductsForPhotos, setAllProductsForPhotos] = useState([]); // Todos os produtos para buscar fotos
  const [categories, setCategories] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [bairros, setBairros] = useState([]);
  const [paymentMethodsDelivery, setPaymentMethodsDelivery] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [cart, setCart] = useState([]);

  // Categorias que possuem ao menos um produto visível para Delivery — respeita display_order do backend
  const categoriesWithProducts = useMemo(() => {
    const deliveryProducts = (products || []).filter(p =>
      !p.is_insumo && !p.hidden && (!p.visible_modules || p.visible_modules.length === 0 || p.visible_modules.includes('Delivery'))
    );
    const categorySet = new Set(deliveryProducts.map(p => p.category).filter(Boolean));
    return (categories || []).filter(cat => categorySet.has(cat.name));
  }, [categories, products]);
  
  // Cliente selecionado ou novo
  const [selectedCliente, setSelectedCliente] = useState(null);
  // Campanha Inteligente: este popup soma e envia pelo sale_price. Editando pedido
  // existente a campanha não entra — o preço daquele pedido já foi decidido.
  const ofertasCliente = useOfertasNoCarrinho({
    clienteId: pedidoParaEditar ? null : (selectedCliente?.id || null),
    modulo: "Delivery", cart, setCart, campoPreco: "sale_price",
  });
  const [clienteSearch, setClienteSearch] = useState("");
  const [showClienteDropdown, setShowClienteDropdown] = useState(false);
  const [clienteAceso, setClienteAceso] = useState(0); // ↑↓ na lista de clientes (29/09/2026)
  const [novoCliente, setNovoCliente] = useState({ nome: "", telefone: "" });
  const [creatingCliente, setCreatingCliente] = useState(false);
  const nomeClienteInputRef = useRef(null);
  const clienteSearchRef = useRef(null);
  const [highlightClienteSearch, setHighlightClienteSearch] = useState(false);
  
  // Histórico de pedidos do cliente
  const [clienteHistorico, setClienteHistorico] = useState([]);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  
  // Endereços salvos do cliente
  const [enderecosSalvos, setEnderecosSalvos] = useState([]);
  const [enderecoSelecionado, setEnderecoSelecionado] = useState(null);
  
  // Múltiplos pedidos simultâneos
  const [pedidosAtivos, setPedidosAtivos] = useState([]);
  const [pedidoAtualId, setPedidoAtualId] = useState(null);
  
  // Tipo de entrega e endereço
  const [tipoEntrega, setTipoEntrega] = useState("delivery"); // delivery ou pickup
  const [endereco, setEndereco] = useState({
    rua: "",
    numero: "",
    bairro: "",
    complemento: "",
    referencia: "",
    cep: ""
  });
  const [taxaEntrega, setTaxaEntrega] = useState(0);
  
  // Pagamento e observações
  const [formaPagamento, setFormaPagamento] = useState("");
  const [observacao, setObservacao] = useState("");
  const [trocoPara, setTrocoPara] = useState("");
  const [precisaTroco, setPrecisaTroco] = useState(false);

  // Split payment (CardapioPopup)
  const [cpSplitPayment, setCpSplitPayment] = useState(false);
  const [cpSplitPayments, setCpSplitPayments] = useState([]);
  const [cpShowSplitModal, setCpShowSplitModal] = useState(false);
  const [cpSplitSelectedMethod, setCpSplitSelectedMethod] = useState(null);
  const [cpSplitAmount, setCpSplitAmount] = useState("");
  const [cpSplitTrocoNeeds, setCpSplitTrocoNeeds] = useState(false);
  const [cpSplitTrocoAmount, setCpSplitTrocoAmount] = useState("");

  // Já pago
  const [jaPago, setJaPago] = useState(false);
  // Desconto aplicado no pedido (manual % / manual R$ fixo / cupom codigo)
  const [discountType, setDiscountType] = useState('none'); // 'none' | 'percent' | 'fixed' | 'coupon'
  const [discountValue, setDiscountValue] = useState(0); // percentual (1..100) ou valor (R$)
  const [couponCode, setCouponCode] = useState('');
  const [couponData, setCouponData] = useState(null); // { code, discount, ... } apos validar
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  const [discountModalMode, setDiscountModalMode] = useState(null); // 'manual' | 'coupon'
  const [couponValidating, setCouponValidating] = useState(false);
  const [couponError, setCouponError] = useState('');
  // Drafts do painel de desconto manual — so viram efetivos ao clicar em Aplicar
  const [draftPercent, setDraftPercent] = useState(0);      // 0..100
  const [draftFinalValue, setDraftFinalValue] = useState(''); // valor final em R$ (subtotal - desconto)

  // Finalizar dialog (replaces step navigation)
  const [showFinalizarDialog, setShowFinalizarDialog] = useState(false);
  
  // Popup de produto
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productQuantity, setProductQuantity] = useState(1);
  // Peso lido da balança do computador no popup do produto (features/balanca, 26/10/2026)
  const [pesadoBalanca, setPesadoBalanca] = useState(false);
  const [productObservation, setProductObservation] = useState("");
  const [activePromotions, setActivePromotions] = useState([]);
  // Promoção exclusiva de tipos de cliente (27/10/2026): com o cliente escolhido,
  // entram as do tipo dele (sem guardar no cache, que é de todos)
  const promosDoCliente = useRef(false);
  useEffect(() => {
    if (!promosDoCliente.current) { promosDoCliente.current = true; return; }
    const doCliente = selectedCliente?.id ? `&cliente_id=${encodeURIComponent(selectedCliente.id)}` : "";
    axios.get(`${API}/promotions/active?module=Delivery${doCliente}`)
      .then((r) => { if (Array.isArray(r.data)) setActivePromotions(r.data); }).catch(() => {});
  }, [selectedCliente?.id]);
  
  // Estados para Combo/Order Steps
  const [comboStep, setComboStep] = useState(0); // 0 = seleção tipo, 1+ = etapas
  const [stepSearch, setStepSearch] = useState(""); // busca dentro de uma etapa de adicionais
  useEffect(() => { setStepSearch(""); }, [comboStep]);
  const [selectedComboType, setSelectedComboType] = useState(null); // 'simples' ou 'combo'
  const [stepSelections, setStepSelections] = useState({});
  
  // Etapa do checkout
  const [step, setStep] = useState(1); // 1 = Produtos, 2 = Cliente, 3 = Entrega, 4 = Pagamento
  const [cartStep, setCartStep] = useState(1); // sidebar wizard: 1=carrinho, 2=entrega, 3=pagamento
  const [mobileCartSheetOpen, setMobileCartSheetOpen] = useState(false); // mobile: sheet com carrinho
  const [showNewAddressForm, setShowNewAddressForm] = useState(false);
  const [historicoCollapsed, setHistoricoCollapsed] = useState(true);
  const [cardapioStats, setCardapioStats] = useState(null); // tempo medio + faixa de entrega

  // Ao sair do Carrinho (etapa 1), recolhe o historico automaticamente
  // — ele so faz sentido junto com a grade de produtos.
  useEffect(() => {
    if (cartStep !== 1 && !historicoCollapsed) {
      setHistoricoCollapsed(true);
    }
  }, [cartStep]); // eslint-disable-line react-hooks/exhaustive-deps

  // Quando entra no modo 'manual' do painel de desconto, reseta drafts
  // (% e R$ ambos zerados — operador começa do zero).
  useEffect(() => {
    if (showDiscountModal && discountModalMode === 'manual') {
      setDraftPercent(0);
      setDraftFinalValue('');
    }
  }, [showDiscountModal, discountModalMode]); // eslint-disable-line react-hooks/exhaustive-deps

  // Carrega stats do cardapio (tempo medio + faixa de entrega) ao abrir o popup
  useEffect(() => {
    if (!open) return;
    axios.get(`/api/public/cardapio-stats`)
      .then(r => setCardapioStats(r.data || null))
      .catch(() => setCardapioStats(null));
  }, [open]);
  
  const [submitting, setSubmitting] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(true);
  // 30/09/2026 (features/novo-pedido-regras): cliente da tela para descartar
  // resposta atrasada de endereços/histórico; chave do envio (mesma nas novas
  // tentativas, nova no pedido seguinte); trava contra envio em dobro; "Descartar?".
  const clienteAtualRef = useRef(null);
  clienteAtualRef.current = selectedCliente?.id ?? null;
  const chaveEnvioRef = useRef(null);
  const enviandoRef = useRef(false);
  // Cupom que veio do pedido na edição (achado 444): se o atendente tirar,
  // o PUT manda cupom_codigo "" — sem isso o servidor não sabe se foi
  // de propósito e mantém o cupom do pedido.
  const cupomCarregadoRef = useRef(null);
  const [confirmarDescarte, setConfirmarDescarte] = useState(false);

  // Carregar dados e preencher se estiver editando
  useEffect(() => {
    if (open) {
      // Só esconder spinner se TODOS os caches estiverem populados (incluindo produtos).
      // Antes só checava clientes+bairros, então abrir o popup logo após login mostrava tela em branco.
      const hasCache = !!(
        CARDAPIO_POPUP_CACHE.clientes &&
        CARDAPIO_POPUP_CACHE.bairros &&
        getProductsFromCache()
      );
      setLoadingProducts(!hasCache);
      // Formas de pagamento: usa cache + refresh em background
      const mapPm = (pms) => {
        const iconMap = { dinheiro: Banknote, pix: Banknote, pix_online: Banknote, cartao_online: CreditCard, credito: CreditCard, debito: CreditCard, cartao: CreditCard, cartao_credito: CreditCard, cartao_debito: CreditCard };
        return pms.map(pm => ({
          id: pm.code || pm.id, code: pm.code, label: pm.name || pm.code,
          icon: iconMap[(pm.code || "").toLowerCase()] || CreditCard,
          emoji: pm.emoji || pm.icon_emoji || pm.icon || null,
        }));
      };
      if (CARDAPIO_POPUP_CACHE.paymentMethods) {
        setPaymentMethodsDelivery(mapPm(CARDAPIO_POPUP_CACHE.paymentMethods));
      }
      axios.get(`${API}/payment-methods/module/delivery`, getAuthHeader())
        .then(res => {
          const pms = Array.isArray(res.data) ? res.data : [];
          CARDAPIO_POPUP_CACHE.paymentMethods = pms;
          setPaymentMethodsDelivery(mapPm(pms));
        })
        .catch(() => { if (!CARDAPIO_POPUP_CACHE.paymentMethods) setPaymentMethodsDelivery([]); });

      // Se estiver editando, carregar apenas o necessário e preencher imediatamente
      if (pedidoParaEditar) {
        // Carregar dados em paralelo, mas preencher assim que clientes estiverem carregados
        Promise.all([
          fetchClientes(),
          fetchBairros(),
          fetchProducts(),
          fetchCategories(),
          fetchActivePromotions()
        ]).then(() => {
          setLoadingProducts(false);
          // Preencher dados imediatamente após carregar
          preencherDadosDoPedido(pedidoParaEditar);
        }).catch(() => {
          setLoadingProducts(false);
        });
      } else {
        // Defensivo (v1.5.381): garante wizard na etapa 1 ao abrir pra pedido
        // NOVO — cobre qualquer caminho de fechamento que não passe pelo
        // resetForm (ex.: popup fechado logo após edição).
        setCartStep(1);
        // Para novo pedido, carregar tudo normalmente
        Promise.all([
          fetchProducts(),
          fetchCategories(),
          fetchClientes(),
          fetchBairros(),
          fetchActivePromotions()
        ]).finally(() => {
          setLoadingProducts(false);
          // Veio do Balcão ("Entrega" na mercearia): os produtos já entram no carrinho.
          const passagem = lerPassagem();
          if (passagem) {
            setCart(passagem.itens);
            // Desconto dado no Balcão vem junto, do mesmo tipo (30/09/2026):
            // % ou R$ sobre os produtos, ou o cupom já validado.
            const dB = passagem.desconto;
            if (dB?.tipo === "percent" || dB?.tipo === "fixed") { setDiscountType(dB.tipo); setDiscountValue(Number(dB.valor) || 0); }
            else if (dB?.tipo === "coupon" && dB.cupom?.code) { setCouponCode(dB.cupom.code); setCouponData(dB.cupom); setDiscountType("coupon"); setDiscountValue(0); }
            // Cliente do Balcão já vem escolhido e a tela pula para a Entrega
            // (endereço); sem cliente, o cursor abre na busca (29/09/2026).
            if (passagem.cliente?.id) { handleSelectCliente(passagem.cliente); setCartStep(2); }
            toast.info(passagem.cliente?.id ? "Produtos e cliente do Balcão no pedido: escolha o endereço da entrega." : "Produtos do Balcão no pedido: escolha o cliente e o endereço da entrega.");
          }
          if (!passagem?.cliente?.id) setTimeout(() => clienteSearchRef.current?.focus(), 50);
        });
      }
    } else {
      // Reset ao fechar (apenas se não estiver editando)
      if (!pedidoParaEditar) {
        resetForm();
      }
    }
  }, [open, pedidoParaEditar]);

  // Editar pedido (30/09/2026): o item gravado não traz sale_unit/is_divisible —
  // completa pelo cadastro para o −/+ andar 0,1 kg e o peso sair em kg.
  useEffect(() => {
    if (!open || !pedidoParaEditar) return;
    const lista = allProductsForPhotos.length ? allProductsForPhotos : products;
    if (lista.length) setCart((c) => completarUnidadeDoCadastro(c, lista));
  }, [open, pedidoParaEditar, products, allProductsForPhotos, cart]);

  // Preencher dados do pedido para edição
  const preencherDadosDoPedido = (pedido) => {
    try {
      // Preencher cliente
      if (pedido.cliente_id) {
        const cliente = clientes.find(c => c.id === pedido.cliente_id);
        if (cliente) {
          setSelectedCliente(cliente);
        } else {
          // Se cliente não encontrado, criar objeto do cliente a partir dos dados do pedido
          setSelectedCliente({
            id: pedido.cliente_id,
            nome: pedido.cliente_nome,
            telefone: pedido.cliente_telefone
          });
        }
      }

      // Preencher tipo de entrega
      setTipoEntrega(pedido.tipo_entrega === 'pickup' ? 'pickup' : 'delivery');

      // Preencher endereço
      if (pedido.tipo_entrega !== 'pickup') {
        setEndereco({
          rua: pedido.endereco_rua || "",
          numero: pedido.endereco_numero || "",
          bairro: pedido.endereco_bairro || "",
          complemento: pedido.endereco_complemento || "",
          referencia: "",
          cep: pedido.endereco_cep || ""
        });
        setTaxaEntrega(pedido.valor_entrega || 0);
      }

      // Preencher carrinho com items do pedido
      if (pedido.items && pedido.items.length > 0) {
        const cartItems = pedido.items.map(item => ({
          id: item.id || item.product_id,
          name: item.nome || item.name,
          quantity: item.quantidade || item.qty || 1,
          sale_price: item.preco_unitario || item.preco || item.price || 0,
          observation: item.observacao || "",
          photo_url: item.photo_url || null,
          subitems: item.subitems || [],
          etapas: item.etapas || [],
          combo_type: item.combo_type || null,
          etiqueta_balanca: item.etiqueta_balanca || null
        }));
        setCart(cartItems);
      }

      // Desconto do pedido (cupom ou manual). Sem isto, salvar a edição gravava desconto
      // 0 e o total voltava cheio: 29 pedidos com cupom perderam o desconto entre
      // mai–set/2026 depois de editados aqui.
      const cupomDesconto = Number(pedido.cupom_desconto || 0);
      const descontoManual = Number(pedido.desconto_manual || 0);
      cupomCarregadoRef.current = pedido.cupom_codigo && cupomDesconto > 0 ? String(pedido.cupom_codigo).toUpperCase() : null;
      if (pedido.cupom_codigo && cupomDesconto > 0) {
        setCouponCode(pedido.cupom_codigo);
        setCouponData({ valid: true, code: pedido.cupom_codigo, discount: cupomDesconto });
        setDiscountValue(0);
        setDiscountType('coupon');
      } else if (descontoManual > 0) {
        const pct = Number(pedido.desconto_percentual || 0);
        if (pedido.desconto_tipo === 'percent' && pct > 0) {
          setDiscountValue(pct);
          setDiscountType('percent');
        } else {
          setDiscountValue(descontoManual);
          setDiscountType('fixed');
        }
      }

      // Preencher forma de pagamento (dividido volta como as partes gravadas)
      const partesSalvas = Array.isArray(pedido.pagamentos) ? pedido.pagamentos : [];
      if (pedido.forma_pagamento === "multiplo" && partesSalvas.length > 0) {
        setCpSplitPayment(true);
        setCpSplitPayments(partesSalvas.map(pg => ({
          method: pg.method,
          code: pg.method,
          label: pg.label || pg.method,
          amount: Number(pg.amount) || 0,
          troco_precisa: !!pg.troco_precisa,
          troco_valor: pg.troco_valor || null,
        })));
        setFormaPagamento("");
      } else {
        setFormaPagamento(pedido.forma_pagamento || "");
      }

      // Preencher troco
      if (pedido.troco_precisa && pedido.troco_valor) {
        setPrecisaTroco(true);
        setTrocoPara(pedido.troco_valor.toString());
      }

      // Preencher observação
      setObservacao(pedido.observacao || "");

      // Preencher status de pagamento (já pago)
      setJaPago(pedido.payment_status === 'paid');

      // Carregar histórico e endereços do cliente se tiver cliente_id (em background, não bloquear)
      if (pedido.cliente_id) {
        // Carregar em background para não bloquear a UI
        fetchClienteHistorico(pedido.cliente_id);
        fetchClienteEnderecos(pedido.cliente_id);
      }

      // Começar pela etapa 1 (produtos) para permitir edição
      setStep(1);
    } catch (error) {
      console.error("Erro ao preencher dados do pedido:", error);
      toast.error("Erro ao carregar dados do pedido");
    }
  };

  // Reset form
  const resetForm = () => {
    setCart([]);
    setSelectedCliente(null);
    setTipoEntrega("delivery");
    setEndereco({ rua: "", numero: "", bairro: "", complemento: "", referencia: "", cep: "" });
    setTaxaEntrega(0);
    setFormaPagamento("");
    setObservacao("");
    setTrocoPara("");
    setPrecisaTroco(false);
    setCpSplitPayment(false);
    setCpSplitPayments([]);
    setCpShowSplitModal(false);
    setJaPago(false);
    setShowFinalizarDialog(false);
    setStep(1);
    setSearchTerm("");
    setSelectedCategory(null);
    // cartStep TAMBÉM precisa voltar pra 1 (v1.5.381): a grade de produtos da
    // coluna central só renderiza em cartStep===1 — sem esse reset, o wizard
    // ficava preso na etapa de pagamento do pedido ANTERIOR e a segunda
    // abertura do "Novo Pedido" vinha com a tela de produtos em branco.
    setCartStep(1);
    setMobileCartSheetOpen(false);
    setClienteSearch("");
    setShowClienteDropdown(false);
    setHighlightClienteSearch(false);
    setClienteHistorico([]);
    setEnderecosSalvos([]);
    setEnderecoSelecionado(null);
    setShowNewAddressForm(false);
    setHistoricoCollapsed(true);
    setDiscountType('none');
    setDiscountValue(0);
    setCouponCode('');
    setCouponData(null);
    setCouponError('');
    // Pedido seguinte ganha outra chave de envio (a do anterior já criou pedido).
    chaveEnvioRef.current = null;
    cupomCarregadoRef.current = null;
  };

  const fetchProducts = async () => {
    // Buscar lista completa autenticada (inclui insumos/adicionais com fotos) em paralelo
    axios.get(`${API}/products`, getAuthHeader())
      .then(res => {
        const all = Array.isArray(res.data) ? res.data : [];
        if (all.length > 0) setAllProductsForPhotos(all);
      })
      .catch(() => {});

    // Primeiro, tentar usar cache (instantâneo)
    const cached = getProductsFromCache();
    if (cached && cached.products && cached.products.length > 0) {
      setProducts(cached.products);
      setAllProductsForPhotos(prev => prev.length >= cached.allProducts.length ? prev : cached.allProducts);
      // Atualizar cache em background sem bloquear
      loadProductsCache().then(() => {
        const updated = getProductsFromCache();
        if (updated && updated.products && updated.products.length > 0) {
          setProducts(updated.products);
        }
      }).catch(() => {});
      return;
    }

    // Sem cache válido: tentar com retry automático antes de desistir.
    // Antes, qualquer falha caia no catch e setava products=[], deixando a tela em branco.
    const tryLoadOnce = async () => {
      await loadProductsCache();
      const cachedAfterLoad = getProductsFromCache();
      if (cachedAfterLoad && cachedAfterLoad.products && cachedAfterLoad.products.length > 0) {
        setProducts(cachedAfterLoad.products);
        // O cache é a lista de venda (sem insumos); não pisa na lista completa do
        // GET /products acima se ela chegou antes (achado 522).
        setAllProductsForPhotos(prev => prev.length >= cachedAfterLoad.allProducts.length ? prev : cachedAfterLoad.allProducts);
        return true;
      }
      // Fallback direto pro endpoint autenticado
      const res = await axios.get(`${API}/products`, getAuthHeader());
      const prods = Array.isArray(res.data) ? res.data : [];
      if (prods.length > 0) {
        setAllProductsForPhotos(prods);
        setProducts(prods.filter(p => !p.is_insumo && !p.hidden));
        return true;
      }
      return false;
    };

    let success = false;
    for (let attempt = 0; attempt < 3 && !success; attempt++) {
      try {
        success = await tryLoadOnce();
        if (success) break;
      } catch (error) {
        console.error(`[fetchProducts] tentativa ${attempt + 1} falhou:`, error?.message || error);
      }
      if (!success && attempt < 2) {
        // Backoff curto (200ms, 600ms) — soluciona blip de rede sem travar o usuário
        await new Promise(r => setTimeout(r, 200 * (attempt + 1) * (attempt + 1)));
      }
    }

    if (!success) {
      // Após 3 tentativas, mantém estado anterior (não zera produtos);
      // toast informa o usuário pra ele saber que pode tentar Recarregar.
      console.error("[fetchProducts] falha após 3 tentativas — mantendo estado");
      try { toast.error("Não foi possível carregar produtos. Verifique sua conexão."); } catch (_) {}
    }
  };

  const fetchActivePromotions = async () => {
    if (CARDAPIO_POPUP_CACHE.activePromotions) {
      setActivePromotions(CARDAPIO_POPUP_CACHE.activePromotions);
      axios.get(`${API}/promotions/active?module=Delivery`)
        .then(res => {
          const data = Array.isArray(res.data) ? res.data : [];
          CARDAPIO_POPUP_CACHE.activePromotions = data;
          setActivePromotions(data);
        }).catch(() => {});
      return;
    }
    try {
      const res = await axios.get(`${API}/promotions/active?module=Delivery`);
      const data = Array.isArray(res.data) ? res.data : [];
      CARDAPIO_POPUP_CACHE.activePromotions = data;
      setActivePromotions(data);
    } catch { setActivePromotions([]); }
  };

  const getPromoForProduct = (productId, comboType) => {
    for (const promo of activePromotions) {
      const pp = (promo.products || []).find(p => p.product_id === productId);
      if (pp) {
        if (comboType === 'combo' && pp.discount_value_combo) {
          return { promo, value: pp.discount_value_combo, type: promo.discount_type };
        }
        // Pizza por tamanho — sem valor único pra exibir; popup mostra preço promo por tamanho.
        if (pp.sizes && typeof pp.sizes === 'object' && pp.discount_value == null) return null;
        return { promo, value: pp.discount_value, type: promo.discount_type };
      }
    }
    return null;
  };

  const calcPromoPrice = (originalPrice, promoInfo) => {
    if (!promoInfo) return null;
    if (promoInfo.type === 'percentage') return originalPrice * (1 - promoInfo.value / 100);
    if (promoInfo.type === 'fixed_price') return promoInfo.value;
    return null;
  };

  // Preço do produto com a promoção ativa — o mesmo do clique (confirmAddToCart).
  // Leitor de código de barras e Repetir pedido (30/09/2026). → { preco, promocional }
  const precoComPromocao = (produto, comboType = 'simples') => {
    const cheio = produto.product_type === 'combo' && comboType !== 'combo'
      ? (produto.simple_price || Math.round((produto.sale_price || 0) * 0.7 * 100) / 100)
      : (produto.sale_price || 0);
    const comPromo = calcPromoPrice(cheio, getPromoForProduct(produto.id, comboType === 'combo' ? 'combo' : 'simples'));
    return { preco: comPromo ?? cheio, promocional: comPromo != null && comPromo < cheio - 0.001 };
  };

  const fetchCategories = async () => {
    // Primeiro, tentar usar cache (instantâneo)
    const cached = getProductsFromCache();
    if (cached && cached.categories) {
      setCategories(cached.categories);
      // Atualizar cache em background
      loadProductsCache();
      return;
    }
    
    // Se não tem cache, carregar normalmente
    try {
      await loadProductsCache();
      const cachedAfterLoad = getProductsFromCache();
      if (cachedAfterLoad && cachedAfterLoad.categories) {
        setCategories(cachedAfterLoad.categories);
      } else {
        // Fallback
        const res = await axios.get(`${API}/categories`, getAuthHeader());
        setCategories(Array.isArray(res.data) ? res.data : []);
      }
    } catch (error) {
      console.error("Erro ao carregar categorias:", error);
      setCategories([]);
    }
  };

  const fetchClientes = async () => {
    // Cache hit -> set imediato e refresh em background
    if (CARDAPIO_POPUP_CACHE.clientes) {
      setClientes(CARDAPIO_POPUP_CACHE.clientes);
      setLoading(false);
      axios.get(`${API}/clientes`, getAuthHeader())
        .then(res => {
          const data = Array.isArray(res.data) ? res.data : [];
          CARDAPIO_POPUP_CACHE.clientes = data;
          setClientes(data);
        })
        .catch(() => {});
      return;
    }
    try {
      const res = await axios.get(`${API}/clientes`, getAuthHeader());
      const data = Array.isArray(res.data) ? res.data : [];
      CARDAPIO_POPUP_CACHE.clientes = data;
      setClientes(data);
    } catch (error) {
      console.error("Erro ao carregar clientes:", error);
      setClientes([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchBairros = async () => {
    if (CARDAPIO_POPUP_CACHE.bairros) {
      setBairros(CARDAPIO_POPUP_CACHE.bairros);
      axios.get(`${API}/bairros`, getAuthHeader())
        .then(res => {
          const data = Array.isArray(res.data) ? res.data : [];
          CARDAPIO_POPUP_CACHE.bairros = data;
          setBairros(data);
        })
        .catch(() => {});
      return;
    }
    try {
      const res = await axios.get(`${API}/bairros`, getAuthHeader());
      const data = Array.isArray(res.data) ? res.data : [];
      CARDAPIO_POPUP_CACHE.bairros = data;
      setBairros(data);
    } catch (error) {
      console.error("Erro ao carregar bairros:", error);
      setBairros([]);
    }
  };

  // Buscar histórico de pedidos do cliente
  // Resposta que chega depois de trocar de cliente é descartada (30/09/2026):
  // antes o histórico/endereços do cliente anterior podiam cair no novo.
  const aindaEhOCliente = (clienteId) => String(clienteAtualRef.current ?? "") === String(clienteId ?? "");
  const fetchClienteHistorico = async (clienteId) => {
    setLoadingHistorico(true);
    try {
      const res = await axios.get(`${API}/pedidos?cliente_id=${clienteId}`, getAuthHeader());
      const pedidos = Array.isArray(res.data) ? res.data : (res.data.pedidos || []);
      
      // Buscar todos os produtos para mapear as fotos
      let produtosMap = {};
      try {
        const prodRes = await axios.get(`${API}/products`, getAuthHeader());
        const produtosList = Array.isArray(prodRes.data) ? prodRes.data : [];
        produtosList.forEach(p => {
          produtosMap[p.id] = p;
          // Também mapear por nome para pedidos antigos
          produtosMap[p.name?.toLowerCase()] = p;
        });
      } catch {
        // Se falhar, continua sem fotos
      }
      
      // Enriquecer items com fotos
      const pedidosComFotos = pedidos.slice(0, 10).map(pedido => {
        if (pedido.items && pedido.items.length > 0) {
          const itemsComFoto = pedido.items.map(item => {
            // Se já tem foto, retorna
            if (item.foto_url || item.photo_url) return item;
            
            // Buscar pelo ID ou pelo nome
            const produto = produtosMap[item.id] || 
                           produtosMap[item.nome?.toLowerCase()] || 
                           produtosMap[item.name?.toLowerCase()];
            
            if (produto && produto.photo_url) {
              return { ...item, photo_url: produto.photo_url };
            }
            return item;
          });
          return { ...pedido, items: itemsComFoto };
        }
        return pedido;
      });
      
      if (aindaEhOCliente(clienteId)) setClienteHistorico(pedidosComFotos);
    } catch (error) {
      console.error("Erro ao carregar histórico:", error);
      if (aindaEhOCliente(clienteId)) setClienteHistorico([]);
    } finally {
      if (aindaEhOCliente(clienteId)) setLoadingHistorico(false);
    }
  };

  // Buscar endereços salvos do cliente (da tabela client_addresses + pedidos anteriores)
  const fetchClienteEnderecos = async (clienteId) => {
    try {
      // 1. Buscar endereços salvos
      const resEnderecos = await axios.get(`${API}/client-addresses/${clienteId}`, getAuthHeader());
      const enderecosSalvos = Array.isArray(resEnderecos.data) ? resEnderecos.data : [];
      
      // 2. Buscar endereços dos pedidos anteriores
      const resPedidos = await axios.get(`${API}/pedidos?cliente_id=${clienteId}`, getAuthHeader());
      const pedidos = Array.isArray(resPedidos.data) ? resPedidos.data : [];
      
      // Extrair endereços únicos dos pedidos
      const enderecosDosPedidos = [];
      const enderecosVistos = new Set();
      
      pedidos.forEach(pedido => {
        if (pedido.endereco_rua && pedido.tipo_entrega === 'delivery') {
          const chave = `${pedido.endereco_rua}-${pedido.endereco_numero}-${pedido.endereco_bairro}`.toLowerCase();
          if (!enderecosVistos.has(chave)) {
            enderecosVistos.add(chave);
            enderecosDosPedidos.push({
              id: `pedido-${pedido.id}`,
              label: pedido.endereco_label || 'Pedido anterior',
              rua: pedido.endereco_rua || '',
              numero: pedido.endereco_numero || '',
              bairro: pedido.endereco_bairro || '',
              complemento: pedido.endereco_complemento || '',
              referencia: '',
              cep: pedido.endereco_cep || '',
              fromPedido: true
            });
          }
        }
      });
      
      // Converter endereços salvos para formato usado no componente
      const enderecosMapeados = enderecosSalvos.map(end => ({
        id: end.id,
        label: end.label || 'Endereço',
        rua: end.endereco || '',
        numero: end.numero || '',
        bairro: end.bairro || '',
        complemento: end.complemento || '',
        referencia: '',
        cep: end.cep || ''
      }));
      
      // Filtrar endereços de pedidos que já existem nos salvos
      const enderecosPedidosFiltrados = enderecosDosPedidos.filter(epd => {
        const chavePedido = `${epd.rua}-${epd.numero}-${epd.bairro}`.toLowerCase();
        return !enderecosMapeados.some(es => 
          `${es.rua}-${es.numero}-${es.bairro}`.toLowerCase() === chavePedido
        );
      });
      
      // Apenas endereços do cadastro do cliente (não inclui pedidos anteriores)
      if (aindaEhOCliente(clienteId)) setEnderecosSalvos(enderecosMapeados);
    } catch (error) {
      console.error("Erro ao carregar endereços:", error);
      if (aindaEhOCliente(clienteId)) setEnderecosSalvos([]);
    }
  };

  // Quando selecionar um cliente, carregar histórico e endereços
  const handleSelectCliente = (cliente) => {
    setSelectedCliente(cliente);
    setClienteSearch("");
    setShowClienteDropdown(false);
    
    // Carregar histórico
    fetchClienteHistorico(cliente.id);
    
    // Carregar endereços salvos da tabela client_addresses
    fetchClienteEnderecos(cliente.id);
  };

  // "Trocar" cliente (30/09/2026): o endereço, a taxa e o bairro eram do cliente
  // anterior e ficavam no pedido — agora zeram e a tela volta para a etapa 1.
  const trocarCliente = () => {
    setSelectedCliente(null);
    setClienteHistorico([]);
    setLoadingHistorico(false);
    setEnderecosSalvos([]);
    setEnderecoSelecionado(null);
    setEndereco({ rua: "", numero: "", bairro: "", complemento: "", referencia: "", cep: "" });
    setTaxaEntrega(0);
    setShowNewAddressForm(false);
    setCartStep(1);
  };

  // Selecionar endereço salvo
  const handleSelectEndereco = (end) => {
    setEnderecoSelecionado(end.id);
    setEndereco({
      rua: end.rua || '',
      numero: end.numero || '',
      bairro: end.bairro || '',
      complemento: end.complemento || '',
      referencia: end.referencia || '',
      cep: end.cep || ''
    });
    // Buscar taxa do bairro (com trim para evitar espaços)
    const bairro = bairros.find(b => (b.nome || '').trim().toLowerCase() === (end.bairro || '').trim().toLowerCase());
    if (bairro) {
      setTaxaEntrega(bairro.valor_entrega || bairro.taxa_entrega || 0);
    }
  };

  // Gerenciar múltiplos pedidos - Salvar pedido atual na lista
  const salvarPedidoAtual = () => {
    // Só salva se tiver algo (carrinho ou cliente)
    if (cart.length > 0 || selectedCliente) {
      const id = pedidoAtualId || Date.now();
      const pedidoAtual = {
        id: id,
        cart: [...cart],
        selectedCliente,
        tipoEntrega,
        endereco: {...endereco},
        formaPagamento,
        observacao,
        step
      };
      
      setPedidosAtivos(prev => {
        const existe = prev.find(p => p.id === id);
        if (existe) {
          return prev.map(p => p.id === id ? pedidoAtual : p);
        } else {
          return [...prev, pedidoAtual];
        }
      });
      
      // Retorna o ID do pedido salvo
      if (!pedidoAtualId) {
        setPedidoAtualId(id);
      }
      return pedidoAtual;
    }
    return null;
  };

  // Criar novo pedido (botão "+ Novo")
  const novoPedidoTab = () => {
    // Se tem algo no pedido atual, salva antes de criar novo
    if (cart.length > 0 || selectedCliente) {
      const id = pedidoAtualId || Date.now();
      const pedidoAtual = {
        id: id,
        cart: [...cart],
        selectedCliente,
        tipoEntrega,
        endereco: {...endereco},
        formaPagamento,
        observacao,
        step
      };
      
      // Adiciona à lista
      setPedidosAtivos(prev => {
        const existe = prev.find(p => p.id === id);
        if (!existe) {
          return [...prev, pedidoAtual];
        }
        return prev.map(p => p.id === id ? pedidoAtual : p);
      });
    }
    
    // Usar setTimeout para garantir que o state anterior foi salvo
    setTimeout(() => {
      const novoId = Date.now();
      
      // Limpar todos os states para novo pedido
      setPedidoAtualId(novoId);
      setCart([]);
      setSelectedCliente(null);
      setTipoEntrega("delivery");
      setEndereco({ rua: "", numero: "", bairro: "", complemento: "", referencia: "", cep: "" });
      setFormaPagamento("");
      setObservacao("");
      setTrocoPara("");
      setPrecisaTroco(false);
      setStep(1);
      setClienteHistorico([]);
      setEnderecosSalvos([]);
      setEnderecoSelecionado(null);
      setClienteSearch("");
      setShowClienteDropdown(false);
    }, 100);
  };

  // Trocar para pedido existente
  const switchPedido = (pedido) => {
    // Salvar atual primeiro
    salvarPedidoAtual();
    
    // Carregar o pedido selecionado
    setPedidoAtualId(pedido.id);
    setCart(pedido.cart || []);
    setSelectedCliente(pedido.selectedCliente);
    setTipoEntrega(pedido.tipoEntrega || "delivery");
    setEndereco(pedido.endereco || { rua: "", numero: "", bairro: "", complemento: "", referencia: "", cep: "" });
    setFormaPagamento(pedido.formaPagamento || "");
    setObservacao(pedido.observacao || "");
    setStep(pedido.step || 1);
    
    // Carregar histórico e endereços se tiver cliente
    if (pedido.selectedCliente) {
      fetchClienteHistorico(pedido.selectedCliente.id);
      fetchClienteEnderecos(pedido.selectedCliente.id);
    }
  };

  // Remover pedido da lista
  const removerPedidoTab = (pedidoId) => {
    setPedidosAtivos(prev => prev.filter(p => p.id !== pedidoId));
    if (pedidoAtualId === pedidoId) {
      // Se removeu o atual, criar um novo
      novoPedidoTab();
    }
  };

  // Repetir um pedido anterior (adiciona todos os itens ao carrinho). Desde
  // 30/09/2026 com o preço de HOJE (com promoção) e avisando o que mudou;
  // esgotado ou fora do cardápio não entra — features/novo-pedido-regras.
  const repetirPedido = (pedido) => {
    if (!pedido.items || pedido.items.length === 0) return;
    const { itens, mudaram, fora } = montarRepeticao(pedido.items, {
      produtos: products,
      precoAtual: precoComPromocao,
      precoDoSubitem: (produto, sub) => {
        const etapa = (produto.order_steps || []).find((st) => st.name === sub.step_name);
        const it = etapa?.items?.find((i) => i.product_id === sub.product_id);
        if (it) return getItemPrice(it, etapa);
        return sub.product_id && allProductsForPhotos.some((p) => p.id === sub.product_id) ? getProductPrice(sub.product_id) : null;
      },
    });
    if (itens.length) setCart(prev => [...prev, ...itens]);
    if (mudaram.length) toast.warning(`Preço mudou desde aquele pedido: ${mudaram.join(", ")}. Entrou com o preço de hoje.`, { duration: 6000 });
    if (fora.length) toast.error(`Não entrou (esgotado ou fora do cardápio): ${fora.join(", ")}`, { duration: 6000 });
    // Ir para etapa de produtos para revisar
    setStep(1);
  };

  // Filtrar produtos — pelo nome ou pelo código de barras digitado (30/09/2026)
  const peloCodigo = casaPeloCodigo(searchTerm, products);
  const filteredProducts = products.filter(p => {
    const matchSearch = p.name.toLowerCase().includes(searchTerm.toLowerCase()) || peloCodigo(p);
    const matchCategory = !selectedCategory || p.category === selectedCategory;
    return matchSearch && matchCategory;
  });

  // Função para normalizar telefone (remove caracteres não numéricos)
  const normalizePhone = (phone) => {
    if (!phone) return '';
    return phone.replace(/\D/g, '');
  };

  // Função para verificar se o telefone do cliente corresponde à busca
  const matchPhone = (clientePhone, searchPhone) => {
    if (!clientePhone || !searchPhone) return false;
    
    const phoneClean = normalizePhone(clientePhone);
    const searchClean = normalizePhone(searchPhone);
    
    if (!phoneClean || !searchClean) return false;
    
    // Busca direta (contém)
    if (phoneClean.includes(searchClean)) return true;
    
    // Se o telefone do cliente tem 11 dígitos (com DDD e 9)
    // Ex: 34999658914
    if (phoneClean.length === 11) {
      const ddd = phoneClean.substring(0, 2);           // 34
      const noveDigito = phoneClean.substring(2, 3);    // 9
      const numero = phoneClean.substring(3);           // 99658914
      const numeroSem9 = phoneClean.substring(2);       // 999658914
      
      // Busca sem DDD: 999658914
      if (numeroSem9.includes(searchClean)) return true;
      
      // Busca sem DDD e sem o 9 inicial: 99658914
      if (numero.includes(searchClean)) return true;
      
      // Busca com DDD mas sem o 9: 3499658914
      const phoneSem9 = ddd + numero;
      if (phoneSem9.includes(searchClean)) return true;
      
      // Busca pelo número sem 9 no meio
      if (searchClean === numero) return true;
    }
    
    // Se o telefone do cliente tem 10 dígitos (com DDD, sem 9)
    // Ex: 3499658914
    if (phoneClean.length === 10) {
      const ddd = phoneClean.substring(0, 2);
      const numero = phoneClean.substring(2);
      
      // Busca sem DDD
      if (numero.includes(searchClean)) return true;
      
      // Busca com 9 adicionado: 34999658914
      const phoneCom9 = ddd + '9' + numero;
      if (phoneCom9.includes(searchClean)) return true;
    }
    
    return false;
  };

  // Função para detectar se o texto digitado é um telefone
  const isPhoneNumber = (text) => {
    if (!text) return false;
    const cleaned = normalizePhone(text);
    // Telefone deve ter pelo menos 10 dígitos (DDD + número) e no máximo 11 (com 9 inicial)
    return cleaned.length >= 10 && cleaned.length <= 11 && /^\d+$/.test(cleaned);
  };

  // Filtrar clientes por nome, CPF ou telefone - MEMOIZADO
  const filteredClientes = useMemo(() => {
    return clientes.filter(c => {
    if (!clienteSearch || clienteSearch.trim() === '') return false;
    
    const search = clienteSearch.toLowerCase().trim();
    const searchClean = normalizePhone(clienteSearch);
    
    // Busca por nome - suporta múltiplas palavras (nome + sobrenome)
    if (c.nome) {
      const nomeLower = c.nome.toLowerCase().trim();
      const palavras = nomeLower.split(/\s+/);
      const searchWords = search.split(/\s+/).filter(w => w.length > 0);
      
      // Se o termo de busca tem múltiplas palavras (ex: "Diego A" ou "Diego Addad")
      if (searchWords.length > 1) {
        // Verificar se todas as palavras de busca estão presentes no nome
        // e começam com as palavras de busca correspondentes
        let allWordsMatch = true;
        let searchIndex = 0;
        
        for (const palavraNome of palavras) {
          if (searchIndex < searchWords.length) {
            const searchWord = searchWords[searchIndex];
            if (palavraNome.startsWith(searchWord)) {
              searchIndex++;
            }
          }
        }
        
        // Se encontrou todas as palavras de busca em sequência, aceita
        if (searchIndex >= searchWords.length) {
          return true;
        }
        
        // Fallback: verificar se o nome completo contém o termo como substring contínua
        // Isso ajuda com buscas como "Diego A" encontrando "Diego Addad"
        if (nomeLower.includes(search)) {
          return true;
        }
      } else {
        // Busca simples (uma palavra): verificar se alguma palavra do nome começa com o termo
        for (const palavra of palavras) {
          if (palavra.startsWith(search)) {
            return true;
          }
        }
      }
    }
    
    // Busca por CPF - apenas substring contínua
    if (c.cpf && searchClean.length >= 3) {
      const cpfClean = normalizePhone(c.cpf);
      if (cpfClean.includes(searchClean)) return true;
    }
    
    // Busca por telefone (com várias combinações)
    if (matchPhone(c.telefone, clienteSearch)) return true;
    
    return false;
    }).slice(0, 10);
  }, [clientes, clienteSearch]);

  // Verificar se deve mostrar o botão de cadastrar novo cliente
  const shouldShowCreateButton = clienteSearch && 
                                  !selectedCliente && 
                                  filteredClientes.length === 0 && 
                                  isPhoneNumber(clienteSearch);

  // Função para cadastrar novo cliente com telefone digitado
  const handleCadastrarClienteFromPhone = () => {
    const telefone = clienteSearch.trim();
    setNovoCliente({ nome: "", telefone: telefone });
    setClienteSearch("");
    // Focar no campo nome após um pequeno delay para garantir que o campo foi renderizado
    setTimeout(() => {
      if (nomeClienteInputRef.current) {
        nomeClienteInputRef.current.focus();
      }
    }, 100);
  };

  // Adicionar ao carrinho
  const addToCart = (product, quantity = 1, observation = "") => {
    // Se tem observação, combo_type, subitems ou etapas, sempre adiciona como novo item (não agrupa)
    // Regra compartilhada (utils/cartGrouping) — o PDV já estava CORRETO aqui;
    // agora os 4 canais leem a mesma definição, que foi justamente o que
    // divergiu e causou o bug da pizza nos outros três.
    const hasCustomization = temPersonalizacao({ ...product, observation });

    if (hasCustomization) {
      setCart([...cart, { ...product, quantity, observation }]);
    } else {
      // Sem personalização, agrupa por id (apenas itens simples sem combo_type)
      const existing = cart.find(item => item.id === product.id && !temPersonalizacao(item));
      if (existing) {
        const alvo = existing.cartItemId || existing.id;
        setCart(cart.map(item =>
          (item.cartItemId || item.id) === alvo
            ? { ...item, quantity: item.quantity + quantity }
            : item
        ));
      } else {
        setCart([...cart, { ...product, quantity, observation: "" }]);
      }
    }
  };

  // Pizza tem fluxo dedicado — abre PizzaPopup em vez do popup genérico.
  // CardapioPopup não tem state próprio de tema; lê do localStorage (mesma fonte que Delivery usa).
  const cpIsDark = typeof localStorage !== "undefined" && localStorage.getItem("darkMode") === "true";
  const cpPizza = usePizzaPopup({
    clienteId: ofertasCliente.estado === "ativo" ? (selectedCliente?.id || null) : null,
    moduloOferta: "Delivery",
    onAddToCart: (item) => addToCart(
      {
        ...item,
        final_price: item.preco || item.sale_price || 0,
        sale_price: item.preco || item.sale_price || 0,
      },
      item.quantity || 1,
      item.observation || ""
    ),
    allProducts: allProductsForPhotos.length ? allProductsForPhotos : products,
    darkMode: cpIsDark,
  });

  // Abrir popup do produto
  const openProductPopup = (product) => {
    if (cpPizza.tryOpenPizza(product)) return;
    setSelectedProduct(product);
    setProductQuantity(1);
    setPesadoBalanca(false);
    setProductObservation("");
    setSelectedComboType(null);
    setStepSelections({});

    // Produto combo: inicia em comboStep=0 (tela de escolha SIMPLES vs COMBO)
    // Produto nao-combo com etapas: inicia em comboStep=1 (primeira etapa direta)
    // Produto nao-combo sem etapas: inicia em comboStep=0 (tela resumo normal)
    if (product.product_type !== 'combo' && product.order_steps?.length > 0) {
      initializeDefaultSelections(product.order_steps);
      setComboStep(1);
    } else {
      setComboStep(0);
    }
  };

  // Leitor de código de barras USB: bipou, o produto entra no carrinho (ou abre a montagem).
  // Embalagem entra com a promoção (igual ao clique); etiqueta repetida entra como outra linha, só avisa (31/10/2026).
  useLeitorNovoPedido({ ativo: open, products, allProducts: allProductsForPhotos, cart, addToCart, abrirProduto: openProductPopup, precoDoProduto: precoComPromocao });
  
  // Inicializar seleções padrão para etapas
  const initializeDefaultSelections = (steps, filterComboOnly = false, comboType = null) => {
    const newSelections = {};
    let relevantSteps = steps || [];
    
    if (filterComboOnly && comboType === 'simples') {
      relevantSteps = steps.filter(step => !step.combo_only);
    }
    
    relevantSteps.forEach((step, index) => {
      const defaultItems = step.items?.filter(item => item.is_default).map(item => item.product_id) || [];
      if (defaultItems.length > 0) {
        newSelections[index] = defaultItems;
      } else {
        newSelections[index] = [];
      }
    });
    setStepSelections(newSelections);
  };

  // Fechar popup do produto
  const closeProductPopup = () => {
    setSelectedProduct(null);
    setProductQuantity(1);
    setProductObservation("");
    setComboStep(0);
    setSelectedComboType(null);
    setStepSelections({});
  };
  
  // Selecionar tipo combo/simples
  const handleSelectComboType = (type) => {
    setSelectedComboType(type);
    if (selectedProduct?.order_steps?.length > 0) {
      initializeDefaultSelections(selectedProduct.order_steps, true, type);
    }
  };
  
  // Toggle seleção de item em uma etapa
  const toggleItemSelection = (stepIndex, productId) => {
    const step = getRelevantSteps()[stepIndex];
    if (!step) return;
    
    const currentSelections = stepSelections[stepIndex] || [];
    const isSelected = currentSelections.includes(productId);
    
    let newSelections;
    if (isSelected) {
      newSelections = currentSelections.filter(id => id !== productId);
    } else {
      if (step.max_selections && currentSelections.length >= step.max_selections) {
        newSelections = [...currentSelections.slice(1), productId];
      } else {
        newSelections = [...currentSelections, productId];
      }
    }
    
    setStepSelections({ ...stepSelections, [stepIndex]: newSelections });
  };
  
  // Obter etapas relevantes baseado no tipo selecionado
  const getRelevantSteps = () => {
    if (!selectedProduct?.order_steps) return [];
    if (selectedComboType === 'simples') {
      return selectedProduct.order_steps.filter(step => !step.combo_only);
    }
    return selectedProduct.order_steps;
  };
  
  // Verificar se pode avançar na etapa atual
  const canAdvanceComboStep = () => {
    if (comboStep === 0) {
      return selectedComboType !== null;
    }
    
    const relevantSteps = getRelevantSteps();
    if (comboStep > relevantSteps.length) return true;
    
    const currentStepIndex = comboStep - 1;
    const currentStep = relevantSteps[currentStepIndex];
    if (!currentStep) return true;
    
    const selections = stepSelections[currentStepIndex] || [];
    const minSelections = currentStep.min_selections || 0;
    
    return selections.length >= minSelections;
  };
  
  // Avançar para próxima etapa do combo
  const handleNextComboStep = () => {
    const relevantSteps = getRelevantSteps();
    const totalSteps = relevantSteps.length;
    
    if (comboStep === 0) {
      if (totalSteps === 0) {
        // Sem etapas, vai direto para resumo/adicionar
        setComboStep(1);
      } else {
        setComboStep(1);
      }
    } else if (comboStep <= totalSteps) {
      setComboStep(comboStep + 1);
    }
  };
  
  // Calcular preço do combo com seleções
  const calculateComboPrice = () => {
    if (!selectedProduct) return 0;
    
    const isCombo = selectedProduct.product_type === 'combo';
    const comboPrice = selectedProduct.sale_price || 0;
    const simplePrice = selectedProduct.simple_price || Math.round(comboPrice * 0.7 * 100) / 100;

    let basePrice;
    if (isCombo) {
      if (selectedComboType === 'combo') {
        const promoC = getPromoForProduct(selectedProduct.id, 'combo');
        basePrice = calcPromoPrice(comboPrice, promoC) ?? comboPrice;
      } else {
        const promoS = getPromoForProduct(selectedProduct.id, 'simples');
        basePrice = calcPromoPrice(simplePrice, promoS) ?? simplePrice;
      }
    } else {
      const promoS = getPromoForProduct(selectedProduct.id, 'simples');
      basePrice = calcPromoPrice(selectedProduct.sale_price || 0, promoS) ?? (selectedProduct.sale_price || 0);
    }
    
    // Adicionar preços extras das seleções (usando getItemPrice para sincronizar com PRODUTOS)
    const relevantSteps = getRelevantSteps();
    Object.entries(stepSelections).forEach(([stepIdx, selections]) => {
      const step = relevantSteps[parseInt(stepIdx)];
      if (step?.items) {
        // Soma, Máximo ou Subtração: regra única em utils/precoEtapas.js
        const precos = selections
          .map(productId => step.items.find(i => i.product_id === productId))
          .filter(Boolean)
          .map(item => getItemPrice(item, step));
        basePrice += valorDaEtapa(step, precos);
      }
    });

    return Math.max(0, basePrice);
  };
  
  // Obter foto do produto por ID (busca em TODOS os produtos, incluindo insumos)
  const getProductPhoto = (productId) => {
    const product = allProductsForPhotos.find(p => p.id === productId);
    return product?.photo_url || null;
  };
  
  // Verificar se produto está disponível (available)
  const isProductAvailable = (productId) => {
    const product = allProductsForPhotos.find(p => p.id === productId);
    return product?.available !== false;
  };

  // Produto marcado como "escondido" em Produtos→Cardápio OU arquivado/deletado
  // (não vem mais em /products) → some de todos os modulos e das etapas.
  const isProductHidden = (productId) => {
    const product = allProductsForPhotos.find(p => p.id === productId);
    return !product || product.hidden === true;
  };
  
  // Buscar preço atual do produto pelo ID (para sincronizar com PRODUTOS)
  const getProductPrice = (productId) => {
    const product = allProductsForPhotos.find(p => p.id === productId);
    return product?.sale_price || 0;
  };
  
  // Buscar descrição do produto pelo ID
  const getProductDescription = (productId) => {
    const product = allProductsForPhotos.find(p => p.id === productId);
    return product?.description || "";
  };
  
  // Obter preço do item (verifica sync_prices da etapa)
  const getItemPrice = (item, step) => {
    // Se a etapa tem sync_prices ativo (ou não definido = default true), usa preço do produto
    if (step?.sync_prices !== false) {
      return getProductPrice(item.product_id);
    }
    // Se sync_prices está desativado, usa price_override
    // Se price_override está definido explicitamente como 0, é grátis
    if (item.price_override === 0) return 0;
    // Se price_override > 0, usa ele
    if (item.price_override > 0) return item.price_override;
    // Fallback: busca o preço atual do produto
    return getProductPrice(item.product_id);
  };

  // Confirmar adição do popup (com suporte a combo)
  const confirmAddToCart = () => {
    if (selectedProduct) {
      const isCombo = selectedProduct.product_type === 'combo';
      let finalPrice;
      if (isCombo || selectedProduct.order_steps?.length > 0) {
        finalPrice = calculateComboPrice();
      } else {
        const promoS = getPromoForProduct(selectedProduct.id, 'simples');
        finalPrice = calcPromoPrice(selectedProduct.sale_price || 0, promoS) ?? (selectedProduct.sale_price || 0);
      }
      // Vai no pedido como `is_promotional` (o leitor e o Repetir marcam igual, 30/09/2026)
      const emPromocao = precoComPromocao(selectedProduct, isCombo && selectedComboType === 'combo' ? 'combo' : 'simples').promocional;
      
      // Construir subitems a partir das seleções
      const subitems = [];
      const etapas = []; // Formato resumido para exibição
      const relevantSteps = getRelevantSteps();
      
      Object.entries(stepSelections).forEach(([stepIdx, selections]) => {
        const step = relevantSteps[parseInt(stepIdx)];
        if (step?.items && selections.length > 0) {
          const stepItemNames = [];
          const daEtapa = selections.map(productId => step.items.find(i => i.product_id === productId)).filter(Boolean);
          // Valor de cada linha conforme o tipo da etapa (Soma, Máximo, Subtração).
          const precosDaEtapa = linhasDaEtapa(step, daEtapa.map(item => ({ preco: getItemPrice(item, step), qtd: 1 })));
          daEtapa.forEach((item, posicao) => {
            subitems.push({
              product_id: item.product_id,
              nome: item.product_name,
              name: item.product_name,
              preco: precosDaEtapa[posicao], // preço atualizado do produto, pelo tipo da etapa
              step_name: step.name
            });
            stepItemNames.push(item.product_name);
          });
          if (stepItemNames.length > 0) {
            etapas.push({
              etapa: step.name,
              itens: stepItemNames
            });
          }
        }
      });
      
      const productToAdd = {
        ...selectedProduct,
        sale_price: finalPrice,
        is_promotional: emPromocao,
        combo_type: isCombo ? selectedComboType : null,
        subitems: subitems.length > 0 ? subitems : undefined,
        etapas: etapas.length > 0 ? etapas : undefined,
        ...(pesadoBalanca ? { pesado_balanca: true } : {}),
      };
      
      addToCart(productToAdd, productQuantity, productObservation.trim());
      closeProductPopup();
    }
  };

  // Remover do carrinho
  const removeFromCart = (productId, index) => {
    const item = cart[index];
    if (item && item.quantity > 1) {
      const newCart = [...cart];
      newCart[index] = { ...newCart[index], quantity: newCart[index].quantity - 1 };
      setCart(newCart);
    } else {
      setCart(cart.filter((_, i) => i !== index));
    }
  };

  // Calcular totais
  const subtotal = cart.reduce((acc, item) => acc + (item.sale_price || 0) * item.quantity, 0);
  const taxaAplicada = tipoEntrega === "delivery" ? taxaEntrega : 0;
  // Valor do desconto conforme o tipo escolhido
  const discountAmount = (() => {
    if (discountType === 'none') return 0;
    if (discountType === 'percent') return Math.max(0, subtotal * (Math.min(100, Math.max(0, Number(discountValue) || 0)) / 100));
    if (discountType === 'fixed') return Math.max(0, Math.min(subtotal, Number(discountValue) || 0));
    // Frete grátis nunca passa da taxa atual (30/09/2026)
    if (discountType === 'coupon') return descontoDoCupom(couponData, subtotal, taxaAplicada);
    return 0;
  })();
  const total = Math.max(0, subtotal + taxaAplicada - discountAmount);

  // Cupom validado de novo 1 s depois de mudar subtotal, taxa ou cliente
  // (30/09/2026, features/novo-pedido-regras). Deixou de valer → sai e avisa.
  const cupomAtivo = discountType === 'coupon' ? ((couponData?.code || couponCode || '').toUpperCase() || null) : null;
  const tirarCupom = () => {
    setDiscountType('none');
    setDiscountValue(0);
    setCouponCode('');
    setCouponData(null);
    setCouponError('');
  };
  // Carrinho no formato da conferência do cupom (o preço é o mesmo do subtotal desta tela).
  const itensDoCupomDoCarrinho = itensDoCupom(cart, (i) => i.sale_price);
  const cupomNovo = useRevalidarCupom({
    codigo: cupomAtivo,
    desconto: couponData?.discount,
    subtotal,
    taxa: taxaAplicada,
    cliente: selectedCliente,
    itens: itensDoCupomDoCarrinho,
    editando: !!pedidoParaEditar,
    aplicar: (d) => setCouponData((prev) => ({ ...(prev || {}), ...d, valid: true, code: prev?.code || d.code || cupomAtivo })),
    remover: (motivo) => { tirarCupom(); toast.error(`Cupom ${cupomAtivo} saiu do pedido: ${motivo}`, { duration: 6000 }); },
  });

  // Forma escolhida é dinheiro (aparece o troco) — a mesma regra da tela e do envio.
  const formaEhDinheiro = String(formaPagamento || '').toLowerCase().includes('dinheiro') ||
    String((paymentMethodsDelivery.find(m => (m.code || m.id) === formaPagamento) || {}).label || '').toLowerCase().includes('dinheiro');
  const trocoVisivel = formaEhDinheiro && !jaPago;
  // Parte da divisão em dinheiro: o code real é "dinheiro_<uuid>", então
  // comparar com "dinheiro" exato nunca pedia nem gravava o troco (achado 269).
  const cpSplitEhDinheiro = _formaBase(cpSplitSelectedMethod) === "dinheiro";
  const trocoErrado = !cpSplitPayment && trocoVisivel && trocoAbaixoDoTotal(trocoPara, total);

  // Split payment helpers
  const cpSplitTotal = cpSplitPayments.reduce((s, p) => s + p.amount, 0);
  const cpSplitRemaining = Math.max(0, total - cpSplitTotal);
  const cpSplitComplete = cpSplitPayments.length > 0 && Math.abs(cpSplitTotal - total) < 0.01;

  const cpToggleSplit = () => {
    if (!cpSplitPayment) {
      setCpSplitPayment(true);
      setFormaPagamento("");
      setCpSplitPayments([]);
    } else {
      setCpSplitPayment(false);
      setCpSplitPayments([]);
    }
  };

  const cpOpenSplitModal = () => {
    setCpSplitSelectedMethod(null);
    setCpSplitAmount(cpSplitRemaining > 0 ? cpSplitRemaining.toFixed(2) : "");
    setCpSplitTrocoNeeds(false);
    setCpSplitTrocoAmount("");
    setCpShowSplitModal(true);
  };

  const cpAddSplitPayment = () => {
    const amt = parseFloat(cpSplitAmount);
    if (!cpSplitSelectedMethod || !amt || amt <= 0) { toast.error("Selecione forma e valor"); return; }
    if (amt > cpSplitRemaining + 0.01) { toast.error(`Valor máximo: R$ ${cpSplitRemaining.toFixed(2).replace(".", ",")}`); return; }
    if (cpSplitEhDinheiro && cpSplitTrocoNeeds && trocoAbaixoDoTotal(cpSplitTrocoAmount, amt)) {
      toast.error(`O troco é para um valor menor que esta parte (R$ ${amt.toFixed(2).replace(".", ",")})`); return;
    }
    const pms = paymentMethodsDelivery.length > 0 ? paymentMethodsDelivery : [
      { id: "dinheiro", code: "dinheiro", label: "Dinheiro" },
      { id: "pix", code: "pix", label: "PIX" },
      { id: "credito", code: "credito", label: "Crédito" },
      { id: "debito", code: "debito", label: "Débito" },
    ];
    const pm = pms.find(p => (p.code || p.id) === cpSplitSelectedMethod);
    setCpSplitPayments(prev => [...prev, {
      method: cpSplitSelectedMethod,
      code: pm?.code || cpSplitSelectedMethod,
      label: pm?.label || cpSplitSelectedMethod,
      amount: amt,
      troco_precisa: cpSplitEhDinheiro ? (cpSplitTrocoNeeds || false) : false,
      troco_valor: cpSplitEhDinheiro && cpSplitTrocoNeeds ? parseFloat(cpSplitTrocoAmount) || null : null,
    }]);
    setCpShowSplitModal(false);
  };

  const cpRemoveSplitPayment = (idx) => {
    setCpSplitPayments(prev => prev.filter((_, i) => i !== idx));
  };

  // Buscar taxa de entrega pelo bairro (com trim para evitar espaços)
  useEffect(() => {
    if (endereco.bairro && tipoEntrega === "delivery") {
      const bairro = bairros.find(b => (b.nome || '').trim().toLowerCase() === (endereco.bairro || '').trim().toLowerCase());
      if (bairro) {
        setTaxaEntrega(bairro.valor_entrega || bairro.taxa_entrega || 0);
      }
    }
  }, [endereco.bairro, bairros, tipoEntrega]);

  // Criar cliente
  const handleCriarCliente = async () => {
    if (!novoCliente.nome || !novoCliente.telefone) {
      toast.error("Nome e telefone são obrigatórios");
      return;
    }
    
    setCreatingCliente(true);
    try {
      const res = await axios.post(`${API}/clientes`, {
        nome: novoCliente.nome,
        telefone: novoCliente.telefone
      }, getAuthHeader());
      
      setSelectedCliente(res.data);
      setClientes([...clientes, res.data]);
      setNovoCliente({ nome: "", telefone: "" });
      toast.success("Cliente criado!");
    } catch (error) {
      if (error?.response?.status === 409) {
        // Cliente ja existe com esse telefone - buscar e selecionar automaticamente
        try {
          const { data: list } = await axios.get(`${API}/clientes`, getAuthHeader());
          const existing = list.find(c => c.telefone === novoCliente.telefone);
          if (existing) {
            setSelectedCliente(existing);
            setClientes(prev => prev.some(c => c.id === existing.id) ? prev : [...prev, existing]);
            setNovoCliente({ nome: "", telefone: "" });
            toast.info("Cliente ja cadastrado - selecionado automaticamente.");
            return;
          }
        } catch (_) {}
      }
      toast.error(error?.response?.data?.detail || "Erro ao criar cliente");
    } finally {
      setCreatingCliente(false);
    }
  };

  // Criar pedido
  const handleSubmit = async () => {
    // Já enviando (Enter + clique, duplo Enter): não manda de novo (30/09/2026)
    if (enviandoRef.current) return;
    if (cart.length === 0) {
      toast.error("Adicione produtos ao carrinho");
      return;
    }
    
    if (!selectedCliente) {
      toast.error("Selecione um cliente");
      return;
    }

    if (tipoEntrega === "delivery") {
      if (!String(endereco.rua || "").trim() || !String(endereco.numero || "").trim() || !String(endereco.bairro || "").trim()) {
        toast.error("Informe rua, número e bairro de entrega");
        return;
      }
      // Bloqueia bairro fora do cadastro — sem isso a taxa fica em 0 e o pedido
      // vai sem cobrar (caso real: #21561 UAI Pizza com bairro 'Santa Vitória').
      const alvo = String(endereco.bairro || "").trim().toLowerCase();
      const matchBairro = (bairros || []).find(
        (b) => String(b.nome || b.name || "").trim().toLowerCase() === alvo
      );
      if (!matchBairro) {
        toast.error(
          `Bairro '${endereco.bairro}' não está cadastrado. Selecione um da lista pra ter a taxa correta.`,
          { duration: 6000 },
        );
        return;
      }
    }

    // Forma de pagamento:
    //   - split: precisa estar completo.
    //   - pickup (retirada): OPCIONAL — UI mostra "Pagar na Retirada" como
    //     default, backend grava com forma `pagar_na_retirada` (auditável
    //     no relatório, não cai em "Não informado").
    //   - delivery: obrigatória.
    if (cpSplitPayment) {
      if (!cpSplitComplete) {
        toast.error(`A soma dos pagamentos deve ser igual ao total (R$ ${total.toFixed(2).replace(".", ",")})`);
        return;
      }
    } else if (!formaPagamento && tipoEntrega !== "pickup") {
      toast.error("Selecione a forma de pagamento");
      return;
    }
    // Troco para menos que o total não serve (30/09/2026)
    if (!cpSplitPayment && trocoVisivel && trocoAbaixoDoTotal(trocoPara, total)) {
      toast.error(`O troco é para um valor menor que o total (R$ ${total.toFixed(2).replace(".", ",")}). Corrija o "troco para quanto".`);
      return;
    }

    enviandoRef.current = true;
    setSubmitting(true);
    try {
      // Cupom conferido com o carrinho de agora; se mudou, a tela mostra o total
      // novo e o atendente cria de novo (troco e divisão usam o total novo).
      if (!pedidoParaEditar && !(await cupomNovo.conferirAgora())) {
        toast.info("O cupom foi recalculado. Confira o total e crie o pedido de novo.");
        return;
      }
      // Determinar forma de pagamento principal
      // Dividido em 2+ formas: "multiplo" + as partes em `pagamentos` (mesmo
      // formato do Totem/Balcão) — o caixa lança uma venda por forma na conclusão
      const partesPagamento = cpSplitPayment ? cpSplitPayments.map(sp => ({
        method: sp.code,
        label: sp.label,
        amount: sp.amount,
        troco_precisa: sp.troco_precisa,
        troco_valor: sp.troco_valor
      })) : [];
      const dividido = partesPagamento.length > 1;
      const mainPayment = cpSplitPayment ? (dividido ? "multiplo" : (partesPagamento[0]?.method || "dinheiro")) : formaPagamento;
      const mainTroco = cpSplitPayment
        ? { precisa: cpSplitPayments.some(p => p.troco_precisa), valor: cpSplitPayments.find(p => p.troco_precisa)?.troco_valor || null }
        : (() => {
            const isDin = String(formaPagamento || '').toLowerCase().includes('dinheiro') || String((paymentMethodsDelivery.find(m => (m.code || m.id) === formaPagamento) || {}).label || '').toLowerCase().includes('dinheiro');
            return { precisa: isDin && trocoPara ? true : false, valor: isDin && trocoPara ? parseFloat(trocoPara) : null };
          })();

      const pedidoData = {
        cliente_id: selectedCliente.id,
        cliente_nome: selectedCliente.nome,
        cliente_telefone: selectedCliente.telefone,
        tipo_entrega: tipoEntrega,
        modulo: "Delivery",
        items: cart.map(item => ({
          id: item.id,
          nome: item.name,
          quantidade: item.quantity,
          preco: item.sale_price || 0,
          observacao: item.observation || "",
          photo_url: item.photo_url || null,
          subitems: item.subitems || [],
          etapas: item.etapas || [],
          combo_type: item.combo_type || null,
          // Pizza: tamanho/sabores/borda para o backend conferir o preço (igual ao cardápio)
          pizza_meta: pizzaMetaDoItem(item),
          ...(item.pesado_balanca ? { pesado_balanca: true } : {}),
          // Promoção do clique/leitor. Etiqueta da balança nunca (decisão do dono, 30/09/2026).
          is_promotional: item.etiqueta_balanca ? false : !!item.is_promotional,
          // Etiqueta da balança: o servidor relê e confere o valor (validation_etiqueta.py).
          etiqueta_balanca: item.etiqueta_balanca || null
        })),
        total: total,
        forma_pagamento: mainPayment,
        troco_precisa: mainTroco.precisa,
        troco_valor: mainTroco.valor,
        observacao: observacao,
        // Desconto aplicado (manual ou via cupom). Na edição (achado 444) o servidor
        // recalcula o cupom do pedido pela regra da criação: a tela só diz qual
        // cupom vale — o carregado/aplicado, "" quando o atendente tirou o que
        // veio do pedido, null quando não mexeu (o servidor mantém o do pedido).
        // Antes mandava cupom_desconto: 0 e o pedido perdia o desconto.
        cupom_codigo: discountType === 'coupon'
          ? (couponData?.code || couponCode || '').toUpperCase()
          : (pedidoParaEditar && cupomCarregadoRef.current ? '' : null),
        cupom_desconto: pedidoParaEditar ? null : (discountType === 'coupon' ? Number(couponData?.discount || 0) : 0),
        desconto_manual: discountType === 'percent' || discountType === 'fixed' ? Number(discountAmount || 0) : 0,
        // Quando tipo='percent', preserva o % digitado pra exibir no alerta de WhatsApp
        // (sem isso o backend tenta calcular a partir de R$/subtotal e arredonda)
        desconto_percentual: discountType === 'percent' ? Number(discountValue || 0) : null,
        desconto_tipo: discountType === 'none' ? null : discountType,
        valor_entrega: tipoEntrega === "delivery" ? taxaEntrega : 0,
        endereco_rua: tipoEntrega === "delivery" ? endereco.rua : null,
        endereco_numero: tipoEntrega === "delivery" ? endereco.numero : null,
        endereco_bairro: tipoEntrega === "delivery" ? endereco.bairro : null,
        endereco_complemento: tipoEntrega === "delivery" ? endereco.complemento : null,
        endereco_cep: tipoEntrega === "delivery" ? endereco.cep : null,
        endereco_referencia: tipoEntrega === "delivery" ? endereco.referencia : null,
        status: pedidoParaEditar ? pedidoParaEditar.status : "aguardando_aceite",
        payment_status: jaPago ? "paid" : "pending",
        // Na edição, lista vazia apaga partes antigas de quando era dividido
        pagamentos: dividido ? partesPagamento : (pedidoParaEditar ? [] : null)
      };
      
      if (pedidoParaEditar) {
        // Atualizar pedido existente
        const { data: updatedPedido } = await axios.put(`${API}/pedidos/${pedidoParaEditar.id}`, pedidoData, getAuthHeader());
        // O servidor refez o cupom e o total (achado 444): se ficou diferente do que a tela mostrava, avisa.
        const totalGravado = Number(updatedPedido?.total);
        if (Number.isFinite(totalGravado) && Math.abs(totalGravado - total) > 0.009) {
          toast.info(`Total gravado: R$ ${totalGravado.toFixed(2).replace(".", ",")} (cupom ${updatedPedido?.cupom_codigo || ''} recalculado pelo servidor).`, { duration: 7000 });
        }
        // Reimprimir cupons após edição
        const pedidoForPrint = updatedPedido || { ...pedidoParaEditar, ...pedidoData };
        (async () => {
          try {
            await Promise.all([imprimirCupom(pedidoForPrint), imprimirCupomPreparo(pedidoForPrint)]);
          } catch (e) {
            console.error('Erro ao reimprimir após edição:', e);
            toast.error('Falha ao reimprimir pedido editado');
          }
        })();
      } else {
        // Criar novo pedido — nasce em AGUARDANDO ACEITE e o SISTEMA aceita
        // automaticamente na sequência (alinhamento de 21/07/2026): pedido do
        // Delivery é criado pela própria equipe, então o aceite é implícito,
        // independente do switch de auto-aceite. Quem IMPRIME é a transição
        // aguardando_aceite → producao no backend (server-side, não depende
        // desta tela). Se o PATCH falhar (ex: pagamento online pendente, 409),
        // o pedido fica em Aguardando Aceite e imprime no aceite posterior.
        // Mesma chave nas novas tentativas: se a 1ª gravou e a resposta se perdeu,
        // o servidor devolve o pedido já criado em vez de criar outro (30/09/2026).
        if (!chaveEnvioRef.current) chaveEnvioRef.current = novaChaveEnvio();
        const { data: createdPedido } = await axios.post(`${API}/pedidos`, { ...pedidoData, chave_envio: chaveEnvioRef.current }, getAuthHeader());
        // Veio do Balcão: a passagem só sai agora, com o pedido gravado.
        apagarPassagem();
        if (createdPedido && createdPedido.id) {
          try {
            await axios.patch(`${API}/pedidos/${createdPedido.id}/status?status=producao`, {}, getAuthHeader());
          } catch (e) {
            console.error('Auto-aceite do novo pedido falhou (fica em Aguardando Aceite):', e);
          }
        }
      }

      // Reset estado
      resetForm();

      onPedidoCriado(pedidoParaEditar ? { ...pedidoParaEditar, ...pedidoData, payment_status: jaPago ? 'paid' : 'pending' } : null);
    } catch (error) {
      console.error(`Erro ao ${pedidoParaEditar ? 'atualizar' : 'criar'} pedido:`, error);
      // O servidor diz o motivo em `detail` (cupom, estoque, etiqueta...) — 30/09/2026
      toast.error(mensagemDoErro(error, `Erro ao ${pedidoParaEditar ? 'atualizar' : 'criar'} pedido`), { duration: 7000 });
    } finally {
      enviandoRef.current = false;
      setSubmitting(false);
    }
  };

  // Reset ao fechar. Novo Pedido com produtos no carrinho pergunta antes
  // ("Descartar o pedido?", 30/09/2026); descartar apaga também a passagem do Balcão.
  const fecharDeVez = () => {
    setConfirmarDescarte(false);
    if (!pedidoParaEditar) apagarPassagem();
    resetForm();
    onClose();
  };
  const handleClose = () => {
    if (!pedidoParaEditar && cart.length > 0) { setConfirmarDescarte(true); return; }
    fecharDeVez();
  };

  // ===== Teclado do Novo Pedido (29/09/2026) — features/novo-pedido-teclado =====
  // Endereços salvos na ordem da tela (o usado por último primeiro): a etapa 2
  // desenha com eles e as setas ↑↓ andam por eles.
  const enderecosEmOrdem = useMemo(() => {
    // Mapeia endereco (rua+numero) -> data do ultimo pedido desse cliente nesse endereco
    const lastUsedMap = {};
    for (const p of (clienteHistorico || [])) {
      const key = `${(p.endereco_rua || '').trim().toLowerCase()}|${(p.endereco_numero || '').trim()}`;
      const ts = p.created_at ? new Date(p.created_at).getTime() : 0;
      if (ts && (!lastUsedMap[key] || ts > lastUsedMap[key])) {
        lastUsedMap[key] = ts;
      }
    }
    // Ordena: mais recentemente usado primeiro; enderecos nunca usados vao pro fim
    const enderecosOrdenados = [...enderecosSalvos].sort((a, b) => {
      const ka = `${(a.rua || '').trim().toLowerCase()}|${(a.numero || '').trim()}`;
      const kb = `${(b.rua || '').trim().toLowerCase()}|${(b.numero || '').trim()}`;
      return (lastUsedMap[kb] || 0) - (lastUsedMap[ka] || 0);
    });
    const firstUsedKey = enderecosOrdenados.length
      ? `${(enderecosOrdenados[0].rua || '').trim().toLowerCase()}|${(enderecosOrdenados[0].numero || '').trim()}`
      : null;
    return { lista: enderecosOrdenados, lastUsedMap, firstUsedKey };
  }, [clienteHistorico, enderecosSalvos]);
  const escolherEndereco = (end) => {
    setEndereco({ rua: end.rua||"", numero: end.numero||"", bairro: end.bairro||"", complemento: end.complemento||"", referencia: end.referencia||"", cep: end.cep||"" });
    if (end.taxa_entrega) setTaxaEntrega(parseFloat(end.taxa_entrega));
  };
  // Entrega ↔ Retirada (clique e F3/F4). Ao ir para a retirada, sai o que não
  // vale nela (30/09/2026): forma que não está na lista (só online), "Já pago"
  // e a divisão — antes ficavam escondidos e iam no pedido.
  const mudarTipoEntrega = (tipo) => {
    setTipoEntrega(tipo);
    if (tipo !== "pickup" || tipoEntrega === "pickup") return;
    if (formaPagamento && !["pix_online", "cartao_online"].includes(formaPagamento)) setFormaPagamento("");
    setTrocoPara("");
    setJaPago(false);
    setCpSplitPayment(false);
    setCpSplitPayments([]);
  };
  // Formas de pagamento da etapa 3 (retirada: só as online).
  const formasPagamentoVisiveis = useMemo(() => (paymentMethodsDelivery.length > 0 ? paymentMethodsDelivery : [
    { id: "dinheiro", code: "dinheiro", label: "Dinheiro" },
    { id: "pix", code: "pix", label: "PIX" },
    { id: "credito", code: "credito", label: "Crédito" },
    { id: "debito", code: "debito", label: "Débito" },
  ]).filter((fp) => {
    if (tipoEntrega === "pickup") {
      const fpId = fp.code || fp.id;
      return fpId === 'pix_online' || fpId === 'cartao_online';
    }
    return true;
  }), [paymentMethodsDelivery, tipoEntrega]);
  // O que falta no endereço de entrega (número, bairro cadastrado) — 30/09/2026.
  const faltasEndereco = tipoEntrega === "delivery" ? faltasDoEndereco(endereco, bairros) : [];
  // "Próximo": etapa 1 → 2 precisa de cliente; 2 → 3, de endereço na entrega.
  const avancarEtapa = () => {
    // Carrinho vazio não avança (o Enter chegava na Entrega sem produto, 30/09/2026)
    if (cart.length === 0) {
      toast.error("Adicione produtos ao carrinho");
      setCartStep(1);
      return;
    }
    if (cartStep === 1 && !selectedCliente) {
      setHighlightClienteSearch(true);
      toast.error("Selecione um cliente para avançar para Entrega");
      setTimeout(() => { clienteSearchRef.current?.focus(); }, 100);
      setTimeout(() => setHighlightClienteSearch(false), 2500);
      return;
    }
    if (cartStep === 2 && tipoEntrega === "delivery" && !endereco.rua) {
      toast.error("Selecione ou cadastre um endereço de entrega");
      return;
    }
    // Número e bairro cadastrado conferidos já aqui, não só no Criar (30/09/2026)
    if (cartStep === 2 && tipoEntrega === "delivery" && faltasEndereco.length) {
      toast.error(`Endereço incompleto: falta ${faltasEndereco.join(", ")}`, { duration: 6000 });
      return;
    }
    setCartStep(cartStep + 1);
  };
  const podeCriarPedido = !(cart.length === 0 || !selectedCliente || submitting || (!cpSplitPayment && !formaPagamento && tipoEntrega !== "pickup") || (cpSplitPayment && !cpSplitComplete));
  const teclasNP = useTeclasNovoPedido({
    open, cartStep, setCartStep, avancarEtapa, clienteSearchRef, tipoEntrega, setTipoEntrega: mudarTipoEntrega,
    enderecos: enderecosEmOrdem.lista, endereco, escolherEndereco, showNewAddressForm,
    formas: formasPagamentoVisiveis, formaPagamento, setFormaPagamento, cpSplitPayment, podeCriar: podeCriarPedido, handleSubmit,
  });

  if (!open) return null;

  // Página, não popup (pedido do dono, 23/09/2026): cobre a área inteira da tela
  // Delivery, mas o Delivery continua montado por baixo — é ele que faz o aceite
  // automático e imprime o pedido lançado aqui. Uma rota separada desmontaria a
  // tela e o cupom do pedido novo não sairia.
  return (
    <>
      <div role="region" aria-label={pedidoParaEditar ? `Editar ${pedidoParaEditar.codigo}` : "Novo Pedido"} data-e2e="pagina-novo-pedido" className="absolute inset-0 z-40 flex flex-col bg-background overflow-hidden">
        {/* HEADER com Cliente sempre visível — titulo a esquerda + busca cliente CENTRALIZADA */}
        <div className="relative border-b flex-shrink-0 bg-gradient-to-r from-orange-500/5 via-transparent to-transparent px-3 sm:px-4 md:px-6 py-2.5">
          {/* Bloco Titulo — flow normal no mobile, absolute na esquerda em sm+ */}
          <div className="flex items-center gap-2.5 mb-2 sm:mb-0 sm:absolute sm:left-3 md:left-6 sm:top-1/2 sm:-translate-y-1/2 z-10">
            <button
              type="button"
              onClick={handleClose}
              aria-label="Voltar para o Delivery"
              title="Voltar para o Delivery"
              className="w-9 h-9 rounded-xl border bg-background hover:bg-muted flex items-center justify-center shrink-0 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
            </button>
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center shadow-sm shrink-0">
              <ShoppingBag className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            </div>
            <h2 className="font-bold text-sm sm:text-base md:text-lg tracking-tight truncate">
              {pedidoParaEditar ? `Editar ${pedidoParaEditar.codigo}` : "Novo Pedido"}
            </h2>
          </div>

          {/* Bloco Cliente (centralizado horizontalmente) */}
          <div className="w-full max-w-md mx-auto min-w-0">
            {selectedCliente ? (
              <div className="flex items-center gap-2 bg-muted/60 border border-border/50 rounded-lg py-1.5 px-2">
                <User className="w-4 h-4 text-orange-500 flex-shrink-0 ml-0.5" />
                <span className="font-semibold text-green-600 text-sm truncate">{selectedCliente.nome}</span>
                {selectedCliente.telefone && (
                  <span className="text-xs text-muted-foreground truncate">· {selectedCliente.telefone}</span>
                )}
                <Button variant="ghost" size="sm" className="ml-auto text-xs h-7 px-2 shrink-0" onClick={trocarCliente}>
                  <X className="w-3.5 h-3.5" /> <span className="hidden sm:inline ml-1">Trocar</span>
                </Button>
              </div>
            ) : (
              <div className="relative">
                <div className={`flex items-center gap-2 bg-background border-2 rounded-xl px-3 h-11 transition-all ${
                  highlightClienteSearch
                    ? 'border-red-500 shadow-[0_0_0_4px_rgba(239,68,68,0.25)] animate-[shake_0.4s_ease-in-out]'
                    : 'border-orange-500/40 shadow-[0_0_0_4px_rgba(249,115,22,0.08)] focus-within:border-orange-500 focus-within:shadow-[0_0_0_4px_rgba(249,115,22,0.18)]'
                }`}>
                  <User className={`w-5 h-5 flex-shrink-0 ${highlightClienteSearch ? 'text-red-500' : 'text-orange-500'}`} />
                  <Input
                    ref={clienteSearchRef}
                    placeholder={highlightClienteSearch ? 'Informe o cliente para avançar' : 'Buscar cliente — nome, CPF ou telefone... (F2)'}
                    value={clienteSearch}
                    onChange={(e) => {
                      // Se o usuario digita APENAS numeros, aplica mascara (CPF ou telefone).
                      // Se tiver qualquer letra, deixa passar sem formatacao (nome/email).
                      const raw = e.target.value;
                      const hasLetter = /[a-zA-ZÀ-ú]/.test(raw);
                      let next = raw;
                      if (!hasLetter && raw.trim() !== "") {
                        const digits = raw.replace(/\D/g, "").slice(0, 11);
                        if (digits.length === 0) {
                          next = "";
                        } else if (digits.length <= 10) {
                          // Telefone fixo ou parcial: (DD)NNNN-NNNN
                          if (digits.length <= 2) next = `(${digits}`;
                          else if (digits.length <= 6) next = `(${digits.slice(0,2)})${digits.slice(2)}`;
                          else next = `(${digits.slice(0,2)})${digits.slice(2,6)}-${digits.slice(6)}`;
                        } else if (digits[2] === '9') {
                          // 11 digitos com 9 na posicao 3 -> telefone mobile (DD)9.NNNN-NNNN
                          next = `(${digits.slice(0,2)})${digits[2]}.${digits.slice(3,7)}-${digits.slice(7)}`;
                        } else {
                          // 11 digitos sem 9 na posicao 3 -> CPF 999.999.999-99
                          next = `${digits.slice(0,3)}.${digits.slice(3,6)}.${digits.slice(6,9)}-${digits.slice(9)}`;
                        }
                      }
                      setClienteSearch(next);
                      setShowClienteDropdown(true);
                      setClienteAceso(0);
                      if (highlightClienteSearch) setHighlightClienteSearch(false);
                    }}
                    onKeyDown={(e) => {
                      // Teclado (29-30/09/2026): ↑↓ e Tab andam na lista, Enter escolhe (ou
                      // cadastra o telefone que não achou), Esc limpa.
                      const lista = filteredClientes;
                      if ((e.key === "ArrowDown" || (e.key === "Tab" && !e.shiftKey)) && lista.length) { e.preventDefault(); setShowClienteDropdown(true); setClienteAceso((a) => (a + 1) % lista.length); }
                      else if ((e.key === "ArrowUp" || (e.key === "Tab" && e.shiftKey)) && lista.length) { e.preventDefault(); setShowClienteDropdown(true); setClienteAceso((a) => (a - 1 + lista.length) % lista.length); }
                      else if (e.key === "Enter" && clienteSearch.trim()) {
                        e.preventDefault();
                        if (lista.length) { handleSelectCliente(lista[Math.min(clienteAceso, lista.length - 1)]); e.currentTarget.blur(); }
                        else if (shouldShowCreateButton) handleCadastrarClienteFromPhone();
                      } else if (e.key === "Escape" && clienteSearch) { e.preventDefault(); setClienteSearch(""); setShowClienteDropdown(false); }
                    }}
                    data-e2e="np-busca-cliente"
                    onFocus={() => { setShowClienteDropdown(true); if (highlightClienteSearch) setHighlightClienteSearch(false); }}
                    className="border-0 shadow-none focus-visible:ring-0 bg-transparent text-sm font-medium placeholder:text-muted-foreground/70 px-0"
                    inputMode="text"
                  />
                </div>
                {showClienteDropdown && clienteSearch && filteredClientes.length > 0 && (
                  <div className="absolute z-50 w-full mt-1 bg-card border rounded-lg shadow-lg max-h-48 overflow-auto">
                    {filteredClientes.map((cliente, ci) => (
                      <div
                        key={cliente.id}
                        data-e2e="np-cliente-opcao"
                        className={`p-3 hover:bg-muted cursor-pointer flex justify-between ${ci === clienteAceso ? "bg-muted" : ""}`}
                        onClick={() => handleSelectCliente(cliente)}
                      >
                        <span className="font-medium">{cliente.nome}</span>
                        <span className="text-muted-foreground">{cliente.telefone}</span>
                      </div>
                    ))}
                  </div>
                )}
                {shouldShowCreateButton && (
                  <div className="absolute z-50 w-full mt-1 bg-white dark:bg-gray-900 border border-orange-300 dark:border-orange-700 rounded-lg shadow-lg p-3">
                    <p className="text-sm text-orange-700 dark:text-orange-400 mb-2">Cliente não encontrado</p>
                    <Button
                      onClick={handleCadastrarClienteFromPhone}
                      className="w-full bg-orange-500 hover:bg-orange-600 text-white"
                      size="sm"
                    >
                      <Plus className="w-4 h-4 mr-1" /> Cadastrar novo Cliente
                    </Button>
                  </div>
                )}
              </div>
            )}

            {/* Form criar novo cliente inline */}
            {!selectedCliente && (novoCliente.nome || novoCliente.telefone) && (
              <div className="mt-2 p-3 bg-green-50 dark:bg-green-950/20 rounded-lg border border-green-200 dark:border-green-800"
                // Enter no nome ou no telefone cria o cliente (pedido do dono, 30/09/2026).
                onKeyDown={(e) => { if (e.key === "Enter" && e.target.tagName === "INPUT") { e.preventDefault(); if (!creatingCliente) handleCriarCliente(); } }}
                data-e2e="np-novo-cliente">
                <p className="text-sm font-medium text-green-700 dark:text-green-400 mb-2">Criar novo cliente:</p>
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
                  <Input
                    ref={nomeClienteInputRef}
                    value={novoCliente.nome}
                    onChange={(e) => setNovoCliente({...novoCliente, nome: e.target.value})}
                    placeholder="Nome"
                    className="flex-1"
                    data-e2e="np-novo-cliente-nome"
                  />
                  <Input
                    value={novoCliente.telefone}
                    onChange={(e) => setNovoCliente({...novoCliente, telefone: e.target.value})}
                    placeholder="Telefone"
                    className="w-full sm:w-40"
                  />
                  <div className="flex gap-2">
                    <Button onClick={handleCriarCliente} disabled={creatingCliente} className="flex-1 sm:flex-none bg-green-600 hover:bg-green-700">
                      {creatingCliente ? "..." : "Criar"}
                    </Button>
                    <Button variant="ghost" size="sm" onClick={() => setNovoCliente({ nome: "", telefone: "" })}>
                      <X className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        
        {/* BARRA HORIZONTAL - Pedidos Ativos (aparece so quando ha abas ativas) */}
        {!pedidoParaEditar && pedidosAtivos.length > 0 && (
          <div className="border-b bg-muted/30 px-3 sm:px-4 md:px-6 py-2 flex items-center gap-2 overflow-x-auto shrink-0">
            <span className="text-[11px] font-semibold text-muted-foreground uppercase tracking-wide shrink-0">Abas:</span>
            <div className="flex items-center gap-2 overflow-x-auto flex-1 min-w-0">
              {pedidosAtivos.map((pedido, idx) => (
                <div
                  key={pedido.id}
                  className={`flex items-center gap-2 pl-3 pr-1.5 py-1.5 rounded-full cursor-pointer text-xs shrink-0 transition-all ${pedidoAtualId === pedido.id ? 'bg-orange-500 text-white shadow-sm' : 'bg-card hover:bg-muted border border-border'}`}
                  onClick={() => switchPedido(pedido)}
                >
                  <span className="font-medium truncate max-w-[140px]">
                    {pedido.selectedCliente?.nome || `Pedido ${idx + 1}`}
                  </span>
                  <span className={`text-[10px] ${pedidoAtualId === pedido.id ? 'bg-white/20' : 'bg-muted'} rounded-full px-1.5 py-0.5 font-semibold`}>
                    {pedido.cart?.length || 0}
                  </span>
                  <button
                    onClick={(e) => { e.stopPropagation(); removerPedidoTab(pedido.id); }}
                    className="opacity-60 hover:opacity-100 w-5 h-5 flex items-center justify-center rounded-full hover:bg-black/10"
                  >
                    <X className="w-3 h-3" />
                  </button>
                </div>
              ))}
            </div>
            <Button size="sm" variant="outline" className="shrink-0 h-8 gap-1 border-dashed" onClick={() => novoPedidoTab()}>
              <Plus className="w-3.5 h-3.5" /> Nova aba
            </Button>
          </div>
        )}

        <div className="flex-1 overflow-hidden flex flex-col lg:flex-row">
          {/* COLUNA HISTÓRICO DO CLIENTE - retrátil */}
          {selectedCliente && step === 1 && cartStep === 1 && !pedidoParaEditar && historicoCollapsed && (
            <div className="hidden xl:flex w-10 border-r bg-muted/20 flex-col items-center pt-3 shrink-0">
              <button
                onClick={() => setHistoricoCollapsed(false)}
                title="Expandir histórico"
                className={`relative w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
                  clienteHistorico.length > 0
                    ? 'bg-orange-500 text-white shadow-md hover:bg-orange-600 animate-pulse'
                    : 'hover:bg-orange-500/10 text-orange-500'
                }`}
              >
                <ChevronRight className="w-4 h-4" />
                {clienteHistorico.length > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-green-400 ring-2 ring-background" />
                )}
              </button>
              <div className="mt-2 flex flex-col items-center gap-1 [writing-mode:vertical-rl] rotate-180 text-[10px] text-muted-foreground font-semibold uppercase tracking-wider">
                <Clock className="w-3 h-3 mb-1 rotate-180" />
                Histórico
              </div>
            </div>
          )}
          {selectedCliente && step === 1 && cartStep === 1 && !pedidoParaEditar && !historicoCollapsed && (
            <div className="hidden xl:flex w-56 2xl:w-64 border-r bg-muted/20 flex-col flex-shrink-0">
              <div className="p-3 border-b bg-card flex items-center justify-between gap-2">
                <h3 className="font-semibold flex items-center gap-2 text-sm min-w-0 flex-1">
                  <Clock className="w-4 h-4 text-orange-500 shrink-0" />
                  <span className="truncate">Histórico de {selectedCliente.nome?.split(' ')[0]}</span>
                </h3>
                <button onClick={() => setHistoricoCollapsed(true)} title="Recolher" className="p-1 rounded hover:bg-muted shrink-0">
                  <ChevronLeft className="w-4 h-4 text-muted-foreground" />
                </button>
              </div>
              
              <div className="flex-1 overflow-y-auto p-2 space-y-3">
                {loadingHistorico ? (
                  <div className="flex items-center justify-center py-8">
                    <RefreshCw className="w-5 h-5 animate-spin text-orange-500" />
                  </div>
                ) : clienteHistorico.length === 0 ? (
                  <div className="text-center text-muted-foreground py-8 text-sm">
                    <FileText className="w-8 h-8 mx-auto mb-2 opacity-50" />
                    <p>Nenhum pedido anterior</p>
                  </div>
                ) : (
                  clienteHistorico.slice(0, 3).map((pedido) => (
                    <div key={pedido.id} className="bg-card border rounded-lg p-2 space-y-2">
                      {/* Header com data e valor */}
                      <div className="flex items-center justify-between px-1">
                        <div className="flex items-center gap-1 text-xs">
                          <Calendar className="w-3 h-3 text-muted-foreground" />
                          <span className="text-muted-foreground">
                            {new Date(pedido.created_at).toLocaleDateString('pt-BR')}
                          </span>
                        </div>
                        <span className="text-orange-600 font-bold text-sm">
                          R$ {(pedido.total || 0).toFixed(2).replace(".", ",")}
                        </span>
                      </div>
                      
                      {/* Endereço */}
                      {pedido.endereco_rua && (
                        <div className="flex items-start gap-1 text-xs text-muted-foreground px-1">
                          <MapPin className="w-3 h-3 mt-0.5 flex-shrink-0" />
                          <span className="line-clamp-1">
                            {pedido.endereco_rua}{pedido.endereco_numero ? `, ${pedido.endereco_numero}` : ''}
                            {pedido.endereco_bairro ? ` - ${pedido.endereco_bairro}` : ''}
                          </span>
                        </div>
                      )}
                      
                      {/* Itens com detalhes de personalização */}
                      <div className="pt-1 border-t space-y-1.5">
                        {pedido.items?.slice(0, 4).map((item, idx) => (
                          <div key={idx} className="bg-muted/50 rounded-lg p-1.5">
                            <div className="flex items-center gap-2">
                              {/* Mini foto */}
                              <div className="w-8 h-8 rounded overflow-hidden bg-muted flex-shrink-0">
                                {item.foto_url || item.photo_url ? (
                                  <img 
                                    src={getImageUrl(item.foto_url || item.photo_url)} 
                                    alt={item.nome || item.name}
                                    className="w-full h-full object-cover"
                                    loading="lazy"
                                    decoding="async"
                                  />
                                ) : (
                                  <div className="w-full h-full flex items-center justify-center">
                                    <Package className="w-4 h-4 text-muted-foreground" />
                                  </div>
                                )}
                              </div>
                              {/* Info do item */}
                              <div className="flex-1 min-w-0">
                                <p className="text-xs font-medium truncate">
                                  {qtdDoItem(item.quantidade || item.qty || 1, medidaDoItem(item, allProductsForPhotos.length ? allProductsForPhotos : products))} {item.nome || item.name}
                                </p>
                                {item.combo_type && (
                                  <span className="text-[9px] text-orange-500">({item.combo_type === 'combo' ? 'Combo' : 'Simples'})</span>
                                )}
                              </div>
                              <span className="text-xs font-semibold text-orange-600">
                                R$ {((item.preco || 0) * (item.quantidade || 1)).toFixed(2).replace(".", ",")}
                              </span>
                            </div>
                            {/* Subitems/Personalizações */}
                            {item.subitems && item.subitems.length > 0 && (
                              <div className="mt-1 pl-10 space-y-0.5">
                                {item.subitems.slice(0, 3).map((sub, subIdx) => (
                                  <p key={subIdx} className="text-[9px] text-muted-foreground flex items-center gap-0.5">
                                    <span className="text-orange-400">•</span>
                                    {sub.step_name && <span className="opacity-70">{sub.step_name}:</span>}
                                    <span className="truncate">{sub.nome || sub.name}</span>
                                  </p>
                                ))}
                                {item.subitems.length > 3 && (
                                  <p className="text-[9px] text-muted-foreground">+{item.subitems.length - 3} mais...</p>
                                )}
                              </div>
                            )}
                            {/* Etapas (formato alternativo) */}
                            {(!item.subitems || item.subitems.length === 0) && item.etapas && item.etapas.length > 0 && (
                              <div className="mt-1 pl-10 space-y-0.5">
                                {item.etapas.slice(0, 3).map((etapa, etapaIdx) => (
                                  <div key={etapaIdx} className="space-y-0.5">
                                    {etapa.itens && etapa.itens.length > 0 && etapa.itens.slice(0, 2).map((itemEtapa, itemIdx) => {
                                      const itemNome = typeof itemEtapa === 'string' ? itemEtapa : (itemEtapa.nome || itemEtapa.name || '');
                                      return (
                                        <p key={itemIdx} className="text-[9px] text-muted-foreground">
                                          <span className="text-orange-400">-></span> <span className="truncate">{itemNome}</span>
                                        </p>
                                      );
                                    })}
                                    {etapa.itens && etapa.itens.length > 2 && (
                                      <p className="text-[9px] text-muted-foreground">... +{etapa.itens.length - 2} mais</p>
                                    )}
                                  </div>
                                ))}
                                {item.etapas.length > 3 && (
                                  <p className="text-[9px] text-muted-foreground">+{item.etapas.length - 3} mais...</p>
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      {pedido.items?.length > 4 && (
                        <p className="text-xs text-muted-foreground text-center">
                          +{pedido.items?.length - 4} item(s)
                        </p>
                      )}
                      
                      {/* Botão Repetir Pedido */}
                      <button
                        onClick={() => repetirPedido(pedido)}
                        className="w-full mt-2 py-1.5 px-2 bg-orange-500 hover:bg-orange-600 text-white text-xs font-medium rounded-lg flex items-center justify-center gap-1 transition-colors"
                      >
                        <RefreshCw className="w-3 h-3" />
                        Repetir Pedido
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}

          {/* COLUNA CENTRAL - Conteúdo Principal */}
          <div className="flex-1 overflow-y-auto p-2 sm:p-3 md:p-4 bg-muted/30 dark:bg-zinc-900">
            {/* PRODUTOS - apenas etapa 1 */}
            {cartStep === 1 && (
              <div className="space-y-4">
                {/* Busca e categorias */}
                <div className="space-y-2">
                  <div className="relative">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                    <Input
                      type="text"
                      placeholder="Buscar produto..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="h-9 pl-9 text-sm bg-card dark:bg-zinc-800 border-border dark:border-zinc-700 text-foreground dark:text-white placeholder:text-muted-foreground"
                    />
                  </div>
                  <div className="flex gap-1.5 overflow-x-auto pb-1 scrollbar-hide">
                    <button
                      onClick={() => setSelectedCategory(null)}
                      className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all flex-shrink-0 ${
                        !selectedCategory ? 'bg-orange-500 text-white' : 'bg-card dark:bg-zinc-800 text-foreground dark:text-zinc-300 border border-border dark:border-zinc-700 hover:border-foreground/30 dark:hover:border-zinc-500'
                      }`}
                    >
                      Todos
                    </button>
                    {categoriesWithProducts.map(cat => (
                      <button
                        key={cat.id}
                        onClick={() => setSelectedCategory(selectedCategory === cat.name ? null : cat.name)}
                        className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all flex-shrink-0 ${
                          selectedCategory === cat.name ? 'bg-orange-500 text-white' : 'bg-card dark:bg-zinc-800 text-foreground dark:text-zinc-300 border border-border dark:border-zinc-700 hover:border-foreground/30 dark:hover:border-zinc-500'
                        }`}
                      >
                        {cat.name}
                      </button>
                    ))}
                  </div>
                </div>
                
                {/* Loading state */}
                {loadingProducts ? (
                  // Carregamento com cards (25/10/2026): a grade de produtos com foto piscando
                  <CarregandoGrade quantos={12} comImagem className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-[repeat(auto-fill,minmax(170px,1fr))]" />
                ) : products.length === 0 ? (
                  /* Lista totalmente vazia: provavelmente cache estourou ou load falhou. Oferece retry. */
                  <div className="text-center py-12 text-muted-foreground">
                    <Package className="w-12 h-12 mx-auto mb-3 opacity-50" />
                    <p className="font-medium mb-1">Não conseguimos carregar os produtos</p>
                    <p className="text-xs mb-4 opacity-70">Verifique sua conexão e tente novamente.</p>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => {
                        // Invalida cache e recarrega tudo
                        productsCache = null;
                        productsCacheTime = null;
                        productsCacheLoading = false;
                        setLoadingProducts(true);
                        Promise.all([fetchProducts(), fetchCategories()]).finally(() => setLoadingProducts(false));
                      }}
                    >
                      <RefreshCw className="w-4 h-4 mr-2" />
                      Recarregar
                    </Button>
                  </div>
                ) : filteredProducts.length === 0 ? (
                  <div className="text-center py-12 text-muted-foreground">
                    <Package className="w-12 h-12 mx-auto mb-2 opacity-50" />
                    <p>Nenhum produto encontrado</p>
                  </div>
                ) : (
                  /* Produtos agrupados por categoria */
                  <div className="space-y-6">
                    {/* Promoções Ativas no Topo - CardapioPopup */}
                    {activePromotions.length > 0 && activePromotions.map(promo => {
                      const promoProds = (promo.products || [])
                        .map(pp => products.find(p => p.id === pp.product_id))
                        .filter(Boolean);
                      if (promoProds.length === 0) return null;
                      return (
                        <div key={promo.id}>
                          <h3 className="font-bold text-sm sm:text-base md:text-lg text-green-500 mb-2 sm:mb-3 pb-1.5 sm:pb-2 border-b flex items-center gap-1.5 sm:gap-2">
                            <span>🔥</span> {promo.name}
                          </h3>
                          {promo.description && <p className="text-xs text-muted-foreground mb-2 -mt-1">{promo.description}</p>}
                          <div className="flex lg:grid gap-3 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0 snap-x snap-mandatory lg:snap-none scrollbar-hide lg:grid-cols-[repeat(auto-fill,minmax(170px,1fr))]">
                            {promoProds.map(product => {
                              const isUnavailable = product.available === false;
                              const promoInfo = getPromoForProduct(product.id, 'simples');
                              const origPrice = product.sale_price || 0;
                              const finalPrice = calcPromoPrice(origPrice, promoInfo);
                              return (
                                <div key={product.id}
                                  className={`bg-card dark:bg-zinc-800 rounded-md overflow-hidden snap-start flex-shrink-0 lg:flex-shrink transition-all cursor-pointer hover:shadow-lg cardapio-item-mobile border-2 border-green-500/50 ${isUnavailable ? 'opacity-60 cursor-not-allowed' : ''}`}
                                  onClick={() => !isUnavailable && openProductPopup(product)}
                                >
                                  <div className="aspect-[3.6/3.9675] relative overflow-hidden bg-gradient-to-b from-orange-900/20 to-orange-800/30">
                                    {product.photo_url ? (
                                      <img src={getImageUrl(product.photo_url)} alt={product.name} className={`w-full h-full object-contain p-0.5 ${isUnavailable ? 'grayscale' : ''}`} loading="lazy" decoding="async" onError={(e) => e.target.style.display = 'none'} />
                                    ) : (
                                      <div className="w-full h-full flex items-center justify-center"><Package className="w-8 h-8 text-zinc-600" /></div>
                                    )}
                                    {isUnavailable && (
                                      <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                                        <span className="bg-red-500 text-white text-[10px] font-bold px-2 py-1 rounded-full">ESGOTADO</span>
                                      </div>
                                    )}
                                  </div>
                                  <div className="p-1.5 lg:p-2">
                                    <h3 className="font-semibold text-white text-[11px] lg:text-xs line-clamp-1 lg:line-clamp-2 leading-tight mb-0.5">{product.name}</h3>
                                    {finalPrice != null && finalPrice !== origPrice ? (
                                      <div className="flex items-center gap-1">
                                        <span className="text-[9px] line-through text-muted-foreground">R$ {origPrice.toFixed(2).replace(".", ",")}</span>
                                        <span className="font-bold text-[11px] lg:text-xs text-green-500">R$ {finalPrice.toFixed(2).replace(".", ",")}</span>
                                      </div>
                                    ) : (
                                      <span className="font-bold text-[11px] lg:text-xs text-orange-500">R$ {origPrice.toFixed(2).replace(".", ",")}</span>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                    {categories
                      .filter(cat => !selectedCategory || cat.name === selectedCategory)
                      .map(cat => {
                        const catProducts = filteredProducts.filter(p => p.category === cat.name);
                        if (catProducts.length === 0) return null;
                        return (
                          <div key={cat.id}>
                            <div className="flex items-center justify-between mb-3">
                              <h2 className="text-base lg:text-lg font-bold text-orange-500 uppercase">{cat.name}</h2>
                              <span className="text-xs text-muted-foreground">{catProducts.length} itens</span>
                            </div>
                            <div className="flex lg:grid gap-3 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0 snap-x snap-mandatory lg:snap-none scrollbar-hide lg:grid-cols-[repeat(auto-fill,minmax(170px,1fr))]">
                              {[...catProducts]
                                .sort((a, b) => (a.available === false ? 1 : 0) - (b.available === false ? 1 : 0))
                                .map(product => {
                                const isUnavailable = product.available === false;
                                const isComboType = product.product_type === 'combo';
                                const simplePrice = product.simple_price || 0;
                                const comboPrice = product.sale_price || 0;
                                const promoSimples = getPromoForProduct(product.id, 'simples');
                                const promoCombo = getPromoForProduct(product.id, 'combo');
                                const hasPromo = !isUnavailable && (promoSimples || promoCombo);
                                const simpleFinal = calcPromoPrice(isComboType ? simplePrice : comboPrice, promoSimples);
                                const comboFinal = calcPromoPrice(comboPrice, promoCombo);
                                const showBothPrices = isComboType && simplePrice > 0 && comboPrice > 0 && simplePrice !== comboPrice;
                                const lowestPromo = [promoSimples, promoCombo].filter(Boolean)[0];
                                return (
                                  <div
                                    key={product.id}
                                    onClick={() => !isUnavailable && openProductPopup(product)}
                                    className={`relative group bg-card rounded-xl overflow-hidden snap-start flex-shrink-0 w-[160px] lg:w-auto flex flex-col transition-all cursor-pointer border ${
                                      isUnavailable
                                        ? 'opacity-60 cursor-not-allowed border-border'
                                        : hasPromo
                                          ? 'border-green-500/60 shadow-[0_0_0_1px_rgba(34,197,94,0.3)] hover:shadow-lg'
                                          : 'border-border hover:border-orange-500/40 hover:shadow-md'
                                    }`}
                                  >
                                    <div className="aspect-square relative overflow-hidden bg-muted">
                                      {product.photo_url ? (
                                        <img
                                          src={getImageUrl(product.photo_url)}
                                          alt={product.name}
                                          className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 ${isUnavailable ? 'grayscale' : ''}`}
                                          loading="lazy"
                                          decoding="async"
                                          onError={(e) => e.target.style.display = 'none'}
                                        />
                                      ) : (
                                        <div className="w-full h-full flex items-center justify-center text-muted-foreground/40">
                                          <Package className="w-10 h-10" />
                                        </div>
                                      )}
                                      {isUnavailable && (
                                        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                                          <span className="bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full">ESGOTADO</span>
                                        </div>
                                      )}
                                      {lowestPromo && lowestPromo.value != null && !isUnavailable && (
                                        <div className="absolute top-1.5 left-1.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-extrabold text-[10px] px-2 py-0.5 rounded-md shadow-sm">
                                          {lowestPromo.type === 'percentage'
                                            ? `-${Math.round(lowestPromo.value)}%`
                                            : `- R$ ${Number(lowestPromo.value).toFixed(2).replace('.', ',')}`}
                                        </div>
                                      )}
                                      {isComboType && !isUnavailable && (
                                        <div className="absolute top-1.5 right-1.5 bg-orange-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-md shadow-sm tracking-wider">
                                          COMBO
                                        </div>
                                      )}
                                    </div>
                                    <div className="p-2.5 flex flex-col flex-1">
                                      <h3 className="font-semibold text-foreground text-sm leading-tight line-clamp-2 mb-0.5">
                                        {product.name}
                                      </h3>
                                      {product.description && (
                                        <p className="text-muted-foreground text-[11px] line-clamp-2 mb-2 leading-snug">
                                          {product.description}
                                        </p>
                                      )}
                                      <div className="mt-auto pt-1.5 border-t border-border/50 space-y-0.5">
                                        {showBothPrices ? (
                                          <>
                                            <div className="flex items-center justify-between gap-1">
                                              <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-semibold">Simples</span>
                                              {simpleFinal != null && simpleFinal !== simplePrice && !isUnavailable ? (
                                                <span className="flex items-center gap-1">
                                                  <span className="text-[9px] line-through text-muted-foreground/70">R$ {simplePrice.toFixed(2).replace(".", ",")}</span>
                                                  <span className="font-bold text-sm text-green-600 dark:text-green-500">R$ {simpleFinal.toFixed(2).replace(".", ",")}</span>
                                                </span>
                                              ) : (
                                                <span className={`font-bold text-sm ${isUnavailable ? 'text-muted-foreground line-through' : 'text-foreground'}`}>R$ {simplePrice.toFixed(2).replace(".", ",")}</span>
                                              )}
                                            </div>
                                            <div className="flex items-center justify-between gap-1">
                                              <span className="text-[10px] text-orange-500 uppercase tracking-wider font-bold">Combo</span>
                                              {comboFinal != null && comboFinal !== comboPrice && !isUnavailable ? (
                                                <span className="flex items-center gap-1">
                                                  <span className="text-[9px] line-through text-muted-foreground/70">R$ {comboPrice.toFixed(2).replace(".", ",")}</span>
                                                  <span className="font-bold text-sm text-green-600 dark:text-green-500">R$ {comboFinal.toFixed(2).replace(".", ",")}</span>
                                                </span>
                                              ) : (
                                                <span className={`font-bold text-sm ${isUnavailable ? 'text-muted-foreground line-through' : 'text-orange-500'}`}>R$ {comboPrice.toFixed(2).replace(".", ",")}</span>
                                              )}
                                            </div>
                                          </>
                                        ) : (
                                          (() => {
                                            const op = comboPrice;
                                            const fp = simpleFinal;
                                            return fp != null && fp !== op && !isUnavailable ? (
                                              <div className="flex items-baseline justify-between">
                                                <span className="text-[10px] line-through text-muted-foreground/70">R$ {op.toFixed(2).replace(".", ",")}</span>
                                                <span className="font-bold text-base text-green-600 dark:text-green-500">R$ {fp.toFixed(2).replace(".", ",")}</span>
                                              </div>
                                            ) : (
                                              <span className={`block text-right font-bold text-base ${isUnavailable ? 'text-muted-foreground line-through' : 'text-orange-500'}`}>R$ {op.toFixed(2).replace(".", ",")}</span>
                                            );
                                          })()
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    
                    {/* Produtos sem categoria */}
                    {(() => {
                      const uncategorized = filteredProducts.filter(p => !p.category || !categories.find(c => c.name === p.category));
                      if (uncategorized.length === 0 || selectedCategory) return null;
                      return (
                        <div>
                          <div className="flex items-center justify-between mb-3">
                            <h2 className="text-base lg:text-lg font-bold text-muted-foreground uppercase">Outros</h2>
                            <span className="text-xs text-muted-foreground">{uncategorized.length} itens</span>
                          </div>
                          <div className="flex lg:grid gap-3 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0 snap-x snap-mandatory lg:snap-none scrollbar-hide lg:grid-cols-[repeat(auto-fill,minmax(170px,1fr))]">
                            {uncategorized.map(product => {
                              const isUnavailable = product.available === false;
                              return (
                                <div
                                  key={product.id}
                                  onClick={() => !isUnavailable && openProductPopup(product)}
                                  className={`relative group bg-card rounded-xl overflow-hidden snap-start flex-shrink-0 w-[160px] lg:w-auto flex flex-col transition-all cursor-pointer border ${
                                    isUnavailable ? 'opacity-60 cursor-not-allowed border-border' : 'border-border hover:border-orange-500/40 hover:shadow-md'
                                  }`}
                                >
                                  <div className="aspect-square relative overflow-hidden bg-muted">
                                    {product.photo_url ? (
                                      <img src={getImageUrl(product.photo_url)} alt={product.name} className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 ${isUnavailable ? 'grayscale' : ''}`} loading="lazy" decoding="async" onError={(e) => e.target.style.display = 'none'} />
                                    ) : (
                                      <div className="w-full h-full flex items-center justify-center text-muted-foreground/40"><Package className="w-10 h-10" /></div>
                                    )}
                                    {isUnavailable && (
                                      <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                                        <span className="bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full">ESGOTADO</span>
                                      </div>
                                    )}
                                  </div>
                                  <div className="p-2.5 flex flex-col flex-1">
                                    <h3 className="font-semibold text-foreground text-sm leading-tight line-clamp-2 mb-0.5">{product.name}</h3>
                                    {product.description && (
                                      <p className="text-muted-foreground text-[11px] line-clamp-2 mb-2 leading-snug">{product.description}</p>
                                    )}
                                    <div className="mt-auto pt-1.5 border-t border-border/50">
                                      {(() => {
                                        const pi = getPromoForProduct(product.id, 'simples');
                                        const op = product.sale_price || 0;
                                        const fp = calcPromoPrice(op, pi);
                                        const unitSuffix = (product.sale_unit && product.sale_unit !== "un")
                                          ? <span className="text-[10px] font-normal text-muted-foreground ml-0.5">/{product.sale_unit}</span>
                                          : null;
                                        return fp != null && fp !== op && !isUnavailable ? (
                                          <div className="flex items-baseline justify-between">
                                            <span className="text-[10px] line-through text-muted-foreground/70">R$ {op.toFixed(2).replace(".", ",")}</span>
                                            <span className="font-bold text-base text-green-600 dark:text-green-500">R$ {fp.toFixed(2).replace(".", ",")}{unitSuffix}</span>
                                          </div>
                                        ) : (
                                          <span className={`block text-right font-bold text-base ${isUnavailable ? 'text-muted-foreground line-through' : 'text-orange-500'}`}>R$ {op.toFixed(2).replace(".", ",")}{unitSuffix}</span>
                                        );
                                      })()}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
            )}

            {/* ENTREGA — etapa 2 (área principal) */}
            {cartStep === 2 && cart.length > 0 && (
              <div className="max-w-3xl mx-auto space-y-6">
                {/* Header com icone em destaque */}
                <div className="flex items-start gap-3">
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center shadow-md shrink-0">
                    <Bike className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold tracking-tight text-foreground">Entrega</h2>
                    <p className="text-sm text-muted-foreground">Como o cliente vai receber o pedido</p>
                    <p className="mt-1 text-xs text-muted-foreground flex flex-wrap items-center gap-x-2 gap-y-1" data-e2e="np-dica-entrega">
                      <span><Tecla>F3</Tecla> Entrega</span><span><Tecla>F4</Tecla> Retirada</span>
                      <span><Tecla>↑ ↓</Tecla> endereço / novo</span><span><Tecla>Enter</Tecla> próximo</span><span><Tecla>Esc</Tecla> volta</span>
                    </p>
                  </div>
                </div>

                {/* Cards de tipo de entrega */}
                <div className="grid grid-cols-2 gap-3 sm:gap-4">
                  <button
                    className={`relative p-5 border-2 rounded-2xl flex flex-col items-center gap-3 transition-all ${
                      tipoEntrega === "delivery"
                        ? "border-orange-500 bg-gradient-to-br from-orange-500/15 to-orange-500/5 shadow-md"
                        : "border-border bg-card hover:border-orange-500/40 hover:bg-orange-500/5"
                    }`}
                    onClick={(e) => { mudarTipoEntrega("delivery"); e.currentTarget.blur(); }}
                  >
                    {tipoEntrega === "delivery" && (
                      <div className="absolute top-3 right-3 w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center shadow-sm">
                        <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
                      </div>
                    )}
                    <div className={`w-14 h-14 rounded-full flex items-center justify-center transition-colors ${
                      tipoEntrega === "delivery" ? 'bg-orange-500 text-white' : 'bg-orange-500/10 text-orange-500'
                    }`}>
                      <Bike className="w-7 h-7" />
                    </div>
                    <div className="text-center">
                      <p className="font-bold text-base text-foreground">Delivery</p>
                      <p className="text-xs text-muted-foreground mt-0.5">Entrega no endereço</p>
                    </div>
                    {/* Stats inline dentro do card */}
                    <div className="flex flex-col w-full gap-1.5 pt-3 border-t border-border/60">
                      {cardapioStats?.avg_order_time_min != null && (
                        <div className="flex items-center justify-between gap-2 text-xs">
                          <span className="flex items-center gap-1.5 text-muted-foreground">
                            <Clock className="w-3.5 h-3.5 text-blue-500" />
                            Tempo médio
                          </span>
                          <span className="font-bold text-blue-600 dark:text-blue-400">{Math.round(cardapioStats.avg_order_time_min)} min</span>
                        </div>
                      )}
                      {cardapioStats?.delivery_fee_min != null && (
                        <div className="flex items-center justify-between gap-2 text-xs">
                          <span className="flex items-center gap-1.5 text-muted-foreground">
                            <Bike className="w-3.5 h-3.5 text-orange-500" />
                            Taxa
                          </span>
                          <span className="font-bold text-orange-600 dark:text-orange-400">
                            {cardapioStats.delivery_fee_min === cardapioStats.delivery_fee_max
                              ? `R$ ${Number(cardapioStats.delivery_fee_min).toFixed(2).replace('.', ',')}`
                              : `R$ ${Number(cardapioStats.delivery_fee_min).toFixed(2).replace('.', ',')} – R$ ${Number(cardapioStats.delivery_fee_max).toFixed(2).replace('.', ',')}`}
                          </span>
                        </div>
                      )}
                    </div>
                  </button>
                  <button
                    className={`relative p-5 border-2 rounded-2xl flex flex-col items-center gap-3 transition-all ${
                      tipoEntrega === "pickup"
                        ? "border-orange-500 bg-gradient-to-br from-orange-500/15 to-orange-500/5 shadow-md"
                        : "border-border bg-card hover:border-orange-500/40 hover:bg-orange-500/5"
                    }`}
                    onClick={(e) => { mudarTipoEntrega("pickup"); e.currentTarget.blur(); }}
                  >
                    {tipoEntrega === "pickup" && (
                      <div className="absolute top-3 right-3 w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center shadow-sm">
                        <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
                      </div>
                    )}
                    <div className={`w-14 h-14 rounded-full flex items-center justify-center transition-colors ${
                      tipoEntrega === "pickup" ? 'bg-orange-500 text-white' : 'bg-orange-500/10 text-orange-500'
                    }`}>
                      <Store className="w-7 h-7" />
                    </div>
                    <div className="text-center">
                      <p className="font-bold text-base text-foreground">Retirada</p>
                      <p className="text-xs text-muted-foreground mt-0.5">Cliente retira no local</p>
                    </div>
                    {/* Info inline — sem overlap */}
                    <div className="flex flex-col w-full gap-1.5 pt-3 border-t border-border/60">
                      <div className="flex items-center justify-between gap-2 text-xs">
                        <span className="flex items-center gap-1.5 text-muted-foreground">
                          <Check className="w-3.5 h-3.5 text-green-500" />
                          Taxa
                        </span>
                        <span className="font-bold text-green-600 dark:text-green-400">Sem taxa</span>
                      </div>
                      <div className="flex items-center justify-between gap-2 text-xs">
                        <span className="flex items-center gap-1.5 text-muted-foreground">
                          <Store className="w-3.5 h-3.5 text-purple-500" />
                          Retirar em
                        </span>
                        <span className="font-bold text-foreground">Balcão</span>
                      </div>
                    </div>
                  </button>
                </div>

                {tipoEntrega === "delivery" && !showNewAddressForm && (() => {
                  const { lista: enderecosOrdenados, lastUsedMap, firstUsedKey } = enderecosEmOrdem;
                  return (
                    <div className="space-y-3">
                      <div className="flex items-center gap-2">
                        <MapPin className="w-4 h-4 text-orange-500" />
                        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Endereços salvos</p>
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {enderecosOrdenados.map((end) => {
                          const isSelected = endereco.rua === end.rua && endereco.numero === end.numero;
                          const key = `${(end.rua || '').trim().toLowerCase()}|${(end.numero || '').trim()}`;
                          const isMostRecent = firstUsedKey && key === firstUsedKey && lastUsedMap[key];
                          return (
                            <button
                              key={end.id}
                              type="button"
                              // Tira o foco: o Enter segue a regra da tela (Próximo), não "clica" de novo
                              onClick={(e) => { escolherEndereco(end); e.currentTarget.blur(); }}
                              className={`relative text-left p-4 rounded-xl border-2 transition-all ${
                                isSelected
                                  ? "border-green-500 bg-green-500/10 shadow-sm"
                                  : "border-border bg-card hover:border-green-500/50 hover:bg-green-500/5"
                              }`}
                            >
                              {isMostRecent && (
                                <div
                                  className="absolute -top-1.5 -left-1.5 w-5 h-5 rounded-full bg-orange-500 flex items-center justify-center shadow-md ring-2 ring-background"
                                  title="Usado recentemente"
                                >
                                  <Clock className="w-2.5 h-2.5 text-white" strokeWidth={3} />
                                </div>
                              )}
                              {isSelected && (
                                <div className="absolute top-3 right-3 w-5 h-5 rounded-full bg-green-500 flex items-center justify-center">
                                  <Check className="w-3 h-3 text-white" strokeWidth={3} />
                                </div>
                              )}
                              <div className="flex items-start gap-2.5 pr-6">
                                <MapPin className={`w-4 h-4 shrink-0 mt-0.5 ${isSelected ? 'text-green-500' : 'text-muted-foreground'}`} />
                                <div className="min-w-0 flex-1">
                                  <p className="font-semibold text-sm text-foreground truncate">{end.rua}, {end.numero}</p>
                                  {end.bairro && <p className="text-xs text-muted-foreground mt-0.5 truncate">{end.bairro}</p>}
                                  {end.complemento && <p className="text-xs text-muted-foreground/70 italic truncate">{end.complemento}</p>}
                                </div>
                              </div>
                            </button>
                          );
                        })}
                        <button
                          type="button"
                          onClick={() => { setEndereco({ rua: "", numero: "", bairro: "", complemento: "", referencia: "", cep: "" }); setShowNewAddressForm(true); }}
                          data-e2e="np-novo-endereco"
                          className="p-4 rounded-xl border-2 border-dashed border-border hover:border-orange-500 hover:bg-orange-500/5 text-muted-foreground hover:text-orange-500 transition-all flex items-center justify-center gap-2 text-sm font-medium min-h-[80px]"
                        >
                          <Plus className="w-5 h-5" />
                          Cadastrar novo endereço
                        </button>
                      </div>
                      {/* O que falta no endereço escolhido — mostrado já aqui (30/09/2026) */}
                      {endereco.rua && faltasEndereco.length > 0 && (
                        <div data-e2e="np-endereco-faltas" className="p-3 rounded-xl border-2 border-amber-500/40 bg-amber-500/10 text-sm text-amber-800 dark:text-amber-300">
                          <p className="font-semibold">Falta no endereço: {faltasEndereco.join(" · ")}</p>
                          <p className="text-xs mt-0.5 opacity-80">Cadastre o endereço de novo com o que falta para seguir.</p>
                        </div>
                      )}
                    </div>
                  );
                })()}

                {tipoEntrega === "delivery" && showNewAddressForm && (
                  <FormNovoEndereco
                    endereco={endereco}
                    setEndereco={setEndereco}
                    bairros={bairros}
                    taxaEntrega={taxaEntrega}
                    setTaxaEntrega={setTaxaEntrega}
                    onFechar={() => setShowNewAddressForm(false)}
                    onConcluir={avancarEtapa}
                  />
                )}
              </div>
            )}

            {/* PAGAMENTO — etapa 3 (área principal) */}
            {cartStep === 3 && cart.length > 0 && (
              <div className="max-w-3xl mx-auto space-y-6">
                {/* Header com icone em destaque */}
                <div className="flex items-start gap-3">
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center shadow-md shrink-0">
                    <CreditCard className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold tracking-tight text-foreground">Pagamento</h2>
                    <p className="text-sm text-muted-foreground">
                      {tipoEntrega === "pickup" ? "Opcional para retirada — preencha se desejar" : "Como o cliente vai pagar"}
                      {teclasNP.formaAcesa !== null && (
                        <span className="block mt-1 text-xs flex flex-wrap items-center gap-x-2 gap-y-1" data-e2e="np-dica-pagamento">
                          <span><Tecla>Tab</Tecla> ou <Tecla>← →</Tecla> alterna</span><span><Tecla>Enter</Tecla> escolhe</span><span><Tecla>Enter</Tecla> de novo cria o pedido</span>
                        </span>
                      )}
                    </p>
                  </div>
                </div>

                {/* Barra de acoes rapidas — Ja pago / Dividir */}
                {tipoEntrega !== "pickup" && (
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => setJaPago(!jaPago)}
                      className={`flex items-center gap-2 px-3 py-2 rounded-full border-2 text-xs font-semibold transition-all ${
                        jaPago
                          ? 'border-green-500 bg-green-500/15 text-green-600 dark:text-green-400 shadow-sm'
                          : 'border-border bg-card text-muted-foreground hover:border-green-500/50'
                      }`}
                    >
                      {jaPago ? <ToggleRight className="w-4 h-4" /> : <ToggleLeft className="w-4 h-4" />}
                      {jaPago ? 'Já pago' : 'Marcar como já pago'}
                    </button>
                    <button
                      onClick={cpToggleSplit}
                      className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-xs font-semibold border-2 transition-all ${
                        cpSplitPayment
                          ? 'border-purple-500 bg-purple-500/15 text-purple-600 dark:text-purple-400 shadow-sm'
                          : 'border-border bg-card text-muted-foreground hover:border-purple-500/50'
                      }`}
                    >
                      <Layers className="w-4 h-4" /> Dividir pagamento
                    </button>
                  </div>
                )}

                {/* Card 'Pagar na Retirada' — visual no-op, ja vem 'selecionado' pra preencher
                    o espaco vazio do form quando o pedido e de retirada (sem forma online configurada). */}
                {tipoEntrega === "pickup" && !cpSplitPayment && (
                  <div className="p-4 border-2 rounded-2xl flex items-center gap-3 border-orange-500 bg-gradient-to-br from-orange-500/15 to-orange-500/5 shadow-md relative">
                    <div className="absolute top-2 right-2 w-5 h-5 rounded-full bg-orange-500 flex items-center justify-center shadow-sm">
                      <Check className="w-3 h-3 text-white" strokeWidth={3} />
                    </div>
                    <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0 bg-orange-500/15 text-orange-600 dark:text-orange-400">
                      <Store className="w-5 h-5" />
                    </div>
                    <div className="flex-1 min-w-0 pr-6">
                      <p className="text-sm font-bold text-foreground">Pagar na Retirada</p>
                      <p className="text-[11px] text-muted-foreground">Cliente paga ao buscar o pedido no balcão</p>
                    </div>
                  </div>
                )}

                {/* Grade de formas de pagamento */}
                {!cpSplitPayment && (
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                    {formasPagamentoVisiveis.map((fp, fpIdx) => {
                      const fpId = fp.code || fp.id;
                      const isOnline = fpId === 'pix_online' || fpId === 'cartao_online';
                      const slug = String(fpId || fp.label || '').toLowerCase();
                      const isDinheiro = slug.includes('dinheiro') || slug.includes('cash');
                      const isPix = slug.includes('pix');
                      const isCartao = slug.includes('credit') || slug.includes('cartao') || slug.includes('cart') || slug.includes('debit');
                      const isMarketplace = slug.includes('market');
                      const Icon = isDinheiro ? Banknote : isPix ? DollarSign : isCartao ? CreditCard : isMarketplace ? ShoppingBag : Banknote;
                      const iconTint = isDinheiro ? 'green' : isPix ? 'yellow' : isCartao ? 'blue' : isMarketplace ? 'purple' : 'orange';
                      const tintClasses = {
                        green: 'bg-green-500/10 text-green-600 dark:text-green-400',
                        yellow: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
                        blue: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
                        purple: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
                        orange: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
                      }[iconTint];
                      const selected = formaPagamento === fpId;
                      return (
                        <button
                          key={fpId}
                          data-e2e="np-forma" data-acesa={teclasNP.formaAcesa === fpIdx ? "1" : "0"}
                          className={`relative p-4 border-2 rounded-2xl flex items-center gap-3 transition-all text-left ${teclasNP.formaAcesa === fpIdx ? "ring-4 ring-orange-500/40 " : ""}${
                            selected
                              ? 'border-orange-500 bg-gradient-to-br from-orange-500/15 to-orange-500/5 shadow-md'
                              : 'border-border bg-card hover:border-orange-500/40 hover:bg-orange-500/5'
                          }`}
                          // Tira o foco: o Enter segue a regra da tela (cria o pedido), 30/09/2026
                          onClick={(e) => { setFormaPagamento(fpId); e.currentTarget.blur(); }}
                        >
                          {selected && (
                            <div className="absolute top-2 right-2 w-5 h-5 rounded-full bg-orange-500 flex items-center justify-center shadow-sm">
                              <Check className="w-3 h-3 text-white" strokeWidth={3} />
                            </div>
                          )}
                          <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${tintClasses}`}>
                            <Icon className="w-5 h-5" />
                          </div>
                          <div className="flex-1 min-w-0 pr-5">
                            <p className="text-sm font-bold text-foreground truncate">{fp.label}</p>
                            {isOnline && (
                              <span className="inline-block mt-0.5 text-[9px] font-bold tracking-wider px-1.5 py-0.5 rounded bg-blue-500/15 text-blue-600 dark:text-blue-400">
                                ONLINE
                              </span>
                            )}
                          </div>
                        </button>
                      );
                    })}
                  </div>
                )}

                {/* Troco — aparece para dinheiro nao pago */}
                {!cpSplitPayment && (String(formaPagamento || '').toLowerCase().includes('dinheiro') ||
                  String((paymentMethodsDelivery.find(m => (m.code || m.id) === formaPagamento) || {}).label || '').toLowerCase().includes('dinheiro')) && !jaPago && (
                  <div className="p-4 bg-amber-500/10 rounded-2xl border-2 border-amber-500/30 space-y-3">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-lg bg-amber-500/20 flex items-center justify-center">
                        <Banknote className="w-4 h-4 text-amber-600 dark:text-amber-400" />
                      </div>
                      <div>
                        <p className="text-sm font-bold text-amber-700 dark:text-amber-300">Precisa de troco?</p>
                        <p className="text-[11px] text-muted-foreground">Selecione o valor que o cliente vai pagar</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-5 gap-1.5">
                      {[20, 50, 100, 150, 200].map((valor) => (
                        <button key={valor} type="button" onClick={() => setTrocoPara(valor.toString())}
                          className={`py-2 rounded-lg border-2 text-xs font-bold transition-all ${
                            trocoPara === valor.toString()
                              ? 'border-amber-500 bg-amber-500 text-white shadow-sm'
                              : 'border-amber-500/30 text-amber-700 dark:text-amber-400 hover:bg-amber-500/10'
                          }`}
                        >R$ {valor}</button>
                      ))}
                    </div>
                    <div className="flex gap-2 items-center">
                      <Input
                        type="text"
                        inputMode="decimal"
                        value={trocoPara}
                        onChange={(e) => setTrocoPara(sanitizeCurrencyInput(e.target.value))}
                        data-enter-avanca="1"
                        placeholder={`Outro valor (Total: R$ ${total.toFixed(2).replace(".", ",")})`}
                        className="flex-1 bg-background"
                      />
                      {trocoPara && (
                        <button onClick={() => setTrocoPara("")} className="text-xs font-semibold text-amber-700 dark:text-amber-400 hover:underline">Limpar</button>
                      )}
                    </div>
                    {trocoErrado && (
                      <p data-e2e="np-troco-menor" className="text-xs font-semibold text-red-600 dark:text-red-400">
                        Menor que o total (R$ {total.toFixed(2).replace(".", ",")}): o troco precisa ser para um valor maior.
                      </p>
                    )}
                    {trocoPara && parseFloat(trocoPara) > total && (
                      <div className="flex items-center justify-between p-2 bg-green-500/10 rounded-lg border border-green-500/30">
                        <span className="text-xs font-medium text-green-700 dark:text-green-400">Troco para o cliente</span>
                        <span className="text-base font-bold text-green-700 dark:text-green-400">R$ {(parseFloat(trocoPara) - total).toFixed(2).replace(".", ",")}</span>
                      </div>
                    )}
                  </div>
                )}

                {/* Split payment */}
                {cpSplitPayment && (
                  <div className="p-4 bg-purple-500/5 rounded-2xl border-2 border-purple-500/20 space-y-3">
                    <div className="flex items-center justify-between text-xs">
                      <span className="text-muted-foreground">
                        Adicionado: <strong className="text-foreground">R$ {cpSplitTotal.toFixed(2).replace(".", ",")}</strong> de <strong className="text-foreground">R$ {total.toFixed(2).replace(".", ",")}</strong>
                      </span>
                      <span className={`font-bold ${cpSplitRemaining > 0.01 ? "text-amber-600 dark:text-amber-400" : "text-green-600 dark:text-green-400"}`}>
                        {cpSplitRemaining > 0.01 ? `Falta R$ ${cpSplitRemaining.toFixed(2).replace(".", ",")}` : '✓ Completo'}
                      </span>
                    </div>
                    <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                      <div className={`h-2 rounded-full transition-all ${cpSplitComplete ? 'bg-green-500' : 'bg-purple-500'}`} style={{ width: `${Math.min(100, (cpSplitTotal / total) * 100)}%` }} />
                    </div>
                    <div className="space-y-2">
                      {cpSplitPayments.map((sp, idx) => (
                        <div key={idx} className="flex items-center justify-between p-3 bg-card rounded-lg border border-border text-sm">
                          <div className="flex items-center gap-2.5">
                            <div className="w-8 h-8 rounded-lg bg-purple-500/15 flex items-center justify-center">
                              <CreditCard className="w-4 h-4 text-purple-600 dark:text-purple-400" />
                            </div>
                            <span className="font-semibold">{sp.label}</span>
                          </div>
                          <div className="flex items-center gap-3">
                            <span className="font-bold text-foreground">R$ {sp.amount.toFixed(2).replace(".", ",")}</span>
                            <button onClick={() => cpRemoveSplitPayment(idx)} className="text-red-500 hover:text-red-600" title="Remover"><X className="w-4 h-4" /></button>
                          </div>
                        </div>
                      ))}
                      {!cpSplitComplete && (
                        <button onClick={cpOpenSplitModal} className="w-full p-3 border-2 border-dashed border-purple-500/40 rounded-lg text-purple-600 dark:text-purple-400 hover:bg-purple-500/10 flex items-center justify-center gap-2 text-sm font-semibold">
                          <Plus className="w-4 h-4" /> Adicionar pagamento
                        </button>
                      )}
                    </div>
                  </div>
                )}

                {/* Observação geral do pedido (30/09/2026) — vai em `observacao` do pedido */}
                <div className="space-y-1.5">
                  <Label htmlFor="np-observacao" className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Observação do pedido</Label>
                  <Textarea
                    id="np-observacao"
                    data-e2e="np-observacao"
                    value={observacao}
                    onChange={(e) => setObservacao(e.target.value)}
                    placeholder="Ex.: portão azul, interfone quebrado, entregar na portaria..."
                    rows={2}
                    className="resize-none bg-card"
                  />
                </div>
              </div>
            )}
          </div>

          {/* Carrinho lateral — estilo Mesas. Mais larga desde que o Novo Pedido
              virou página inteira (23/09/2026). */}
           <div className="hidden lg:flex w-72 xl:w-80 2xl:w-96 flex-col border-l bg-gradient-to-b from-muted/30 to-muted/10 shrink-0">
            <div className="p-4 border-b bg-card/50">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-orange-500/10 flex items-center justify-center">
                  <ShoppingCart className="w-4 h-4 text-orange-500" />
                </div>
                <h3 className="font-bold text-base tracking-tight">Pedido</h3>
                {cart.length > 0 && (
                  <span className="ml-auto text-[10px] font-semibold bg-orange-500 text-white rounded-full px-2 py-0.5">
                    {contarItens(cart)} {contarItens(cart) === 1 ? 'item' : 'itens'}
                  </span>
                )}
              </div>
            </div>

            {/* Indicador de etapas */}
            {cart.length > 0 && (
              <div className="px-3 pt-3 pb-1 flex items-center gap-1.5 text-[10px] font-semibold uppercase">
                {[
                  { n: 1, label: 'Carrinho' },
                  { n: 2, label: 'Entrega' },
                  { n: 3, label: 'Pagamento' },
                ].map((s, i) => (
                  <div key={s.n} className="flex items-center gap-1.5 flex-1">
                    <div className={`w-5 h-5 rounded-full flex items-center justify-center text-[10px] ${cartStep >= s.n ? 'bg-orange-500 text-white' : 'bg-muted text-muted-foreground'}`}>{s.n}</div>
                    <span className={`flex-1 truncate ${cartStep === s.n ? 'text-orange-500' : 'text-muted-foreground'}`}>{s.label}</span>
                  </div>
                ))}
              </div>
            )}
            <div className="flex-1 overflow-auto p-3 space-y-4">
              <AvisoOfertasCliente ofertasDia={ofertasCliente} cart={cart} className="mb-2" />
              {/* Itens do Pedido (sempre visível na sidebar) */}
              <div>
                <p className="text-[10px] font-semibold text-muted-foreground uppercase tracking-wider mb-2">Itens do Pedido</p>
                {cart.length === 0 ? (
                  <div className="flex flex-col items-center justify-center py-10 text-center gap-3">
                    <div className="w-14 h-14 rounded-full bg-muted/60 flex items-center justify-center">
                      <ShoppingCart className="w-6 h-6 text-muted-foreground/60" />
                    </div>
                    <div className="space-y-0.5">
                      <p className="text-sm font-medium text-muted-foreground">Carrinho vazio</p>
                      <p className="text-xs text-muted-foreground/70">Selecione itens ao lado →</p>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-2">
                    {cart.map((item, index) => {
                      // Agrupa subitems por step_name (mesmo padrão do carrinho do CardapioPublico).
                      // Lookup de foto via product_id em allProductsForPhotos.
                      const allProds = (allProductsForPhotos && allProductsForPhotos.length ? allProductsForPhotos : products) || [];
                      const groupedSteps = (() => {
                        if (!Array.isArray(item.subitems) || item.subitems.length === 0) return [];
                        const grouped = {};
                        const order = [];
                        item.subitems.forEach((si) => {
                          const k = (si.step_name && String(si.step_name).trim()) || "Adicionais";
                          if (grouped[k] === undefined) { grouped[k] = []; order.push(k); }
                          grouped[k].push(si);
                        });
                        return order.map((name) => ({
                          stepName: name,
                          items: grouped[name].map((si, idx) => {
                            const lookup = si.product_id ? allProds.find(p => String(p.id) === String(si.product_id)) : null;
                            return {
                              id: si.product_id || `${name}-${idx}`,
                              name: si.nome || si.name || "",
                              photo_url: si.photo_url || lookup?.photo_url || null,
                              price: si.preco != null ? Number(si.preco) : (si.price != null ? Number(si.price) : null),
                              qty: si.quantidade || si.qty || 1,
                            };
                          }).filter(x => x.name),
                        })).filter(s => s.items.length > 0);
                      })();

                      return (
                        <div key={`${item.id}-${index}`} className="flex flex-col gap-2 p-3 bg-background rounded-lg border">
                          {/* Header horizontal: foto + nome/preço/qty */}
                          <div className="flex items-start gap-2">
                            <div className="w-12 h-12 bg-muted rounded-lg flex-shrink-0 overflow-hidden">
                              {item.photo_url ? (
                                <img src={getImageUrl(item.photo_url)} alt="" className="w-full h-full object-cover" />
                              ) : (
                                <div className="w-full h-full flex items-center justify-center text-base">🍽️</div>
                              )}
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-1 flex-wrap">
                                <p className="font-medium text-sm leading-tight">{item.name}</p>
                                {item.combo_type && (
                                  <span className={`text-[9px] px-1 py-0.5 rounded ${item.combo_type === 'combo' ? 'bg-green-500/20 text-green-700 dark:text-green-400' : 'bg-blue-500/20 text-blue-600 dark:text-blue-400'}`}>
                                    {item.combo_type === 'combo' ? 'COMBO' : 'SIMPLES'}
                                  </span>
                                )}
                              </div>
                              <p className="text-sm text-primary font-bold mt-0.5">
                                R$ {((item.sale_price || 0) * item.quantity).toFixed(2).replace('.', ',')}
                              </p>
                            </div>
                            <div className="flex items-center gap-1 flex-shrink-0">
                              {(item.quantity === 1 && !item.is_divisible) || item.etiqueta_balanca ? (
                                <Button variant="outline" size="icon" className="h-7 w-7 border-red-500/50 text-red-500 hover:bg-red-500/10 hover:text-red-600" onClick={() => { const c=[...cart]; c.splice(index, 1); setCart(c); }}>
                                  <Trash2 className="w-3.5 h-3.5" />
                                </Button>
                              ) : (
                                <Button variant="outline" size="icon" className="h-7 w-7" onClick={() => {
                                  if (item.is_divisible) {
                                    const step = (item.sale_unit === "kg" || item.sale_unit === "L") ? 0.1 : 0.5;
                                    const next = parseFloat((item.quantity - step).toFixed(3));
                                    const c = [...cart];
                                    if (next <= 0) c.splice(index, 1);
                                    else c[index] = { ...c[index], quantity: next };
                                    setCart(c);
                                  } else {
                                    removeFromCart(item.id, index);
                                  }
                                }}>
                                  <Minus className="w-3 h-3" />
                                </Button>
                              )}
                              <span className="min-w-[1.5rem] text-center text-sm">
                                {item.is_divisible ? Number(item.quantity).toFixed(3).replace('.', ',') : item.quantity}
                                {item.sale_unit && item.sale_unit !== "un" && <span className="text-[10px] text-muted-foreground ml-0.5">{item.sale_unit}</span>}
                              </span>
                              {/* Item de etiqueta da balança: o peso é o da etiqueta (o servidor confere). */}
                              {!item.etiqueta_balanca && (<Button variant="outline" size="icon" className="h-7 w-7" onClick={() => {
                                const c=[...cart];
                                if (item.is_divisible) {
                                  const step = (item.sale_unit === "kg" || item.sale_unit === "L") ? 0.1 : 0.5;
                                  c[index] = { ...c[index], quantity: parseFloat((c[index].quantity + step).toFixed(3)) };
                                } else {
                                  c[index] = { ...c[index], quantity: c[index].quantity + 1 };
                                }
                                setCart(c);
                              }}>
                                <Plus className="w-3 h-3" />
                              </Button>)}
                            </div>
                          </div>

                          {/* Observação */}
                          {item.observation && (
                            <p className="text-xs text-orange-500 break-words">📝 {item.observation}</p>
                          )}

                          {/* Subitens agrupados por etapa (Sabores, Borda, Adicionais...) — bordas sem foto não mostram placeholder */}
                          {groupedSteps.length > 0 && (
                            <div className="space-y-2 mt-1">
                              {groupedSteps.map((step, gi) => (
                                <div key={gi}>
                                  <p className="text-[9px] font-semibold text-muted-foreground uppercase tracking-wide mb-1">
                                    {step.stepName}
                                  </p>
                                  <div className="space-y-1">
                                    {step.items.map((si, i) => (
                                      <div key={i} className="flex items-center gap-2">
                                        {si.photo_url && (
                                          <div className="w-7 h-7 rounded-md bg-muted flex-shrink-0 overflow-hidden">
                                            <img
                                              src={getImageUrl(si.photo_url)}
                                              alt=""
                                              className="w-full h-full object-cover"
                                              onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
                                            />
                                          </div>
                                        )}
                                        <div className="flex-1 min-w-0">
                                          <p className="text-[11px] truncate leading-tight">
                                            {si.qty > 1 && <span className="text-muted-foreground mr-0.5">{si.qty}×</span>}
                                            {si.name}
                                          </p>
                                          {si.price != null && si.price > 0 && (
                                            <p className="text-[10px] text-orange-500 font-medium leading-tight">
                                              R$ {si.price.toFixed(2).replace('.', ',')}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Entrega (movido para área principal) */}
              {false && cart.length > 0 && cartStep === 2 && (
                <div>
                  <p className="text-xs font-semibold text-muted-foreground uppercase mb-2">Entrega</p>
                  <div className="grid grid-cols-2 gap-2 mb-3">
                    <button
                      className={`p-2.5 border-2 rounded-lg flex flex-col items-center gap-1 transition-all ${
                        tipoEntrega === "delivery" ? "border-orange-500 bg-orange-500/10" : "border-border"
                      }`}
                      onClick={() => setTipoEntrega("delivery")}
                    >
                      <Bike className="w-5 h-5 text-orange-500" />
                      <span className="text-xs font-medium">Delivery</span>
                    </button>
                    <button
                      className={`p-2.5 border-2 rounded-lg flex flex-col items-center gap-1 transition-all ${
                        tipoEntrega === "pickup" ? "border-orange-500 bg-orange-500/10" : "border-border"
                      }`}
                      onClick={() => setTipoEntrega("pickup")}
                    >
                      <Store className="w-5 h-5 text-orange-500" />
                      <span className="text-xs font-medium">Retirada</span>
                    </button>
                  </div>

                  {tipoEntrega === "delivery" && (
                    <div className="space-y-2">
                      {enderecosSalvos.length > 0 && (
                        <div className="space-y-1.5">
                          <p className="text-[10px] font-medium text-green-600">Endereços salvos:</p>
                          <div className="space-y-1 max-h-28 overflow-y-auto">
                            {enderecosSalvos.map((end) => (
                              <button
                                key={end.id}
                                type="button"
                                onClick={() => {
                                  setEndereco({ rua: end.rua||"", numero: end.numero||"", bairro: end.bairro||"", complemento: end.complemento||"", referencia: end.referencia||"", cep: end.cep||"" });
                                  if (end.taxa_entrega) setTaxaEntrega(parseFloat(end.taxa_entrega));
                                }}
                                className={`w-full text-left p-2 rounded-lg border text-xs transition-all ${
                                  endereco.rua === end.rua && endereco.numero === end.numero ? "border-green-500 bg-green-500/10" : "border-border hover:border-green-300"
                                }`}
                              >
                                <span className="font-medium">{end.rua}, {end.numero}</span>
                                {end.bairro && <span className="text-muted-foreground"> - {end.bairro}</span>}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                      <div className="grid grid-cols-3 gap-1.5">
                        <div className="col-span-2">
                          <Label className="text-[10px]">Rua</Label>
                          <Input value={endereco.rua} onChange={e => setEndereco({...endereco, rua: e.target.value})} className="h-8 text-xs" placeholder="Rua..." />
                        </div>
                        <div>
                          <Label className="text-[10px]">Nº</Label>
                          <Input value={endereco.numero} onChange={e => setEndereco({...endereco, numero: e.target.value})} className="h-8 text-xs" placeholder="Nº" />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-1.5">
                        <div>
                          <Label className="text-[10px]">Bairro</Label>
                          <Input value={endereco.bairro} onChange={e => setEndereco({...endereco, bairro: e.target.value})} className="h-8 text-xs" placeholder="Bairro" />
                        </div>
                        <div>
                          <Label className="text-[10px]">Complemento</Label>
                          <Input value={endereco.complemento} onChange={e => setEndereco({...endereco, complemento: e.target.value})} className="h-8 text-xs" placeholder="Comp." />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-1.5">
                        <div>
                          <Label className="text-[10px]">Referência</Label>
                          <Input value={endereco.referencia} onChange={e => setEndereco({...endereco, referencia: e.target.value})} className="h-8 text-xs" placeholder="Referência" />
                        </div>
                        <div>
                          <Label className="text-[10px]">CEP</Label>
                          <Input value={endereco.cep} onChange={e => setEndereco({...endereco, cep: e.target.value})} className="h-8 text-xs" placeholder="CEP" />
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <Label className="text-[10px] whitespace-nowrap">Taxa entrega (R$):</Label>
                        <Input type="text" inputMode="decimal" value={taxaEntrega} onChange={e => setTaxaEntrega(parseFloat(e.target.value) || 0)} className="h-8 text-xs w-24" placeholder="0.00" />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Pagamento (movido para área principal) */}
              {false && cart.length > 0 && cartStep === 3 && (
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <p className="text-xs font-semibold text-muted-foreground uppercase">
                      Pagamento {tipoEntrega === "pickup" && <span className="normal-case font-normal">(opcional)</span>}
                    </p>
                    {tipoEntrega !== "pickup" && (
                    <button
                      onClick={cpToggleSplit}
                      className={`flex items-center gap-1 px-2 py-1 rounded text-[10px] font-medium border ${
                        cpSplitPayment ? 'border-purple-500 bg-purple-500/10 text-purple-600' : 'border-border text-muted-foreground hover:border-purple-300'
                      }`}
                    >
                      <Layers className="w-3 h-3" /> Dividir
                    </button>
                    )}
                  </div>

                  {tipoEntrega === "pickup" && (
                    <p className="text-[10px] text-muted-foreground mb-2">Cliente pode pagar ao retirar. Selecione apenas se for pagamento online.</p>
                  )}

                  {/* Já pago — só para delivery */}
                  {tipoEntrega !== "pickup" && (
                  <button
                    onClick={() => setJaPago(!jaPago)}
                    className={`w-full flex items-center gap-2 p-2 rounded-lg border-2 transition-all text-xs mb-2 ${
                      jaPago ? 'border-green-500 bg-green-500/10 text-green-700 dark:text-green-400' : 'border-border text-muted-foreground hover:border-green-300'
                    }`}
                  >
                    {jaPago ? <ToggleRight className="w-4 h-4 text-green-500" /> : <ToggleLeft className="w-4 h-4" />}
                    <span className="font-medium">{jaPago ? 'Já pago' : 'Marcar como já pago'}</span>
                    {jaPago && <Check className="w-3.5 h-3.5 ml-auto text-green-500" />}
                  </button>
                  )}

                  {/* Modo simples */}
                  {!cpSplitPayment && (
                    <>
                      <div className="grid grid-cols-2 gap-1.5">
                        {(paymentMethodsDelivery.length > 0 ? paymentMethodsDelivery : [
                          { id: "dinheiro", code: "dinheiro", label: "Dinheiro", icon: Banknote },
                          { id: "pix", code: "pix", label: "PIX", icon: CreditCard },
                          { id: "credito", code: "credito", label: "Crédito", icon: CreditCard },
                          { id: "debito", code: "debito", label: "Débito", icon: CreditCard },
                        ]).filter(fp => {
                          if (tipoEntrega === "pickup") {
                            const fpId = fp.code || fp.id;
                            return fpId === 'pix_online' || fpId === 'cartao_online';
                          }
                          return true;
                        }).map(fp => {
                          const fpId = fp.code || fp.id;
                          const isOnline = fpId === 'pix_online' || fpId === 'cartao_online';
                          return (
                            <button
                              key={fpId}
                              className={`p-2 border-2 rounded-lg flex items-center gap-1.5 transition-all ${
                                formaPagamento === fpId
                                  ? isOnline ? 'border-[hsl(var(--primary))] bg-[hsl(var(--primary)/0.1)]' : 'border-orange-500 bg-orange-500/10'
                                  : 'border-border'
                              }`}
                              onClick={() => setFormaPagamento(fpId)}
                            >
                              <fp.icon className="w-4 h-4 flex-shrink-0" />
                              <span className="text-xs">{fp.label}</span>
                              {isOnline && <span className="text-[8px] font-bold px-1 rounded ml-auto" style={{ backgroundColor: 'hsl(var(--primary) / 0.15)', color: 'hsl(var(--primary))' }}>ONLINE</span>}
                            </button>
                          );
                        })}
                      </div>

                      {(String(formaPagamento || '').toLowerCase().includes('dinheiro') || String((paymentMethodsDelivery.find(m => (m.code || m.id) === formaPagamento) || {}).label || '').toLowerCase().includes('dinheiro')) && !jaPago && (
                        <div className="mt-2 space-y-2 p-2.5 bg-amber-50 dark:bg-amber-950/30 rounded-lg border border-amber-200 dark:border-amber-800">
                          <Label className="text-amber-800 dark:text-amber-300 font-medium flex items-center gap-1.5 text-xs">
                            <Banknote className="w-4 h-4" /> Precisa de troco?
                          </Label>
                          <div className="grid grid-cols-5 gap-1">
                            {[20, 50, 100, 150, 200].map((valor) => (
                              <button key={valor} type="button" onClick={() => setTrocoPara(valor.toString())}
                                className={`p-1.5 rounded border text-[10px] font-medium ${trocoPara === valor.toString() ? 'border-amber-500 bg-amber-500 text-white' : 'border-amber-300 text-amber-700 dark:text-amber-400'}`}
                              >
                                {valor}
                              </button>
                            ))}
                          </div>
                          <div className="flex gap-1.5 items-center">
                            <Input type="text" inputMode="decimal" value={trocoPara} onChange={(e) => setTrocoPara(sanitizeCurrencyInput(e.target.value))} placeholder={`Total: R$ ${total.toFixed(2).replace(".", ",")}`} className="h-8 text-xs bg-white dark:bg-background flex-1" />
                            <button onClick={() => setTrocoPara("")} className="text-[10px] text-amber-700 hover:underline whitespace-nowrap">Limpar</button>
                          </div>
                          {trocoPara && parseFloat(trocoPara) > total && (
                            <p className="text-[10px] text-green-700 dark:text-green-400 font-medium">Troco: R$ {(parseFloat(trocoPara) - total).toFixed(2).replace(".", ",")}</p>
                          )}
                        </div>
                      )}
                    </>
                  )}

                  {/* Modo split */}
                  {cpSplitPayment && (
                    <div className="space-y-2">
                      <div className="space-y-1">
                        <div className="flex justify-between text-[10px]">
                          <span>Adicionado: <strong>R$ {cpSplitTotal.toFixed(2).replace(".", ",")}</strong></span>
                          <span className={cpSplitRemaining > 0.01 ? "text-amber-600 font-medium" : "text-green-600 font-medium"}>
                            {cpSplitRemaining > 0.01 ? `Falta: R$ ${cpSplitRemaining.toFixed(2).replace(".", ",")}` : 'Completo!'}
                          </span>
                        </div>
                        <div className="w-full bg-muted rounded-full h-2">
                          <div className={`h-2 rounded-full transition-all ${cpSplitComplete ? 'bg-green-500' : 'bg-purple-500'}`} style={{ width: `${Math.min(100, (cpSplitTotal / total) * 100)}%` }} />
                        </div>
                      </div>
                      {cpSplitPayments.map((sp, idx) => (
                        <div key={idx} className="flex items-center justify-between p-2 bg-card rounded-lg border text-xs">
                          <div className="flex items-center gap-1.5">
                            <CreditCard className="w-3.5 h-3.5 text-purple-500" />
                            <span className="font-medium">{sp.label}</span>
                          </div>
                          <div className="flex items-center gap-1.5">
                            <span className="font-bold">R$ {sp.amount.toFixed(2).replace(".", ",")}</span>
                            <button onClick={() => cpRemoveSplitPayment(idx)} className="text-red-400 hover:text-red-600"><X className="w-3.5 h-3.5" /></button>
                          </div>
                        </div>
                      ))}
                      {!cpSplitComplete && (
                        <button onClick={cpOpenSplitModal} className="w-full p-2 border-2 border-dashed border-purple-300 dark:border-purple-700 rounded-lg text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-950/30 flex items-center justify-center gap-1.5 text-xs font-medium">
                          <Plus className="w-3.5 h-3.5" /> Adicionar pagamento
                        </button>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Observações (movido para área principal) */}
              {false && cart.length > 0 && cartStep === 3 && (
                <div className="border-t pt-4">
                  <p className="text-xs font-semibold text-muted-foreground uppercase mb-2">Observações</p>
                  <Textarea value={observacao} onChange={(e) => setObservacao(e.target.value)} placeholder="Observações do pedido..." rows={2} className="text-xs resize-none" />
                </div>
              )}
            </div>

            {/* Footer fixo — Total + Botão CRIAR PEDIDO */}
            <div className="p-4 border-t bg-background">
              <div className="flex justify-between items-center mb-1">
                <span className="text-sm text-muted-foreground">Subtotal</span>
                <span className="text-sm">R$ {subtotal.toFixed(2).replace(".", ",")}</span>
              </div>
              {tipoEntrega === "delivery" && taxaEntrega > 0 && (
                <div className="flex justify-between items-center mb-1 text-sm text-muted-foreground">
                  <span>Taxa</span>
                  <span>R$ {taxaEntrega.toFixed(2).replace(".", ",")}</span>
                </div>
              )}
              {/* Linha Desconto/Cupom — entre Subtotal/Taxa e Total (expansao inline) */}
              {discountType === 'none' ? (
                cart.length > 0 && (
                  <>
                    <button
                      onClick={() => setShowDiscountModal(v => !v)}
                      className="w-full flex items-center justify-between text-xs text-orange-600 dark:text-orange-400 hover:bg-orange-500/10 border border-dashed border-orange-500/30 rounded-md py-1.5 px-2 mb-2 transition-colors"
                    >
                      <span className="flex items-center gap-1.5 font-semibold">
                        <Ticket className="w-3.5 h-3.5" /> Aplicar desconto ou cupom
                      </span>
                      {showDiscountModal ? <ChevronDown className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5" />}
                    </button>
                    {showDiscountModal && (
                      <div className="mb-2 bg-muted/40 border border-border rounded-lg p-2.5 space-y-2.5">
                        {!discountModalMode ? (
                          <div className="grid grid-cols-2 gap-2">
                            <button
                              onClick={() => setDiscountModalMode('manual')}
                              className="p-2.5 rounded-lg border-2 border-border bg-card hover:border-orange-500 hover:bg-orange-500/5 flex flex-col items-center gap-1 transition-all"
                            >
                              <Percent className="w-4 h-4 text-orange-500" />
                              <p className="text-[11px] font-bold">Desconto</p>
                              <p className="text-[9px] text-muted-foreground">% ou R$ fixo</p>
                            </button>
                            <button
                              onClick={() => { setDiscountModalMode('coupon'); setCouponError(''); }}
                              className="p-2.5 rounded-lg border-2 border-border bg-card hover:border-orange-500 hover:bg-orange-500/5 flex flex-col items-center gap-1 transition-all"
                            >
                              <Ticket className="w-4 h-4 text-orange-500" />
                              <p className="text-[11px] font-bold">Cupom</p>
                              <p className="text-[9px] text-muted-foreground">código</p>
                            </button>
                          </div>
                        ) : discountModalMode === 'manual' ? (
                          <div className="space-y-3">
                            <div className="flex items-center gap-1.5 text-muted-foreground">
                              <Percent className="w-3 h-3" />
                              <span className="text-[10px] font-semibold uppercase tracking-wider">Ajuste sincronizado</span>
                            </div>
                            <div className="grid grid-cols-2 gap-2.5">
                              {/* Campo % */}
                              <div>
                                <label className="text-[10px] font-semibold text-muted-foreground block mb-1">Percentual</label>
                                <div className={`relative rounded-lg border-2 transition-all ${
                                  Number(draftPercent) > 0 ? 'border-orange-500/60 bg-orange-500/5' : 'border-border bg-background'
                                } focus-within:border-orange-500`}>
                                  <Input
                                    type="text"
                                    inputMode="decimal"
                                    value={draftPercent === 0 ? '' : String(draftPercent).replace('.', ',')}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => {
                                      const raw = sanitizeCurrencyInput(e.target.value);
                                      const pct = Math.max(0, Math.min(100, Number(raw) || 0));
                                      setDraftPercent(pct);
                                      // Sincroniza R$: draftFinalValue agora guarda VALOR DO DESCONTO em R$
                                      const desc = subtotal * (pct / 100);
                                      setDraftFinalValue(desc.toFixed(2));
                                    }}
                                    placeholder="0"
                                    className="h-10 text-base font-bold text-center border-0 shadow-none focus-visible:ring-0 bg-transparent pr-8"
                                  />
                                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-bold text-orange-500 pointer-events-none">%</span>
                                </div>
                              </div>
                              {/* Campo valor do desconto em R$ (não é mais valor final) */}
                              <div>
                                <label className="text-[10px] font-semibold text-muted-foreground block mb-1">Desconto em R$</label>
                                <div className={`relative rounded-lg border-2 transition-all ${
                                  (Number(draftFinalValue) || 0) > 0 ? 'border-orange-500/60 bg-orange-500/5' : 'border-border bg-background'
                                } focus-within:border-orange-500`}>
                                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm font-bold text-muted-foreground pointer-events-none">R$</span>
                                  <Input
                                    type="text"
                                    inputMode="decimal"
                                    value={draftFinalValue}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => {
                                      const raw = sanitizeCurrencyInput(e.target.value);
                                      // Agora o campo é o VALOR DO DESCONTO em R$
                                      const desc = Math.max(0, Math.min(subtotal, Number(raw) || 0));
                                      setDraftFinalValue(raw);
                                      const pct = subtotal > 0 ? Math.max(0, Math.min(100, (desc / subtotal) * 100)) : 0;
                                      setDraftPercent(Number(pct.toFixed(2)));
                                    }}
                                    placeholder="0,00"
                                    className="h-10 text-base font-bold text-center border-0 shadow-none focus-visible:ring-0 bg-transparent pl-10"
                                  />
                                </div>
                              </div>
                            </div>
                            {/* Preview do desconto */}
                            {(() => {
                              const discountCalc = Math.max(0, Math.min(subtotal, Number(draftFinalValue) || 0));
                              if (discountCalc <= 0) {
                                return (
                                  <p className="text-[11px] text-center text-muted-foreground italic">
                                    Informe o desconto em % ou R$
                                  </p>
                                );
                              }
                              const finalV = Math.max(0, subtotal - discountCalc);
                              return (
                                <div className="p-2.5 bg-green-500/10 border border-green-500/30 rounded-lg space-y-1">
                                  <div className="flex items-center justify-between">
                                    <span className="text-xs text-green-700 dark:text-green-400 font-semibold">Desconto total</span>
                                    <span className="text-base font-black text-green-600 dark:text-green-500">− R$ {discountCalc.toFixed(2).replace(".", ",")}</span>
                                  </div>
                                  <div className="flex items-center justify-between text-[11px] text-muted-foreground">
                                    <span>Valor final</span>
                                    <span className="font-mono">R$ {finalV.toFixed(2).replace(".", ",")}</span>
                                  </div>
                                </div>
                              );
                            })()}
                            <div className="flex gap-2 pt-0.5">
                              <Button variant="outline" className="flex-1 h-9" onClick={() => setDiscountModalMode(null)}>
                                Voltar
                              </Button>
                              <Button
                                className="flex-[1.5] h-9 bg-orange-500 hover:bg-orange-600 font-semibold"
                                disabled={!((Number(draftFinalValue) || 0) > 0)}
                                onClick={() => {
                                  const fixedDisc = Math.max(0, Math.min(subtotal, Number(draftFinalValue) || 0));
                                  // Se o usuário usou %, preserva como percent (alerta WhatsApp mostra '%')
                                  if (Number(draftPercent) > 0 && Math.abs((subtotal * (Number(draftPercent) / 100)) - fixedDisc) < 0.01) {
                                    setDiscountType('percent');
                                    setDiscountValue(Number(draftPercent));
                                  } else {
                                    setDiscountType('fixed');
                                    setDiscountValue(fixedDisc);
                                  }
                                  setShowDiscountModal(false);
                                  setDiscountModalMode(null);
                                  toast.success('Desconto aplicado');
                                }}
                              >
                                Aplicar desconto
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <>
                            <Input
                              value={couponCode}
                              onChange={(e) => { setCouponCode(e.target.value.toUpperCase()); setCouponError(''); }}
                              onFocus={(e) => e.target.select()}
                              placeholder="CÓDIGO DO CUPOM"
                              className="h-10 text-sm uppercase tracking-wider font-bold text-center"
                              autoFocus
                            />
                            {couponError && <p className="text-[10px] text-red-500">{couponError}</p>}
                            <div className="flex gap-1.5">
                              <Button variant="outline" size="sm" className="flex-1 h-8 text-[11px]" onClick={() => { setDiscountModalMode(null); setCouponError(''); }}>
                                Voltar
                              </Button>
                              <Button
                                size="sm"
                                className="flex-1 h-8 text-[11px] bg-orange-500 hover:bg-orange-600"
                                disabled={!couponCode.trim() || couponValidating}
                                onClick={async () => {
                                  setCouponValidating(true);
                                  setCouponError('');
                                  try {
                                    const res = await axios.post(`${API}/coupons/validate`, {
                                      code: couponCode.trim().toUpperCase(),
                                      order_total: subtotal + taxaAplicada,
                                      // Sem o frete o cupom de frete grátis voltava R$ 0,00.
                                      products_total: subtotal,
                                      delivery_fee: taxaAplicada,
                                      customer_id: selectedCliente?.id || null,
                                      customer_phone: selectedCliente?.telefone || null,
                                      // O servidor tira da conta o produto em promoção que não aceita cupom (achado 411).
                                      items: itensDoCupomDoCarrinho, modulo: "Delivery",
                                    });
                                    const d = res.data || {};
                                    if (!d.valid) {
                                      setCouponError(d.message || d.error || 'Cupom inválido.');
                                      return;
                                    }
                                    setCouponData(d);
                                    setDiscountType('coupon');
                                    setDiscountValue(0);
                                    setShowDiscountModal(false);
                                    setDiscountModalMode(null);
                                    toast.success(`Cupom ${d.code || couponCode} aplicado!${avisoDoCupom(d) ? ` ${avisoDoCupom(d)}` : ""}`, avisoDoCupom(d) ? { duration: 7000 } : undefined);
                                  } catch (err) {
                                    setCouponError(mensagemDoErro(err, 'Erro ao validar cupom.'));
                                  } finally {
                                    setCouponValidating(false);
                                  }
                                }}
                              >
                                {couponValidating ? '...' : 'Aplicar'}
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )
              ) : (
                <div className="flex justify-between items-center mb-2 text-sm">
                  <span className="flex items-center gap-1.5 text-green-600 dark:text-green-400 font-medium">
                    <Ticket className="w-3.5 h-3.5" />
                    {discountType === 'percent' ? `Desconto ${discountValue}%`
                      : discountType === 'fixed' ? 'Desconto'
                      : `Cupom ${couponData?.code || couponCode}`}
                    <button
                      onClick={tirarCupom}
                      className="text-muted-foreground hover:text-red-500"
                      title="Remover desconto"
                    >
                      <X className="w-3.5 h-3.5" />
                    </button>
                  </span>
                  <span className="font-semibold text-green-600 dark:text-green-400">- R$ {discountAmount.toFixed(2).replace(".", ",")}</span>
                </div>
              )}
              <div className="flex justify-between items-center mb-3">
                <span className="font-medium">Total</span>
                <span className="text-xl font-bold text-primary">R$ {total.toFixed(2).replace(".", ",")}</span>
              </div>
              {cart.length > 0 && cartStep < 3 ? (
                <div className="flex gap-2">
                  {cartStep > 1 && (
                    <Button variant="outline" className="h-12 px-4" onClick={() => setCartStep(cartStep - 1)}>
                      <ArrowLeft className="w-4 h-4" />
                    </Button>
                  )}
                  <Button
                    onClick={avancarEtapa}
                    className="flex-1 h-12 font-semibold bg-orange-500 hover:bg-orange-600"
                  >
                    Próximo <ChevronRight className="w-4 h-4 ml-1" /> <Tecla className="ml-2 hidden xl:inline-flex">Enter</Tecla>
                  </Button>
                </div>
              ) : (
                <div className="flex gap-2">
                  {cart.length > 0 && cartStep === 3 && (
                    <Button variant="outline" className="h-12 px-4" onClick={() => setCartStep(2)}>
                      <ArrowLeft className="w-4 h-4" />
                    </Button>
                  )}
                  <Button
                    onClick={handleSubmit}
                    className="flex-1 h-12 font-semibold bg-orange-500 hover:bg-orange-600"
                    disabled={cart.length === 0 || !selectedCliente || submitting || (!cpSplitPayment && !formaPagamento && tipoEntrega !== "pickup") || (cpSplitPayment && !cpSplitComplete)}
                  >
                    {submitting ? "Criando..." : !selectedCliente ? "Selecione um cliente" : cart.length === 0 ? "Adicione itens" : pedidoParaEditar ? "SALVAR" : "CRIAR PEDIDO"}
                    {podeCriarPedido && <Tecla className="ml-2 hidden xl:inline-flex">Enter</Tecla>}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Barra fixa mobile — só aparece quando sidebar está oculta */}
        <div className="lg:hidden border-t bg-card flex items-center gap-2 px-3 py-2 pb-[max(0.5rem,env(safe-area-inset-bottom,0px))] shrink-0">
          <button
            type="button"
            onClick={() => setMobileCartSheetOpen(true)}
            className="flex items-center gap-2 min-w-0 flex-1 h-12 px-2 rounded-lg active:opacity-80"
          >
            <ShoppingCart className="w-5 h-5 text-orange-500 shrink-0" />
            <span className="text-sm font-semibold whitespace-nowrap">{cart.length} {cart.length === 1 ? 'item' : 'itens'}</span>
            <span className="text-sm font-bold text-orange-500 truncate">R$ {total.toFixed(2).replace(".", ",")}</span>
          </button>
          {cart.length > 0 && cartStep < 3 ? (
            <Button
              onClick={avancarEtapa}
              className="h-12 px-4 font-semibold bg-orange-500 hover:bg-orange-600 shrink-0"
            >
              {cartStep === 1 ? 'Próximo' : 'Pagamento'} <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
          ) : cart.length > 0 && cartStep === 3 ? (
            <div className="flex items-center gap-2 shrink-0">
              <Button variant="outline" className="h-12 px-3" onClick={() => setCartStep(2)}>
                <ArrowLeft className="w-4 h-4" />
              </Button>
              <Button
                onClick={handleSubmit}
                className="h-12 px-3 font-semibold bg-orange-500 hover:bg-orange-600"
                disabled={cart.length === 0 || !selectedCliente || submitting || (!cpSplitPayment && !formaPagamento && tipoEntrega !== "pickup") || (cpSplitPayment && !cpSplitComplete)}
              >
                {submitting ? "Criando..." : pedidoParaEditar ? "SALVAR" : "CRIAR"}
              </Button>
            </div>
          ) : null}
        </div>

        {/* Sheet do carrinho — mobile */}
        <Sheet open={mobileCartSheetOpen} onOpenChange={setMobileCartSheetOpen}>
          <SheetContent side="bottom" className="max-h-[80dvh] flex flex-col p-0 gap-0 rounded-t-2xl lg:hidden">
            <div className="px-4 py-3 border-b flex items-center justify-between shrink-0">
              <h3 className="font-bold text-base">Carrinho · {cart.length} {cart.length === 1 ? 'item' : 'itens'}</h3>
              <button onClick={() => setMobileCartSheetOpen(false)} className="text-muted-foreground hover:text-foreground">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-3 space-y-2 min-h-0">
              {cart.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-10 text-center gap-3">
                  <div className="w-14 h-14 rounded-full bg-muted/60 flex items-center justify-center">
                    <ShoppingCart className="w-6 h-6 text-muted-foreground/60" />
                  </div>
                  <p className="text-sm text-muted-foreground">Carrinho vazio</p>
                </div>
              ) : (
                cart.map((item, index) => (
                  <div key={`mc-${item.id}-${index}`} className="flex items-start gap-2 p-2 rounded-lg border bg-card">
                    <div className="w-10 h-10 rounded-lg overflow-hidden bg-muted flex-shrink-0">
                      {item.photo_url ? (
                        <img src={getImageUrl(item.photo_url)} alt="" className="w-full h-full object-cover" />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center text-base">🍽️</div>
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold line-clamp-1">{item.name}</p>
                      {item.combo_type && (
                        <span className={`inline-block text-[9px] font-bold px-1.5 py-0.5 rounded mt-0.5 ${item.combo_type === 'combo' ? 'bg-green-500/20 text-green-700 dark:text-green-400' : 'bg-blue-500/20 text-blue-600 dark:text-blue-400'}`}>
                          {item.combo_type === 'combo' ? 'COMBO' : 'SIMPLES'}
                        </span>
                      )}
                      {item.observation && <p className="text-[11px] text-orange-500 line-clamp-1 mt-0.5">📝 {item.observation}</p>}
                      {item.subitems && item.subitems.length > 0 && (
                        <p className="text-[10px] text-muted-foreground line-clamp-2 mt-0.5">
                          {item.subitems.map(s => s.nome || s.name).filter(Boolean).join(', ')}
                        </p>
                      )}
                      <p className="text-xs text-primary font-bold mt-1">R$ {((item.sale_price || 0) * item.quantity).toFixed(2).replace(".", ",")}</p>
                    </div>
                    <div className="flex items-center gap-1 shrink-0">
                      {(item.quantity === 1 && !item.is_divisible) || item.etiqueta_balanca ? (
                        <Button variant="outline" size="icon" className="h-7 w-7 border-red-500/50 text-red-500" onClick={() => { const c=[...cart]; c.splice(index, 1); setCart(c); }}>
                          <Trash2 className="w-3.5 h-3.5" />
                        </Button>
                      ) : (
                        <Button variant="outline" size="icon" className="h-7 w-7" onClick={() => {
                          if (item.is_divisible) {
                            const step = (item.sale_unit === "kg" || item.sale_unit === "L") ? 0.1 : 0.5;
                            const next = parseFloat((item.quantity - step).toFixed(3));
                            const c = [...cart];
                            if (next <= 0) c.splice(index, 1);
                            else c[index] = { ...c[index], quantity: next };
                            setCart(c);
                          } else {
                            removeFromCart(item.id, index);
                          }
                        }}>
                          <Minus className="w-3 h-3" />
                        </Button>
                      )}
                      <span className="min-w-[1.5rem] text-center text-sm font-bold">
                        {item.is_divisible ? Number(item.quantity).toFixed(3).replace('.', ',') : item.quantity}
                        {item.sale_unit && item.sale_unit !== "un" && <span className="text-[10px] text-muted-foreground font-normal ml-0.5">{item.sale_unit}</span>}
                      </span>
                      {/* Item de etiqueta da balança: o peso é o da etiqueta (o servidor confere). */}
                      {!item.etiqueta_balanca && (<Button variant="outline" size="icon" className="h-7 w-7" onClick={() => {
                        const c=[...cart];
                        if (item.is_divisible) {
                          const step = (item.sale_unit === "kg" || item.sale_unit === "L") ? 0.1 : 0.5;
                          c[index] = { ...c[index], quantity: parseFloat((c[index].quantity + step).toFixed(3)) };
                        } else {
                          c[index] = { ...c[index], quantity: c[index].quantity + 1 };
                        }
                        setCart(c);
                      }}>
                        <Plus className="w-3 h-3" />
                      </Button>)}
                    </div>
                  </div>
                ))
              )}
            </div>
            <div className="border-t bg-muted/30 px-4 py-3 flex items-center justify-between">
              <span className="text-sm font-semibold">Total</span>
              <span className="text-xl font-bold text-orange-500">R$ {total.toFixed(2).replace(".", ",")}</span>
            </div>
          </SheetContent>
        </Sheet>
      </div>


      {/* Sair com produtos no carrinho: "Descartar o pedido?" (30/09/2026) */}
      <ConfirmarDescarte open={confirmarDescarte} onOpenChange={setConfirmarDescarte} onDescartar={fecharDeVez} />

      {/* Modal de adicionar split payment — <Dialog> Radix por cima da página
          de Novo Pedido. Até 23/09/2026 o Novo Pedido também era um Dialog e
          este ficava aninhado nele; portais customizados pra body falhavam
          porque o Dialog pai aplicava `inert` nos irmãos. */}
      <Dialog open={cpShowSplitModal} onOpenChange={setCpShowSplitModal}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Adicionar Pagamento</DialogTitle>
          </DialogHeader>
          <div className="space-y-3">

            <div className="grid grid-cols-2 gap-2">
              {(paymentMethodsDelivery.length > 0 ? paymentMethodsDelivery : [
                { id: "dinheiro", code: "dinheiro", label: "Dinheiro", icon: Banknote },
                { id: "pix", code: "pix", label: "PIX", icon: CreditCard },
                { id: "credito", code: "credito", label: "Crédito", icon: CreditCard },
                { id: "debito", code: "debito", label: "Débito", icon: CreditCard },
              ]).map(fp => {
                const fpId = fp.code || fp.id;
                return (
                  <button
                    key={fpId}
                    className={`p-2 border-2 rounded-lg flex items-center gap-1.5 transition-all text-xs ${
                      cpSplitSelectedMethod === fpId
                        ? 'border-purple-500 bg-purple-500/10'
                        : 'border-border hover:border-purple-300'
                    }`}
                    onClick={() => setCpSplitSelectedMethod(fpId)}
                  >
                    <fp.icon className="w-4 h-4 flex-shrink-0" />
                    <span>{fp.label}</span>
                  </button>
                );
              })}
            </div>

            <div>
              <Label className="text-xs">Valor (R$)</Label>
              <Input
                type="text"
                inputMode="decimal"
                value={String(cpSplitAmount).replace(".", ",")}
                onChange={e => setCpSplitAmount(sanitizeCurrencyInput(e.target.value))}
                placeholder={`Restante: R$ ${cpSplitRemaining.toFixed(2).replace(".", ",")}`}
                className="h-9 text-sm"
              />
            </div>

            {cpSplitEhDinheiro && !jaPago && (
              <div className="space-y-2 p-2.5 bg-amber-50 dark:bg-amber-950/30 rounded-lg border border-amber-200 dark:border-amber-800">
                <Label className="text-amber-800 dark:text-amber-300 text-xs font-medium">Precisa de troco?</Label>
                <div className="flex gap-2">
                  <button
                    onClick={() => setCpSplitTrocoNeeds(false)}
                    className={`flex-1 p-1.5 rounded-lg border text-xs font-medium ${!cpSplitTrocoNeeds ? 'border-amber-500 bg-amber-500 text-white' : 'border-amber-300 text-amber-700'}`}
                  >
                    Não
                  </button>
                  <button
                    onClick={() => setCpSplitTrocoNeeds(true)}
                    className={`flex-1 p-1.5 rounded-lg border text-xs font-medium ${cpSplitTrocoNeeds ? 'border-amber-500 bg-amber-500 text-white' : 'border-amber-300 text-amber-700'}`}
                  >
                    Sim
                  </button>
                </div>
                {cpSplitTrocoNeeds && (
                  <div>
                    <Label className="text-[10px] text-amber-700 dark:text-amber-400">Troco para quanto?</Label>
                    <Input
                      type="text"
                      inputMode="decimal"
                      value={cpSplitTrocoAmount}
                      onChange={e => setCpSplitTrocoAmount(sanitizeCurrencyInput(e.target.value))}
                      placeholder="Ex: 100"
                      className="h-8 text-xs bg-white dark:bg-background"
                    />
                  </div>
                )}
              </div>
            )}

            <Button
              onClick={cpAddSplitPayment}
              disabled={!cpSplitSelectedMethod || !cpSplitAmount || parseFloat(cpSplitAmount) <= 0}
              className="w-full bg-purple-600 hover:bg-purple-700 text-white"
            >
              <Plus className="w-4 h-4 mr-1" /> Adicionar R$ {cpSplitAmount ? parseFloat(cpSplitAmount).toFixed(2).replace(".", ",") : '0,00'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Popup de Produto - COM SUPORTE A COMBO */}
      <Dialog open={!!selectedProduct} onOpenChange={(open) => !open && closeProductPopup()}>
        <DialogContent {...tecladoPopupProduto()} aria-describedby={undefined} hideClose className="max-w-[100vw] sm:max-w-lg md:max-w-xl w-full h-[100dvh] sm:h-[88dvh] sm:max-h-[720px] p-0 overflow-hidden flex flex-col m-0 sm:m-4 rounded-none sm:rounded-2xl shadow-2xl">
          <DialogTitle className="sr-only">{selectedProduct?.name || "Produto"}</DialogTitle>
          {selectedProduct && (() => {
            const isCombo = selectedProduct.product_type === 'combo';
            const hasOrderSteps = selectedProduct.order_steps?.length > 0;
            const relevantSteps = getRelevantSteps();
            const totalSteps = relevantSteps.length;
            const comboPrice = selectedProduct.sale_price || 0;
            const simplePrice = selectedProduct.simple_price || Math.round(comboPrice * 0.7 * 100) / 100;
            const _promoS = getPromoForProduct(selectedProduct.id, 'simples');
            const _promoC = getPromoForProduct(selectedProduct.id, 'combo');
            const simplePricePromo = isCombo ? calcPromoPrice(simplePrice, _promoS) : calcPromoPrice(comboPrice, _promoS);
            const comboPricePromo = calcPromoPrice(comboPrice, _promoC);
            const isOnSummaryStep = comboStep > totalSteps && comboStep > 0;
            // Contagem de telas — incluindo a de conferencia/resumo como ultima etapa.
            // Total = (1 se tipo combo, pra tela SIMPLES/COMBO) + order_steps + 1 (resumo)
            const totalScreens = (isCombo ? 1 : 0) + totalSteps + 1;
            const currentScreen = (isCombo && comboStep === 0)
              ? 1
              : (comboStep > 0 && comboStep <= totalSteps)
                ? (isCombo ? 1 : 0) + comboStep
                : totalScreens; // resumo

            // TELA 1: Seleção COMBO vs SIMPLES (apenas para produtos tipo combo)
            if (isCombo && comboStep === 0) {
              return (
                <>
                  <div className="relative p-4 sm:p-5 border-b bg-gradient-to-br from-orange-500/5 to-transparent">
                    <div className="flex items-center justify-between mb-3">
                      <div className="w-8" />
                      <div className="flex items-center gap-1.5">
                        {Array.from({ length: totalScreens }).map((_, i) => (
                          <div key={i} className={`h-1.5 rounded-full transition-all ${i + 1 < currentScreen ? 'w-4 bg-orange-500' : i + 1 === currentScreen ? 'w-8 bg-orange-500' : 'w-4 bg-muted'}`} />
                        ))}
                      </div>
                      <button
                        onClick={closeProductPopup}
                        className="w-8 h-8 rounded-full bg-muted hover:bg-muted/80 flex items-center justify-center transition-colors"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                    <p className="text-[10px] uppercase tracking-wider text-muted-foreground/70 text-center font-semibold">
                      Etapa {currentScreen} de {totalScreens}
                    </p>
                    <h2 className="text-lg sm:text-xl md:text-2xl font-bold tracking-tight text-center mt-1">{selectedProduct.name}</h2>
                    {selectedProduct.description && (
                      <p className="text-xs sm:text-sm text-muted-foreground mt-1.5 line-clamp-2 text-center">{selectedProduct.description}</p>
                    )}
                    <p className="text-xs uppercase tracking-wider text-muted-foreground/80 mt-3 font-semibold text-center">Como você quer o pedido?</p>
                  </div>

                  <div className="p-3 sm:p-4 flex-1 overflow-y-auto">
                    <div className="grid grid-cols-2 gap-3">
                      {/* Card SIMPLES */}
                      <button
                        onClick={() => handleSelectComboType('simples')}
                        data-opcao data-escolhida={selectedComboType === 'simples' ? "1" : "0"}
                        className={`${ANEL_FOCO} relative rounded-2xl border-2 transition-all text-left overflow-hidden flex flex-col ${
                          selectedComboType === 'simples'
                            ? 'border-orange-500 bg-gradient-to-br from-orange-500/10 to-transparent shadow-md'
                            : 'border-border bg-card hover:border-orange-500/40 hover:shadow-sm'
                        }`}
                      >
                        {selectedComboType === 'simples' && (
                          <div className="absolute top-2 right-2 w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center z-10 shadow-sm">
                            <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
                          </div>
                        )}
                        <div className="aspect-square relative overflow-hidden bg-muted">
                          {(selectedProduct.simple_photo_url || selectedProduct.photo_url) ? (
                            <img
                              src={getImageUrl(selectedProduct.simple_photo_url || selectedProduct.photo_url)}
                              alt={selectedProduct.name}
                              className="w-full h-full object-cover"
                              loading="lazy"
                              decoding="async"
                            />
                          ) : (
                            <div className="w-full h-full flex items-center justify-center text-5xl">🍽️</div>
                          )}
                        </div>
                        <div className="p-3 flex-1 flex flex-col">
                          <p className="font-bold text-sm tracking-wide">SIMPLES</p>
                          <p className="text-[11px] text-muted-foreground mt-0.5 line-clamp-2 mb-2">
                            {selectedProduct.simple_description || 'Apenas o produto'}
                          </p>
                          <div className="mt-auto">
                            {simplePricePromo != null && simplePricePromo !== simplePrice ? (
                              <>
                                <span className="text-[10px] line-through text-muted-foreground/70 block">R$ {simplePrice.toFixed(2).replace(".", ",")}</span>
                                <p className="text-lg font-black text-green-600 dark:text-green-500 leading-none">R$ {simplePricePromo.toFixed(2).replace(".", ",")}</p>
                              </>
                            ) : (
                              <p className="text-lg font-black text-orange-500 leading-none">R$ {simplePrice.toFixed(2).replace(".", ",")}</p>
                            )}
                          </div>
                        </div>
                      </button>

                      {/* Card COMBO */}
                      <button
                        onClick={() => handleSelectComboType('combo')}
                        data-opcao data-escolhida={selectedComboType === 'combo' ? "1" : "0"}
                        className={`${ANEL_FOCO} relative rounded-2xl border-2 transition-all text-left overflow-hidden flex flex-col ${
                          selectedComboType === 'combo'
                            ? 'border-orange-500 bg-gradient-to-br from-orange-500/10 to-transparent shadow-md'
                            : 'border-border bg-card hover:border-orange-500/40 hover:shadow-sm'
                        }`}
                      >
                        <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-green-500 to-emerald-600 text-white text-[10px] font-extrabold tracking-wider py-1 text-center z-10 shadow-sm">
                          ★ RECOMENDADO
                        </div>
                        {selectedComboType === 'combo' && (
                          <div className="absolute top-8 right-2 w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center z-10 shadow-sm">
                            <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
                          </div>
                        )}
                        <div className="aspect-square relative overflow-hidden bg-muted pt-6">
                          {(selectedProduct.combo_photo_url || selectedProduct.photo_url) ? (
                            <img
                              src={getImageUrl(selectedProduct.combo_photo_url || selectedProduct.photo_url)}
                              alt={selectedProduct.name}
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <div className="w-full h-full flex items-center justify-center text-5xl">🍽️</div>
                          )}
                        </div>
                        <div className="p-3 flex-1 flex flex-col">
                          <p className="font-bold text-sm tracking-wide">COMBO</p>
                          <p className="text-[11px] text-muted-foreground mt-0.5 line-clamp-2 mb-2">
                            {selectedProduct.combo_description || '+ Batata + Refrigerante'}
                          </p>
                          <div className="mt-auto">
                            {comboPricePromo != null && comboPricePromo !== comboPrice ? (
                              <>
                                <span className="text-[10px] line-through text-muted-foreground/70 block">R$ {comboPrice.toFixed(2).replace(".", ",")}</span>
                                <p className="text-lg font-black text-green-600 dark:text-green-500 leading-none">R$ {comboPricePromo.toFixed(2).replace(".", ",")}</p>
                              </>
                            ) : (
                              <p className="text-lg font-black text-orange-500 leading-none">R$ {comboPrice.toFixed(2).replace(".", ",")}</p>
                            )}
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>

                  <div className="p-3 sm:p-4 bg-muted/40 border-t">
                    <Button
                      onClick={handleNextComboStep}
                      data-avancar
                      disabled={!canAdvanceComboStep()}
                      className="w-full h-12 text-sm sm:text-base font-semibold bg-orange-500 hover:bg-orange-600 disabled:bg-muted disabled:text-muted-foreground"
                    >
                      {selectedComboType && hasOrderSteps && relevantSteps.length > 0
                        ? <>Próxima etapa <ChevronRight className="w-4 h-4 ml-1" /></>
                        : `Adicionar • R$ ${(selectedComboType === 'combo' ? (comboPricePromo ?? comboPrice) : (simplePricePromo ?? simplePrice)).toFixed(2).replace(".", ",")}`
                      }
                    </Button>
                  </div>
                </>
              );
            }
            
            // TELA 2: Etapas de seleção (order_steps)
            if ((isCombo || hasOrderSteps) && comboStep > 0 && comboStep <= totalSteps) {
              const currentStepIndex = comboStep - 1;
              const currentStep = relevantSteps[currentStepIndex];
              const selections = stepSelections[currentStepIndex] || [];
              
              if (!currentStep) {
                setComboStep(totalSteps + 1);
                return null;
              }
              
              return (
                <>
                  <div className="p-4 sm:p-5 border-b bg-gradient-to-br from-orange-500/5 to-transparent">
                    <div className="flex items-center justify-between mb-3">
                      <button
                        onClick={() => setComboStep(comboStep - 1)}
                        data-voltar
                        className="w-8 h-8 rounded-full bg-muted hover:bg-muted/80 flex items-center justify-center transition-colors"
                      >
                        <ArrowLeft className="w-4 h-4" />
                      </button>
                      <div className="flex items-center gap-1.5">
                        {Array.from({ length: totalScreens }).map((_, i) => (
                          <div
                            key={i}
                            className={`h-1.5 rounded-full transition-all ${
                              i + 1 < currentScreen
                                ? 'w-4 bg-orange-500'
                                : i + 1 === currentScreen
                                  ? 'w-8 bg-orange-500'
                                  : 'w-4 bg-muted'
                            }`}
                          />
                        ))}
                      </div>
                      <button
                        onClick={closeProductPopup}
                        className="w-8 h-8 rounded-full bg-muted hover:bg-muted/80 flex items-center justify-center transition-colors"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                    <p className="text-[10px] uppercase tracking-wider text-muted-foreground/70 text-center font-semibold">
                      Etapa {currentScreen} de {totalScreens}
                    </p>
                    <h2 className="text-lg sm:text-xl font-bold text-center mt-1 tracking-tight">{currentStep.name || `Etapa ${comboStep}`}</h2>
                    {(currentStep.min_selections > 0 || currentStep.max_selections > 0) && (
                      <p className="text-xs text-muted-foreground text-center mt-1.5">
                        {currentStep.min_selections > 0 && currentStep.max_selections > 0 && currentStep.min_selections === currentStep.max_selections
                          ? `Selecione ${currentStep.min_selections} ${currentStep.min_selections === 1 ? 'opção' : 'opções'}`
                          : currentStep.min_selections > 0
                            ? `Selecione no mínimo ${currentStep.min_selections}`
                            : currentStep.max_selections > 0
                              ? `Selecione até ${currentStep.max_selections}`
                              : 'Selecione suas opções'
                        }
                        {selections.length > 0 && (
                          <span className="ml-2 font-bold text-orange-500">({selections.length} selecionada{selections.length === 1 ? '' : 's'})</span>
                        )}
                      </p>
                    )}
                    {/* Busca quando a etapa tem >6 itens */}
                    {(() => {
                      const visibleItems = (currentStep.items || []).filter(it => (!it.visible_modules || it.visible_modules.includes("Delivery")) && !isProductHidden(it.product_id));
                      if (visibleItems.length <= 6) return null;
                      return (
                        <div data-busca-opcao className="relative mt-3 max-w-sm mx-auto">
                          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                          <Input
                            type="text"
                            placeholder="Buscar opção..."
                            value={stepSearch}
                            onChange={(e) => setStepSearch(e.target.value)}
                            className="h-9 pl-9 pr-8 text-sm rounded-full"
                          />
                          {stepSearch && (
                            <button
                              onClick={() => setStepSearch("")}
                              className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center rounded-full text-muted-foreground hover:bg-muted"
                            >
                              <X className="w-3.5 h-3.5" />
                            </button>
                          )}
                        </div>
                      );
                    })()}
                  </div>

                  <div className="p-3 sm:p-4 flex-1 overflow-y-auto">
                    <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
                      {(currentStep.items || [])
                        .filter(item => (!item.visible_modules || item.visible_modules.includes("Delivery")) && !isProductHidden(item.product_id))
                        .filter(item => {
                          const s = stepSearch.trim().toLowerCase();
                          if (!s) return true;
                          return (item.product_name || '').toLowerCase().includes(s);
                        })
                        .map((item) => {
                        const isSelected = selections.includes(item.product_id);
                        const itemPhoto = getProductPhoto(item.product_id);
                        const itemAvailable = isProductAvailable(item.product_id);
                        const itemPrice = getItemPrice(item, currentStep);
                        const itemDescription = getProductDescription(item.product_id);

                        return (
                          <button
                            key={item.product_id}
                            onClick={() => itemAvailable && toggleItemSelection(currentStepIndex, item.product_id)}
                            disabled={!itemAvailable}
                            data-opcao data-escolhida={isSelected ? "1" : "0"}
                            className={`${ANEL_FOCO} relative rounded-lg border-2 transition-all text-left flex flex-col overflow-hidden ${
                              !itemAvailable
                                ? 'border-border bg-muted/30 opacity-60 cursor-not-allowed'
                                : isSelected
                                  ? 'border-orange-500 bg-gradient-to-br from-orange-500/10 to-transparent shadow-md'
                                  : 'border-border bg-card hover:border-orange-500/40 hover:shadow-sm'
                            }`}
                          >
                            {isSelected && itemAvailable && (
                              <div className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-orange-500 flex items-center justify-center z-10 shadow-sm">
                                <Check className="w-3 h-3 text-white" strokeWidth={3} />
                              </div>
                            )}
                            <div className="aspect-square relative overflow-hidden bg-muted">
                              {itemPhoto ? (
                                <img
                                  src={getImageUrl(itemPhoto)}
                                  alt={item.product_name}
                                  className={`w-full h-full object-cover ${!itemAvailable ? 'grayscale' : ''}`}
                                />
                              ) : (
                                <div className="w-full h-full flex items-center justify-center text-2xl">🍽️</div>
                              )}
                              {!itemAvailable && (
                                <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                                  <span className="text-white text-[9px] font-bold bg-red-500 px-1.5 py-0.5 rounded-full">ESGOTADO</span>
                                </div>
                              )}
                            </div>
                            <div className="p-1.5 flex-1 flex flex-col">
                              <p className={`font-semibold text-[11px] line-clamp-1 leading-tight ${!itemAvailable ? 'text-muted-foreground line-through' : ''}`}>
                                {item.product_name}
                              </p>
                              <div className="mt-auto pt-1">
                                {!itemAvailable ? (
                                  <span className="text-[9px] text-red-500 font-bold">—</span>
                                ) : itemPrice > 0 ? (
                                  <span className="text-[11px] text-orange-500 font-bold">{sinalDaEtapa(currentStep)}R$ {itemPrice.toFixed(2).replace(".", ",")}</span>
                                ) : (
                                  <span className="text-[9px] text-green-600 dark:text-green-500 font-bold uppercase tracking-wider">Grátis</span>
                                )}
                              </div>
                            </div>
                          </button>
                        );
                      })}
                    </div>
                    {/* Empty state quando busca nao retorna nada */}
                    {stepSearch.trim() && (currentStep.items || []).filter(item => {
                      if (item.visible_modules && !item.visible_modules.includes("Delivery")) return false;
                      if (isProductHidden(item.product_id)) return false;
                      return (item.product_name || '').toLowerCase().includes(stepSearch.trim().toLowerCase());
                    }).length === 0 && (
                      <div className="text-center py-10 text-sm text-muted-foreground">
                        Nenhuma opção encontrada para "{stepSearch}"
                      </div>
                    )}
                  </div>

                  <div className="p-3 sm:p-4 bg-muted/40 border-t">
                    <Button
                      onClick={handleNextComboStep}
                      data-avancar
                      disabled={!canAdvanceComboStep()}
                      className="w-full h-12 text-sm sm:text-base font-semibold bg-orange-500 hover:bg-orange-600 disabled:bg-muted disabled:text-muted-foreground"
                    >
                      {comboStep < totalSteps ? <>Próxima etapa <ChevronRight className="w-4 h-4 ml-1" /></> : <>Revisar pedido <ChevronRight className="w-4 h-4 ml-1" /></>}
                    </Button>
                  </div>
                </>
              );
            }
            
            // TELA 3: Resumo/Finalização (para combos) ou Tela normal (para produtos simples)
            const showNormalView = !isCombo && !hasOrderSteps;
            const showSummaryView = (isCombo && isOnSummaryStep) || (hasOrderSteps && comboStep > totalSteps);
            
            if (showNormalView || showSummaryView || (!isCombo && hasOrderSteps && comboStep === 0)) {
              const finalPrice = calculateComboPrice();
              
              return (
                <>
                  {/* Header topbar com progress + nav — igual as outras telas */}
                  {(isCombo || hasOrderSteps) && (
                    <div className="p-3 sm:p-4 border-b bg-gradient-to-br from-orange-500/5 to-transparent">
                      <div className="flex items-center justify-between mb-2">
                        <button
                          onClick={() => setComboStep(totalSteps > 0 ? totalSteps : 0)}
                          data-voltar
                          className="w-8 h-8 rounded-full bg-muted hover:bg-muted/80 flex items-center justify-center transition-colors"
                        >
                          <ArrowLeft className="w-4 h-4" />
                        </button>
                        <div className="flex items-center gap-1.5">
                          {Array.from({ length: totalScreens }).map((_, i) => (
                            <div key={i} className={`h-1.5 rounded-full transition-all ${i + 1 < currentScreen ? 'w-4 bg-orange-500' : i + 1 === currentScreen ? 'w-8 bg-orange-500' : 'w-4 bg-muted'}`} />
                          ))}
                        </div>
                        <button
                          onClick={closeProductPopup}
                          className="w-8 h-8 rounded-full bg-muted hover:bg-muted/80 flex items-center justify-center transition-colors"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      </div>
                      <p className="text-[10px] uppercase tracking-wider text-muted-foreground/70 text-center font-semibold">
                        Etapa {currentScreen} de {totalScreens} · Conferência
                      </p>
                    </div>
                  )}

                  <div className="p-3 sm:p-4 flex-1 overflow-y-auto">
                    {/* Linha superior: Imagem + Infos principais (side-by-side em desktop) */}
                    <div className="flex gap-3 sm:gap-4">
                      <div className="relative w-28 h-28 sm:w-36 sm:h-36 rounded-xl overflow-hidden shrink-0 bg-muted">
                        {selectedProduct.photo_url ? (
                          <img
                            src={getImageUrl(selectedProduct.photo_url)}
                            alt={selectedProduct.name}
                            className={`w-full h-full ${isPngImage(selectedProduct.photo_url) ? 'object-contain p-2 bg-gradient-to-br from-orange-100 to-orange-50 dark:from-orange-900/20 dark:to-transparent' : 'object-cover'}`}
                          />
                        ) : (
                          <div className="w-full h-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center">
                            <Package className="w-10 h-10 text-white/60" />
                          </div>
                        )}
                        {/* Close floating (quando nao tem header topbar) */}
                        {!(isCombo || hasOrderSteps) && (
                          <button
                            onClick={closeProductPopup}
                            className="absolute top-1.5 right-1.5 bg-black/60 backdrop-blur rounded-full w-7 h-7 flex items-center justify-center text-white hover:bg-black/80 transition-colors"
                          >
                            <X className="w-3.5 h-3.5" />
                          </button>
                        )}
                      </div>
                      <div className="flex-1 min-w-0 flex flex-col">
                        <h2 className="text-base sm:text-lg font-bold tracking-tight leading-tight">{selectedProduct.name}</h2>
                        {isCombo && selectedComboType && (
                          <span className={`inline-flex items-center gap-1 self-start mt-1 px-2 py-0.5 rounded-full text-[10px] font-bold ${
                            selectedComboType === 'combo'
                              ? 'bg-green-500/15 text-green-600 dark:text-green-400'
                              : 'bg-muted text-muted-foreground'
                          }`}>
                            {selectedComboType === 'combo' ? '🍟 COMBO' : 'SIMPLES'}
                          </span>
                        )}
                        {selectedProduct.description && (
                          <p className="text-[11px] sm:text-xs text-muted-foreground mt-1.5 line-clamp-3 leading-snug">{selectedProduct.description}</p>
                        )}
                        <div className="mt-auto pt-2">
                          {(() => {
                            const origP = isCombo ? (selectedComboType === 'combo' ? comboPrice : simplePrice) : (selectedProduct.sale_price || 0);
                            return finalPrice !== origP ? (
                              <div className="flex items-baseline gap-2">
                                <span className="text-xs line-through text-muted-foreground">R$ {origP.toFixed(2).replace(".", ",")}</span>
                                <span className="text-xl sm:text-2xl font-black text-green-600 dark:text-green-500">R$ {finalPrice.toFixed(2).replace(".", ",")}</span>
                              </div>
                            ) : (
                              <span className="text-xl sm:text-2xl font-black text-orange-500">R$ {finalPrice.toFixed(2).replace(".", ",")}</span>
                            );
                          })()}
                        </div>
                      </div>
                    </div>

                    {/* Resumo das seleções */}
                    {showSummaryView && Object.keys(stepSelections).length > 0 && (() => {
                      const blocks = relevantSteps.map((step, idx) => {
                        const sel = stepSelections[idx] || [];
                        if (sel.length === 0) return null;
                        const items = sel.map(id => step.items?.find(i => i.product_id === id)).filter(Boolean);
                        if (items.length === 0) return null;
                        return (
                          <div key={idx} className="space-y-1">
                            <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">{step.name}</p>
                            <div className="flex flex-wrap gap-1.5">
                              {items.map(it => {
                                const ph = getProductPhoto(it.product_id);
                                const price = getItemPrice(it, step);
                                return (
                                  <div key={it.product_id} className="flex items-center gap-1.5 bg-card border border-border rounded-full pr-2 pl-0.5 py-0.5">
                                    <div className="w-7 h-7 rounded-full overflow-hidden bg-muted shrink-0 ring-1 ring-border">
                                      {ph ? (
                                        <img src={getImageUrl(ph)} alt="" className="w-full h-full object-cover" />
                                      ) : (
                                        <div className="w-full h-full flex items-center justify-center text-[10px]">🍽️</div>
                                      )}
                                    </div>
                                    <span className="text-[11px] font-medium text-foreground">{it.product_name}</span>
                                    {price > 0 && (
                                      <span className="text-[10px] font-bold text-orange-500">{sinalDaEtapa(step)}R$ {price.toFixed(2).replace(".", ",")}</span>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      }).filter(Boolean);
                      if (blocks.length === 0) return null;
                      return (
                        <div className="mt-4 space-y-2.5 p-3 bg-muted/50 rounded-xl border border-border/50">
                          <p className="text-[10px] uppercase tracking-wider font-semibold text-muted-foreground">Suas escolhas</p>
                          {blocks}
                        </div>
                      );
                    })()}

                    {/* Quilo/litro: os mesmos botões de peso do Balcão e do cardápio (29/09/2026). */}
                    {vendePorPeso(selectedProduct) && (
                      <div className="mt-4" data-e2e="delivery-peso">
                        <Label className="text-xs font-semibold">Quantidade (em {selectedProduct.sale_unit})</Label>
                        <div className="mt-1"><QuantidadePeso product={selectedProduct} quantity={productQuantity} setQuantity={setProductQuantity} variante="painel" modulo="Delivery" setPesadoBalanca={setPesadoBalanca} /></div>
                      </div>
                    )}

                    <div className="mt-4">
                      <Label className="text-xs font-semibold">Observação (opcional)</Label>
                      <Textarea
                        value={productObservation}
                        onChange={(e) => setProductObservation(e.target.value)}
                        placeholder="Ex: Sem cebola, bem passado..."
                        rows={2}
                        className="mt-1 resize-none"
                      />
                    </div>
                  </div>

                  {/* Footer fixo: quantidade + adicionar */}
                  <div className="p-3 sm:p-4 bg-muted/40 border-t flex items-center justify-between gap-3">
                    {vendePorPeso(selectedProduct) ? null : selectedProduct?.is_divisible ? (
                      <div className="flex items-center gap-1.5 bg-card border-2 border-orange-500/30 rounded-full p-1 shrink-0">
                        <button
                          onClick={() => setProductQuantity(Math.max(0.001, parseFloat((productQuantity - (selectedProduct.sale_unit === "kg" || selectedProduct.sale_unit === "L" ? 0.1 : 0.5)).toFixed(3))))}
                          className="w-7 h-7 rounded-full bg-orange-500/10 hover:bg-orange-500 text-orange-500 hover:text-white flex items-center justify-center transition-colors"
                        >
                          <Minus className="w-3.5 h-3.5" />
                        </button>
                        <input
                          type="number"
                          step="0.001"
                          min="0.001"
                          value={productQuantity}
                          onChange={(e) => { const v = parseFloat(e.target.value); if (!isNaN(v) && v > 0) setProductQuantity(v); }}
                          className="w-16 text-center text-base font-bold bg-transparent border-0 focus:outline-none"
                        />
                        <button
                          onClick={() => setProductQuantity(parseFloat((productQuantity + (selectedProduct.sale_unit === "kg" || selectedProduct.sale_unit === "L" ? 0.1 : 0.5)).toFixed(3)))}
                          className="w-7 h-7 rounded-full bg-orange-500/10 hover:bg-orange-500 text-orange-500 hover:text-white flex items-center justify-center transition-colors"
                        >
                          <Plus className="w-3.5 h-3.5" />
                        </button>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2 bg-card border-2 border-orange-500/30 rounded-full p-1 shrink-0">
                        <button
                          onClick={() => setProductQuantity(Math.max(1, productQuantity - 1))}
                          className="w-8 h-8 rounded-full bg-orange-500/10 hover:bg-orange-500 text-orange-500 hover:text-white flex items-center justify-center transition-colors"
                        >
                          <Minus className="w-4 h-4" />
                        </button>
                        <span className="text-base font-bold w-7 text-center">{productQuantity}</span>
                        <button
                          onClick={() => setProductQuantity(productQuantity + 1)}
                          className="w-8 h-8 rounded-full bg-orange-500/10 hover:bg-orange-500 text-orange-500 hover:text-white flex items-center justify-center transition-colors"
                        >
                          <Plus className="w-4 h-4" />
                        </button>
                      </div>
                    )}
                    <Button
                      onClick={confirmAddToCart}
                      data-avancar
                      className="flex-1 h-11 text-sm sm:text-base font-semibold bg-orange-500 hover:bg-orange-600"
                    >
                      Adicionar · R$ {(finalPrice * productQuantity).toFixed(2).replace(".", ",")}
                    </Button>
                  </div>
                </>
              );
            }
            
            return null;
          })()}
        </DialogContent>
      </Dialog>
      {/* Popup dedicado de Pizza dentro do CardapioPopup */}
      {cpPizza.popup}
    </>
  );
}
